import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date */
  Date: { input: string; output: string; }
  /** DateTime */
  DateTime: { input: string; output: string; }
  /** Must be a valid email address */
  Email: { input: string; output: string; }
  /** An alpha-numeric string that represents a fee category. */
  FeeCategoryCode: { input: any; output: any; }
  /** An integer that represents a Group Coordinator's free place ratio for tour products or insurance. */
  FreePlaceRatio: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: { }; output: { }; }
  /** Trip component line item code */
  LineItemCode: { input: string; output: string; }
  /** Mongodb ObjectId */
  ObjectId: { input: string; output: string; }
  /** Percent value */
  Percentage: { input: any; output: any; }
  /** Phone number */
  PhoneNumber: { input: string; output: string; }
  /** A component that differentiates different events happening on the same date. I.E 2 different departures on the same date for the same tour. */
  Series: { input: any; output: any; }
  /** A time of day without a date */
  Time: { input: any; output: any; }
  /** An alpha-numeric string that represents a tour cabin. */
  TourCabinCode: { input: any; output: any; }
};

export type AchPaymentMethod = {
  __typename?: 'ACHPaymentMethod';
  accountNumberMask: Scalars['String']['output'];
  address?: Maybe<Address>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  processorPaymentMethodId?: Maybe<Scalars['Int']['output']>;
  routingNumber: Scalars['String']['output'];
};

export type AcceptGcDepartureTermsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidOrderError | InvalidTermError | NotAuthorizedError | NotFoundError | ValidationError;

export type AcceptTripTermsResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTermError | NotAuthorizedError | NotFoundError | ValidationError;

/** Add promos to a campaign */
export type AddCampaignPromosInput = {
  offerCodes: Array<Scalars['String']['input']>;
};

export type AddCampaignPromosResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftBookingPaymentScheduleResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | InvalidPaymentError | InvalidPaymentScheduleError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderAdjustmentInput = {
  /** The dollar amount to adjust the trip by. */
  amount: Scalars['Float']['input'];
  /** Specific line item the adjustment targets. If not provided, the adjustment will target the trip in total. */
  targetLineItem?: InputMaybe<Scalars['ObjectId']['input']>;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId']['input'];
};

export type AddDraftOrderAdjustmentResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidAdjustmentError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderCampaignResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | InvalidOrderError | InvalidPromoError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderExcursionInput = {
  /** Excursion lineItemCode to add. */
  extensionExcursionLineItemCodes: Array<Scalars['LineItemCode']['input']>;
  /** Excursion lineItemCode to add. */
  mainTourExcursionLineItemCodes: Array<Scalars['LineItemCode']['input']>;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId']['input'];
};

export type AddDraftOrderExcursionsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderExtendedStayInput = {
  /** Extended stay end date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** The number of days of the extended stay. */
  nbDays?: Scalars['Int']['input'];
  /** Extended stay start date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId']['input'];
};

export type AddDraftOrderExtensionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderFeeInput = {
  /** The fee amount. Will override the results of buildPrice(). */
  overrideAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The line item the fee should target. */
  targetLineItemId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId']['input'];
};

export type AddDraftOrderFeeResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderInsuranceAddonInput = {
  /** lineItemCode for the insurance plan addon. */
  insuranceAddonLineItemCode: Scalars['LineItemCode']['input'];
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId']['input'];
};

export type AddDraftOrderInsuranceAddonResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderInsuranceExtensionInput = {
  /** Number of days to the insurance extension. */
  daysToExtend: Scalars['Int']['input'];
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId']['input'];
};

export type AddDraftOrderInsuranceExtensionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderInsuranceResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderPostStayResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderPreStayResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderPrivateGroupResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderPromoResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | InvalidPromoError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftQuoteTripInput = {
  /** The DraftOrder _id */
  _id: Scalars['ObjectId']['input'];
  /** The Customer ID for the Trip being added to the Draft Quote, if one exists */
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** The customer's home gateway code */
  gatewayCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddDraftQuoteTripResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidFlightPackageError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddEmployeesToRoleInput = {
  employeeIds: Array<Scalars['ObjectId']['input']>;
};

export type AddEmployeesToRoleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Role | ValidationError;

/** Add additional targets to a promo */
export type AddPrivateGroupInput = {
  basePrice: Array<MoneyInput>;
  rollsUpToTarget?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddPrivateGroupResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPrivateGroupError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

/** Add promo codes to a promo */
export type AddPromoCodesInput = {
  promoCodes: Array<Scalars['String']['input']>;
};

export type AddPromoCodesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type AddPromoCustomersInput = {
  customerIds: Array<Scalars['ObjectId']['input']>;
};

export type AddPromoCustomersResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Add gc departure to a promo */
export type AddPromoGcDepartureInput = {
  gcDepartureIds: Array<Scalars['ObjectId']['input']>;
};

export type AddPromoGcDeparturesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Add additional targets to a promo */
export type AddPromoTargetsInput = {
  targets: Array<CreatePromoTargetInput>;
};

export type AddPromoTargetsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type AddTourExcursionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type AddTourExtensionExcursionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

/** Non standard increases or reductions to a trip balance */
export type Adjustment = TripComponent & {
  __typename?: 'Adjustment';
  _id: Scalars['ObjectId']['output'];
  adjustmentCode: Scalars['String']['output'];
  businessCode?: Maybe<BusinessCode>;
  displayName: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  isRefundable: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  meta?: Maybe<AdjustmentMetadata>;
  persistsOnCancelAndRebook: Scalars['Boolean']['output'];
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: TripComponentStatus;
  type: TripComponentType;
};

export type AdjustmentLineItem = LineItem & {
  __typename?: 'AdjustmentLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  meta?: Maybe<AdjustmentMetadata>;
  persistsOnCancelAndRebook: Scalars['Boolean']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

/** Additional settings for this adjustment line item */
export type AdjustmentLineItemMetadata = {
  __typename?: 'AdjustmentLineItemMetadata';
  isCompanionDiscount: Scalars['Boolean']['output'];
  isFreePlace: Scalars['Boolean']['output'];
  isStaffOnTour: Scalars['Boolean']['output'];
};

/** Additional settings for this adjustment */
export type AdjustmentMetadata = {
  __typename?: 'AdjustmentMetadata';
  isCompanionDiscount: Scalars['Boolean']['output'];
  isFreePlace: Scalars['Boolean']['output'];
  isStaffOnTour: Scalars['Boolean']['output'];
};

/** A paginated result of Discounts */
export type AdjustmentPaginatedResult = {
  __typename?: 'AdjustmentPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Adjustment>;
};

export enum AdjustmentSortField {
  AdjustmentCode = 'adjustmentCode',
  LineItemCode = 'lineItemCode'
}

/** Generate a magic link, and send to a customer or tour director */
export type AdminCreateMagicLinkInput = {
  email: Scalars['String']['input'];
  isTourDirector?: InputMaybe<Scalars['Boolean']['input']>;
  returnURL: Scalars['String']['input'];
};

export type AdminCreateMagicLinkResult = AdminMagicLinkResult | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidMagicLinkError | NotAuthorizedError | NotFoundError | ValidationError;

export type AdminMagicLinkResult = {
  __typename?: 'AdminMagicLinkResult';
  returnLink: Scalars['String']['output'];
};

export type AffirmPaymentMethod = {
  __typename?: 'AffirmPaymentMethod';
  /** The CHECKOUT_TOKEN from affirm for this loan */
  checkoutToken: Scalars['String']['output'];
  /** The loan id from affirm */
  transactionId: Scalars['String']['output'];
};

export type AffirmPaymentMethodInput = {
  /** The CHECKOUT_TOKEN from affirm for this loan */
  affirmCheckoutToken: Scalars['String']['input'];
};

/** Airline company that provides air transportation services for passengers */
export type Airline = {
  __typename?: 'Airline';
  _id: Scalars['ObjectId']['output'];
  code: Scalars['String']['output'];
  iataCode?: Maybe<Scalars['String']['output']>;
  icaoCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Airport transfers are for LO1 flights where the customer has purchased a transfer to/from the airport */
export type AirportTransfer = {
  __typename?: 'AirportTransfer';
  airline: Scalars['String']['output'];
  arrivalDate: Scalars['Date']['output'];
  arrivalTime: Scalars['Time']['output'];
  departureDate: Scalars['Date']['output'];
  departureTime: Scalars['Time']['output'];
  flightNumber: Scalars['String']['output'];
  gatewayCodeFrom: Scalars['String']['output'];
  gatewayCodeTo: Scalars['String']['output'];
  gatewayFrom?: Maybe<Gateway>;
  gatewayTo?: Maybe<Gateway>;
  pnrLocator?: Maybe<Scalars['String']['output']>;
};

export type AirportTransferInput = {
  airline: Scalars['String']['input'];
  arrivalDate: Scalars['Date']['input'];
  arrivalTime: Scalars['Time']['input'];
  departureDate: Scalars['Date']['input'];
  departureTime: Scalars['Time']['input'];
  flightNumber: Scalars['String']['input'];
  gatewayCodeFrom: Scalars['String']['input'];
  gatewayCodeTo: Scalars['String']['input'];
  pnrLocator?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a grouping of money unique by currency code */
export type Amount = {
  __typename?: 'Amount';
  cad?: Maybe<Money>;
  currencies: Array<CurrencyCode>;
  usd?: Maybe<Money>;
  value: Array<Money>;
};

/** Input for answering a free text question */
export type AnswerFreeTextQuestionInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['ObjectId']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Input for answering a matrix question */
export type AnswerMatrixQuestionInput = {
  questionId: Scalars['ObjectId']['input'];
  rows: Array<AnswerMatrixRowInput>;
};

/** Input for answering a matrix row */
export type AnswerMatrixRowInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  choiceId: Scalars['ObjectId']['input'];
  rowId: Scalars['ObjectId']['input'];
};

/** Input for answering a multiple choice question */
export type AnswerMultipleChoiceQuestionInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  choiceId: Scalars['ObjectId']['input'];
  questionId: Scalars['ObjectId']['input'];
};

/** API Key used for auth with x-api-key header */
export type ApiKey = {
  __typename?: 'ApiKey';
  _id: Scalars['ObjectId']['output'];
  description: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleIds: Array<Scalars['ObjectId']['output']>;
};

/** API Keys only return the generated key at creation. It will never be available again after */
export type ApiKeyResult = {
  __typename?: 'ApiKeyResult';
  /** The created API key */
  apiKey: ApiKey;
  /** The generated token to use with a basic auth header */
  token: Scalars['String']['output'];
};

export type ApplyGcDeparturePrivateGroupFeeResult = ApplyGcDeparturePrivateGroupFeeSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidFeeError | InvalidGcDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type ApplyGcDeparturePrivateGroupFeeSuccess = {
  __typename?: 'ApplyGCDeparturePrivateGroupFeeSuccess';
  data: Array<Booking>;
};

/** Represents an asset, most commonly images */
export type Asset = {
  __typename?: 'Asset';
  _id: Scalars['ObjectId']['output'];
  filename: Scalars['String']['output'];
  folderId?: Maybe<Scalars['ObjectId']['output']>;
  key: Scalars['String']['output'];
  location: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  tags: Array<Scalars['String']['output']>;
};

/** Filters for asset query */
export type AssetFilterInput = {
  businessCode?: InputMaybe<BusinessCode>;
  folderId?: InputMaybe<Scalars['ObjectId']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A paginated set of Assets */
export type AssetPaginatedResult = {
  __typename?: 'AssetPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Asset>;
};

/** A room with assigned roommates (or a single) */
export type AssignedRoom = {
  __typename?: 'AssignedRoom';
  bedCode: Scalars['String']['output'];
  trips: Array<BookingTrip>;
};

/** The user that made the change. */
export type AuditIdentity = {
  __typename?: 'AuditIdentity';
  _id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /** The user that made the change. Returns null if the user is not found or the type is not a system user. */
  user?: Maybe<User>;
};

/** A booked order */
export type Booking = Order & {
  __typename?: 'Booking';
  _id: Scalars['ObjectId']['output'];
  /** The active payment plan attached to the order. */
  activePaymentSchedule?: Maybe<PaymentSchedule>;
  /** The amount paid on the booking. */
  amountPaid: Money;
  /** The payment methods available when enrolling the booking on autopay. */
  autopayPaymentMethods: Array<BookingAllowedPaymentMethodType>;
  /** The available balance for each payment method. */
  availablePaymentBalanceByPaymentMethod?: Maybe<Array<PaymentBalanceByPaymentMethod>>;
  /** The remaining balance of the booking. */
  balance: Money;
  /** Where the order was booked. */
  bookingMethod: BookingMethod;
  businessCode: BusinessCode;
  canEnrollInAutopay: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The currency code of the order. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer who initiated the booking. */
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  /** The date the booking was made. */
  dateBooked: Scalars['DateTime']['output'];
  departure?: Maybe<Departure>;
  /** The departure id of the order. */
  departureId: Scalars['ObjectId']['output'];
  /** The extended date the final payment is due for the order. */
  extendedFinalPaymentDate?: Maybe<Scalars['Date']['output']>;
  /** The date the final installment for app is due for the order. */
  finalInstallmentDate: Scalars['Date']['output'];
  /** The date the final payment is due for the order. */
  finalPaymentDate: Scalars['Date']['output'];
  gcDeparture?: Maybe<GcDeparture>;
  /** The id of the gc departure associated with the order. */
  gcDepartureId?: Maybe<Scalars['ObjectId']['output']>;
  /** The total amount of the booking. This includes all line items and fees. */
  grandTotal: Money;
  /** Sum of all line item prices without discounts applied */
  grandTotalBeforeDiscount: Money;
  /** Sum of all line items excluding flights */
  grandTotalWithoutFlights: Money;
  /** Whether or not the booking has a positive balance. */
  hasBalanceRemaining: Scalars['Boolean']['output'];
  /** Whether or not the order has an automatic payment plan that has been COMPLETED. */
  hasCompletePaymentPlan: Scalars['Boolean']['output'];
  /** Whether or not the order has an automatic payment plan that is ACTIVE or PENDING. */
  hasOpenPaymentPlan: Scalars['Boolean']['output'];
  /** Whether or not the order has automatic payment plan that is ACTIVE, PENDING, or COMPLETED. */
  isEnrolledInAutopay: Scalars['Boolean']['output'];
  /** Indicates if the final payment date has been extended. */
  isFinalPaymentDateExtended: Scalars['Boolean']['output'];
  lastSuccsessfulAutopayTransactionDate?: Maybe<Scalars['DateTime']['output']>;
  /** The latest date the final installment for app is due for the order. */
  latestFinalInstallmentDate: Scalars['Date']['output'];
  /** The latest date the final payment is due for the order. */
  latestFinalPaymentDate: Scalars['Date']['output'];
  /** The minimum amount owed today on the booking. */
  minimumAmountDue: Money;
  opportunityId?: Maybe<Scalars['String']['output']>;
  paymentOptions: Array<BookingPaymentOption>;
  /** The payment plans attached to the order. */
  paymentSchedules: Array<PaymentSchedule>;
  /** The order that this order was rebooked from. */
  rebookedFromOrder?: Maybe<Order>;
  /** The order id that this order was rebooked from. */
  rebookedFromOrderId?: Maybe<Scalars['ObjectId']['output']>;
  /** The risk free period end date. */
  riskFreePeriodEndDate?: Maybe<Scalars['Date']['output']>;
  /** The stage of the order. */
  stage: OrderStage;
  /** Sum of all discount line items */
  totalDiscount: Money;
  tourLineItemCode?: Maybe<Scalars['LineItemCode']['output']>;
  /** The transactions applied to the order, sorted by ascending transaction date. */
  transactions: Array<PaymentTransaction>;
  /** The transferable and non transferable payment amounts for each payment method used in confirmed or pending transactions. */
  transferableAmounts: TransferableAmount;
  trips: Array<BookingTrip>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The version of the order. */
  versionId: Scalars['Int']['output'];
};

/** The type of payment methods allowed for a Booking */
export enum BookingAllowedPaymentMethodType {
  Ach = 'ACH',
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD'
}

export type BookingAutopayPaymentOption = {
  __typename?: 'BookingAutopayPaymentOption';
  allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>;
  earliestPaymentScheduleStartDate: Scalars['Date']['output'];
  latestPaymentScheduleStartDate: Scalars['Date']['output'];
  type: BookingPaymentOptionType;
};

export type BookingManualPaymentOption = {
  __typename?: 'BookingManualPaymentOption';
  allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>;
  type: BookingPaymentOptionType;
};

export enum BookingMethod {
  Mobile = 'MOBILE',
  Offline = 'OFFLINE',
  Web = 'WEB'
}

export type BookingPaginatedResult = {
  __typename?: 'BookingPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Booking>;
};

export type BookingPaymentOption = BookingAutopayPaymentOption | BookingManualPaymentOption;

/** The type of payment options for a Booking */
export enum BookingPaymentOptionType {
  AutoPay = 'AUTO_PAY',
  Manual = 'MANUAL'
}

export enum BookingSortField {
  BusinessCode = 'businessCode',
  DateBooked = 'dateBooked'
}

/** Represents a trip on a booking order */
export type BookingTrip = Trip & {
  __typename?: 'BookingTrip';
  _id: Scalars['ObjectId']['output'];
  /** The address for the trip. */
  address?: Maybe<Address>;
  booking?: Maybe<Booking>;
  businessCode?: Maybe<BusinessCode>;
  /** Whether the trip is within the cutoff date range for reviews */
  canBeReviewed?: Maybe<Scalars['Boolean']['output']>;
  cancellationMeta?: Maybe<TripCancellationMeta>;
  checklistItems: Array<TripChecklistItem>;
  /** Offers that can be applied to the trip but are not specific to a single component. Flight package offers are not included. */
  conditionalOffers: Array<ConditionalOffer>;
  /** The currency code of the trip. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer id of the trip. */
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  customerType: TripCustomerType;
  dateBooked: Scalars['DateTime']['output'];
  /** Offers for departing flights that can be added to the trip. */
  departingFlightOffers: Array<FlightOffer>;
  departure?: Maybe<Departure>;
  departureDate: Scalars['Date']['output'];
  /** The deposit amount for the trip. */
  depositAmount: Money;
  /** Checklist item for whether or not the trip has emergency contacts */
  emergencyContactChecklistItem?: Maybe<EmergencyContactChecklistItem>;
  /** The emergency contacts for the trip. */
  emergencyContacts?: Maybe<Array<EmergencyContact>>;
  emergencyContactsSelfServiceDeadline?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['Date']['output'];
  evaluation?: Maybe<CustomerEvaluation>;
  evaluationRelease?: Maybe<ReleaseDetails>;
  /** Offers for excursions that can be added to the trip. Includes extension excursions if the trip is booked on the extension. */
  excursionOffers: Array<DepartureExcursionOffer>;
  /** The departure excursions and extension excursions for the open excursion line items on this trip */
  excursions: Array<DepartureExcursion>;
  /** Sum of all open excursion line items */
  excursionsTotal: Money;
  /** The departure extension for the open extension line item on this trip */
  extension?: Maybe<DepartureExtension>;
  /** Offer for an extension that can be added to the trip. */
  extensionOffer?: Maybe<DepartureExtensionOffer>;
  /** The departure room for the open extension room line item on this trip */
  extensionRoom?: Maybe<DepartureRoom>;
  extensionRoommates?: Maybe<Array<Customer>>;
  flightPackagePrice?: Maybe<Money>;
  flights?: Maybe<TripFlights>;
  grandTotal: Money;
  hasAddress: Scalars['Boolean']['output'];
  hasConfirmedExcursions: Scalars['Boolean']['output'];
  hasConfirmedTSAInformation: Scalars['Boolean']['output'];
  hasDepartingFlightDeviation: Scalars['Boolean']['output'];
  hasEmergencyContacts: Scalars['Boolean']['output'];
  /** Whether the trip has an open line item for an extension */
  hasExtension: Scalars['Boolean']['output'];
  hasInsurance: Scalars['Boolean']['output'];
  hasReturningFlightDeviation: Scalars['Boolean']['output'];
  hasSignedTerms: Scalars['Boolean']['output'];
  hasTsaInformation: Scalars['Boolean']['output'];
  /** Checklist item for whether or not the trip has health notes */
  healthNotesChecklistItem?: Maybe<HealthNotesChecklistItem>;
  healthNotesSelfServiceDeadline?: Maybe<Scalars['DateTime']['output']>;
  hotels?: Maybe<Array<TripHotel>>;
  insurancePlanOffers: Array<InsurancePlanOffer>;
  /** Whether the trip is cancelled. */
  isCancelled: Scalars['Boolean']['output'];
  /** Whether the trip is confirmed. */
  isConfirmed: Scalars['Boolean']['output'];
  isLandOnly: Scalars['Boolean']['output'];
  /** Whether the trip is open. */
  isOpen: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  /** Whether the trip is quoted. */
  isQuoted: Scalars['Boolean']['output'];
  /** Whether the trip is rebooked. */
  isRebooked: Scalars['Boolean']['output'];
  /** Whether the trip is requested. */
  isRequested: Scalars['Boolean']['output'];
  isTravelReady: Scalars['Boolean']['output'];
  /** Whether the trip is waitlisted. */
  isWaitlisted: Scalars['Boolean']['output'];
  /** The line items that compose the trip. */
  lineItems: Array<LineItem>;
  /** The REBOOKED + OPEN line items if the trip is rebooked, the CANCELLED + OPEN line items with PARENT_TRIP_CANCELLED cancellation metadata if the trip is cancelled, or the open line items in all other cases.  */
  lineItemsMatchingTripStatus: Array<LineItem>;
  locator: Scalars['String']['output'];
  openAdjustmentLineItems: Array<AdjustmentLineItem>;
  openDepartingFlightLineItem?: Maybe<FlightPackageLineItem>;
  openExcursionLineItems: Array<TourExcursionLineItem>;
  openExtensionLineItem?: Maybe<TourExtensionLineItem>;
  openExtensionRoomLineItem?: Maybe<TourRoomLineItem>;
  openFeeLineItems: Array<FeeLineItem>;
  openInsuranceAddonLineItems: Array<InsuranceAddonLineItem>;
  openInsuranceLineItem?: Maybe<InsuranceLineItem>;
  /** The line items that compose the trip which are not CANCELLED or REBOOKED */
  openLineItems: Array<LineItem>;
  openPostStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPreStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPrivateGroupLineItem?: Maybe<PrivateGroupLineItem>;
  openPromoLineItems: Array<PromoLineItem>;
  openReturningFlightLineItem?: Maybe<FlightPackageLineItem>;
  openRoomLineItem?: Maybe<TourRoomLineItem>;
  /** Checklist item for whether or not the trip has passport information */
  passportInformationChecklistItem?: Maybe<PassportInformationChecklistItem>;
  passportInformationSelfServiceDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** The trip ID for the trip that this trip was rebooked from. */
  rebookedFromTripId?: Maybe<Scalars['ObjectId']['output']>;
  rebookingMeta?: Maybe<TripRebookingMeta>;
  requestedRoommates?: Maybe<Array<Scalars['String']['output']>>;
  requestedTravelCompanions?: Maybe<Array<Scalars['String']['output']>>;
  /** Offers for returning flights that can be added to the trip. */
  returningFlightOffers: Array<FlightOffer>;
  review?: Maybe<Review>;
  /** The departure room for the open room line item on this trip */
  room?: Maybe<DepartureRoom>;
  /** Offers for rooms that can be added to the trip. Includes extension rooms if the trip is booked on the extension. */
  roomOffers: Array<DepartureRoomOffer>;
  roommates?: Maybe<Array<Customer>>;
  serviceRecoveries: Array<ServiceRecovery>;
  signedTerms?: Maybe<Term>;
  /** The status of the trip */
  status: TripStatus;
  termsAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  termsSignature?: Maybe<TermsSignature>;
  /** Checklist item for whether or not the trip has signed terms */
  termsSignatureChecklistItem?: Maybe<TermsSignatureChecklistItem>;
  timingStatus: TripTimingStatus;
  tourLineItem?: Maybe<TourLineItem>;
  travelerNotes?: Maybe<TravelerNotes>;
  /** Checklist item for whether or not the trip has confirmed TSA identifiers */
  tsaIdentifiersChecklistItem?: Maybe<TsaIdentifiersChecklistItem>;
  tsaIdentifiersSelfServiceDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** The TSA information for the trip. */
  tsaInformation?: Maybe<TsaInformation>;
};

export type BulkCreateDepartureExcursionInput = {
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  matchCode: Scalars['String']['input'];
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkCreateDepartureExcursionsResult = BulkCreateDepartureExcursionsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureExcursionsSuccess = {
  __typename?: 'BulkCreateDepartureExcursionsSuccess';
  data: Array<Departure>;
};

export type BulkCreateDepartureExtensionExcursionInput = {
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  extensionTourCode: Scalars['String']['input'];
  matchCode: Scalars['String']['input'];
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkCreateDepartureExtensionExcursionsResult = BulkCreateDepartureExtensionExcursionsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureExtensionExcursionsSuccess = {
  __typename?: 'BulkCreateDepartureExtensionExcursionsSuccess';
  data: Array<Departure>;
};

export type BulkCreateDepartureExtensionInput = {
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  extensionTourCode: Scalars['String']['input'];
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkCreateDepartureExtensionRoomInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  /** Extension tour code of the departure */
  extensionTourCode: Scalars['String']['input'];
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  /** Tour code of the departure */
  tourCode: Scalars['String']['input'];
};

export type BulkCreateDepartureExtensionRoomsResult = BulkCreateDepartureExtensionRoomsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureExtensionRoomsSuccess = {
  __typename?: 'BulkCreateDepartureExtensionRoomsSuccess';
  data: Array<Departure>;
};

export type BulkCreateDepartureExtensionsResult = BulkCreateDepartureExtensionsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureExtensionsSuccess = {
  __typename?: 'BulkCreateDepartureExtensionsSuccess';
  data: Array<Departure>;
};

export type BulkCreateDepartureInput = {
  addonPrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  departureDate: Scalars['Date']['input'];
  exclusivityType: DepartureExclusivityType;
  extensionTourCode?: InputMaybe<Scalars['String']['input']>;
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  status: DepartureStatus;
  tourCode: Scalars['String']['input'];
};

export type BulkCreateDepartureNotesInput = {
  businessCode: BusinessCode;
  departureDate: Scalars['Date']['input'];
  note: Scalars['String']['input'];
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkCreateDepartureNotesResult = BulkCreateDepartureNotesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureNotesSuccess = {
  __typename?: 'BulkCreateDepartureNotesSuccess';
  data: Array<Departure>;
};

export type BulkCreateDepartureRoomInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkCreateDepartureRoomsResult = BulkCreateDepartureRoomsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureRoomsSuccess = {
  __typename?: 'BulkCreateDepartureRoomsSuccess';
  data: Array<Departure>;
};

export type BulkCreateDeparturesResult = BulkCreateDeparturesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDeparturesSuccess = {
  __typename?: 'BulkCreateDeparturesSuccess';
  data: Array<Departure>;
};

export type BulkCreateFlightPackagesInput = {
  businessCode: BusinessCode;
  flightPackages: Array<BulkFlightPackageInput>;
};

export type BulkCreateFlightPackagesResult = BulkCreateFlightPackagesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidFlightPackageError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateFlightPackagesSuccess = {
  __typename?: 'BulkCreateFlightPackagesSuccess';
  data: Array<FlightPackage>;
};

/** Input for creating a gc departure prospect */
export type BulkCreateGcDepartureProspectsInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gcDepartureId: Scalars['ObjectId']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  levelOfInterest?: InputMaybe<GcDepartureProspectLevelOfInterest>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type BulkCreateGcDepartureProspectsResult = BulkCreateGcDepartureProspectsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidGcDepartureError | InvalidGcDepartureProspectError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateGcDepartureProspectsSuccess = {
  __typename?: 'BulkCreateGCDepartureProspectsSuccess';
  data: Array<GcDepartureProspect>;
};

export type BulkCreatePrivateGroupsInput = {
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  priceYear: Scalars['Int']['input'];
  rollsUpToTarget?: Scalars['Boolean']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkCreatePrivateGroupsResult = BulkCreatePrivateGroupsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | InvalidPrivateGroupError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreatePrivateGroupsSuccess = {
  __typename?: 'BulkCreatePrivateGroupsSuccess';
  data: Array<Tour>;
};

/** Input type for bulk creating promo audience members */
export type BulkCreatePromoAudienceMemberInput = {
  businessCode: BusinessCode;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  offerCode: Scalars['String']['input'];
};

export type BulkCreatePromoAudienceMembersResult = BulkCreatePromoAudienceMembersSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPromoError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreatePromoAudienceMembersSuccess = {
  __typename?: 'BulkCreatePromoAudienceMembersSuccess';
  data: Array<PromoAudienceMember>;
};

export type BulkCreatePromoTargetInput = {
  amount: Array<MoneyInput>;
  businessCode: BusinessCode;
  componentType: TripComponentType;
  departureDateFrom?: InputMaybe<Scalars['Date']['input']>;
  departureDateTo?: InputMaybe<Scalars['Date']['input']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']['input']>;
  offerCode: Scalars['String']['input'];
  series?: InputMaybe<Scalars['Series']['input']>;
};

export type BulkCreatePromoTargetsResult = BulkCreatePromoTargetsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPromoError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreatePromoTargetsSuccess = {
  __typename?: 'BulkCreatePromoTargetsSuccess';
  data: Array<Promo>;
};

export type BulkCreatePromosResult = BulkCreatePromosSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPromoError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreatePromosSuccess = {
  __typename?: 'BulkCreatePromosSuccess';
  data: Array<Promo>;
};

export type BulkFlightPackageInput = {
  arrivalGatewayCode: Scalars['String']['input'];
  basePrice: Array<MoneyInput>;
  departureGatewayCode: Scalars['String']['input'];
  isCustomGateway: Scalars['Boolean']['input'];
};

/** Update the targets of a promo */
export type BulkRemovePromoAudienceMembersInput = {
  businessCode: BusinessCode;
  /** The offer code of the promo to delete audience members from */
  offerCode: Scalars['String']['input'];
};

export type BulkRemovePromoAudienceMembersResult = BulkRemovePromoAudienceMembersSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPromoError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkRemovePromoAudienceMembersSuccess = {
  __typename?: 'BulkRemovePromoAudienceMembersSuccess';
  data: Array<PromoAudienceMember>;
};

export type BulkUpdateDepartureExcursionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']['input']>;
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  matchCode: Scalars['String']['input'];
  minNbTravelersRequired?: InputMaybe<Scalars['Int']['input']>;
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  status?: InputMaybe<DepartureStatus>;
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateDepartureExcursionsResult = BulkUpdateDepartureExcursionsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureExcursionsSuccess = {
  __typename?: 'BulkUpdateDepartureExcursionsSuccess';
  data: Array<Departure>;
};

export type BulkUpdateDepartureExtensionExcursionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']['input']>;
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  /** Extension tour code of the departure */
  extensionTourCode: Scalars['String']['input'];
  matchCode: Scalars['String']['input'];
  minNbTravelersRequired?: InputMaybe<Scalars['Int']['input']>;
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  status?: InputMaybe<DepartureStatus>;
  /** Tour code of the departure */
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateDepartureExtensionExcursionsResult = BulkUpdateDepartureExtensionExcursionsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureExtensionExcursionsSuccess = {
  __typename?: 'BulkUpdateDepartureExtensionExcursionsSuccess';
  data: Array<Departure>;
};

export type BulkUpdateDepartureExtensionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']['input']>;
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  /** Extension tour code of the departure */
  extensionTourCode: Scalars['String']['input'];
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  status?: InputMaybe<DepartureStatus>;
  /** Tour code of the departure */
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateDepartureExtensionRoomInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  /** Extension tour code of the departure */
  extensionTourCode: Scalars['String']['input'];
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  status?: InputMaybe<DepartureStatus>;
  /** Tour code of the departure */
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateDepartureExtensionRoomsResult = BulkUpdateDepartureExtensionRoomsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureExtensionRoomsSuccess = {
  __typename?: 'BulkUpdateDepartureExtensionRoomsSuccess';
  data: Array<Departure>;
};

export type BulkUpdateDepartureExtensionsResult = BulkUpdateDepartureExtensionsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureExtensionsSuccess = {
  __typename?: 'BulkUpdateDepartureExtensionsSuccess';
  data: Array<Departure>;
};

export type BulkUpdateDepartureInput = {
  addonPrice?: InputMaybe<Array<MoneyInput>>;
  autoApproveDeadline?: InputMaybe<Scalars['Date']['input']>;
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  exclusivityType?: InputMaybe<DepartureExclusivityType>;
  finalInstallmentDeadline?: InputMaybe<Scalars['Date']['input']>;
  finalPaymentDeadline?: InputMaybe<Scalars['Date']['input']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  priceYear: Scalars['Int']['input'];
  reservedCapacity?: InputMaybe<Scalars['Int']['input']>;
  series: Scalars['Series']['input'];
  status?: InputMaybe<DepartureStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateDepartureOwnerInput = {
  businessCode: BusinessCode;
  departureDate: Scalars['Date']['input'];
  ownerEmail?: InputMaybe<Scalars['Email']['input']>;
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateDepartureOwnersResult = BulkUpdateDepartureOwnersSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureOwnersSuccess = {
  __typename?: 'BulkUpdateDepartureOwnersSuccess';
  data: Array<Departure>;
};

export type BulkUpdateDepartureRoomInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['Date']['input'];
  priceYear: Scalars['Int']['input'];
  series: Scalars['Series']['input'];
  status?: InputMaybe<DepartureStatus>;
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateDepartureRoomsResult = BulkUpdateDepartureRoomsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureRoomsSuccess = {
  __typename?: 'BulkUpdateDepartureRoomsSuccess';
  data: Array<Departure>;
};

export type BulkUpdateDeparturesResult = BulkUpdateDeparturesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDeparturesSuccess = {
  __typename?: 'BulkUpdateDeparturesSuccess';
  data: Array<Departure>;
};

export type BulkUpdateExtendedStayPriceRulesInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cityGatewayCode: Scalars['String']['input'];
  priceRules: Array<PriceRuleInput>;
};

export type BulkUpdateExtendedStayPriceRulesResult = BulkUpdateExtendedStayPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateExtendedStayPriceRulesSuccess = {
  __typename?: 'BulkUpdateExtendedStayPriceRulesSuccess';
  data: Array<ExtendedStay>;
};

export type BulkUpdateFeePriceRulesInput = {
  businessCode: BusinessCode;
  categoryCode: Scalars['FeeCategoryCode']['input'];
  priceRules: Array<PriceRuleInput>;
  typeCode: FeeTypeCode;
};

export type BulkUpdateFeePriceRulesResult = BulkUpdateFeePriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateFeePriceRulesSuccess = {
  __typename?: 'BulkUpdateFeePriceRulesSuccess';
  data: Array<Fee>;
};

export type BulkUpdateFlightPackagePriceRulesInput = {
  arrivalGatewayCode: Scalars['String']['input'];
  businessCode: BusinessCode;
  departureGatewayCode: Scalars['String']['input'];
  priceRules: Array<PriceRuleInput>;
};

export type BulkUpdateFlightPackagePriceRulesResult = BulkUpdateFlightPackagePriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateFlightPackagePriceRulesSuccess = {
  __typename?: 'BulkUpdateFlightPackagePriceRulesSuccess';
  data: Array<FlightPackage>;
};

export type BulkUpdateInsurancePlanAddonPriceRulesInput = {
  addonPlanCode: Scalars['String']['input'];
  businessCode: BusinessCode;
  planCode: Scalars['String']['input'];
  priceRules: Array<PriceRuleInput>;
};

export type BulkUpdateInsurancePlanAddonPriceRulesResult = BulkUpdateInsurancePlanAddonPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateInsurancePlanAddonPriceRulesSuccess = {
  __typename?: 'BulkUpdateInsurancePlanAddonPriceRulesSuccess';
  data: Array<InsurancePlan>;
};

export type BulkUpdateInsurancePlanPriceRulesInput = {
  businessCode: BusinessCode;
  planCode: Scalars['String']['input'];
  priceRules: Array<PriceRuleInput>;
};

export type BulkUpdateInsurancePlanPriceRulesResult = BulkUpdateInsurancePlanPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateInsurancePlanPriceRulesSuccess = {
  __typename?: 'BulkUpdateInsurancePlanPriceRulesSuccess';
  data: Array<InsurancePlan>;
};

export type BulkUpdatePrivateGroupPriceRulesInput = {
  businessCode: BusinessCode;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkUpdatePrivateGroupPriceRulesResult = BulkUpdatePrivateGroupPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | InvalidPrivateGroupError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdatePrivateGroupPriceRulesSuccess = {
  __typename?: 'BulkUpdatePrivateGroupPriceRulesSuccess';
  data: Array<Tour>;
};

export type BulkUpdatePrivateGroupsInput = {
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  priceYear: Scalars['Int']['input'];
  rollsUpToTarget?: Scalars['Boolean']['input'];
  status?: InputMaybe<TripComponentStatus>;
  tourCode: Scalars['String']['input'];
};

export type BulkUpdatePrivateGroupsResult = BulkUpdatePrivateGroupsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | InvalidPrivateGroupError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdatePrivateGroupsSuccess = {
  __typename?: 'BulkUpdatePrivateGroupsSuccess';
  data: Array<Tour>;
};

export type BulkUpdatePromoInput = {
  businessCode: BusinessCode;
  displayName?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  exclusivity?: InputMaybe<PromoExclusivity>;
  isGroupsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenFromSales?: InputMaybe<Scalars['Boolean']['input']>;
  isIndiesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isShareable?: InputMaybe<Scalars['Boolean']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  offerCode: Scalars['String']['input'];
  promoCategory?: InputMaybe<PromoCategory>;
  status?: InputMaybe<TripComponentStatus>;
};

export type BulkUpdatePromosResult = BulkUpdatePromosSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPromoError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdatePromosSuccess = {
  __typename?: 'BulkUpdatePromosSuccess';
  data: Array<Promo>;
};

export type BulkUpdateTourExcursionInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  matchCode: Scalars['String']['input'];
  /** The minimum number of travelers required for this excursion to be confirmed. */
  minNbTravelersRequired?: InputMaybe<Scalars['Int']['input']>;
  priceYear: Scalars['Int']['input'];
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type BulkUpdateTourExcursionPriceRulesInput = {
  businessCode: BusinessCode;
  matchCode: Scalars['String']['input'];
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int']['input'];
};

export type BulkUpdateTourExcursionPriceRulesResult = BulkUpdateTourExcursionPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExcursionPriceRulesSuccess = {
  __typename?: 'BulkUpdateTourExcursionPriceRulesSuccess';
  data: Array<TourExcursion>;
};

export type BulkUpdateTourExcursionsResult = BulkUpdateTourExcursionsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExcursionsSuccess = {
  __typename?: 'BulkUpdateTourExcursionsSuccess';
  data: Array<TourExcursion>;
};

export type BulkUpdateTourExtensionInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  /** The default capacity that will set for Departures created from this Tour Extension. */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPreExtension?: InputMaybe<Scalars['Boolean']['input']>;
  minimumCapacity?: InputMaybe<Scalars['Int']['input']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  priceYear: Scalars['Int']['input'];
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateTourExtensionPriceRulesInput = {
  businessCode: BusinessCode;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateTourExtensionPriceRulesResult = BulkUpdateTourExtensionPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionPriceRulesSuccess = {
  __typename?: 'BulkUpdateTourExtensionPriceRulesSuccess';
  data: Array<TourExtension>;
};

export type BulkUpdateTourExtensionRoomInput = {
  basePrice?: InputMaybe<Array<MoneyInput>>;
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  /** The capacity that will set for Departure Rooms created from this Tour Extension Room. */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not roommate matching is needed for this room */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']['input']>;
  priceYear: Scalars['Int']['input'];
  status?: InputMaybe<TripComponentStatus>;
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateTourExtensionRoomPriceRulesInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateTourExtensionRoomPriceRulesResult = BulkUpdateTourExtensionRoomPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionRoomPriceRulesSuccess = {
  __typename?: 'BulkUpdateTourExtensionRoomPriceRulesSuccess';
  data: Array<TourExtension>;
};

export type BulkUpdateTourExtensionRoomsResult = BulkUpdateTourExtensionRoomsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionRoomsSuccess = {
  __typename?: 'BulkUpdateTourExtensionRoomsSuccess';
  data: Array<TourExtension>;
};

export type BulkUpdateTourExtensionsResult = BulkUpdateTourExtensionsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionsSuccess = {
  __typename?: 'BulkUpdateTourExtensionsSuccess';
  data: Array<TourExtension>;
};

export type BulkUpdateTourInput = {
  activityLevel?: InputMaybe<Scalars['Int']['input']>;
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  classLevel?: InputMaybe<Scalars['Int']['input']>;
  /** The default capacity that will set for Departures created from this Tour. */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  deposit?: InputMaybe<Array<MoneyInput>>;
  depositForAutomaticPlan?: InputMaybe<Array<MoneyInput>>;
  depositForLateAdd?: InputMaybe<Array<MoneyInput>>;
  feeCategoryCode?: InputMaybe<Scalars['FeeCategoryCode']['input']>;
  finalInstallmentDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  finalPaymentDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isNonRevenueTour?: InputMaybe<Scalars['Boolean']['input']>;
  isPassportRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isVisaRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  minimumCapacity?: InputMaybe<Scalars['Int']['input']>;
  nbDepartureFlightDays?: InputMaybe<Scalars['Int']['input']>;
  nbReturningFlightDays?: InputMaybe<Scalars['Int']['input']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  priceYear: Scalars['Int']['input'];
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateTourPriceRulesInput = {
  businessCode: BusinessCode;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateTourPriceRulesResult = BulkUpdateTourPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourPriceRulesSuccess = {
  __typename?: 'BulkUpdateTourPriceRulesSuccess';
  data: Array<Tour>;
};

export type BulkUpdateTourRoomInput = {
  basePrice?: InputMaybe<Array<MoneyInput>>;
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  /** The capacity that will set for Departure Rooms created from this Tour Room.  */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not roommate matching is needed for this room */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']['input']>;
  priceYear: Scalars['Int']['input'];
  status?: InputMaybe<TripComponentStatus>;
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateTourRoomPriceRulesInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int']['input'];
  tourCode: Scalars['String']['input'];
};

export type BulkUpdateTourRoomPriceRulesResult = BulkUpdateTourRoomPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourRoomPriceRulesSuccess = {
  __typename?: 'BulkUpdateTourRoomPriceRulesSuccess';
  data: Array<Tour>;
};

export type BulkUpdateTourRoomsResult = BulkUpdateTourRoomsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourRoomsSuccess = {
  __typename?: 'BulkUpdateTourRoomsSuccess';
  data: Array<Tour>;
};

export type BulkUpdateToursResult = BulkUpdateToursSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateToursSuccess = {
  __typename?: 'BulkUpdateToursSuccess';
  data: Array<Tour>;
};

/** Represents a business tenant */
export type Business = {
  __typename?: 'Business';
  /** The unique identifier of the business */
  _id: Scalars['ObjectId']['output'];
  code: BusinessCode;
  name: Scalars['String']['output'];
  priceYears: Array<PriceYear>;
  settings: BusinessSettings;
};

export enum BusinessCode {
  Adv = 'ADV',
  Gat = 'GAT',
  Ub = 'UB'
}

/** The CurrentUser is not authorized to perform the requested action */
export type BusinessNotSpecifiedError = DomainError & {
  __typename?: 'BusinessNotSpecifiedError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Object that represents settings specific to a business */
export type BusinessSettings = {
  __typename?: 'BusinessSettings';
  chat: ChatSettings;
  departures: DepartureSettings;
  evaluations: EvaluationSettings;
  fees: FeeSettings;
  flights: FlightSettings;
  gcDepartures: GcDepartureSettings;
  groupTripChecklists: GroupTripChecklistSettings;
  insurance: InsuranceSettings;
  integrations?: Maybe<IntegrationSettings>;
  orders: OrderSettings;
  promos: PromoSettings;
  reviews: ReviewSettings;
  supportTickets: SupportTicketSettings;
  tripChecklists: TripChecklistSettings;
  tsa: TsaSettings;
};

export type CalculatePaymentScheduleInput = {
  frequency: PaymentScheduleFrequency;
  /** An initial amount paid that will discount the payments in the schedule. */
  initialPayment?: InputMaybe<MoneyInput>;
  /** The date of the first scheduled payment. Defaults to the earliest allowed first payment date. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CalculatePaymentScheduleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPaymentScheduleError | NotAuthorizedError | NotFoundError | PaymentSchedule | ValidationError;

/** A collection of promotions that are conditionally applied. */
export type Campaign = {
  __typename?: 'Campaign';
  _id: Scalars['ObjectId']['output'];
  campaignCode: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /** The date when the promo is applicable and can be used */
  effectiveFrom: Scalars['DateTime']['output'];
  /** The date when the promo expires and is no longer valid. */
  effectiveTo: Scalars['DateTime']['output'];
  isValid: Scalars['Boolean']['output'];
  /** The number of promos associated with the campaign. */
  nbPromos?: Maybe<Scalars['Int']['output']>;
  promoIds: Array<Scalars['ObjectId']['output']>;
  status: CampaignStatus;
};

/** A paginated result of campaigns. */
export type CampaignPaginatedResult = {
  __typename?: 'CampaignPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Campaign>;
};

export enum CampaignStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type CancelDraftBookingInput = {
  /** The draft booking ID */
  _id: Scalars['ObjectId']['input'];
  /** The business reason for the cancellation */
  cancellationCategory: TripCancellationCategory;
  /** A free-text reason for the cancellation */
  cancellationReason: Scalars['String']['input'];
  /** Whether or not to waive the cancellation fee */
  waiveFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelDraftBookingPaymentScheduleResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | InvalidPaymentError | NotAuthorizedError | NotFoundError | ValidationError;

export type CancelDraftBookingResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type CancelDraftBookingTripsInput = {
  /** The draft booking ID */
  _id: Scalars['ObjectId']['input'];
  /** The business reason for the cancellation */
  cancellationCategory: TripCancellationCategory;
  /** A free-text reason for the cancellation */
  cancellationReason: Scalars['String']['input'];
  /** The new primary trip ID, if the primary trip is being cancelled but not all trips are being cancelled */
  newPrimaryTripId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** The trip IDs to cancel */
  tripIds: Array<Scalars['ObjectId']['input']>;
  /** Whether or not to waive the cancellation fee */
  waiveFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelDraftBookingTripsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type CancelGcDepartureInput = {
  /** The ID of the GC Departure to cancel */
  _id: Scalars['ObjectId']['input'];
  /** The business reason for cancelling the GC Departure */
  cancellationCategory: GcDepartureCancellationCategory;
  /** The reason for cancelling the GC Departure */
  reason: Scalars['String']['input'];
};

export type CancelGcDepartureResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidGcDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export enum CardBrand {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Mastercard = 'MASTERCARD',
  Unknown = 'UNKNOWN',
  Visa = 'VISA'
}

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  address?: Maybe<Address>;
  cardBrand: CardBrand;
  cardNumberMask: Scalars['String']['output'];
  cardType: CardType;
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  isExpired: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  processorPaymentMethodId?: Maybe<Scalars['Int']['output']>;
};

export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Unknown = 'UNKNOWN'
}

/** A category organizes tags into a hierarchy */
export type Category = {
  __typename?: 'Category';
  _id: Scalars['ObjectId']['output'];
  businessCode?: Maybe<BusinessCode>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tags: Array<Tag>;
};

/** A paginated set of Categories */
export type CategoryPaginatedResult = {
  __typename?: 'CategoryPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Category>;
};

/** Inputs necessary to change the expiration date of a voucher */
export type ChangeVoucherExpirationInput = {
  _id: Scalars['ObjectId']['input'];
  expirationDate: Scalars['Date']['input'];
};

export type ChangeVoucherExpirationResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Chat Settings */
export type ChatSettings = {
  __typename?: 'ChatSettings';
  /** The DPD in which the chat is open for the departure, checks if the channel exists and if today is within the chat open range */
  availabilityDpd?: Maybe<Scalars['Int']['output']>;
  /** The DPD in which the tour director is available for the customer to send a direct message */
  tourDirectorDirectMessageDpd?: Maybe<Scalars['Int']['output']>;
};

export enum CheckListItemImportanceLevel {
  HighlyRecommended = 'HIGHLY_RECOMMENDED',
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED'
}

export type CheckPaymentMethod = {
  __typename?: 'CheckPaymentMethod';
  checkNumber?: Maybe<Scalars['String']['output']>;
  isFromLockbox: Scalars['Boolean']['output'];
};

export type CheckPaymentMethodInput = {
  /** The 3-6 digit number to identify the check */
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  /** Date we received the check */
  checkReceivedDate?: InputMaybe<Scalars['Date']['input']>;
  /** Was this check processed via lockbox */
  isFromLockBox?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckTripChecklistItemResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTripChecklistItemTemplateError | NotAuthorizedError | NotFoundError | TripChecklistItemState | ValidationError;

export type City = Place & {
  __typename?: 'City';
  _id: Scalars['ObjectId']['output'];
  monthlyWeathers: Array<MonthlyWeather>;
  name: Scalars['String']['output'];
  parentIds: Array<Scalars['ObjectId']['output']>;
  type: PlaceType;
};

export type ConditionalOffer = {
  __typename?: 'ConditionalOffer';
  /** The Promo Target that the trip is eligible for. */
  target: PromoTarget;
};

export type ConfirmGcDepartureResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidGcDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type ContactInfoContent = {
  __typename?: 'ContactInfoContent';
  address: ContactInfoContentAddress;
  groupSales?: Maybe<ContactInfoContentDepartment>;
  groupService?: Maybe<ContactInfoContentDepartment>;
  id: Scalars['String']['output'];
  indiesSales?: Maybe<ContactInfoContentDepartment>;
  indiesService?: Maybe<ContactInfoContentDepartment>;
  onTourSupport?: Maybe<ContactInfoContentDepartment>;
};

export type ContactInfoContentAddress = {
  __typename?: 'ContactInfoContentAddress';
  addressName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Contact information for a specific department. Null for workHours just indicates that work hours have not been configured. */
export type ContactInfoContentDepartment = {
  __typename?: 'ContactInfoContentDepartment';
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberFormatted?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workHoursFriday?: Maybe<ContactInfoContentWorkHours>;
  workHoursMonday?: Maybe<ContactInfoContentWorkHours>;
  workHoursSaturday?: Maybe<ContactInfoContentWorkHours>;
  workHoursSunday?: Maybe<ContactInfoContentWorkHours>;
  workHoursThursday?: Maybe<ContactInfoContentWorkHours>;
  workHoursTuesday?: Maybe<ContactInfoContentWorkHours>;
  workHoursWednesday?: Maybe<ContactInfoContentWorkHours>;
};

export type ContactInfoContentWorkHours = {
  __typename?: 'ContactInfoContentWorkHours';
  endTime?: Maybe<Scalars['String']['output']>;
  /** Override startTime and endTime to indicate that office is closed. */
  isClosed?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

/** Ancestor stories of content. Useful for generating breadcrumbs. */
export type ContentAncestor = {
  __typename?: 'ContentAncestor';
  fullSlug: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ContentAsset = {
  __typename?: 'ContentAsset';
  alt?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  focus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Storyblok link type */
export type ContentLink = {
  __typename?: 'ContentLink';
  cachedUrl?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkType?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Blok containing text and a link */
export type ContentTextLink = {
  __typename?: 'ContentTextLink';
  link?: Maybe<ContentLink>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Continent = Place & {
  __typename?: 'Continent';
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
  type: PlaceType;
};

export type Country = Place & {
  __typename?: 'Country';
  _id: Scalars['ObjectId']['output'];
  /** Two-letter country code as defined in ISO 3166 */
  alpha2Code: Scalars['String']['output'];
  /** Three-letter country code as defined in ISO 3166 */
  alpha3Code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentIds: Array<Scalars['ObjectId']['output']>;
  type: PlaceType;
};

export type CountryRegion = Place & {
  __typename?: 'CountryRegion';
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
  parentIds: Array<Scalars['ObjectId']['output']>;
  type: PlaceType;
};

export type CreateAdjustmentInput = {
  adjustmentCode: Scalars['String']['input'];
  businessCode: BusinessCode;
  displayName: Scalars['String']['input'];
  isRefundable?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<CreateAdjustmentMetaInput>;
  persistsOnCancelAndRebook?: InputMaybe<Scalars['Boolean']['input']>;
  rollsUpToTarget?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: Array<Scalars['ObjectId']['input']>;
};

export type CreateAdjustmentMetaInput = {
  isCompanionDiscount: Scalars['Boolean']['input'];
  isFreePlace: Scalars['Boolean']['input'];
  isStaffOnTour: Scalars['Boolean']['input'];
};

export type CreateAdjustmentResult = Adjustment | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateApiKeyInput = {
  description: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  roleIds: Array<Scalars['ObjectId']['input']>;
};

export type CreateApiKeyResult = ApiKeyResult | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateCampaignInput = {
  businessCode: BusinessCode;
  campaignCode: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo: Scalars['DateTime']['input'];
  promoIds: Array<Scalars['ObjectId']['input']>;
};

export type CreateCampaignResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Create a new category */
export type CreateCategoryInput = {
  businessCode: BusinessCode;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type CreateCategoryResult = BusinessNotSpecifiedError | Category | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Create a new customer */
export type CreateCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type CreateCustomerResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureExcursionInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  lineItemCode: Scalars['LineItemCode']['input'];
};

export type CreateDepartureExcursionResult = BusinessNotSpecifiedError | DepartureExcursion | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureExtensionExcursionInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  lineItemCode: Scalars['LineItemCode']['input'];
};

export type CreateDepartureExtensionExcursionResult = BusinessNotSpecifiedError | DepartureExcursion | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureExtensionInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  lineItemCode: Scalars['LineItemCode']['input'];
};

export type CreateDepartureExtensionResult = BusinessNotSpecifiedError | DepartureExtension | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureExtensionRoomInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  lineItemCode: Scalars['LineItemCode']['input'];
};

export type CreateDepartureExtensionRoomResult = BusinessNotSpecifiedError | DepartureRoom | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureRoomInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  lineItemCode: Scalars['LineItemCode']['input'];
};

export type CreateDepartureRoomResult = BusinessNotSpecifiedError | DepartureRoom | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDraftOrderResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Create a draft term */
export type CreateDraftTermInput = {
  businessCode: BusinessCode;
  certificationText?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  market: TermMarket;
  termType: TermType;
};

export type CreateDraftTermResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Term | ValidationError;

export type CreateExtendedStayInput = {
  basePrice: Array<MoneyInput>;
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cityGatewayCode: Scalars['String']['input'];
};

export type CreateExtendedStayResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExtendedStay | InvalidDateError | InvalidExtendedStayError | NotAuthorizedError | NotFoundError | ValidationError;

/** Create a new fee */
export type CreateFeeInput = {
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  categoryCode: Scalars['FeeCategoryCode']['input'];
  isRefundable?: InputMaybe<Scalars['Boolean']['input']>;
  rollsUpToTarget?: InputMaybe<Scalars['Boolean']['input']>;
  typeCode: FeeTypeCode;
};

export type CreateFeeResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | Fee | InvalidDateError | InvalidFeeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateFlightPackageInput = {
  arrivalGatewayCode: Scalars['String']['input'];
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  departureGatewayCode: Scalars['String']['input'];
  isCustomGateway: Scalars['Boolean']['input'];
};

export type CreateFlightPackageResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightPackage | InvalidDateError | InvalidFlightPackageError | NotAuthorizedError | NotFoundError | ValidationError;

/** Input for creating a GC Departure */
export type CreateGcDepartureInput = {
  companionDiscountRate: Scalars['Float']['input'];
  departureId: Scalars['ObjectId']['input'];
  expectedVolume?: InputMaybe<Scalars['Int']['input']>;
  freeInsuranceRatio: Scalars['FreePlaceRatio']['input'];
  freePlaceRatio: Scalars['FreePlaceRatio']['input'];
  groupCoordinatorCustomerId: Scalars['ObjectId']['input'];
  groupSizeEstimate?: InputMaybe<Scalars['Int']['input']>;
  includePrivateGroupFee?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemRules?: InputMaybe<Array<CreateGcDepartureLineItemRuleInput>>;
  micrositeUrl?: InputMaybe<Scalars['String']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  primaryCurrencyCode: CurrencyCode;
  recruitmentMeetingDate?: InputMaybe<Scalars['Date']['input']>;
  stipendRate: Scalars['Float']['input'];
};

/** The input for creating a GC Departure Line Item Rule */
export type CreateGcDepartureLineItemRuleInput = {
  level: GcDepartureRuleLevel;
  lineItemCode: Scalars['LineItemCode']['input'];
  lineItemType: GcDepartureRuleLineItemType;
};

export type CreateGcDepartureResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidGcDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateInsuranceExtensionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsuranceExtension | InvalidDateError | InvalidInsurancePlanError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateInsurancePlanAddonInput = {
  basePrice: Array<MoneyInput>;
  includedWithinDays?: InputMaybe<Scalars['Int']['input']>;
  /** A code specific to this insurance plan addon */
  insurancePlanAddonCode: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  preventPurchaseAfterDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateInsurancePlanAddonResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlanAddon | InvalidDateError | InvalidInsurancePlanError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateInsurancePlanInput = {
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  internalName: Scalars['String']['input'];
  isEligibleForRolloverOnRebooking?: InputMaybe<Scalars['Boolean']['input']>;
  planCode: Scalars['String']['input'];
  policyCoversPreExistingConditions?: InputMaybe<Scalars['Boolean']['input']>;
  policyNumber: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
  /** The insurance plan will become available starting from the specified number of days after the booking date */
  purchasableAfterDays?: InputMaybe<Scalars['Int']['input']>;
  /** The insurance plan will be available during the quote process and for the specified number of days after booking */
  purchasableWithinDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateInsurancePlanResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlan | InvalidDateError | InvalidInsurancePlanError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateNoteInput = {
  content: Scalars['String']['input'];
  /** The id of the entity this note applies to */
  targetId: Scalars['ObjectId']['input'];
};

export type CreateNoteResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Note | ValidationError;

export type CreatePromoInput = {
  audienceMemberTypes?: InputMaybe<Array<PromoAudienceMemberType>>;
  businessCode: BusinessCode;
  customerIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  displayName: Scalars['String']['input'];
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo: Scalars['DateTime']['input'];
  exclusivity: PromoExclusivity;
  gcDepartureIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isGroupsOnly?: Scalars['Boolean']['input'];
  isHiddenFromSales?: Scalars['Boolean']['input'];
  isIndiesOnly?: Scalars['Boolean']['input'];
  isShareable?: Scalars['Boolean']['input'];
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  offerCode: Scalars['String']['input'];
  promoCategory?: InputMaybe<PromoCategory>;
  promoCodes: Array<Scalars['String']['input']>;
};

export type CreatePromoResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPromoError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Create a new promo target */
export type CreatePromoTargetInput = {
  amount: Array<MoneyInput>;
  componentType: TripComponentType;
  departureDateFrom?: InputMaybe<Scalars['Date']['input']>;
  departureDateTo?: InputMaybe<Scalars['Date']['input']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']['input']>;
  series?: InputMaybe<Scalars['Series']['input']>;
};

/** Written review from the Customer */
export type CreateReviewDetailInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Create a new review */
export type CreateReviewInput = {
  detail?: InputMaybe<CreateReviewDetailInput>;
  rating: Scalars['Int']['input'];
  tripId: Scalars['ObjectId']['input'];
};

export type CreateReviewResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidRatingError | InvalidReviewError | InvalidReviewResponseError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type CreateRoleInput = {
  businessCode?: InputMaybe<BusinessCode>;
  name: Scalars['String']['input'];
  permissionKeys: Array<PermissionKey>;
};

export type CreateRoleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Role | ValidationError;

export type CreateServiceRecoveryPromoInput = {
  amount: Scalars['Float']['input'];
  businessCode: BusinessCode;
  expiryDate: Scalars['DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  offerCode: Scalars['String']['input'];
  recoveryReason: Scalars['String']['input'];
  tripId: Scalars['ObjectId']['input'];
};

export type CreateServiceRecoveryPromoResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPromoError | NotAuthorizedError | NotFoundError | ServiceRecovery | ValidationError;

export type CreateSupportTicketResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | SupportTicketError | SupportTicketSuccess | ValidationError;

/** Create a new tag */
export type CreateTagInput = {
  categoryId: Scalars['ObjectId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTagResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Tag | ValidationError;

export type CreateTourExcursionInput = {
  autoApproveDeadlineDpd: Scalars['Int']['input'];
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  matchCode: Scalars['String']['input'];
  minNbTravelersRequired: Scalars['Int']['input'];
  placeIds?: Array<Scalars['ObjectId']['input']>;
  priceYear: Scalars['Int']['input'];
  tagIds?: Array<Scalars['ObjectId']['input']>;
};

export type CreateTourExcursionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | TourExcursion | ValidationError;

export type CreateTourExtensionInput = {
  autoApproveDeadlineDpd: Scalars['Int']['input'];
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  /** The default capacity that will set for departures created from this Extension. */
  defaultCapacity: Scalars['Int']['input'];
  isFlightShoppingAllowed?: Scalars['Boolean']['input'];
  isPreExtension?: Scalars['Boolean']['input'];
  minimumCapacity?: Scalars['Int']['input'];
  placeIds?: Array<Scalars['ObjectId']['input']>;
  priceYear: Scalars['Int']['input'];
  rooms?: Array<CreateTourRoomInput>;
  tagIds?: Array<Scalars['ObjectId']['input']>;
  /** The extension tour code. */
  tourCode: Scalars['String']['input'];
};

export type CreateTourExtensionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

export type CreateTourExtensionRoomInput = {
  basePrice: Array<MoneyInput>;
  bedCode: TourBedCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  /** The default capacity that will set for Departure Rooms created from this Tour Room. Defaults to the Tour Extension capacity */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not roommate matching is needed for this room */
  enableRoommateMatching?: Scalars['Boolean']['input'];
};

export type CreateTourExtensionRoomResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

/** Create a new tour in a specific tour year */
export type CreateTourInput = {
  activityLevel?: Scalars['Int']['input'];
  autoApproveDeadlineDpd: Scalars['Int']['input'];
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  classLevel?: Scalars['Int']['input'];
  defaultCapacity: Scalars['Int']['input'];
  deposit: Array<MoneyInput>;
  depositForAutomaticPlan: Array<MoneyInput>;
  depositForLateAdd: Array<MoneyInput>;
  feeCategoryCode: Scalars['FeeCategoryCode']['input'];
  finalInstallmentDeadlineDpd: Scalars['Int']['input'];
  finalPaymentDeadlineDpd: Scalars['Int']['input'];
  isFlightShoppingAllowed: Scalars['Boolean']['input'];
  isNonRevenueTour: Scalars['Boolean']['input'];
  isPassportRequired: Scalars['Boolean']['input'];
  isPostStayAllowed: Scalars['Boolean']['input'];
  isPreStayAllowed: Scalars['Boolean']['input'];
  isVisaRequired: Scalars['Boolean']['input'];
  isWaitlistAllowed: Scalars['Boolean']['input'];
  minimumCapacity?: Scalars['Int']['input'];
  nbDepartureFlightDays: Scalars['Int']['input'];
  nbReturningFlightDays: Scalars['Int']['input'];
  placeIds?: Array<Scalars['ObjectId']['input']>;
  priceYear: Scalars['Int']['input'];
  rooms?: Array<CreateTourRoomInput>;
  tagIds?: Array<Scalars['ObjectId']['input']>;
  tourCode: Scalars['String']['input'];
};

export type CreateTourResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type CreateTourRoomInput = {
  basePrice: Array<MoneyInput>;
  bedCode: TourBedCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  /** The default capacity that will set for Departure Rooms created from this Tour Room. Defaults to the Tour capacity. */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not roommate matching is needed for this room */
  enableRoommateMatching?: Scalars['Boolean']['input'];
};

export type CreateTourRoomResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type CreateTripChecklistItemTemplateInput = {
  businessCode: BusinessCode;
  description: Scalars['String']['input'];
  dpd: Scalars['Int']['input'];
  effectiveFrom: Scalars['Date']['input'];
  effectiveTo: Scalars['Date']['input'];
  excludeTourCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  importanceLevel: CheckListItemImportanceLevel;
  includeTourCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  internalName: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateTripChecklistItemTemplateResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTripChecklistItemTemplateError | NotAuthorizedError | NotFoundError | TripChecklistItemTemplate | ValidationError;

/** Inputs necessary to create a voucher that originates from a booking */
export type CreateVoucherFromBookingInput = {
  bookingId: Scalars['ObjectId']['input'];
  customerId: Scalars['ObjectId']['input'];
  expirationDate: Scalars['Date']['input'];
  initialAmount: MoneyInput;
  isRefundable: Scalars['Boolean']['input'];
  /** @deprecated Use voucherReason instead */
  reason?: InputMaybe<CreditReasonCode>;
  voucherReason?: InputMaybe<VoucherReason>;
};

export type CreateVoucherFromBookingResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidMoneyError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Create a voucher that originates from a different system and non WOJO EF Product */
export type CreateVoucherFromExternalInput = {
  businessCode: BusinessCode;
  customerId: Scalars['ObjectId']['input'];
  expirationDate: Scalars['Date']['input'];
  initialAmount: MoneyInput;
  isRefundable: Scalars['Boolean']['input'];
  transferBusinessUnit: Scalars['String']['input'];
};

export type CreateVoucherFromExternalResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Creates a new wishlist item */
export type CreateWishlistItemInput = {
  businessCode: BusinessCode;
  customerId: Scalars['ObjectId']['input'];
  tourCode: Scalars['String']['input'];
};

export type CreateWishlistItemResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError | WishlistItem;

/** A transaction that debits a payment method */
export type CreditPaymentTransaction = PaymentTransaction & {
  __typename?: 'CreditPaymentTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  /** The customer of this transaction. */
  customerId: Scalars['ObjectId']['output'];
  displayStatus: PaymentTransactionDisplayStatus;
  /** The user who initiated the transaction */
  initiatedBy?: Maybe<User>;
  paymentMethod: TransactionPaymentMethod;
  paymentSysResponseCode?: Maybe<Scalars['String']['output']>;
  paymentSysResponseMessage?: Maybe<Scalars['String']['output']>;
  processorTransactionId?: Maybe<Scalars['Int']['output']>;
  reasonCode: CreditReasonCode;
  reconciledBy?: Maybe<Employee>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  settlementDate?: Maybe<Scalars['Date']['output']>;
  /** The status of this transaction. */
  status: PaymentTransactionStatus;
  transactionDate: Scalars['DateTime']['output'];
};

/** The reason code for a credit transaction */
export enum CreditReasonCode {
  /** The transaction was cancelled */
  Cancellation = 'CANCELLATION',
  /** Funds were returned for an unspecified reason */
  Optional = 'OPTIONAL',
  /** The customer overpaid. */
  Overpayment = 'OVERPAYMENT',
  /** The amount was transferred to another order. */
  Transfer = 'TRANSFER',
  /** The amount was converted into a voucher. */
  Voucher = 'VOUCHER'
}

export enum CurrencyCode {
  Cad = 'CAD',
  Usd = 'USD'
}

/** An Abe customer and its associated data */
export type Customer = User & {
  __typename?: 'Customer';
  _id: Scalars['ObjectId']['output'];
  address?: Maybe<Address>;
  bio?: Maybe<Scalars['String']['output']>;
  /** Get a customer's booked trips by business code */
  bookingTrips: Array<BookingTrip>;
  /** Get a customer's canceled trips by business code */
  cancelledTrips: Array<BookingTrip>;
  /** Get the chat user ID for the customer for the given business code */
  chatUserId?: Maybe<Scalars['String']['output']>;
  /** Get GC Departures for Group Coordinators */
  confirmedGCDepartures: Array<GcDeparture>;
  /** Get a customer's pre-2018 confirmed trips by business code */
  confirmedOldTrips: Array<OldTrip>;
  /** Get a customer's confirmed trips by business code */
  confirmedTrips: Array<BookingTrip>;
  customerId: Scalars['ObjectId']['output'];
  email?: Maybe<Scalars['Email']['output']>;
  /** The customer's Facebook URL */
  facebookUrl?: Maybe<Scalars['String']['output']>;
  facebookUsername?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** ID used for resolving in the global rewards system. Currently Phoenix CustomerNumber */
  globalRewardsId?: Maybe<Scalars['String']['output']>;
  /** Check if the customer has any GC Departures */
  hasGCDepartures: Scalars['Boolean']['output'];
  /** Check if the customer has any GM trips for the given business code */
  hasGroupMemberTrips: Scalars['Boolean']['output'];
  /** The customer's Instagram URL */
  instagramUrl?: Maybe<Scalars['String']['output']>;
  instagramUsername?: Maybe<Scalars['String']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legacyIds?: Maybe<LegacyCustomerIds>;
  /** Get the loyalty level for the customer */
  loyaltyLevel?: Maybe<LoyaltyLevel>;
  /**
   * Get a customer's on hold trips by business code
   * @deprecated No longer a valid status
   */
  onHoldTrips: Array<BookingTrip>;
  /** Get past GC Departure Prospects for Group Coordinators */
  pastGCDepartureProspects: Array<GcDepartureProspect>;
  /** Get past Group Members for Group Coordinator */
  pastGroupMembers: Array<GcPastGroupMember>;
  /** Get a customer's pending rebooking trips by business code */
  pendingRebookingTrips: Array<BookingTrip>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  /** The customer's profile image asset */
  profileImageAsset?: Maybe<Asset>;
  /** Get a customer's rebooked trips by business code */
  rebookedTrips: Array<BookingTrip>;
  /** Get a customer's requested trips by business code */
  requestedTrips: Array<BookingTrip>;
  /** Get a customer's saved payment methods (optionally) by business code */
  savedPaymentMethods: Array<SavedPaymentMethod>;
  /** The customer's Snapchat URL */
  snapchatUrl?: Maybe<Scalars['String']['output']>;
  snapchatUsername?: Maybe<Scalars['String']['output']>;
  /** The customer's TikTok URL */
  tiktokUrl?: Maybe<Scalars['String']['output']>;
  tiktokUsername?: Maybe<Scalars['String']['output']>;
  /** Get a customer's vouchers */
  vouchers: Array<Voucher>;
  /** Get a customer's waitlisted trips by business code */
  waitlistedTrips: Array<BookingTrip>;
  /** Get a customer's wishlist items (optionally) by business code */
  wishlist: Array<WishlistItem>;
  /** The customer's X URL */
  xUrl?: Maybe<Scalars['String']['output']>;
  xUsername?: Maybe<Scalars['String']['output']>;
};


/** An Abe customer and its associated data */
export type CustomerBookingTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerCancelledTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerChatUserIdArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerConfirmedGcDeparturesArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerConfirmedOldTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerConfirmedTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerHasGcDeparturesArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerHasGroupMemberTripsArgs = {
  filter: FilterCustomerTripsInput;
};


/** An Abe customer and its associated data */
export type CustomerLoyaltyLevelArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerOnHoldTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerPastGcDepartureProspectsArgs = {
  businessCodes?: InputMaybe<Array<BusinessCode>>;
};


/** An Abe customer and its associated data */
export type CustomerPastGroupMembersArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerPendingRebookingTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerRebookedTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerRequestedTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerSavedPaymentMethodsArgs = {
  businessCode?: InputMaybe<BusinessCode>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Abe customer and its associated data */
export type CustomerWaitlistedTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerWishlistArgs = {
  businessCode?: InputMaybe<BusinessCode>;
};

export type CustomerCredentialOptions = {
  __typename?: 'CustomerCredentialOptions';
  hasEmail: Scalars['Boolean']['output'];
  hasPassword: Scalars['Boolean']['output'];
};

/** Customer evaluation type */
export type CustomerEvaluation = Evaluation & {
  __typename?: 'CustomerEvaluation';
  _id: Scalars['ObjectId']['output'];
  /** The date that the evaluation is available */
  availabilityDate: Scalars['DateTime']['output'];
  businessCode?: Maybe<BusinessCode>;
  /** The date that the evaluation is due */
  deadlineDate: Scalars['DateTime']['output'];
  /** The departure ID of the departure that this evaluation belong to */
  departureId: Scalars['ObjectId']['output'];
  evaluationType: EvaluationType;
  /** The date that the evaluation was finalized */
  finalizationDate?: Maybe<Scalars['DateTime']['output']>;
  hasAnsweredQuestions: Scalars['Boolean']['output'];
  /** Whether the evaluation has been started */
  hasBeenStarted: Scalars['Boolean']['output'];
  /** The NPS score of the evaluation */
  npsScore?: Maybe<Scalars['Int']['output']>;
  questions: Array<EvaluationQuestion>;
  /** The date that the evaluation was submitted */
  submissionDate?: Maybe<Scalars['DateTime']['output']>;
  templateId: Scalars['ObjectId']['output'];
  /** The trip ID of the booking trip that this evaluation belong to */
  tripId: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

/** Customer evaluation settings */
export type CustomerEvaluationSettings = {
  __typename?: 'CustomerEvaluationSettings';
  /** List component types to make customer eval questions for. */
  componentTypeCodes: Array<Scalars['String']['output']>;
  /** boolean to determine if all questions should be generated at once */
  generateAllQuestionsAtOnce: Scalars['Boolean']['output'];
  /** the number of days before a departure or before a departure end that eval availabilityDate should be set */
  nbDaysUntilEvaluationAvailable?: Maybe<Scalars['Int']['output']>;
  /** the number of days after a departure that an eval is due */
  nbDaysUntilEvaluationDue?: Maybe<Scalars['Int']['output']>;
  /** number of days before the departure that the preDepartureEnd questions should be generated */
  nbPreDepartureEndQuestionDays?: Maybe<Scalars['Int']['output']>;
  /** number of days before the departure that the preDeparture questions should be generated */
  nbPreDepartureQuestionDays?: Maybe<Scalars['Int']['output']>;
  /** boolean to determine if an eval should be generated before the departure, otherwise will generate x days before departure end */
  shouldGeneratePreDeparture: Scalars['Boolean']['output'];
};

/** Customer merge error */
export type CustomerMergeError = DomainError & {
  __typename?: 'CustomerMergeError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CustomerPaginatedResult = {
  __typename?: 'CustomerPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Customer>;
};

export type CustomerSignupResult = {
  __typename?: 'CustomerSignupResult';
  customer: Customer;
  token: Scalars['String']['output'];
  tokenExpiresAt: Scalars['DateTime']['output'];
};

export type DateOnlyRangeInput = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A transaction that debits a payment method */
export type DebitPaymentTransaction = PaymentTransaction & {
  __typename?: 'DebitPaymentTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  /** The customer of this transaction. */
  customerId: Scalars['ObjectId']['output'];
  displayStatus: PaymentTransactionDisplayStatus;
  /** The user who initiated the transaction */
  initiatedBy?: Maybe<User>;
  paymentMethod: TransactionPaymentMethod;
  paymentScheduleId?: Maybe<Scalars['ObjectId']['output']>;
  paymentSysResponseCode?: Maybe<Scalars['String']['output']>;
  paymentSysResponseMessage?: Maybe<Scalars['String']['output']>;
  processorTransactionId?: Maybe<Scalars['Int']['output']>;
  reconciledBy?: Maybe<Employee>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  settlementDate?: Maybe<Scalars['Date']['output']>;
  /** The status of this transaction. */
  status: PaymentTransactionStatus;
  transactionDate: Scalars['DateTime']['output'];
};

export type DeleteCategoryResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | SuccessResult | ValidationError;

export type DeleteGcDepartureProspectResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureProspectRemovedResult | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type DeleteReviewImageResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type DeleteTagResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | SuccessResult | ValidationError;

export type DeleteWishlistItemResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError | WishlistItemRemovedResult;

/** Departure of a tour */
export type Departure = {
  __typename?: 'Departure';
  _id: Scalars['ObjectId']['output'];
  /** The sellable extension for a departure if it has one. Otherwise Null. */
  activeExtension?: Maybe<DepartureExtension>;
  activeExtensionContent?: Maybe<TourExtensionContent>;
  addonPrice: Amount;
  autoApproveDeadline: Scalars['Date']['output'];
  /** All trips that count as a spot booked (CONFIRMED, REQUESTED, WAITLISTED). */
  bookedTrips: Array<BookingTrip>;
  /** All booking trips. */
  bookingTrips: Array<BookingTrip>;
  bookings: Array<Booking>;
  cancellationMeta?: Maybe<DepartureItemCancellationMeta>;
  capacity: Scalars['Int']['output'];
  /** Id to use to create a unique chat channel for the departure. Falls back to the legacy id for older departures. */
  chatChannelId: Scalars['String']['output'];
  /** The date the chat channel opens for the departure */
  chatChannelOpenDate?: Maybe<Scalars['Date']['output']>;
  /** Confirmed GC departures associated with the departure */
  confirmedGcDepartures?: Maybe<Array<GcDeparture>>;
  confirmedRooming?: Maybe<DepartureRooming>;
  confirmedTrips: Array<BookingTrip>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The identity of the user who created the record */
  createdBy?: Maybe<AuditIdentity>;
  /** Returns the prices for the available custom departing flight packages based on the base tour's start gateway code. */
  customDepartingFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for available custom returning flight packages based on the base tour's end gateway code. */
  customReturningFlightPrices: Array<DepartureFlightPackagePrice>;
  customerEvaluations?: Maybe<Array<CustomerEvaluation>>;
  /** Returns the prices for all available departing flight packages based on the base tour's start gateway code. */
  departingFlightPrices: Array<DepartureFlightPackagePrice>;
  departureDate: Scalars['Date']['output'];
  departureDateWithExtension: Scalars['Date']['output'];
  /** Departure itinerary associated with the departure */
  departureItinerary?: Maybe<DepartureItinerary>;
  /** Document metadata */
  documentMetadata?: Maybe<Array<DocumentMetadata>>;
  dpd: Scalars['Int']['output'];
  /** Includes the date at which eTicket information is released, and whether or not it is already released */
  eTicketsRelease?: Maybe<ReleaseDetails>;
  endDate: Scalars['Date']['output'];
  endDateWithExtension: Scalars['Date']['output'];
  endGateway?: Maybe<Gateway>;
  endGatewayCode: Scalars['String']['output'];
  exclusivityType: DepartureExclusivityType;
  excursions: Array<DepartureExcursion>;
  extendedFamilyCode: Scalars['String']['output'];
  /** All extensions for a departure regardless of status. At most one can be active. */
  extensions: Array<DepartureExtension>;
  familyCode: Scalars['String']['output'];
  finalInstallmentDeadline: Scalars['Date']['output'];
  finalPaymentDeadline: Scalars['Date']['output'];
  /** Includes the date at which flights are released, and whether or not they are already released */
  flightsRelease?: Maybe<ReleaseDetails>;
  /**
   * The date that flight line items go on request
   * @deprecated Use flightsRequestDeadlineDate which has no timestamp
   */
  flightsRequestDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** The date that flight line items go on request */
  flightsRequestDeadlineDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The deadline for customers to request flights
   * @deprecated Use flightsRequestMessagingDeadlineDate which has no timestamp
   */
  flightsRequestMessagingDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** The deadline for customers to request flights */
  flightsRequestMessagingDeadlineDate?: Maybe<Scalars['Date']['output']>;
  /** GC departures associated with the departure */
  gcDeparture?: Maybe<Array<GcDeparture>>;
  hasSpotsLeft: Scalars['Boolean']['output'];
  hasUnmatchedRoommates: Scalars['Boolean']['output'];
  hotelsRelease?: Maybe<ReleaseDetails>;
  /** @deprecated Use hotelsRequestDeadlineDate which has no timestamp */
  hotelsRequestDeadline?: Maybe<Scalars['DateTime']['output']>;
  hotelsRequestDeadlineDate?: Maybe<Scalars['Date']['output']>;
  /** Whether the chat is open for the departure, checks if the channel exists and if today is within the chat open range */
  isChatChannelOpen: Scalars['Boolean']['output'];
  isFlightShoppingAllowed: Scalars['Boolean']['output'];
  isPostStayAllowed: Scalars['Boolean']['output'];
  isPreStayAllowed: Scalars['Boolean']['output'];
  /** Whether or not status is purchasable status. */
  isPurchasable: Scalars['Boolean']['output'];
  /** Whether the tour director is available for the customer to send a direct message */
  isTourDirectorAvailableToDirectMessage: Scalars['Boolean']['output'];
  /** Whether the tour director for the departure should be visible to the user */
  isTourDirectorReleasedToTraveler?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistAllowed: Scalars['Boolean']['output'];
  /** Price with fees and promos optionally applied */
  leadInPrice: Array<LeadInPrice>;
  lineItemCode: Scalars['LineItemCode']['output'];
  nbSpotsBooked: Scalars['Int']['output'];
  nbSpotsLeft: Scalars['Int']['output'];
  /** @deprecated No longer a valid status */
  onHoldTrips: Array<BookingTrip>;
  owner?: Maybe<Employee>;
  ownerId?: Maybe<Scalars['ObjectId']['output']>;
  pendingRebookingTrips: Array<BookingTrip>;
  postStays?: Maybe<Array<ExtendedStay>>;
  preStays?: Maybe<Array<ExtendedStay>>;
  price: Amount;
  priceYear: PriceYear;
  prodTourId?: Maybe<Scalars['Int']['output']>;
  requestedRooming?: Maybe<DepartureRooming>;
  requestedTrips: Array<BookingTrip>;
  reservedCapacity: Scalars['Int']['output'];
  /** Returns the prices for all available returning flight packages based on the base tour's end gateway code. */
  returningFlightPrices: Array<DepartureFlightPackagePrice>;
  rooming?: Maybe<DepartureRooming>;
  rooms: Array<DepartureRoom>;
  salesTourId: Scalars['String']['output'];
  series: Scalars['Series']['output'];
  /** Returns the prices for the available standard departing flight packages based on the base tour's start gateway code. */
  standardDepartingFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for available standard returning flight packages based on the base tour's end gateway code. */
  standardReturningFlightPrices: Array<DepartureFlightPackagePrice>;
  startDate: Scalars['Date']['output'];
  startGateway?: Maybe<Gateway>;
  startGatewayCode: Scalars['String']['output'];
  status: DepartureStatus;
  tagIds: Array<Scalars['ObjectId']['output']>;
  tags: Array<Tag>;
  timingStatus: DepartureTimingStatus;
  /** Parent tour associated with the departure */
  tour?: Maybe<Tour>;
  tourCode: Scalars['String']['output'];
  tourContent?: Maybe<TourContent>;
  /** The DPD at which a tour director will start seeing future departures and will be visible to the travelers */
  tourDirectorFutureToursGateDpd?: Maybe<Scalars['Int']['output']>;
  tourDirectors: Array<TourDirector>;
  tourEndReportRelease?: Maybe<ReleaseDetails>;
  travelers: Array<Customer>;
  /** All trips, including booked and quoted trips associated with the departure */
  trips: Array<Trip>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The identity of the user who last updated the record */
  updatedBy?: Maybe<AuditIdentity>;
};


/** Departure of a tour */
export type DepartureActiveExtensionContentArgs = {
  language: Scalars['String']['input'];
};


/** Departure of a tour */
export type DepartureLeadInPriceArgs = {
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  promoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Departure of a tour */
export type DepartureTourContentArgs = {
  language: Scalars['String']['input'];
};

/** Departure evaluation statistics */
export type DepartureEvaluationSummary = {
  __typename?: 'DepartureEvaluationSummary';
  /** The average percentage based on the average score and the maximum score */
  averagePercentage: Scalars['Float']['output'];
  /** The average score of all answered tour director questions on a departure */
  averageScore: Scalars['Float']['output'];
  /** The average score level based on the average score */
  averageScoreLevel: EvaluationScoreLevel;
  /** Customer responses to the tour director question, only questions with additional comments are processed */
  customerResponses: Array<EvaluationSummaryCustomerResponse>;
  departure: Departure;
  /** Departure ID */
  departureId: Scalars['ObjectId']['output'];
  /** Percentage of evaluations completed */
  evaluationCompletionPercentage: Scalars['Float']['output'];
  /** Evaluation completion percentage level */
  evaluationCompletionPercentageLevel: EvaluationScoreLevel;
  /** Number of completed evaluations */
  nbOfCompletedEvaluations: Scalars['Int']['output'];
  /** Number of evaluations */
  nbOfEvaluations: Scalars['Int']['output'];
  /** NPS score of the tour. */
  npsScore: Scalars['Int']['output'];
  /** NPS score level */
  npsScoreLevel: EvaluationScoreLevel;
  /** List of score ranges, based on the average score of each answered evaluation */
  ranges: Array<EvaluationScoreRange>;
  /** Release information for the evaluation statistics */
  releaseInformation: ReleaseDetails;
};

export enum DepartureExclusivityType {
  Exclusive = 'EXCLUSIVE',
  Standard = 'STANDARD'
}

/** Excursion configuration for a departure */
export type DepartureExcursion = {
  __typename?: 'DepartureExcursion';
  _id: Scalars['ObjectId']['output'];
  /** The deadline past which the status of this Excursion will be REQUESTED when added to a Trip. */
  autoApproveDeadline: Scalars['Date']['output'];
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']['output']>;
  capacity: Scalars['Int']['output'];
  content?: Maybe<TourExcursionContent>;
  hasSpotsLeft: Scalars['Boolean']['output'];
  /** Whether or not status is considered an active status. */
  isActive: Scalars['Boolean']['output'];
  /** Whether or not status is considered a purchasable status. */
  isPurchasable: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  matchCode: Scalars['String']['output'];
  /** Indicates the minimum number of travelers required to run the excursion. */
  minNbTravelersRequired: Scalars['Int']['output'];
  nbSpotsBooked: Scalars['Int']['output'];
  nbSpotsLeft: Scalars['Int']['output'];
  price: Amount;
  series: Scalars['Series']['output'];
  status: DepartureStatus;
  tourExcursion?: Maybe<TourExcursion>;
};


/** Excursion configuration for a departure */
export type DepartureExcursionContentArgs = {
  language: Scalars['String']['input'];
};

export type DepartureExcursionOffer = {
  __typename?: 'DepartureExcursionOffer';
  appliedToTrip: Scalars['Boolean']['output'];
  discountAmount?: Maybe<Money>;
  excursion: DepartureExcursion;
  salePrice?: Maybe<Money>;
};

/** Extension config for a Departure */
export type DepartureExtension = {
  __typename?: 'DepartureExtension';
  _id: Scalars['ObjectId']['output'];
  autoApproveDeadline: Scalars['Date']['output'];
  cancellationMeta?: Maybe<DepartureItemCancellationMeta>;
  capacity: Scalars['Int']['output'];
  confirmedRooming?: Maybe<DepartureRooming>;
  /** Returns the prices for available custom departing flight packages based on the extension or departure's start gateway code. */
  customDepartingFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for available custom returning flight packages based on the extension or departure's end gateway code. */
  customReturningFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for all available departing flight packages based on the extension or departure's start gateway code. */
  departingFlightPrices: Array<DepartureFlightPackagePrice>;
  departure?: Maybe<Departure>;
  departureDate: Scalars['Date']['output'];
  departureId: Scalars['ObjectId']['output'];
  dpd: Scalars['Int']['output'];
  endDate: Scalars['Date']['output'];
  endGatewayCode: Scalars['String']['output'];
  excursions: Array<DepartureExcursion>;
  extendedFamilyCode: Scalars['String']['output'];
  familyCode: Scalars['String']['output'];
  hasSpotsLeft: Scalars['Boolean']['output'];
  isFlightShoppingAllowed: Scalars['Boolean']['output'];
  isPreExtension: Scalars['Boolean']['output'];
  /** Whether or not status is purchasable status. */
  isPurchasable: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  nbSpotsBooked: Scalars['Int']['output'];
  nbSpotsLeft: Scalars['Int']['output'];
  postStays?: Maybe<Array<ExtendedStay>>;
  preStays?: Maybe<Array<ExtendedStay>>;
  price: Amount;
  prodTourId?: Maybe<Scalars['Int']['output']>;
  requestedRooming?: Maybe<DepartureRooming>;
  /** Returns the prices for all available returning flight packages based on the extension or departure's end gateway code. */
  returningFlightPrices: Array<DepartureFlightPackagePrice>;
  rooming?: Maybe<DepartureRooming>;
  rooms: Array<DepartureRoom>;
  salesTourId: Scalars['String']['output'];
  series: Scalars['Series']['output'];
  /** Returns the prices for available standard departing flight packages based on the extension or departure's start gateway code. */
  standardDepartingFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for available standard returning flight packages based on the extension or departure's end gateway code. */
  standardReturningFlightPrices: Array<DepartureFlightPackagePrice>;
  startDate: Scalars['Date']['output'];
  startGatewayCode: Scalars['String']['output'];
  status: DepartureStatus;
  timingStatus: DepartureTimingStatus;
  tourCode: Scalars['String']['output'];
  tourExtension?: Maybe<TourExtension>;
  tourExtensionContent?: Maybe<TourExtensionContent>;
};


/** Extension config for a Departure */
export type DepartureExtensionTourExtensionContentArgs = {
  language: Scalars['String']['input'];
};

export type DepartureExtensionOffer = {
  __typename?: 'DepartureExtensionOffer';
  appliedToTrip: Scalars['Boolean']['output'];
  discountAmount?: Maybe<Money>;
  extension: DepartureExtension;
  salePrice?: Maybe<Money>;
};

export type DepartureFlightPackagePrice = {
  __typename?: 'DepartureFlightPackagePrice';
  homeGateway?: Maybe<Gateway>;
  homeGatewayCode: Scalars['String']['output'];
  isCustomGateway: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  prices: Array<Money>;
};

/** Information about why a departure or extension was cancelled */
export type DepartureItemCancellationMeta = {
  __typename?: 'DepartureItemCancellationMeta';
  cancellationDate: Scalars['Date']['output'];
  cancelledById?: Maybe<Scalars['ObjectId']['output']>;
};

/** The itinerary of a departure */
export type DepartureItinerary = {
  __typename?: 'DepartureItinerary';
  _id: Scalars['ObjectId']['output'];
  components: Array<DepartureItineraryComponent>;
  prodTourId: Scalars['Int']['output'];
  tourDirectors: Array<DepartureItineraryComponent>;
};

/** The component on a departure itinerary */
export type DepartureItineraryComponent = {
  __typename?: 'DepartureItineraryComponent';
  agent?: Maybe<Supplier>;
  breakdown?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Date']['output'];
  externalReferenceNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes: Array<Scalars['String']['output']>;
  productionComponentId: Scalars['Int']['output'];
  reconfirmationDpd?: Maybe<Scalars['Int']['output']>;
  reservation?: Maybe<Reservation>;
  startDate: Scalars['Date']['output'];
  startTime?: Maybe<Scalars['Time']['output']>;
  supplier?: Maybe<Supplier>;
  type: Scalars['String']['output'];
};

/** Departure not bookable error */
export type DepartureNotBookableError = DomainError & {
  __typename?: 'DepartureNotBookableError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** A paginated result of Departures */
export type DeparturePaginatedResult = {
  __typename?: 'DeparturePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Departure>;
};

/** Room on a Departure */
export type DepartureRoom = {
  __typename?: 'DepartureRoom';
  _id: Scalars['ObjectId']['output'];
  bed: TourBed;
  cabinCode?: Maybe<Scalars['TourCabinCode']['output']>;
  capacity: Scalars['Int']['output'];
  content?: Maybe<RoomContent>;
  hasSpotsLeft: Scalars['Boolean']['output'];
  /** Whether or not status is purchasable status. */
  isPurchasable: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  nbSpotsBooked: Scalars['Int']['output'];
  nbSpotsLeft: Scalars['Int']['output'];
  price: Amount;
  /** Whether or not the room requires a roommate configuration. */
  requiresRooming: Scalars['Boolean']['output'];
  series: Scalars['Series']['output'];
  status: DepartureStatus;
};


/** Room on a Departure */
export type DepartureRoomContentArgs = {
  language: Scalars['String']['input'];
};

export type DepartureRoomOffer = {
  __typename?: 'DepartureRoomOffer';
  appliedToTrip: Scalars['Boolean']['output'];
  discountAmount?: Maybe<Money>;
  room: DepartureRoom;
  salePrice?: Maybe<Money>;
};

/** Departure Rooming */
export type DepartureRooming = {
  __typename?: 'DepartureRooming';
  /** Travelers with assigned roommates */
  assignedRooms: Array<AssignedRoom>;
  /** Total room and traveler counts for each bed count */
  breakdown: Array<DepartureRoomingBreakdown>;
  /** Travelers who are yet to be assigned a roommate */
  unassignedTravelers: Array<UnassignedTravelers>;
};

/** The breakdown by bed code */
export type DepartureRoomingBreakdown = {
  __typename?: 'DepartureRoomingBreakdown';
  bedCode: Scalars['String']['output'];
  nbRooms: Scalars['Int']['output'];
  nbTravelers: Scalars['Int']['output'];
};

export type DepartureSettings = {
  __typename?: 'DepartureSettings';
  documentMetadata: Array<DocumentMetadataSettings>;
  /** The DPD at which this business expects flight segments to have e-ticket numbers populated */
  eTicketsAvailabilityDpd?: Maybe<Scalars['Int']['output']>;
  /** The DPD at which this business expects flights information populated */
  flightsReleaseDpd: Scalars['Int']['output'];
  flightsRequestDpd: Scalars['Int']['output'];
  flightsRequestMessagingDpd: Scalars['Int']['output'];
  hotelsReleaseDpd: Scalars['Int']['output'];
  hotelsRequestDpd: Scalars['Int']['output'];
  /** The estimated days after the flights release date which this business expects flights information to be populated */
  nbEstimatedDaysForFlightRelease?: Maybe<Scalars['Int']['output']>;
  publicDepartureMinDpd: Scalars['Int']['output'];
  /** The DPD at which a tour director will start seeing future departures and will be visible to the travelers */
  tourDirectorFutureToursGateDpd?: Maybe<Scalars['Int']['output']>;
};

export enum DepartureSortField {
  AddOnPriceCad = 'addOnPriceCAD',
  AddOnPriceUsd = 'addOnPriceUSD',
  AutoApproveDeadline = 'autoApproveDeadline',
  Capacity = 'capacity',
  CreatedAt = 'createdAt',
  DepartureDate = 'departureDate',
  EndDate = 'endDate',
  ExclusivityType = 'exclusivityType',
  FinalPaymentDeadline = 'finalPaymentDeadline',
  NbSpotsBooked = 'nbSpotsBooked',
  PriceCad = 'priceCAD',
  PriceUsd = 'priceUSD',
  PriceYear = 'priceYear',
  ProdTourId = 'prodTourId',
  SalesTourId = 'salesTourId',
  StartDate = 'startDate',
  Status = 'status',
  TourCode = 'tourCode',
  UpdatedAt = 'updatedAt'
}

export enum DepartureStatus {
  /** The departure has been cancelled, all trips are cancelled, and the departure is cancelled in Atlas. */
  Cancelled = 'CANCELLED',
  /** The trip is no longer available because it's passed it's run date. */
  Closed = 'CLOSED',
  /** Like PENDING except the prod has been created in Atlas. */
  Hold = 'HOLD',
  /** The trip is past the tour finalization and allocation has begun therefore all bookings will be ON_REQUEST until approved by Ops and/or Travel teams */
  OnRequest = 'ON_REQUEST',
  /** The departure is not available for sale yet and the prod has not been created in Atlas. */
  Pending = 'PENDING',
  /** The Prod tour is cancelled in atlas but not all customer trips on it have been cancelled. */
  PendingCancellation = 'PENDING_CANCELLATION',
  /** The departure is available for sale. */
  Sell = 'SELL'
}

export enum DepartureTimingStatus {
  OnTour = 'OnTour',
  PostTour = 'PostTour',
  PreTour = 'PreTour'
}

/** Document metadata for a specific departure. */
export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  /** The full path where the document can be downloaded from. */
  downloadPath: Scalars['String']['output'];
  /** The title of the document to be displayed by clients. */
  title: Scalars['String']['output'];
};

/** Document metadata settings */
export type DocumentMetadataSettings = {
  __typename?: 'DocumentMetadataSettings';
  documentType: DocumentType;
  /** The url path where the document can be found */
  downloadPath: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum DocumentType {
  Cruise = 'CRUISE',
  Extension = 'EXTENSION',
  General = 'GENERAL'
}

/** Domain Error interface for all to implement */
export type DomainError = {
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** A draft of an order for editing */
export type DraftOrder = {
  __typename?: 'DraftOrder';
  _id: Scalars['ObjectId']['output'];
  order: Order;
};

/** An entity with the same unique key already exists */
export type DuplicateUniqueKeyError = DomainError & {
  __typename?: 'DuplicateUniqueKeyError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type EfTransferPaymentMethod = {
  __typename?: 'EFTransferPaymentMethod';
  efProduct: Scalars['String']['output'];
  efStaffName: Scalars['String']['output'];
  efTransferNumber: Scalars['String']['output'];
  externCustomerName: Scalars['String']['output'];
  externalCustomerId: Scalars['String']['output'];
  externalTripId: Scalars['String']['output'];
};

/** Failed to send an email */
export type EmailSendFailedError = DomainError & {
  __typename?: 'EmailSendFailedError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** emergency contact information */
export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  _id: Scalars['ObjectId']['output'];
  confirmationDate?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  relationship: EmergencyContactRelationship;
};

export type EmergencyContactChecklistItem = SystemChecklistItem & {
  __typename?: 'EmergencyContactChecklistItem';
  dueDate?: Maybe<Scalars['Date']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  status?: Maybe<TripChecklistItemStatus>;
};

export type EmergencyContactInput = {
  confirmationDate?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  relationship: EmergencyContactRelationship;
};

export enum EmergencyContactRelationship {
  Child = 'CHILD',
  Friend = 'FRIEND',
  NotSpecified = 'NOT_SPECIFIED',
  Other = 'OTHER',
  Parent = 'PARENT',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE'
}

/** An EF employee and its associated data */
export type Employee = User & {
  __typename?: 'Employee';
  _id: Scalars['ObjectId']['output'];
  email?: Maybe<Scalars['Email']['output']>;
  entraId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullname: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  roleIds: Array<Scalars['ObjectId']['output']>;
  roles: Array<Role>;
};

/** A paginated result of Tours */
export type EmployeePaginatedResult = {
  __typename?: 'EmployeePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Employee>;
};

export enum EmployeeSortField {
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName'
}

/** Base type for all evaluations */
export type Evaluation = {
  _id: Scalars['ObjectId']['output'];
  /** The date that the evaluation is available */
  availabilityDate: Scalars['DateTime']['output'];
  businessCode?: Maybe<BusinessCode>;
  /** The date that the evaluation is due */
  deadlineDate: Scalars['DateTime']['output'];
  /** The departure ID of the departure that this evaluation belong to */
  departureId: Scalars['ObjectId']['output'];
  evaluationType: EvaluationType;
  /** The date that the evaluation was finalized */
  finalizationDate?: Maybe<Scalars['DateTime']['output']>;
  hasAnsweredQuestions: Scalars['Boolean']['output'];
  questions: Array<EvaluationQuestion>;
  /** The date that the evaluation was submitted */
  submissionDate?: Maybe<Scalars['DateTime']['output']>;
  templateId: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

/** Base type for all evaluation answers */
export type EvaluationAnswer = {
  additionalComments?: Maybe<Scalars['String']['output']>;
};

/** An evaluation scale choice */
export type EvaluationChoice = {
  __typename?: 'EvaluationChoice';
  _id: Scalars['ObjectId']['output'];
  label: Scalars['String']['output'];
  /** The value of the choice, can be either a string or a number but always represented as a string in the graph */
  value: Scalars['String']['output'];
};

/** Evaluation free text answer */
export type EvaluationFreeTextAnswer = EvaluationAnswer & {
  __typename?: 'EvaluationFreeTextAnswer';
  additionalComments?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** An evaluation free text question */
export type EvaluationFreeTextQuestion = EvaluationQuestion & {
  __typename?: 'EvaluationFreeTextQuestion';
  _id: Scalars['ObjectId']['output'];
  answer?: Maybe<EvaluationFreeTextAnswer>;
  canonicalId: Scalars['String']['output'];
  /** Whether the question has been answered */
  hasBeenAnswered: Scalars['Boolean']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<EvaluationQuestionMeta>;
  text: Scalars['String']['output'];
};

/** An evaluation matrix answer */
export type EvaluationMatrixAnswer = EvaluationAnswer & {
  __typename?: 'EvaluationMatrixAnswer';
  additionalComments?: Maybe<Scalars['String']['output']>;
  choiceId: Scalars['ObjectId']['output'];
  /** The value of the choice, can be either a string or a number but always represented as a string in the graph */
  value: Scalars['String']['output'];
};

/** An evaluation matrix question */
export type EvaluationMatrixQuestion = EvaluationQuestion & {
  __typename?: 'EvaluationMatrixQuestion';
  _id: Scalars['ObjectId']['output'];
  canonicalId: Scalars['String']['output'];
  choices: Array<EvaluationChoice>;
  /** Whether the question has been answered */
  hasBeenAnswered: Scalars['Boolean']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<EvaluationQuestionMeta>;
  rows: Array<EvaluationMatrixRow>;
  text: Scalars['String']['output'];
};

/** An evaluation matrix row */
export type EvaluationMatrixRow = {
  __typename?: 'EvaluationMatrixRow';
  _id: Scalars['ObjectId']['output'];
  answer?: Maybe<EvaluationMatrixAnswer>;
  text: Scalars['String']['output'];
};

/** Evaluation multiple choice answer */
export type EvaluationMultipleChoiceAnswer = EvaluationAnswer & {
  __typename?: 'EvaluationMultipleChoiceAnswer';
  additionalComments?: Maybe<Scalars['String']['output']>;
  choiceId: Scalars['ObjectId']['output'];
  /** The value of the choice, can be either a string or a number but always represented as a string in the graph */
  value: Scalars['String']['output'];
};

/** An evaluation multiple choice question */
export type EvaluationMultipleChoiceQuestion = EvaluationQuestion & {
  __typename?: 'EvaluationMultipleChoiceQuestion';
  _id: Scalars['ObjectId']['output'];
  answer?: Maybe<EvaluationMultipleChoiceAnswer>;
  canonicalId: Scalars['String']['output'];
  choices: Array<EvaluationChoice>;
  /** Whether the question has been answered */
  hasBeenAnswered: Scalars['Boolean']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<EvaluationQuestionMeta>;
  text: Scalars['String']['output'];
};

/** Base type for all evaluations */
export type EvaluationQuestion = {
  _id: Scalars['ObjectId']['output'];
  canonicalId: Scalars['String']['output'];
  /** Whether the question has been answered */
  hasBeenAnswered: Scalars['Boolean']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<EvaluationQuestionMeta>;
  text: Scalars['String']['output'];
};

/** Meta information about an evaluation question */
export type EvaluationQuestionMeta = {
  __typename?: 'EvaluationQuestionMeta';
  /** The end date of the component, can be used in the UI to group questions by day */
  componentEndDate?: Maybe<Scalars['Date']['output']>;
  /** The start time of the component, can be used in the UI to help order questions */
  componentStartTime?: Maybe<Scalars['Time']['output']>;
  /** The placement type of the question, can be used in the UI to determine where the question should be displayed */
  placementType?: Maybe<EvaluationQuestionPlacementType>;
};

export enum EvaluationQuestionPlacementType {
  PreDeparture = 'PRE_DEPARTURE',
  PreDepartureEnd = 'PRE_DEPARTURE_END'
}

export type EvaluationResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | EvaluationSuccess | InvalidDateError | InvalidEvaluationError | NotAuthorizedError | NotFoundError | ValidationError;

export enum EvaluationScoreLevel {
  Average = 'AVERAGE',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Na = 'NA',
  Poor = 'POOR'
}

/** Evaluation score range */
export type EvaluationScoreRange = {
  __typename?: 'EvaluationScoreRange';
  /** Label for the score range */
  label: Scalars['String']['output'];
  /** Score level */
  level: EvaluationScoreLevel;
  /** Maximum score */
  max: Scalars['Float']['output'];
  /** Minimum score */
  min: Scalars['Float']['output'];
  /** the percentage of items within this range */
  percentage: Scalars['Float']['output'];
  /** the number of items within this range */
  value: Scalars['Int']['output'];
};

/** Evaluation settings */
export type EvaluationSettings = {
  __typename?: 'EvaluationSettings';
  /** the default template string for component questions, example: 'How was your experience with <COMPONENT_NAME>'  */
  componentQuestionText: Scalars['String']['output'];
  /** Customer evaluation settings */
  customerEvaluationSettings: CustomerEvaluationSettings;
  /** Tour director tour end report settings */
  tourDirectorTourEndReportSettings: TourDirectorTourEndReportSettings;
};

export type EvaluationSuccess = {
  __typename?: 'EvaluationSuccess';
  data: Evaluation;
};

/** Evaluation statistics customer response */
export type EvaluationSummaryCustomerResponse = {
  __typename?: 'EvaluationSummaryCustomerResponse';
  /** The level of the response, can be used to highlight good or bad responses */
  level: EvaluationScoreLevel;
  /** The response populated by the additional comments field in the user's answer */
  response: Scalars['String']['output'];
  /** The selected value of the tour director question by the user. This should be a whole number */
  score: Scalars['Int']['output'];
};

export enum EvaluationType {
  CustomerEvaluation = 'CUSTOMER_EVALUATION',
  TourDirectorTourEndReport = 'TOUR_DIRECTOR_TOUR_END_REPORT'
}

export enum ExcursionTourType {
  Extension = 'EXTENSION',
  MainTour = 'MAIN_TOUR'
}

/** Product that represents an extended stay pre or post tour */
export type ExtendedStay = PricedTripComponent & TripComponent & {
  __typename?: 'ExtendedStay';
  _id: Scalars['ObjectId']['output'];
  basePrice: Amount;
  bedCode: TourBedCode;
  businessCode?: Maybe<BusinessCode>;
  /** Additional information about the gateway */
  cityGateway?: Maybe<Gateway>;
  cityGatewayCode: Scalars['String']['output'];
  hasPriceRules: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};

export type ExtendedStayLineItem = LineItem & {
  __typename?: 'ExtendedStayLineItem';
  _id: Scalars['ObjectId']['output'];
  /** The bed code for the extended stay */
  bedCode?: Maybe<TourBedCode>;
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  /** Additional information about the city gateway */
  cityGateway?: Maybe<Gateway>;
  cityGatewayCode: Scalars['String']['output'];
  departureDate: Scalars['Date']['output'];
  endDate: Scalars['Date']['output'];
  isOpen: Scalars['Boolean']['output'];
  isPreStay: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

/** A paginated result of Extended Stays */
export type ExtendedStayPaginatedResult = {
  __typename?: 'ExtendedStayPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<ExtendedStay>;
};

export type ExternalToken = {
  __typename?: 'ExternalToken';
  token: Scalars['String']['output'];
};

export type FaqContent = {
  __typename?: 'FaqContent';
  items: Array<FaqContentItem>;
};

export type FaqContentItem = {
  __typename?: 'FaqContentItem';
  answer?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type Fee = PricedTripComponent & TripComponent & {
  __typename?: 'Fee';
  _id: Scalars['ObjectId']['output'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  categoryCode: Scalars['FeeCategoryCode']['output'];
  hasPriceRules: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isRefundable: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  priceRules: Array<PriceRule>;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: TripComponentStatus;
  type: TripComponentType;
  typeCode: FeeTypeCode;
};

export type FeeApplicationInfo = {
  __typename?: 'FeeApplicationInfo';
  applyTo: FeeApplicationInstructions;
  fee: FeeLineItem;
};

/** Instructs how to apply the fee to the trips on a Quote */
export enum FeeApplicationInstructions {
  AllTrips = 'ALL_TRIPS',
  PrimaryTripOnly = 'PRIMARY_TRIP_ONLY',
  RelevantTrips = 'RELEVANT_TRIPS'
}

export type FeeCalculationRule = {
  __typename?: 'FeeCalculationRule';
  /** Defines the maximum DPD value for this rule to match */
  maxDpd: Scalars['Int']['output'];
  /** The strategy to use when calculating the fee */
  strategy: FeeCalculationStrategy;
  /** The percentage of the trip cost to use for the fee */
  tripPercent: Scalars['Percentage']['output'];
};

export enum FeeCalculationStrategy {
  GreaterFeePriceOrTripCostPercent = 'GreaterFeePriceOrTripCostPercent',
  TripCostPercent = 'TripCostPercent'
}

/** Category Calculation Rule Settings */
export type FeeCancellationSettings = {
  __typename?: 'FeeCancellationSettings';
  categorySpecificRules: Array<FeeCategorySpecificCalculationRule>;
  defaultRules: Array<FeeCalculationRule>;
};

/** Category Calculation Rule Settings */
export type FeeCategorySpecificCalculationRule = {
  __typename?: 'FeeCategorySpecificCalculationRule';
  categoryCodes: Array<Scalars['FeeCategoryCode']['output']>;
  rules: Array<FeeCalculationRule>;
};

/** A product line item */
export type FeeLineItem = LineItem & {
  __typename?: 'FeeLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

/** A paginated result of Fees */
export type FeePaginatedResult = {
  __typename?: 'FeePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Fee>;
};

/** Fee settings */
export type FeeSettings = {
  __typename?: 'FeeSettings';
  /** Settings for calculating cancellation fees */
  cancellationSettings: FeeCancellationSettings;
  useLowestDpdInRebookingChain: Scalars['Boolean']['output'];
};

export enum FeeSortField {
  CategoryCode = 'categoryCode',
  LineItemCode = 'lineItemCode'
}

export enum FeeTypeCode {
  Cax = 'CAX',
  Flightaddcollect = 'FLIGHTADDCOLLECT',
  Flightcax = 'FLIGHTCAX',
  Flightchange = 'FLIGHTCHANGE',
  Latebooking = 'LATEBOOKING',
  Latepay = 'LATEPAY',
  Mpp = 'MPP',
  Payfail = 'PAYFAIL',
  Rebook = 'REBOOK',
  Refundprocessing = 'REFUNDPROCESSING',
  Retcheck = 'RETCHECK',
  Sptravel = 'SPTRAVEL',
  Tsa = 'TSA'
}

export type FilterAdjustmentInput = {
  adjustmentCode?: InputMaybe<Scalars['String']['input']>;
  businessCode?: InputMaybe<BusinessCode>;
  isCompanionDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  isFreePlace?: InputMaybe<Scalars['Boolean']['input']>;
  isStaffOnTour?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type FilterBookingInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  dateBooked?: InputMaybe<Scalars['DateTime']['input']>;
  dateBookedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateBookedTo?: InputMaybe<Scalars['DateTime']['input']>;
  departureDateFrom?: InputMaybe<Scalars['Date']['input']>;
  departureDateTo?: InputMaybe<Scalars['Date']['input']>;
  departureId?: InputMaybe<Scalars['ObjectId']['input']>;
  finalPaymentDateFrom?: InputMaybe<Scalars['Date']['input']>;
  finalPaymentDateTo?: InputMaybe<Scalars['Date']['input']>;
  isEnrolledInAutopay?: InputMaybe<Scalars['Boolean']['input']>;
  lastAutopayTransactionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Filter input for campaigns. */
export type FilterCampaignInput = {
  businessCode?: InputMaybe<BusinessCode>;
  campaignCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  promoIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  status?: InputMaybe<CampaignStatus>;
  /** Include only valid active campaigns. */
  valid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters for category query */
export type FilterCategoryInput = {
  businessCode?: InputMaybe<BusinessCode>;
};

export type FilterCustomerInput = {
  /** Search by id */
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  /** Search by email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Search by first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Search by last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Search by phone number */
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Search first name, last name, email and phone number */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCustomerTripsInput = {
  businessCode: BusinessCode;
};

export type FilterDepartureInput = {
  addOnPriceCADFrom?: InputMaybe<Scalars['Float']['input']>;
  addOnPriceCADTo?: InputMaybe<Scalars['Float']['input']>;
  addOnPriceUSDFrom?: InputMaybe<Scalars['Float']['input']>;
  addOnPriceUSDTo?: InputMaybe<Scalars['Float']['input']>;
  businessCode?: InputMaybe<BusinessCode>;
  capacityFrom?: InputMaybe<Scalars['Int']['input']>;
  capacityTo?: InputMaybe<Scalars['Int']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  departureRange?: InputMaybe<DateOnlyRangeInput>;
  dpdFrom?: InputMaybe<Scalars['Int']['input']>;
  dpdTo?: InputMaybe<Scalars['Int']['input']>;
  endDateRange?: InputMaybe<DateOnlyRangeInput>;
  endGatewayCode?: InputMaybe<Scalars['String']['input']>;
  exclusivityType?: InputMaybe<DepartureExclusivityType>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemCodes?: InputMaybe<Array<Scalars['LineItemCode']['input']>>;
  priceCADFrom?: InputMaybe<Scalars['Float']['input']>;
  priceCADTo?: InputMaybe<Scalars['Float']['input']>;
  priceUSDFrom?: InputMaybe<Scalars['Float']['input']>;
  priceUSDTo?: InputMaybe<Scalars['Float']['input']>;
  priceYear?: InputMaybe<Scalars['Int']['input']>;
  prodTourId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  startDateRange?: InputMaybe<DateOnlyRangeInput>;
  startGatewayCode?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<DepartureStatus>>;
  tourCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAtTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterEmployeeInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type FilterExtendedStayInput = {
  bedCode?: InputMaybe<TourBedCode>;
  businessCode?: InputMaybe<BusinessCode>;
  cityGatewayCode?: InputMaybe<Scalars['String']['input']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type FilterFeeInput = {
  businessCode?: InputMaybe<BusinessCode>;
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type FilterFlightPackageInput = {
  arrivalGatewayCode?: InputMaybe<Scalars['String']['input']>;
  businessCode?: InputMaybe<BusinessCode>;
  departureGatewayCode?: InputMaybe<Scalars['String']['input']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomGateway?: InputMaybe<Scalars['Boolean']['input']>;
  isPriced?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type FilterGcDepartureInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  businessCode?: InputMaybe<BusinessCode>;
  departureDateRange?: InputMaybe<DateOnlyRangeInput>;
  departureIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  groupCoordinatorCustomerIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  opportunityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationDateRange?: InputMaybe<DateOnlyRangeInput>;
  statuses?: InputMaybe<Array<GcDepartureStatus>>;
  tourCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FilterGcDepartureProspectInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']['input']>;
  groupCoordinatorCustomerId?: InputMaybe<Scalars['ObjectId']['input']>;
  levelOfInterest?: InputMaybe<Array<GcDepartureProspectLevelOfInterest>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FilterGatewayInput = {
  cityCode?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  isCityCodeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterInsurancePlanInput = {
  businessCode?: InputMaybe<BusinessCode>;
  planCode?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type FilterNoteInput = {
  employeeId?: InputMaybe<Scalars['ObjectId']['input']>;
  targetId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type FilterOpportunityQuotesInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId: Scalars['ObjectId']['input'];
  expirationDateRange?: InputMaybe<DateRangeInput>;
  /** Will return quotes that have a valid opportunity ID */
  hasOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Will return quotes that have a GC departure ID */
  isGCDeparture: Scalars['Boolean']['input'];
  /** Will return quotes that are currently saved */
  isSaved?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityId: Scalars['String']['input'];
};

export type FilterOrderInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  departureDate?: InputMaybe<Scalars['Date']['input']>;
  departureId?: InputMaybe<Scalars['ObjectId']['input']>;
  stage?: InputMaybe<OrderStage>;
};

export type FilterPaymentReconciliationTransactionInput = {
  businessCode?: InputMaybe<BusinessCode>;
  reconciliationStatus?: InputMaybe<ReconciliationStatus>;
  uploadDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  uploadDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  uploadId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type FilterPaymentReconciliationUploadInput = {
  businessCode?: InputMaybe<BusinessCode>;
  sourceProcessorOrAcquirer?: InputMaybe<SourceProcessorOrAcquirer>;
  uploadDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  uploadDateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterPaymentTransactionInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  dateBooked?: InputMaybe<Scalars['DateTime']['input']>;
  dateBookedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateBookedTo?: InputMaybe<Scalars['DateTime']['input']>;
  departureId?: InputMaybe<Scalars['ObjectId']['input']>;
  transactionDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  transactionDateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Filter input for promo audience members. */
export type FilterPromoAudienceMemberInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  offerCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PromoAudienceMemberType>;
};

export type FilterPromoInput = {
  _ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  audienceMemberTypes?: InputMaybe<Array<PromoAudienceMemberType>>;
  businessCode?: InputMaybe<BusinessCode>;
  customerIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The effective start date of a promo. */
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** The effective end date of a promo. */
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  exclusivity?: InputMaybe<PromoExclusivity>;
  gcDepartureIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  isGroupsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenFromSales?: InputMaybe<Scalars['Boolean']['input']>;
  isIndiesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemCode?: InputMaybe<Scalars['String']['input']>;
  /** Max number of redemptions */
  maxRedeemed?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum value for the maxRedemptions */
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  /** Min number of redemptions */
  minRedeemed?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum value for the maxRedemptions */
  minRedemptions?: InputMaybe<Scalars['Int']['input']>;
  offerCode?: InputMaybe<Scalars['String']['input']>;
  promoCategories?: InputMaybe<Array<PromoCategory>>;
  promoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TripComponentStatus>;
  /** Include only valid active promos. */
  valid?: InputMaybe<Scalars['Boolean']['input']>;
  validForCustomerIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  validForGCDepartureIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  validShareableCustomerIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type FilterQuoteInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  expirationDateRange?: InputMaybe<DateRangeInput>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** Will return quotes that have a valid opportunity ID */
  hasOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Will return quotes that have a GC departure ID */
  isGCDeparture?: InputMaybe<Scalars['Boolean']['input']>;
  /** Will return quotes that are currently saved */
  isSaved?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  /** Will return quotes that have been saved at any point in the past, regardless of their current state */
  previouslySaved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterRoleInput = {
  businessCode?: InputMaybe<BusinessCode>;
  permissionKeys?: InputMaybe<Array<PermissionKey>>;
  query?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type FilterServiceRecoveryInput = {
  businessCode?: InputMaybe<BusinessCode>;
  orderId?: InputMaybe<Scalars['ObjectId']['input']>;
  promoId?: InputMaybe<Scalars['ObjectId']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  recoveryReason?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['ObjectId']['input']>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

/** Filters for tag query */
export type FilterTagInput = {
  businessCode?: InputMaybe<BusinessCode>;
  query?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

/** Filter Tour Directors by specific criteria */
export type FilterTourDirectorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterTourEndReportInput = {
  departureId?: InputMaybe<Scalars['ObjectId']['input']>;
  tourDirectorId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type FilterTourExcursionInput = {
  autoApprovedDeadlineDpdFrom?: InputMaybe<Scalars['Int']['input']>;
  autoApprovedDeadlineDpdTo?: InputMaybe<Scalars['Int']['input']>;
  basePriceCADFrom?: InputMaybe<Scalars['Float']['input']>;
  basePriceCADTo?: InputMaybe<Scalars['Float']['input']>;
  basePriceUSDFrom?: InputMaybe<Scalars['Float']['input']>;
  basePriceUSDTo?: InputMaybe<Scalars['Float']['input']>;
  businessCode?: InputMaybe<BusinessCode>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']['input']>;
  matchCode?: InputMaybe<Scalars['String']['input']>;
  minNbTravelersRequiredFrom?: InputMaybe<Scalars['Int']['input']>;
  minNbTravelersRequiredTo?: InputMaybe<Scalars['Int']['input']>;
  priceYear?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type FilterTourExcursionSpecInput = {
  businessCode?: InputMaybe<BusinessCode>;
  matchCode?: InputMaybe<Scalars['String']['input']>;
  matchCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterTourExtensionInput = {
  autoApproveDeadlineDpdFrom?: InputMaybe<Scalars['Int']['input']>;
  autoApproveDeadlineDpdTo?: InputMaybe<Scalars['Int']['input']>;
  basePriceCADFrom?: InputMaybe<Scalars['Float']['input']>;
  basePriceCADTo?: InputMaybe<Scalars['Float']['input']>;
  basePriceUSDFrom?: InputMaybe<Scalars['Float']['input']>;
  basePriceUSDTo?: InputMaybe<Scalars['Float']['input']>;
  bedCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  businessCode?: InputMaybe<BusinessCode>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  defaultCapacityFrom?: InputMaybe<Scalars['Int']['input']>;
  defaultCapacityTo?: InputMaybe<Scalars['Int']['input']>;
  endGatewayCode?: InputMaybe<Scalars['String']['input']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPreExtension?: InputMaybe<Scalars['Boolean']['input']>;
  nbTourDaysFrom?: InputMaybe<Scalars['Int']['input']>;
  nbTourDaysTo?: InputMaybe<Scalars['Int']['input']>;
  priceYear?: InputMaybe<Scalars['Int']['input']>;
  startGatewayCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TripComponentStatus>;
  tourCode?: InputMaybe<Scalars['String']['input']>;
  tourType?: InputMaybe<Scalars['String']['input']>;
  tourTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type FilterTourInput = {
  bedCodes?: InputMaybe<Array<TourBedCode>>;
  businessCode?: InputMaybe<BusinessCode>;
  createdAtRange?: InputMaybe<DateOnlyRangeInput>;
  defaultCapacityFrom?: InputMaybe<Scalars['Int']['input']>;
  defaultCapacityTo?: InputMaybe<Scalars['Int']['input']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrivateGroup?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isNonRevenueTour?: InputMaybe<Scalars['Boolean']['input']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  nbTourDaysFrom?: InputMaybe<Scalars['Int']['input']>;
  nbTourDaysTo?: InputMaybe<Scalars['Int']['input']>;
  priceYear?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TripComponentStatus>;
  tourCode?: InputMaybe<Scalars['String']['input']>;
  tourCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  tourType?: InputMaybe<TourType>;
  tourTypeCode?: InputMaybe<TourTypeCode>;
};

export type FilterTourPageContentInput = {
  businessCode: BusinessCode;
  language: Scalars['String']['input'];
  market: Scalars['String']['input'];
};

export type FilterTourSpecInput = {
  businessCode?: InputMaybe<BusinessCode>;
  tourCode?: InputMaybe<Scalars['String']['input']>;
  tourCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterTripChecklistItemTemplateInput = {
  businessCode?: InputMaybe<BusinessCode>;
};

export type FilterVoucherInput = {
  bookingId?: InputMaybe<Scalars['ObjectId']['input']>;
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  expirationDateRange?: InputMaybe<DateOnlyRangeInput>;
  isRefundable?: InputMaybe<Scalars['Boolean']['input']>;
  issueDateRange?: InputMaybe<DateOnlyRangeInput>;
  statuses?: InputMaybe<Array<VoucherStatus>>;
};

export type FlightOffer = {
  __typename?: 'FlightOffer';
  appliedToTrip: Scalars['Boolean']['output'];
  discountAmount?: Maybe<Money>;
  flight: FlightPackage;
  salePrice?: Maybe<Money>;
};

/** Product that represents a flight from one Gateway to another */
export type FlightPackage = PricedTripComponent & TripComponent & {
  __typename?: 'FlightPackage';
  _id: Scalars['ObjectId']['output'];
  /** Additional information about the arrival gateway */
  arrivalGateway?: Maybe<Gateway>;
  arrivalGatewayCode: Scalars['String']['output'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  /** Additional information about the departure gateway */
  departureGateway?: Maybe<Gateway>;
  departureGatewayCode: Scalars['String']['output'];
  hasPriceRules: Scalars['Boolean']['output'];
  isCustomGateway: Scalars['Boolean']['output'];
  isLandOnly: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  /** Price for a given departure date */
  price: Amount;
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};


/** Product that represents a flight from one Gateway to another */
export type FlightPackagePriceArgs = {
  departureDate: Scalars['Date']['input'];
};

/** Departing or Returning flight line item and configuration */
export type FlightPackageLineItem = LineItem & {
  __typename?: 'FlightPackageLineItem';
  _id: Scalars['ObjectId']['output'];
  airportTransfer?: Maybe<AirportTransfer>;
  /** Additional information about the arrival gateway */
  arrivalGateway?: Maybe<Gateway>;
  arrivalGatewayCode: Scalars['String']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  departureDate: Scalars['Date']['output'];
  /** Additional information about the departure gateway */
  departureGateway?: Maybe<Gateway>;
  departureGatewayCode: Scalars['String']['output'];
  flightType: FlightType;
  isEligibleForAirportTransfer?: Maybe<Scalars['Boolean']['output']>;
  isLandOnly: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  stopOver?: Maybe<StopOver>;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

/** A paginated result of Flight Packages */
export type FlightPackagePaginatedResult = {
  __typename?: 'FlightPackagePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<FlightPackage>;
};

/** Flight settings */
export type FlightSettings = {
  __typename?: 'FlightSettings';
  allowedStopoverGatewayCodes: Array<Scalars['String']['output']>;
};

export enum FlightType {
  Departing = 'DEPARTING',
  Returning = 'RETURNING'
}

export type ForkBookingInput = {
  fromBookingId: Scalars['ObjectId']['input'];
  newPrimaryTripId: Scalars['ObjectId']['input'];
  transferInputs: Array<ForkTransferInput>;
  tripIds: Array<Scalars['ObjectId']['input']>;
};

export type ForkBookingResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type ForkTransferInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  paymentMethodHash?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Please begin using paymentMethodHash */
  savedPaymentMethodId?: InputMaybe<Scalars['ObjectId']['input']>;
};

/** A collection of travelers (GMs) booking under a Group Coordinator (GC) on a given Departure */
export type GcDeparture = {
  __typename?: 'GCDeparture';
  _id: Scalars['ObjectId']['output'];
  /** The actual price of the private group fee, if it were assessed based on the number of confirmed trips at the time of the API call. */
  actualPrivateGroupFeePrice?: Maybe<Money>;
  /** Adjustments that will be automatically applied to new GM quotes for this GC Departure */
  autoAppliedAdjustments: Array<GcDepartureAdjustment>;
  averageProgramPrice?: Maybe<Money>;
  businessCode: BusinessCode;
  cancelledTrips?: Maybe<Array<BookingTrip>>;
  /** The percentage of the average program fee that counts towards a companion discount for each traveler not already counting towards a free place */
  companionDiscountRate: GcDepartureBenefitRate;
  /** A summary of the companion discount benefit for the GC */
  companionDiscountSummary?: Maybe<GcDepartureCompanionDiscountSummary>;
  confirmedTrips?: Maybe<Array<BookingTrip>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  departure?: Maybe<Departure>;
  /** The date of the departure */
  departureDate: Scalars['Date']['output'];
  /** The Departure this group is traveling on */
  departureId: Scalars['ObjectId']['output'];
  /** Includes the date at which eTicket information is released, and whether or not it is already released */
  eTicketsRelease?: Maybe<ReleaseDetails>;
  /** The price of the private group fee, if it were assessed based on the estimated group size. Used as an estimation tool. Requires the groupSizeEstimate to be set. */
  estimatedPrivateGroupFeePrice?: Maybe<Money>;
  /** The expected number of travelers in the group, used as the stretch goal for the GC */
  expectedVolume?: Maybe<Scalars['Int']['output']>;
  /** Includes the date at which flights are released, and whether or not they are already released */
  flightsRelease?: Maybe<ReleaseDetails>;
  /** The date at which flights are released */
  flightsReleasedDate?: Maybe<Scalars['Date']['output']>;
  /** The rate at which the GC earns free places based on the number of travelers paying for an insurance plan */
  freeInsuranceRatio: Scalars['FreePlaceRatio']['output'];
  /** The rate at which the GC earns free places based on the number of travelers paying for a certain trip component */
  freePlaceRatio: Scalars['FreePlaceRatio']['output'];
  /** A breakdown of free places earned and applied for the various components of bookings on this GCDeparture */
  freePlaceSummary: GcDepartureFreePlaceSummary;
  gcProfileContent?: Maybe<GcProfileContent>;
  groupCoordinator?: Maybe<Customer>;
  /** The customer ID of the GC for this group */
  groupCoordinatorCustomerId: Scalars['ObjectId']['output'];
  /** A configurable estimate of the number of travelers, used to estimate the private group fee */
  groupSizeEstimate?: Maybe<Scalars['Int']['output']>;
  /** Whether or not the private group fee should be assessed at the time of reconciliation */
  includePrivateGroupFee: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  isGroupCoordinator: Scalars['Boolean']['output'];
  isNonBookedGroupCoordinator: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  /** Rules that govern whether certain line items must, should, or cannot be added to group member trips */
  lineItemRules?: Maybe<Array<GcDepartureRule>>;
  micrositeContent?: Maybe<MicrositeContent>;
  /**
   * The URL of the microsite where GMs can quote and book
   * @deprecated Use micrositeUrls instead
   */
  micrositeUrl?: Maybe<Scalars['String']['output']>;
  micrositeUrls: GcDepartureMicrositeUrls;
  nbTravelersCancelled: Scalars['Int']['output'];
  nbTravelersConfirmed: Scalars['Int']['output'];
  nbTravelersConfirmedLandOnly: Scalars['Int']['output'];
  nbTravelersConfirmedWithFlights: Scalars['Int']['output'];
  nbTravelersRebooked: Scalars['Int']['output'];
  nbTravelersRequested: Scalars['Int']['output'];
  nbTravelersWaitlisted: Scalars['Int']['output'];
  nbTravelersWithExtension: Scalars['Int']['output'];
  nbTravelersWithInsurance: Scalars['Int']['output'];
  /** @deprecated No longer a valid status */
  onHoldTrips?: Maybe<Array<BookingTrip>>;
  /** The Salesforce Opportunity ID associated with this GCDeparture, if any */
  opportunityId?: Maybe<Scalars['String']['output']>;
  pendingRebookingTrips?: Maybe<Array<BookingTrip>>;
  /** The primary currency code that will be used to generate price previews and record benefits */
  primaryCurrencyCode: CurrencyCode;
  /** A summary of the pricing for a potential group member quote for this GCDeparture */
  quoteSummary?: Maybe<GcDepartureQuoteSummary>;
  rebookedTrips?: Maybe<Array<BookingTrip>>;
  /** Rules that govern whether certain line items should be added to group member trips */
  recommendedLineItemRules?: Maybe<Array<GcDepartureRule>>;
  /** The date at which EF will review the GCDeparture to assess fees and redeem benefits for the GC */
  reconciliationDate: Scalars['Date']['output'];
  /** The date of the recruitment meeting for the GC to promote the GCDeparture */
  recruitmentMeetingDate?: Maybe<Scalars['Date']['output']>;
  /** The remaining amount of money available to be awarded to the GC a stipend, based on the average program price and any stipend already redeemed */
  remainingStipendAmountAvailable?: Maybe<Money>;
  requestedTrips?: Maybe<Array<BookingTrip>>;
  /** Rules that govern whether certain line items must be added to group member trips */
  requiredLineItemRules?: Maybe<Array<GcDepartureRule>>;
  /** Rules that govern whether certain line items cannot be added to group member trips */
  restrictedLineItemRules?: Maybe<Array<GcDepartureRule>>;
  status: GcDepartureStatus;
  /** A breakdown of the stipend benefit for the GC */
  stipendDetail?: Maybe<GcDepartureStipendDetail>;
  /** The percentage of the average program fee that counts towards the stipend for each traveler not already counting towards a free place */
  stipendRate: GcDepartureBenefitRate;
  /** The terms signed by the group coordinator */
  termsSignature?: Maybe<TermsSignature>;
  /** The tour code associated with the departure */
  tourCode: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  waitlistedTrips?: Maybe<Array<BookingTrip>>;
};


/** A collection of travelers (GMs) booking under a Group Coordinator (GC) on a given Departure */
export type GcDepartureGcProfileContentArgs = {
  language: Scalars['String']['input'];
};


/** A collection of travelers (GMs) booking under a Group Coordinator (GC) on a given Departure */
export type GcDepartureMicrositeContentArgs = {
  language: Scalars['String']['input'];
};

/** Configuration allowing the user to specify which adjustments should auto-apply to GM quotes on a GC Departure. Prices are determined by the settings in this object and visibility is set on the Adjustment itself */
export type GcDepartureAdjustment = {
  __typename?: 'GCDepartureAdjustment';
  adjustment?: Maybe<Adjustment>;
  amount: Amount;
  lineItemCode: Scalars['LineItemCode']['output'];
  /** @deprecated Do not use this field. This field is no longer in use and will be removed in a future release. We're keeping it for backward compatibility. Use amount instead. */
  price: Money;
};

/** An integer representing the percentage a GC earns when redeeming certain types of benefits */
export type GcDepartureBenefitRate = {
  __typename?: 'GCDepartureBenefitRate';
  asDecimal: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export enum GcDepartureCancellationCategory {
  Financial = 'FINANCIAL',
  LifeEvent = 'LIFE_EVENT',
  ProductTransition = 'PRODUCT_TRANSITION',
  TravelerDiscontent = 'TRAVELER_DISCONTENT',
  TravelRequirementNotMet = 'TRAVEL_REQUIREMENT_NOT_MET',
  Unknown = 'UNKNOWN',
  WojoCancellation = 'WOJO_CANCELLATION',
  WorldEvent = 'WORLD_EVENT'
}

export type GcDepartureCompanionDiscountSummary = {
  __typename?: 'GCDepartureCompanionDiscountSummary';
  /** The total amount of money that has been applied to trips as a companion discount */
  amountApplied: Money;
  /** The remaining amount of money available to be applied to trips as a companion discount */
  amountAvailable: Money;
  /** The IDs of the trips that have had the companion discount applied to them */
  appliedToTripIds: Array<Scalars['ObjectId']['output']>;
  /** The trips that have had the companion discount applied to them */
  appliedToTrips: Array<BookingTrip>;
};

/** A preview of a flight package that a group member could add to their quote */
export type GcDepartureFlightPackageSummary = {
  __typename?: 'GCDepartureFlightPackageSummary';
  /** The date that this flight will depart based on whether the extension is recommended or required */
  departureDate: Scalars['Date']['output'];
  flightPackage: FlightPackage;
  /** The price in the gcDeparture's primaryCurrencyCode */
  price: Money;
};

export type GcDepartureFreePlaceDetail = {
  __typename?: 'GCDepartureFreePlaceDetail';
  /** The IDs of the trips that have had the free places applied to them for this trip component */
  appliedToTripIds: Array<Scalars['ObjectId']['output']>;
  /** The trips that have had the free places applied to them for this trip component */
  appliedToTrips: Array<BookingTrip>;
  /** The number of free places earned for this trip component */
  placesEarned: Scalars['Int']['output'];
};

export type GcDepartureFreePlaceExcursionDetail = {
  __typename?: 'GCDepartureFreePlaceExcursionDetail';
  /** The IDs of the trips that have had the free places applied to them */
  appliedToTripIds: Array<Scalars['ObjectId']['output']>;
  /** The trips that have had the free places applied to them */
  appliedToTrips: Array<BookingTrip>;
  /** The line item code of the excursion */
  lineItemCode: Scalars['LineItemCode']['output'];
  /** The number of free places earned for the excursion */
  placesEarned: Scalars['Int']['output'];
};

export type GcDepartureFreePlaceSummary = {
  __typename?: 'GCDepartureFreePlaceSummary';
  excursions: Array<GcDepartureFreePlaceExcursionDetail>;
  extension?: Maybe<GcDepartureFreePlaceDetail>;
  insurance: GcDepartureFreePlaceDetail;
  tour: GcDepartureFreePlaceDetail;
};

export type GcDepartureMicrositeUrls = {
  __typename?: 'GCDepartureMicrositeUrls';
  ca?: Maybe<Scalars['String']['output']>;
  us?: Maybe<Scalars['String']['output']>;
};

/** A paginated result of Departures */
export type GcDeparturePaginatedResult = {
  __typename?: 'GCDeparturePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<GcDeparture>;
};

/** A prospective traveler aspiring to book under a Group Coordinator (GC) on a given Departure */
export type GcDepartureProspect = {
  __typename?: 'GCDepartureProspect';
  _id: Scalars['ObjectId']['output'];
  address?: Maybe<Address>;
  bookedTrip?: Maybe<BookingTrip>;
  businessCode?: Maybe<BusinessCode>;
  cancelledTrip?: Maybe<BookingTrip>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName: Scalars['String']['output'];
  gcDeparture?: Maybe<GcDeparture>;
  gcDepartureId: Scalars['ObjectId']['output'];
  groupCoordinatorCustomerId: Scalars['ObjectId']['output'];
  isBooked: Scalars['Boolean']['output'];
  /** Check if GC Departure of the Prospect is in the past */
  isPast?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  levelOfInterest?: Maybe<GcDepartureProspectLevelOfInterest>;
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum GcDepartureProspectLevelOfInterest {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** A paginated result of GC Departure Prospects. */
export type GcDepartureProspectPaginatedResult = {
  __typename?: 'GCDepartureProspectPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<GcDepartureProspect>;
};

export type GcDepartureProspectRemovedResult = {
  __typename?: 'GCDepartureProspectRemovedResult';
  removedId: Scalars['ObjectId']['output'];
};

export enum GcDepartureProspectSortField {
  BusinessCode = 'businessCode',
  CustomerId = 'customerId',
  Email = 'email',
  FirstName = 'firstName',
  GcDepartureId = 'gcDepartureId',
  GroupCoordinatorCustomerId = 'groupCoordinatorCustomerId',
  LastName = 'lastName',
  LevelOfInterest = 'levelOfInterest',
  Notes = 'notes',
  PhoneNumber = 'phoneNumber'
}

/** A slice of the pricing summary of a potential group member quote for a GC departure */
export type GcDepartureQuoteSummary = {
  __typename?: 'GCDepartureQuoteSummary';
  departingFlightSummary?: Maybe<GcDepartureFlightPackageSummary>;
  insurancePlanOffers: Array<InsurancePlanOffer>;
  privateGroupFeePrice?: Maybe<Money>;
  returningFlightSummary?: Maybe<GcDepartureFlightPackageSummary>;
  totalFlightPackagePrice?: Maybe<Money>;
  /** The base price of the quote with all items recommended by the GC. Includes the tour, extension, optionals, and flight packages */
  totalWithRecommendItems: Money;
  /** The base price of the quote with all items required by the GC. Includes the tour, extension, optionals, and flight packages */
  totalWithRequiredItems: Money;
};

export type GcDepartureQuoteSummaryAdjustmentInput = {
  amount: Array<MoneyInput>;
  lineItemCode: Scalars['LineItemCode']['input'];
  /** @deprecated Do not use this field. This field is no longer in use and will be removed in a future release. We're keeping it for backward compatibility. Use amount instead. */
  price?: MoneyInput;
};

export type GcDepartureQuoteSummaryInput = {
  /** The ID of the GC Departure to calculate a quote summary for */
  _id: Scalars['ObjectId']['input'];
  autoAppliedAdjustments?: InputMaybe<Array<GcDepartureQuoteSummaryAdjustmentInput>>;
  effectivePrivateGroupFeeGroupSize?: InputMaybe<Scalars['Int']['input']>;
  includePrivateGroupFee?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemRules: Array<GcDepartureQuoteSummaryLineItemRuleInput>;
};

export type GcDepartureQuoteSummaryLineItemRuleInput = {
  level: GcDepartureRuleLevel;
  lineItemCode: Scalars['LineItemCode']['input'];
  lineItemType: GcDepartureRuleLineItemType;
};

/** Allows a GC to require, recommend, or restrict certains line item */
export type GcDepartureRule = {
  __typename?: 'GCDepartureRule';
  level: GcDepartureRuleLevel;
  lineItemCode: Scalars['LineItemCode']['output'];
  lineItemType: GcDepartureRuleLineItemType;
};

export enum GcDepartureRuleLevel {
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED',
  Restricted = 'RESTRICTED'
}

export enum GcDepartureRuleLineItemType {
  DepartingFlight = 'DEPARTING_FLIGHT',
  Excursion = 'EXCURSION',
  Extension = 'EXTENSION',
  ReturningFlight = 'RETURNING_FLIGHT'
}

/** GC Departure settings */
export type GcDepartureSettings = {
  __typename?: 'GCDepartureSettings';
  /** The DPD at which this business expects flight segments to have e-ticket numbers populated */
  eTicketsAvailabilityDpd?: Maybe<Scalars['Int']['output']>;
  /** The DPD at which this business expects flights information populated */
  flightsReleasedDpd?: Maybe<Scalars['Int']['output']>;
  /** The estimated days after the flights release date which this business expects flights information to be populated */
  nbEstimatedDaysForFlightRelease?: Maybe<Scalars['Int']['output']>;
  reconciliationDpd?: Maybe<Scalars['Int']['output']>;
};

export enum GcDepartureSortField {
  DepartureDate = 'departureDate',
  ReconciliationDate = 'reconciliationDate',
  Status = 'status'
}

export enum GcDepartureStatus {
  /** The GC Departure has been cancelled, along with the associated Trips */
  Cancelled = 'CANCELLED',
  /** The GC Departure has been prepped for booking and GMs can book */
  Confirmed = 'CONFIRMED',
  /** The GC is in the process of rebooking their group onto a new Departure */
  PendingRebooking = 'PENDING_REBOOKING',
  /** The GC Departure has been prepped for pricing but Trips cannot be booked against it yet */
  Quoted = 'QUOTED',
  /** The GC Departure has been rebooked onto a new Departure and will be tracked separately on a new GC Departure */
  Rebooked = 'REBOOKED'
}

/** The status of any stipend issued to the GC */
export type GcDepartureStipendDetail = {
  __typename?: 'GCDepartureStipendDetail';
  amount?: Maybe<Money>;
  cancelledDate?: Maybe<Scalars['Date']['output']>;
  checkNumber?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['Date']['output']>;
  status: GcDepartureStipendDetailStatus;
};

export enum GcDepartureStipendDetailStatus {
  Cancelled = 'CANCELLED',
  PaidOut = 'PAID_OUT',
  Pending = 'PENDING'
}

/** A past group member of a GC with all their past trips with the GC. */
export type GcPastGroupMember = {
  __typename?: 'GCPastGroupMember';
  customer?: Maybe<Customer>;
  /** The customer ID of the past group member. */
  customerId: Scalars['ObjectId']['output'];
  /** The group members past trips in CANCELLED or CONFIRMED status */
  trips: Array<BookingTrip>;
};

export type GcProfileContent = {
  __typename?: 'GCProfileContent';
  backgroundImage?: Maybe<ContentAsset>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullSlug: Scalars['String']['output'];
  gcCustomer?: Maybe<Customer>;
  gcCustomerId?: Maybe<Scalars['String']['output']>;
  gcDepartures: Array<GcDeparture>;
  image?: Maybe<ContentAsset>;
  logo?: Maybe<ContentAsset>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};


export type GcProfileContentGcDeparturesArgs = {
  businessCode: BusinessCode;
};

/** A gateway that represents either an Airport or a City */
export type Gateway = {
  __typename?: 'Gateway';
  _id: Scalars['ObjectId']['output'];
  airRegionCode: Scalars['String']['output'];
  cityCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  internalCityLongName: Scalars['String']['output'];
  internalCityName: Scalars['String']['output'];
  isCityCodeOnly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  utcOffset?: Maybe<Scalars['Float']['output']>;
  utcOffsetSummer?: Maybe<Scalars['Float']['output']>;
  utcOffsetWinter?: Maybe<Scalars['Float']['output']>;
};

/** A paginated result of Gateways */
export type GatewayPaginatedResult = {
  __typename?: 'GatewayPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Gateway>;
};

export type GeographicRegion = Place & {
  __typename?: 'GeographicRegion';
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
  parentIds: Array<Scalars['ObjectId']['output']>;
  type: PlaceType;
};

/** A summary of the global rewards status and point for Group Coordinators */
export type GlobalRewardsSummary = {
  __typename?: 'GlobalRewardsSummary';
  firstName: Scalars['String']['output'];
  globalRewardsId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  membershipLevelId: Scalars['Int']['output'];
  membershipLevelName: Scalars['String']['output'];
  pointsAccrued: Scalars['Int']['output'];
  pointsActive: Scalars['Int']['output'];
  pointsPending: Scalars['Int']['output'];
  pointsRedeemed: Scalars['Int']['output'];
  pointsSuspended: Scalars['Int']['output'];
  pointsTotal: Scalars['Int']['output'];
};

/** Group trip checklist settings */
export type GroupTripChecklistSettings = {
  __typename?: 'GroupTripChecklistSettings';
  emergencyContactDueAtDpd?: Maybe<Scalars['Int']['output']>;
  healthNotesDueAtDpd?: Maybe<Scalars['Int']['output']>;
  passportInformationDueAtDpd?: Maybe<Scalars['Int']['output']>;
  termsSignatureDaysDueAfterBooking?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the tsa identifier and passport info settings */
  travelerInfoDueAtDpd?: Maybe<Scalars['Int']['output']>;
  tsaIdentifiersDueAtDpd?: Maybe<Scalars['Int']['output']>;
};

export type HealthNotesChecklistItem = SystemChecklistItem & {
  __typename?: 'HealthNotesChecklistItem';
  dueDate?: Maybe<Scalars['Date']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  status?: Maybe<TripChecklistItemStatus>;
};

/** Response from the Zendesk help center API */
export type HelpCenterArticle = {
  __typename?: 'HelpCenterArticle';
  id?: Maybe<Scalars['String']['output']>;
  sectionName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Response from the Zendesk help center API */
export type HelpCenterArticleResponse = {
  __typename?: 'HelpCenterArticleResponse';
  count?: Maybe<Scalars['Int']['output']>;
  nextPage?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
  previousPage?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<HelpCenterArticle>>;
};

export enum IdentityDocumentType {
  DriversLicense = 'DRIVERS_LICENSE',
  Passport = 'PASSPORT'
}

/** Immutable term error */
export type ImmutableTermError = DomainError & {
  __typename?: 'ImmutableTermError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Increases the non-expired voucher by a dollar amount */
export type IncreaseVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId']['input'];
  /** The amount to increase the Voucher by */
  amount: MoneyInput;
  /** The reason that the voucher is being increased */
  reason: Scalars['String']['input'];
};

export type IncreaseVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

export type InsuranceAddonLineItem = LineItem & {
  __typename?: 'InsuranceAddonLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

/** Insurance extension plan details */
export type InsuranceExtension = PricedTripComponent & TripComponent & {
  __typename?: 'InsuranceExtension';
  _id: Scalars['ObjectId']['output'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  hasPriceRules: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};

export type InsuranceExtensionLineItem = LineItem & {
  __typename?: 'InsuranceExtensionLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  daysToExtend: Scalars['Int']['output'];
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

export type InsuranceLineItem = LineItem & {
  __typename?: 'InsuranceLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  travelerInsuranceId: Scalars['ObjectId']['output'];
  travelerInsuranceIdCreationDate: Scalars['Date']['output'];
  type: TripComponentType;
};

/** Primary insurance plan */
export type InsurancePlan = PricedTripComponent & TripComponent & {
  __typename?: 'InsurancePlan';
  _id: Scalars['ObjectId']['output'];
  addons: Array<InsurancePlanAddon>;
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  hasPriceRules: Scalars['Boolean']['output'];
  insuranceExtension?: Maybe<InsuranceExtension>;
  internalName: Scalars['String']['output'];
  isEligibleForRolloverOnRebooking: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  planCode: Scalars['String']['output'];
  policyCoversPreExistingConditions: Scalars['Boolean']['output'];
  policyNumber: Scalars['String']['output'];
  priceRules: Array<PriceRule>;
  providerName: Scalars['String']['output'];
  purchasableAfterDays?: Maybe<Scalars['Int']['output']>;
  purchasableWithinDays?: Maybe<Scalars['Int']['output']>;
  status: TripComponentStatus;
  type: TripComponentType;
};

/** Secondary insurance to be combined with primary insurance */
export type InsurancePlanAddon = PricedTripComponent & TripComponent & {
  __typename?: 'InsurancePlanAddon';
  _id: Scalars['ObjectId']['output'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  hasPriceRules: Scalars['Boolean']['output'];
  includedWithinDays?: Maybe<Scalars['Int']['output']>;
  insurancePlanAddonCode: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  preventPurchaseAfterDays?: Maybe<Scalars['Int']['output']>;
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};

export type InsurancePlanAddonOffer = {
  __typename?: 'InsurancePlanAddonOffer';
  insurancePlanAddon: InsurancePlanAddon;
  price: Money;
};

/** Content describing an insurance plan */
export type InsurancePlanContent = {
  __typename?: 'InsurancePlanContent';
  addons: Array<InsurancePlanContentAddon>;
  benefits: Array<InsurancePlanContentBenefit>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  includedAddonsDescription?: Maybe<Scalars['String']['output']>;
  includedAddonsSubtitle?: Maybe<Scalars['String']['output']>;
  includedAddonsTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  planSummaryDocument?: Maybe<ContentAsset>;
  planSummaryLink?: Maybe<ContentLink>;
  underwriterDescription?: Maybe<Scalars['String']['output']>;
  underwriterDisclaimer?: Maybe<Scalars['String']['output']>;
};

/** Content describing an insurance plan addon */
export type InsurancePlanContentAddon = {
  __typename?: 'InsurancePlanContentAddon';
  addonCode?: Maybe<Scalars['String']['output']>;
  benefits: Array<InsurancePlanContentBenefit>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Content describing an insurance plan benefit */
export type InsurancePlanContentBenefit = {
  __typename?: 'InsurancePlanContentBenefit';
  description?: Maybe<Scalars['String']['output']>;
  /** Describes the limit for a benefit e.g. 'Up to $50,000' */
  limitMessage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type InsurancePlanOffer = {
  __typename?: 'InsurancePlanOffer';
  addons: Array<InsurancePlanAddonOffer>;
  content?: Maybe<InsurancePlanContent>;
  insurancePlan: InsurancePlan;
  price: Money;
};


export type InsurancePlanOfferContentArgs = {
  language: Scalars['String']['input'];
};

/** Paginated result of Insurance Plans, filtered and sorted */
export type InsurancePlanPaginatedResult = {
  __typename?: 'InsurancePlanPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<InsurancePlan>;
};

export enum InsurancePlanSortField {
  PlanCode = 'planCode'
}

/** Insurance settings */
export type InsuranceSettings = {
  __typename?: 'InsuranceSettings';
  nbMaximumDaysToExtend: Scalars['Int']['output'];
  removalWindowDays: Scalars['Int']['output'];
};

/** Settings related to 3rd party APIs or integrations */
export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  /** Canadian merchant ID for cybersource */
  cybersourceMerchantIdCA?: Maybe<Scalars['String']['output']>;
  /** US merchant ID for cybersource */
  cybersourceMerchantIdUS?: Maybe<Scalars['String']['output']>;
  /** Mailroom settings */
  mailroom?: Maybe<MailroomSettings>;
  /** Canadian microsite URL */
  micrositeUrlCA?: Maybe<Scalars['String']['output']>;
  /** US microsite URL */
  micrositeUrlUS?: Maybe<Scalars['String']['output']>;
  /** Atlas Product Market code for the CA market */
  productMarketCodeCA?: Maybe<Scalars['String']['output']>;
  /** Atlas Product Market code for the US market */
  productMarketCodeUS?: Maybe<Scalars['String']['output']>;
  /** Canadian office ID for RightFlight, required for all API calls */
  rightFlightBrandIdCA?: Maybe<Scalars['String']['output']>;
  /** US office ID for RightFlight, required for all API calls */
  rightFlightBrandIdUS?: Maybe<Scalars['String']['output']>;
  /** Settings for transactional emails */
  transactionalEmails?: Maybe<Array<TransactionalEmailSettings>>;
  /** Canadian website URL */
  websiteUrlCA?: Maybe<Scalars['String']['output']>;
  /** US website URL */
  websiteUrlUS?: Maybe<Scalars['String']['output']>;
};

/** Invalid adjustment error */
export type InvalidAdjustmentError = DomainError & {
  __typename?: 'InvalidAdjustmentError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The amount object is invalid */
export type InvalidAmountError = DomainError & {
  __typename?: 'InvalidAmountError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The campaign is invalid. */
export type InvalidCampaignError = DomainError & {
  __typename?: 'InvalidCampaignError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The DateOnly object is not a valid date type */
export type InvalidDateError = DomainError & {
  __typename?: 'InvalidDateError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidDepartureError = DomainError & {
  __typename?: 'InvalidDepartureError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The deposit amount item is invalid */
export type InvalidDepositItemError = DomainError & {
  __typename?: 'InvalidDepositItemError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid evaluation */
export type InvalidEvaluationError = DomainError & {
  __typename?: 'InvalidEvaluationError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidExtendedStayError = DomainError & {
  __typename?: 'InvalidExtendedStayError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid fee error */
export type InvalidFeeError = DomainError & {
  __typename?: 'InvalidFeeError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidFlightPackageError = DomainError & {
  __typename?: 'InvalidFlightPackageError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidGcDepartureError = DomainError & {
  __typename?: 'InvalidGCDepartureError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidGcDepartureProspectError = DomainError & {
  __typename?: 'InvalidGCDepartureProspectError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid insurance extension */
export type InvalidInsuranceExtensionError = DomainError & {
  __typename?: 'InvalidInsuranceExtensionError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid insurance plan */
export type InvalidInsurancePlanError = DomainError & {
  __typename?: 'InvalidInsurancePlanError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Magic link is not valid */
export type InvalidMagicLinkError = DomainError & {
  __typename?: 'InvalidMagicLinkError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The money object is invalid */
export type InvalidMoneyError = DomainError & {
  __typename?: 'InvalidMoneyError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid trip error */
export type InvalidOrderError = DomainError & {
  __typename?: 'InvalidOrderError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid payment error */
export type InvalidPaymentError = DomainError & {
  __typename?: 'InvalidPaymentError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  /** List of payment errors */
  paymentErrors: Array<Scalars['String']['output']>;
};

/** Invalid payment schedule error */
export type InvalidPaymentScheduleError = DomainError & {
  __typename?: 'InvalidPaymentScheduleError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** A PriceYear failed to be created due to validation issues */
export type InvalidPriceYearError = DomainError & {
  __typename?: 'InvalidPriceYearError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The PriceRule is not valid at time of creation */
export type InvalidPricingError = DomainError & {
  __typename?: 'InvalidPricingError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid private group error */
export type InvalidPrivateGroupError = DomainError & {
  __typename?: 'InvalidPrivateGroupError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The promotion is invalid. */
export type InvalidPromoError = DomainError & {
  __typename?: 'InvalidPromoError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid rating error */
export type InvalidRatingError = DomainError & {
  __typename?: 'InvalidRatingError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid review error */
export type InvalidReviewError = DomainError & {
  __typename?: 'InvalidReviewError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid review response error */
export type InvalidReviewResponseError = DomainError & {
  __typename?: 'InvalidReviewResponseError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** User credentials are invalid during login */
export type InvalidSigninError = DomainError & {
  __typename?: 'InvalidSigninError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid term error */
export type InvalidTermError = DomainError & {
  __typename?: 'InvalidTermError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidTourCabinCodeError = DomainError & {
  __typename?: 'InvalidTourCabinCodeError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid tour error */
export type InvalidTourError = DomainError & {
  __typename?: 'InvalidTourError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** An invalid trip checklist item template was specified */
export type InvalidTripChecklistItemTemplateError = DomainError & {
  __typename?: 'InvalidTripChecklistItemTemplateError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid voucher */
export type InvalidVoucherError = DomainError & {
  __typename?: 'InvalidVoucherError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type IssueARefundResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | InvalidPaymentError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError;

export type LeadInPrice = {
  __typename?: 'LeadInPrice';
  /** Amount of discount if applicable. Null if no discount. */
  discountAmount?: Maybe<Money>;
  /** Minimum remaining redemptions for discount offer codes. */
  discountLowestSpotsRemaining?: Maybe<Scalars['Int']['output']>;
  /** Offer codes to calculate sale price. */
  discountOfferCodes: Array<Scalars['String']['output']>;
  /** Original price. */
  price: Money;
  /** Previous discounts applied */
  redeemedPromos: Array<RedeemedPromoType>;
  /** Price after discount if applicable. Null if no discount. */
  salePrice?: Maybe<Money>;
};

export type LegacyCustomerIds = {
  __typename?: 'LegacyCustomerIds';
  gatSalesforceAccountId?: Maybe<Scalars['String']['output']>;
  jasmineCustomerId?: Maybe<Scalars['String']['output']>;
  phxIndividualIds?: Maybe<Array<Scalars['String']['output']>>;
  ubSalesforceAccountId?: Maybe<Scalars['String']['output']>;
};

/** Base line item */
export type LineItem = {
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

/** Line item cancellation meta data. */
export type LineItemCancellationMeta = {
  __typename?: 'LineItemCancellationMeta';
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationReason: LineItemCancellationReason;
  cancelledBy?: Maybe<Scalars['ObjectId']['output']>;
};

export enum LineItemCancellationReason {
  Financial = 'FINANCIAL',
  HealthOrLifeEvent = 'HEALTH_OR_LIFE_EVENT',
  ParentTripCancelled = 'PARENT_TRIP_CANCELLED',
  TravelerDiscontent = 'TRAVELER_DISCONTENT',
  TravelRequirementNotMet = 'TRAVEL_REQUIREMENT_NOT_MET',
  TripDetailsChanged = 'TRIP_DETAILS_CHANGED',
  Unknown = 'UNKNOWN',
  WojoCancellation = 'WOJO_CANCELLATION',
  WorldEvent = 'WORLD_EVENT'
}

export enum LineItemStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  PendingCancellation = 'PENDING_CANCELLATION',
  PendingRebooking = 'PENDING_REBOOKING',
  Quoted = 'QUOTED',
  Rebooked = 'REBOOKED',
  Requested = 'REQUESTED',
  Waitlisted = 'WAITLISTED'
}

/** A customer's repeat loyalty information with a specific business. */
export type LoyaltyLevel = {
  __typename?: 'LoyaltyLevel';
  /** The unique identifier of this item. The combination of businessCode and customerId is the more appropriate unique key */
  _id: Scalars['ObjectId']['output'];
  /** The business code that this loyalty information is associated with */
  businessCode: BusinessCode;
  /** The content associated with this loyalty level */
  content?: Maybe<LoyaltyLevelContent>;
  /** The customer id that this loyalty information is associated with */
  customerId: Scalars['ObjectId']['output'];
  /** The customer's loyalty level based on the repeat threshold in promotion settings that this customer has reached */
  loyaltyLevel: Scalars['Int']['output'];
  /** The number of qualifying trips that count toward the customer's loyalty level */
  nbConfirmedLoyaltyTrips: Scalars['Int']['output'];
  /** The number of additional qualifying trips the customer needs to reach the next loyalty level. If the busines has not configured repeat thresholds, or the customer is at the maximum loyalty level, this will be null */
  nbTripsUntilNextLevelReached?: Maybe<Scalars['Int']['output']>;
  /** The per-tour discount that the customer is entitled based on the loyalty level they have reached */
  repeatDiscount?: Maybe<Amount>;
  /** The promo code associated with the repeat discount */
  repeatPromoCode?: Maybe<Scalars['String']['output']>;
  /** The discount that the customer is currently entitled based on the loyalty level they have reached, as well as whether their previous qualifying trip returned within the return window defined in promo settings. */
  returnWindowDiscount?: Maybe<Amount>;
};


/** A customer's repeat loyalty information with a specific business. */
export type LoyaltyLevelContentArgs = {
  language: Scalars['String']['input'];
};

export type LoyaltyLevelContent = {
  __typename?: 'LoyaltyLevelContent';
  icon?: Maybe<ContentAsset>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MagicLinkResult = {
  __typename?: 'MagicLinkResult';
  expiresAt: Scalars['DateTime']['output'];
};

/** Settings for mailroom. */
export type MailroomSettings = {
  __typename?: 'MailroomSettings';
  isActive: Scalars['Boolean']['output'];
  nbPreDepartureMailDaysFrom: Scalars['Int']['output'];
  nbPreDepartureMailDaysTo: Scalars['Int']['output'];
  preDepartureMailMinimumBalance: Amount;
};

export type MakeAPaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAmountError | InvalidDateError | InvalidOrderError | InvalidPaymentError | InvalidPaymentScheduleError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError;

export type MatchRoommatesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | MatchRoommatesSuccess | NotAuthorizedError | NotFoundError | ValidationError;

export type MatchRoommatesSuccess = {
  __typename?: 'MatchRoommatesSuccess';
  data: Array<Booking>;
};

export type MergeBookingInput = {
  fromBookingId: Scalars['ObjectId']['input'];
  toBookingId: Scalars['ObjectId']['input'];
};

export type MergeBookingResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

/** Merge two customers */
export type MergeCustomerInput = {
  /** The id of the customer merge into and keep. */
  newCustomerId: Scalars['ObjectId']['input'];
  /** The id of the customer to merge and deprecate. */
  oldCustomerId: Scalars['ObjectId']['input'];
};

export type MergeCustomerResult = BusinessNotSpecifiedError | Customer | CustomerMergeError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type MicrositeContent = {
  __typename?: 'MicrositeContent';
  fullSlug?: Maybe<Scalars['String']['output']>;
  gcDeparture?: Maybe<GcDeparture>;
  gcDepartureId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<ContentAsset>;
  title?: Maybe<Scalars['String']['output']>;
  tripBuilderMarketingBody?: Maybe<Scalars['String']['output']>;
  tripBuilderMarketingTitle?: Maybe<Scalars['String']['output']>;
};

/** Represents monetary value in a specific currency */
export type Money = {
  __typename?: 'Money';
  currencyCode: CurrencyCode;
  formatted: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** Input for standard money type */
export type MoneyInput = {
  currencyCode: CurrencyCode;
  value: Scalars['Float']['input'];
};

export type MonthlyWeather = {
  __typename?: 'MonthlyWeather';
  averageHighCelsius: Scalars['Float']['output'];
  averageHighFahrenheit: Scalars['Float']['output'];
  averageLowCelsius: Scalars['Float']['output'];
  averageLowFahrenheit: Scalars['Float']['output'];
  averageRainCentimeters: Scalars['Float']['output'];
  averageRainInches: Scalars['Float']['output'];
  month: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accepts the group terms as a group coordinator. Signs the GC departure, as well as the GC's trip if it exists */
  acceptGCDepartureTerms: AcceptGcDepartureTermsResult;
  /** Accepts the terms and conditions for a single trip on a booking */
  acceptTripTerms: AcceptTripTermsResult;
  /** Add promos to a campaign */
  addCampaignPromos: AddCampaignPromosResult;
  /** Adds a payment schedule to a draft booking as long as one does not already exist */
  addDraftBookingPaymentSchedule: AddDraftBookingPaymentScheduleResult;
  /** Adds adjustment to a trip on a draft order. */
  addDraftOrderAdjustment: AddDraftOrderAdjustmentResult;
  /** Adds a campaign to a draft order for specified trips. */
  addDraftOrderCampaign: AddDraftOrderCampaignResult;
  /** Adds excursions to trips on a draft order. */
  addDraftOrderExcursions: AddDraftOrderExcursionsResult;
  /** Adds extension on draft order for specified trips. */
  addDraftOrderExtension: AddDraftOrderExtensionResult;
  /** Adds fee to a draft order for the specified trips. */
  addDraftOrderFee: AddDraftOrderFeeResult;
  /** Adds insurance on draft order for specified trips. */
  addDraftOrderInsurance: AddDraftOrderInsuranceResult;
  /** Adds insurance plan addons to one or more trips on a draft order. */
  addDraftOrderInsuranceAddon: AddDraftOrderInsuranceAddonResult;
  /** Adds insurance extension for a draft order to one or more trips. */
  addDraftOrderInsuranceExtension: AddDraftOrderInsuranceExtensionResult;
  /** Adds post-stay on draft order for specified trips. */
  addDraftOrderPostStay: AddDraftOrderPostStayResult;
  /** Adds pre-stay on draft order for specified trips. */
  addDraftOrderPreStay: AddDraftOrderPreStayResult;
  /** Adds private group fee to a draft order for the specified trips. */
  addDraftOrderPrivateGroup: AddDraftOrderPrivateGroupResult;
  /** Adds a promo to a draft order for specified trips. */
  addDraftOrderPromo: AddDraftOrderPromoResult;
  /** Adds a Trip to an existing Draft Quote. */
  addDraftQuoteTrip: AddDraftQuoteTripResult;
  /** Update an employee by id. */
  addEmployeesToRole: AddEmployeesToRoleResult;
  /** Adds a private group to a tour */
  addPrivateGroup: AddPrivateGroupResult;
  /** Add promo codes to a promo */
  addPromoCodes: AddPromoCodesResult;
  /** Add customers to a promo */
  addPromoCustomers: AddPromoCustomersResult;
  /** Add gc departure to a promo */
  addPromoGcDepartures: AddPromoGcDeparturesResult;
  /** Adds additional targets to a promo */
  addPromoTargets: AddPromoTargetsResult;
  /** Adds a Tour Excursion to this tour, provided it is set up in the Tour's spec and is not already on the Tour. */
  addTourExcursion: AddTourExcursionResult;
  /** Adds a Tour Excursion to this Tour Extension, provided it is set up in the Tour Extension's spec and is not already on the Extension. */
  addTourExtensionExcursion: AddTourExtensionExcursionResult;
  /** Generate a magic link for a customer or tour director and return it */
  adminCreateMagicLink: AdminCreateMagicLinkResult;
  /** Recalculates and applies or reapplies the private group fee to all confirmed Trips on Bookings associated with a GC Departure. If the fee is already found on a trip with a different price, it will be removed and reapplied with the new price. Does not use a draft publish flow and happens directly on the bookings. Will not apply the private group line item to quotes. Uses the number of confirmed trips as the group size by default. */
  applyGCDeparturePrivateGroupFee: ApplyGcDeparturePrivateGroupFeeResult;
  bulkCreateDepartureExcursions: BulkCreateDepartureExcursionsResult;
  bulkCreateDepartureExtensionExcursions: BulkCreateDepartureExtensionExcursionsResult;
  bulkCreateDepartureExtensionRooms: BulkCreateDepartureExtensionRoomsResult;
  bulkCreateDepartureExtensions: BulkCreateDepartureExtensionsResult;
  bulkCreateDepartureNotes: BulkCreateDepartureNotesResult;
  bulkCreateDepartureRooms: BulkCreateDepartureRoomsResult;
  bulkCreateDepartures: BulkCreateDeparturesResult;
  /** Bulk create flight packages */
  bulkCreateFlightPackages: BulkCreateFlightPackagesResult;
  /** Create GC Departure Prospects in bulk. */
  bulkCreateGCDepartureProspects: BulkCreateGcDepartureProspectsResult;
  /** Bulk create private groups */
  bulkCreatePrivateGroups: BulkCreatePrivateGroupsResult;
  bulkCreatePromoAudienceMembers: BulkCreatePromoAudienceMembersResult;
  bulkCreatePromoTargets: BulkCreatePromoTargetsResult;
  bulkCreatePromos: BulkCreatePromosResult;
  /** Bulk remove audience members from a promo */
  bulkRemovePromoAudienceMembers: BulkRemovePromoAudienceMembersResult;
  bulkUpdateDepartureExcursions: BulkUpdateDepartureExcursionsResult;
  bulkUpdateDepartureExtensionExcursions: BulkUpdateDepartureExtensionExcursionsResult;
  bulkUpdateDepartureExtensionRooms: BulkUpdateDepartureExtensionRoomsResult;
  bulkUpdateDepartureExtensions: BulkUpdateDepartureExtensionsResult;
  bulkUpdateDepartureOwners: BulkUpdateDepartureOwnersResult;
  bulkUpdateDepartureRooms: BulkUpdateDepartureRoomsResult;
  bulkUpdateDepartures: BulkUpdateDeparturesResult;
  bulkUpdateExtendedStayPriceRules: BulkUpdateExtendedStayPriceRulesResult;
  /** Bulk update the price rules for fees */
  bulkUpdateFeePriceRules: BulkUpdateFeePriceRulesResult;
  /** Bulk update flight package price rules, creates the flight package if it doesn't exist. */
  bulkUpdateFlightPackagePriceRules: BulkUpdateFlightPackagePriceRulesResult;
  bulkUpdateInsurancePlanAddonPriceRules: BulkUpdateInsurancePlanAddonPriceRulesResult;
  bulkUpdateInsurancePlanPriceRules: BulkUpdateInsurancePlanPriceRulesResult;
  /** Bulk update the price rules for private groups */
  bulkUpdatePrivateGroupPriceRules: BulkUpdatePrivateGroupPriceRulesResult;
  /** Bulk update private groups */
  bulkUpdatePrivateGroups: BulkUpdatePrivateGroupsResult;
  /** Bulk Update promos. */
  bulkUpdatePromos: BulkUpdatePromosResult;
  bulkUpdateTourExcursionPriceRules: BulkUpdateTourExcursionPriceRulesResult;
  /** Bulk Updates details of a tour room. */
  bulkUpdateTourExcursions: BulkUpdateTourExcursionsResult;
  bulkUpdateTourExtensionPriceRules: BulkUpdateTourExtensionPriceRulesResult;
  bulkUpdateTourExtensionRoomPriceRules: BulkUpdateTourExtensionRoomPriceRulesResult;
  /** Bulk Updates details of a tour extension room. */
  bulkUpdateTourExtensionRooms: BulkUpdateTourExtensionRoomsResult;
  /** Bulk Update Tour Extensions */
  bulkUpdateTourExtensions: BulkUpdateTourExtensionsResult;
  bulkUpdateTourPriceRules: BulkUpdateTourPriceRulesResult;
  bulkUpdateTourRoomPriceRules: BulkUpdateTourRoomPriceRulesResult;
  /** Bulk Updates details of a tour room. */
  bulkUpdateTourRooms: BulkUpdateTourRoomsResult;
  /** Bulk Update tours. */
  bulkUpdateTours: BulkUpdateToursResult;
  calculatePaymentSchedule: CalculatePaymentScheduleResult;
  /** Cancel a Draft Booking by cancelling all of its trips. */
  cancelDraftBooking: CancelDraftBookingResult;
  /** Cancels a payment schedule on a draft booking */
  cancelDraftBookingPaymentSchedule: CancelDraftBookingPaymentScheduleResult;
  /** Cancel one or more trips on a Draft Booking */
  cancelDraftBookingTrips: CancelDraftBookingTripsResult;
  /** Cancel a single GC Departure that is not already cancelled */
  cancelGCDeparture: CancelGcDepartureResult;
  /** Changes the expiration date of a voucher */
  changeVoucherExpiration: ChangeVoucherExpirationResult;
  /** Checks a trip checklist item */
  checkTripChecklistItem: CheckTripChecklistItemResult;
  /** Confirm a single GC Departure */
  confirmGCDeparture: ConfirmGcDepartureResult;
  /** Create a new adjustment for a given price year */
  createAdjustment: CreateAdjustmentResult;
  /** Create a new API key */
  createApiKey: CreateApiKeyResult;
  /** Create a new campaign */
  createCampaign: CreateCampaignResult;
  createCategory: CreateCategoryResult;
  createChatToken?: Maybe<ExternalToken>;
  /** Create a new customer from an email */
  createCustomer: CreateCustomerResult;
  createDepartureExcursion: CreateDepartureExcursionResult;
  createDepartureExtension: CreateDepartureExtensionResult;
  createDepartureExtensionExcursion: CreateDepartureExtensionExcursionResult;
  createDepartureExtensionRoom: CreateDepartureExtensionRoomResult;
  createDepartureRoom: CreateDepartureRoomResult;
  /** Create a new draft booking */
  createDraftOrder: CreateDraftOrderResult;
  /** Create a new draft term */
  createDraftTerm: CreateDraftTermResult;
  /** Create a new extended stay */
  createExtendedStay: CreateExtendedStayResult;
  /** Create a new fee */
  createFee: CreateFeeResult;
  /** Create a new flight package */
  createFlightPackage: CreateFlightPackageResult;
  /** Create a single GC Departure */
  createGCDeparture: CreateGcDepartureResult;
  /** Get a JWT token for logging a customer into the help center. */
  createHelpCenterLoginToken?: Maybe<ExternalToken>;
  /** Get a JWT token for authenticating a customer with the help center messaging platform. */
  createHelpCenterMessagingToken?: Maybe<ExternalToken>;
  /** Create a new insurance extension */
  createInsuranceExtension: CreateInsuranceExtensionResult;
  /** Create a new insurance plan for a given year */
  createInsurancePlan: CreateInsurancePlanResult;
  /** Create a new insurance plan addon for the given insurance plan */
  createInsurancePlanAddon: CreateInsurancePlanAddonResult;
  /** Create a new note targeting any other entity */
  createNote: CreateNoteResult;
  /** Create a new promo offer */
  createPromo: CreatePromoResult;
  /** Create a review of a trip */
  createReview: CreateReviewResult;
  createRole: CreateRoleResult;
  /** Create a new service recovery promo */
  createServiceRecoveryPromo: CreateServiceRecoveryPromoResult;
  /** Creates a support ticket */
  createSupportTicket: CreateSupportTicketResult;
  createTag: CreateTagResult;
  /** Create a new tour for a given year */
  createTour: CreateTourResult;
  /** Create a Tour Excursion for a given base Tour */
  createTourExcursion: CreateTourExcursionResult;
  /** Create a tour excursion for a given base tour */
  createTourExtension: CreateTourExtensionResult;
  createTourExtensionRoom: CreateTourExtensionRoomResult;
  createTourRoom: CreateTourRoomResult;
  /** Creates a TripChecklistItemTemplate */
  createTripChecklistItemTemplate: CreateTripChecklistItemTemplateResult;
  /** Create a voucher that originates from a booking */
  createVoucherFromBooking: CreateVoucherFromBookingResult;
  /** Create a voucher that originates from a different system and EF product outside WOJO */
  createVoucherFromExternal: CreateVoucherFromExternalResult;
  /** Create a Wishlist Item for a Customer and Tour Code */
  createWishlistItem: CreateWishlistItemResult;
  /** Delete a category */
  deleteCategory: DeleteCategoryResult;
  /** Removes a GC Departure Prospect */
  deleteGCDepartureProspect: DeleteGcDepartureProspectResult;
  deleteReviewImage: DeleteReviewImageResult;
  /** Delete a tag */
  deleteTag: DeleteTagResult;
  /** Removes a Wishlist Item from a Customer's wishlist */
  deleteWishlistItem: DeleteWishlistItemResult;
  /** Forks one or more trips from a Booking onto a new Booking. */
  forkBooking: ForkBookingResult;
  /** Increases a non-expired, non-voided voucher by a dollar amount */
  increaseVoucher: IncreaseVoucherResult;
  /** Makes a one time payment on an active booking. Will cause any payment plans on the booking to recalculate. */
  issueARefund: IssueARefundResult;
  /** Makes a one time payment on an active booking. Will cause any payment plans on the booking to recalculate. */
  makeAPayment: MakeAPaymentResult;
  /** Match trips in the same room */
  matchRoommates: MatchRoommatesResult;
  /** Merges a source booking into a target booking. */
  mergeBooking: MergeBookingResult;
  /** Merge two customers */
  mergeCustomer: MergeCustomerResult;
  /** Converts a quote into booking given payment is fulfilled in respect to the payment plan. */
  payAndBook: PayAndBookResult;
  /** Publishes draft booking */
  publishDraftBooking: PublishDraftBookingResult;
  /** Publishes draft quote */
  publishDraftQuote: PublishDraftQuoteResult;
  /** Publish a draft term */
  publishDraftTerm: PublishDraftTermResult;
  /**
   * Reconcile the status of a card or ach payment on a booking.
   * @deprecated Use reconcilePayment instead
   */
  reconcileCardOrAchPayment: ReconcileCardOrAchPaymentResult;
  /** Reconcile a pending check payment on a booking. */
  reconcileCheckPayment: ReconcileCheckPaymentResult;
  /** Reconcile the status of a card or ach payment on a booking. */
  reconcilePayment: ReconcilePaymentResult;
  /** Create a new note targeting any other entity */
  reconcilePayments: ReconcilePaymentsResult;
  /** Reduces a non-expired, non-voided voucher by a dollar amount */
  reduceVoucher: ReduceVoucherResult;
  /** Refunds a refundable, active voucher that has a remaining balance */
  refundVoucher: RefundVoucherResult;
  /** Reinstates a voided voucher, undoing the void. The amount reinstated will be the same as the balance when the voucher was voided. */
  reinstateVoucher: ReinstateVoucherResult;
  /** Add promos to a campaign */
  removeCampaignPromos: RemoveCampaignPromosResult;
  /** Cancels one or more adjustments on a draft order for one or more trips. */
  removeDraftOrderAdjustments: RemoveDraftOrderAdjustmentsResult;
  /** Removes airport transfer from draft order for specified trips. */
  removeDraftOrderAirportTransfer: RemoveDraftOrderAirportTransferResult;
  /** Removes excursion on draft order for specified trips. */
  removeDraftOrderExcursion: RemoveDraftOrderExcursionResult;
  /** Removes all excursions for either the main tour or the extension on the specified trips. */
  removeDraftOrderExcursions: RemoveDraftOrderExcursionsResult;
  /** Removes extension on draft order for specified trips. */
  removeDraftOrderExtension: RemoveDraftOrderExtensionResult;
  /** Removes one or more fees from a draft order for one or more trips. */
  removeDraftOrderFees: RemoveDraftOrderFeesResult;
  /** Removes insurance from one or more trips on a draft order. */
  removeDraftOrderInsurance: RemoveDraftOrderInsuranceResult;
  /** Removes insurance addon for one or more trips on a draft order. */
  removeDraftOrderInsuranceAddon: RemoveDraftOrderInsuranceAddonResult;
  /** Removes the insurance extension for one or more trips on a draft order. */
  removeDraftOrderInsuranceExtension: RemoveDraftOrderInsuranceExtensionResult;
  /** Removes post-stay on draft order for specified trips. */
  removeDraftOrderPostStay: RemoveDraftOrderPostStayResult;
  /** Removes pre-stay on draft order for specified trips. */
  removeDraftOrderPreStay: RemoveDraftOrderPreStayResult;
  /** Removes the private group fee from a draft order for one or more trips. */
  removeDraftOrderPrivateGroup: RemoveDraftOrderPrivateGroupResult;
  /** Removes a promo from one or more trips on a draft order. */
  removeDraftOrderPromo: RemoveDraftOrderPromoResult;
  /** Remove one or more trips from a Draft Quote */
  removeDraftQuoteTrips: RemoveDraftQuoteTripsResult;
  /** Removes the role for employees */
  removeEmployeesFromRole: RemoveEmployeesFromRoleResult;
  /** Remove the private group from a tour */
  removePrivateGroup: RemovePrivateGroupResult;
  /** Remove a promo audience member */
  removePromoAudienceMember: RemovePromoAudienceMemberResult;
  /** Remove promo codes */
  removePromoCodes: RemovePromoCodesResult;
  /** Remove customers from a promo */
  removePromoCustomers: RemovePromoCustomersResult;
  /** Remove gc departure from a promo */
  removePromoGcDepartures: RemovePromoGcDeparturesResult;
  /** Remove targets from a promo */
  removePromoTargets: RemovePromoTargetsResult;
  /** Save an evaluation */
  saveEvaluation: SaveEvaluationResult;
  /** Generate a magic link, and send to a customer or tour director */
  sendMagicLink: SendMagicLinkResult;
  /** Sets customer on draft quote */
  setDraftQuoteCustomer: SetDraftQuoteCustomerResult;
  /** Set review as featured */
  setReviewFeatured: Review;
  /** Signin a customer from a magic link */
  signinCustomerWithMagicLink: SigninCustomerWithMagicLinkResult;
  /** Signin a customer from an email and password */
  signinCustomerWithPassword: SigninCustomerWithPasswordResult;
  /** Signin a tour director from a magic link */
  signinTourDirectorWithMagicLink: SigninTourDirectorWithMagicLinkResult;
  /** Signout the current user */
  signout: SignoutResult;
  /** Create a new customer from an email */
  signupCustomer: SignupCustomerResult;
  /** Start a Quote by creating a DraftOrder for a Quote that does not yet exist. Used to start the Quoting process. While this mutation creates a DraftOrder, the Quote is not saved and cannot be queried until the Draft has been published. By default, creates only a single Trip (The primary Trip). */
  startQuote: StartQuoteResult;
  /** Sets the booking to PENDING_REBOOKING status. */
  startRebooking: StartRebookingResult;
  /** Start a Quote by creating a DraftOrder for a Quote that does not yet exist. Used to start the Quoting process. While this mutation creates a DraftOrder, the Quote is not saved and cannot be queried until the Draft has been published. By default, creates only a single Trip (The primary Trip). */
  startRebookingQuote: StartRebookingQuoteResult;
  /** Submit an evaluation */
  submitEvaluation: SubmitEvaluationResult;
  /** Transfer the balance from one voucher to another */
  transferVoucherExternal: TransferVoucherExternalResult;
  /** Transfer the balance from one voucher to another */
  transferVoucherInternal: TransferVoucherInternalResult;
  /** Unchecks a trip checklist item */
  uncheckTripChecklistItem: UncheckTripChecklistItemResult;
  /** Unmatch trips from a room */
  unmatchRoommates: UnmatchRoommatesResult;
  /** Updates an adjustment. */
  updateAdjustment: UpdateAdjustmentResult;
  /** Updates the status of an adjustment. */
  updateAdjustmentStatus: UpdateAdjustmentStatusResult;
  /** Updates the current business's settings */
  updateBusinessSettings: UpdateBusinessSettingsResult;
  /** Update the details of a campaign */
  updateCampaign: UpdateCampaignResult;
  /** Publish or Unpublish a campaign. */
  updateCampaignStatus: UpdateCampaignStatusResult;
  /** Update the basic details of a category */
  updateCategory: UpdateCategoryResult;
  /** Updates a customer address */
  updateCustomerAddress: UpdateCustomerAddressResult;
  /** Update a customer's email used for logging in */
  updateCustomerEmail: UpdateCustomerEmailResult;
  /** Update a customer's Global Rewards ID (currently Phoenix CustomerNumber) */
  updateCustomerGlobalRewardsId: Customer;
  /** Update a customer's preferred name */
  updateCustomerName: UpdateCustomerNameResult;
  /** Change a customer's password */
  updateCustomerPassword: UpdateCustomerPasswordResult;
  /** Updates a customer phone number. */
  updateCustomerPhoneNumber: UpdateCustomerPhoneNumberResult;
  /** Update customer bio */
  updateCustomerProfileBio: Customer;
  /** Update customer's profile image */
  updateCustomerProfileImage: Customer;
  /** Update customer privacy */
  updateCustomerProfilePrivacy: Customer;
  /** Update customer's social media */
  updateCustomerProfileSocialMedia: Customer;
  updateDeparture: UpdateDepartureResult;
  updateDepartureExcursion: UpdateDepartureExcursionResult;
  updateDepartureExtension: UpdateDepartureExtensionResult;
  updateDepartureExtensionExcursion: UpdateDepartureExtensionExcursionResult;
  updateDepartureExtensionRoom: UpdateDepartureExtensionRoomResult;
  updateDepartureItemStatus: UpdateDepartureItemStatusResult;
  updateDepartureRoom: UpdateDepartureRoomResult;
  /** Updated the payment schedule of a draft booking */
  updateDraftBookingPaymentSchedule: UpdateDraftBookingPaymentScheduleResult;
  /** Updates the payment method for the active payment schedule of a draft booking. */
  updateDraftBookingPaymentSchedulePaymentMethod: UpdateDraftBookingPaymentSchedulePaymentMethodResult;
  /** Updates line item statuses on a draft booking. Can be one of CONFIRMED, REQUESTED, or WAITLISTED. Otherwise, please use the respective mutations for the rest of the statuses. */
  updateDraftBookingTripLineItemStatuses: UpdateDraftBookingTripLineItemStatusesResult;
  /** Updates trip statuses on a draft booking. Can be one of CONFIRMED, REQUESTED, or WAITLISTED. Otherwise, please use the respective mutations for the rest of the statuses. */
  updateDraftBookingTripStatuses: UpdateDraftBookingTripStatusesResult;
  /** Sets Address information on draft order. */
  updateDraftOrderAddress: UpdateDraftOrderAddressResult;
  /** Overrides the price of one or more adjustments from a draft order for one or more trips. */
  updateDraftOrderAdjustmentPrices: UpdateDraftOrderAdjustmentPricesResult;
  /** Update an orders airport transfer details for when a flight is LO1 and customer has purchased a transfer */
  updateDraftOrderAirportTransfer: UpdateDraftOrderAirportTransferResult;
  /** Update the emergency contacts for a traveler on a trip. */
  updateDraftOrderEmergencyContacts: UpdateDraftOrderEmergencyContactsResult;
  /** Updates extension rooms on a draft order. */
  updateDraftOrderExtensionRooms: UpdateDraftOrderExtensionRoomsResult;
  /** Overrides the price of one or more fees from a draft order for one or more trips. */
  updateDraftOrderFeePrices: UpdateDraftOrderFeePricesResult;
  /** Sets the final installment deadline on a draft order. */
  updateDraftOrderFinalInstallmentDeadline: UpdateDraftOrderFinalInstallmentDeadlineResult;
  /** Sets the final payment deadline on a draft order. */
  updateDraftOrderFinalPaymentDeadline: UpdateDraftOrderFinalPaymentDeadlineResult;
  /** Updates flight packages on a draft order. */
  updateDraftOrderFlightPackages: UpdateDraftOrderFlightPackagesResult;
  /** Updates insurance on draft order for specified trips. */
  updateDraftOrderInsurance: UpdateDraftOrderInsuranceResult;
  /** Updates the primary trip on a draft booking */
  updateDraftOrderPrimaryTrip: UpdateDraftOrderPrimaryTripResult;
  /** Overrides the price of one or more promos from a draft order for one or more trips. */
  updateDraftOrderPromoPrices: UpdateDraftOrderPromoPricesResult;
  /** Sets the requested roommates for a trip on a draft order. */
  updateDraftOrderRequestedRoommates: UpdateDraftOrderRequestedRoommatesResult;
  /** Sets the requested travel companions for a trip on a draft order. */
  updateDraftOrderRequestedTravelCompanions: UpdateDraftOrderRequestedTravelCompanionsResult;
  /** Updates rooms on a draft order */
  updateDraftOrderRooms: UpdateDraftOrderRoomsResult;
  /** Update the health notes for a traveler on a trip */
  updateDraftOrderTravelerNotes: UpdateDraftOrderTravelerNotesResult;
  /** Sets TSA information for a trip on a draft order. */
  updateDraftOrderTsaInformation: UpdateDraftOrderTsaInformationResult;
  /** Save or un-save a draft quote */
  updateDraftQuoteSaved: UpdateDraftQuoteSavedResult;
  /** Update a draft term */
  updateDraftTerm: UpdateDraftTermResult;
  /** Update an extended stay's base price */
  updateExtendedStay: UpdateExtendedStayResult;
  /** Updates an Extended Stay status */
  updateExtendedStayStatus: UpdateExtendedStayStatusResult;
  /** Update the base price of a fee. */
  updateFee: UpdateFeeResult;
  /** Updates a Fee status */
  updateFeeStatus: UpdateFeeStatusResult;
  /** Update a flight package details and base price */
  updateFlightPackage: UpdateFlightPackageResult;
  /** Updates a Flight Package status */
  updateFlightPackageStatus: UpdateFlightPackageStatusResult;
  updateGCDeparture: UpdateGcDepartureResult;
  /** Update a GC Departure Prospect  */
  updateGCDepartureProspect: UpdateGcDepartureProspectResult;
  updateGCDepartureStipendDetail: UpdateGcDepartureStipendDetailResult;
  /** Update insurance extension */
  updateInsuranceExtension: UpdateInsuranceExtensionResult;
  /** Publish or unpublish an insurance extension. */
  updateInsuranceExtensionStatus: UpdateInsuranceExtensionStatusResult;
  /** Update an existing insurance plan */
  updateInsurancePlan: UpdateInsurancePlanResult;
  /** Update an insurance plan addon */
  updateInsurancePlanAddon: UpdateInsurancePlanAddonResult;
  /** Publish or Unpublish a insurance plan. */
  updateInsurancePlanAddonStatus: UpdateInsurancePlanAddonStatusResult;
  /** Publish or Unpublish a insurance plan. */
  updateInsurancePlanStatus: UpdateInsurancePlanStatusResult;
  /** Update an existing note */
  updateNote: UpdateNoteResult;
  /** Update the base price of a private group. */
  updatePrivateGroup: UpdatePrivateGroupResult;
  /** Updates a tour's private group status */
  updatePrivateGroupStatus: UpdatePrivateGroupStatusResult;
  /** Update the details of a promo */
  updatePromo: UpdatePromoResult;
  /** Publish or Unpublish a promo. */
  updatePromoStatus: UpdatePromoStatusResult;
  /** Update the targets of a promo. Passing empty array will clear the targets. */
  updatePromoTargets: UpdatePromoTargetsResult;
  /** Updates a quote expiration date */
  updateQuoteExpiry: UpdateQuoteExpiryResult;
  /** Save or un-save a quote */
  updateQuoteSaved: UpdateQuoteSavedResult;
  /** Updates basic fields of an existing review */
  updateReview: UpdateReviewResult;
  /** Updates a review reply or creates one if it doesn't exist. If input is null, it clears the response. */
  updateReviewDetailResponse: UpdateReviewDetailResponseResult;
  /** Updates the review detail status */
  updateReviewDetailStatus: UpdateReviewDetailStatusResult;
  /** Updates the review images status */
  updateReviewImagesStatus: UpdateReviewImagesStatusResult;
  updateRole: UpdateRoleResult;
  /** Update the details of a service recovery promo. */
  updateServiceRecoveryPromo: UpdateServiceRecoveryPromoResult;
  /** Publish or Unpublish a service recovery promo. */
  updateServiceRecoveryPromoStatus: UpdateServiceRecoveryPromoStatusResult;
  /** Update the basic details of a tag */
  updateTag: UpdateTagResult;
  /** Update a tour by id. */
  updateTour: UpdateTourResult;
  /** Update profile info of a tour director such as bio and communication preferences */
  updateTourDirectorProfile: TourDirector;
  /** Updates a Tour Excursion basic details */
  updateTourExcursion: UpdateTourExcursionResult;
  /** Publish or Unpublish a tour excursion. */
  updateTourExcursionStatus: UpdateTourExcursionStatusResult;
  /** Updates details of an extension */
  updateTourExtension: UpdateTourExtensionResult;
  /** Updates details of a tour extension room. */
  updateTourExtensionRoom: UpdateTourExtensionRoomResult;
  /** Publish or Unpublish a tour extension room. */
  updateTourExtensionRoomStatus: UpdateTourExtensionRoomStatusResult;
  /** Publish or Unpublish a tour extension. */
  updateTourExtensionStatus: UpdateTourExtensionStatusResult;
  /** Update prices for any part of a tour including the tour itself */
  updateTourPricing: UpdateTourPricingResult;
  /** Updates details of a tour room. */
  updateTourRoom: UpdateTourRoomResult;
  /** Publish or Unpublish a tour. */
  updateTourRoomStatus: UpdateTourRoomStatusResult;
  /** Publish or Unpublish a tour. */
  updateTourStatus: UpdateTourStatusResult;
  /** Updates a TripChecklistItemTemplate */
  updateTripChecklistItemTemplate: UpdateTripChecklistItemTemplateResult;
  /** Updates the detail of a refund transaction on the specified Voucher, e.g. to add missing check detail */
  updateVoucherRefundDetail: UpdateVoucherRefundDetailResult;
  /** Void a transfer payment on a booking. */
  voidBookingTransferPayment: VoidBookingTransferPaymentResult;
  /** Voids a non-expired, non-voided voucher that has a balance remaining */
  voidVoucher: VoidVoucherResult;
};


export type MutationAcceptGcDepartureTermsArgs = {
  _id: Scalars['ObjectId']['input'];
  acceptanceMethod?: InputMaybe<TermSignatureMethod>;
  signingCustomerId?: InputMaybe<Scalars['ObjectId']['input']>;
  termId: Scalars['ObjectId']['input'];
};


export type MutationAcceptTripTermsArgs = {
  acceptanceMethod?: InputMaybe<TermSignatureMethod>;
  bookingId: Scalars['ObjectId']['input'];
  signingCustomerId?: InputMaybe<Scalars['ObjectId']['input']>;
  termId: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
};


export type MutationAddCampaignPromosArgs = {
  _id: Scalars['ObjectId']['input'];
  input: AddCampaignPromosInput;
};


export type MutationAddDraftBookingPaymentScheduleArgs = {
  _id: Scalars['ObjectId']['input'];
  paymentSchedule: PaymentScheduleInput;
};


export type MutationAddDraftOrderAdjustmentArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderAdjustmentInput>;
  lineItemCode: Scalars['LineItemCode']['input'];
};


export type MutationAddDraftOrderCampaignArgs = {
  _id: Scalars['ObjectId']['input'];
  campaignCode: Scalars['String']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationAddDraftOrderExcursionsArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderExcursionInput>;
};


export type MutationAddDraftOrderExtensionArgs = {
  _id: Scalars['ObjectId']['input'];
  lineItemCode: Scalars['LineItemCode']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationAddDraftOrderFeeArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderFeeInput>;
  lineItemCode: Scalars['LineItemCode']['input'];
};


export type MutationAddDraftOrderInsuranceArgs = {
  _id: Scalars['ObjectId']['input'];
  addOnLineItemCodes?: InputMaybe<Array<Scalars['LineItemCode']['input']>>;
  lineItemCode: Scalars['LineItemCode']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationAddDraftOrderInsuranceAddonArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderInsuranceAddonInput>;
};


export type MutationAddDraftOrderInsuranceExtensionArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderInsuranceExtensionInput>;
};


export type MutationAddDraftOrderPostStayArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderExtendedStayInput>;
  lineItemCode: Scalars['LineItemCode']['input'];
};


export type MutationAddDraftOrderPreStayArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderExtendedStayInput>;
  lineItemCode: Scalars['LineItemCode']['input'];
};


export type MutationAddDraftOrderPrivateGroupArgs = {
  _id: Scalars['ObjectId']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationAddDraftOrderPromoArgs = {
  _id: Scalars['ObjectId']['input'];
  promoCode: Scalars['String']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationAddDraftQuoteTripArgs = {
  input: AddDraftQuoteTripInput;
};


export type MutationAddEmployeesToRoleArgs = {
  _id: Scalars['ObjectId']['input'];
  input: AddEmployeesToRoleInput;
};


export type MutationAddPrivateGroupArgs = {
  _id: Scalars['ObjectId']['input'];
  input: AddPrivateGroupInput;
};


export type MutationAddPromoCodesArgs = {
  _id: Scalars['ObjectId']['input'];
  input: AddPromoCodesInput;
};


export type MutationAddPromoCustomersArgs = {
  _id: Scalars['ObjectId']['input'];
  input: AddPromoCustomersInput;
};


export type MutationAddPromoGcDeparturesArgs = {
  _id: Scalars['ObjectId']['input'];
  input: AddPromoGcDepartureInput;
};


export type MutationAddPromoTargetsArgs = {
  _id: Scalars['ObjectId']['input'];
  input: AddPromoTargetsInput;
};


export type MutationAddTourExcursionArgs = {
  _id: Scalars['ObjectId']['input'];
  tourExcursionId: Scalars['ObjectId']['input'];
};


export type MutationAddTourExtensionExcursionArgs = {
  _id: Scalars['ObjectId']['input'];
  tourExcursionId: Scalars['ObjectId']['input'];
};


export type MutationAdminCreateMagicLinkArgs = {
  input: AdminCreateMagicLinkInput;
};


export type MutationApplyGcDeparturePrivateGroupFeeArgs = {
  _id: Scalars['ObjectId']['input'];
  useEstimatedGroupSize?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBulkCreateDepartureExcursionsArgs = {
  input: Array<BulkCreateDepartureExcursionInput>;
};


export type MutationBulkCreateDepartureExtensionExcursionsArgs = {
  input: Array<BulkCreateDepartureExtensionExcursionInput>;
};


export type MutationBulkCreateDepartureExtensionRoomsArgs = {
  input: Array<BulkCreateDepartureExtensionRoomInput>;
};


export type MutationBulkCreateDepartureExtensionsArgs = {
  input: Array<BulkCreateDepartureExtensionInput>;
};


export type MutationBulkCreateDepartureNotesArgs = {
  input: Array<BulkCreateDepartureNotesInput>;
};


export type MutationBulkCreateDepartureRoomsArgs = {
  input: Array<BulkCreateDepartureRoomInput>;
};


export type MutationBulkCreateDeparturesArgs = {
  input: Array<BulkCreateDepartureInput>;
};


export type MutationBulkCreateFlightPackagesArgs = {
  input: BulkCreateFlightPackagesInput;
};


export type MutationBulkCreateGcDepartureProspectsArgs = {
  groupCoordinatorCustomerId: Scalars['ObjectId']['input'];
  input: Array<BulkCreateGcDepartureProspectsInput>;
};


export type MutationBulkCreatePrivateGroupsArgs = {
  input: Array<BulkCreatePrivateGroupsInput>;
};


export type MutationBulkCreatePromoAudienceMembersArgs = {
  input: Array<BulkCreatePromoAudienceMemberInput>;
};


export type MutationBulkCreatePromoTargetsArgs = {
  input: Array<BulkCreatePromoTargetInput>;
};


export type MutationBulkCreatePromosArgs = {
  input: Array<CreatePromoInput>;
};


export type MutationBulkRemovePromoAudienceMembersArgs = {
  input: BulkRemovePromoAudienceMembersInput;
};


export type MutationBulkUpdateDepartureExcursionsArgs = {
  input: Array<BulkUpdateDepartureExcursionInput>;
};


export type MutationBulkUpdateDepartureExtensionExcursionsArgs = {
  input: Array<BulkUpdateDepartureExtensionExcursionInput>;
};


export type MutationBulkUpdateDepartureExtensionRoomsArgs = {
  input: Array<BulkUpdateDepartureExtensionRoomInput>;
};


export type MutationBulkUpdateDepartureExtensionsArgs = {
  input: Array<BulkUpdateDepartureExtensionInput>;
};


export type MutationBulkUpdateDepartureOwnersArgs = {
  input: Array<BulkUpdateDepartureOwnerInput>;
};


export type MutationBulkUpdateDepartureRoomsArgs = {
  input: Array<BulkUpdateDepartureRoomInput>;
};


export type MutationBulkUpdateDeparturesArgs = {
  input: Array<BulkUpdateDepartureInput>;
};


export type MutationBulkUpdateExtendedStayPriceRulesArgs = {
  input: Array<BulkUpdateExtendedStayPriceRulesInput>;
};


export type MutationBulkUpdateFeePriceRulesArgs = {
  input: Array<BulkUpdateFeePriceRulesInput>;
};


export type MutationBulkUpdateFlightPackagePriceRulesArgs = {
  input: Array<BulkUpdateFlightPackagePriceRulesInput>;
};


export type MutationBulkUpdateInsurancePlanAddonPriceRulesArgs = {
  input: Array<BulkUpdateInsurancePlanAddonPriceRulesInput>;
};


export type MutationBulkUpdateInsurancePlanPriceRulesArgs = {
  input: Array<BulkUpdateInsurancePlanPriceRulesInput>;
};


export type MutationBulkUpdatePrivateGroupPriceRulesArgs = {
  input: Array<BulkUpdatePrivateGroupPriceRulesInput>;
};


export type MutationBulkUpdatePrivateGroupsArgs = {
  input: Array<BulkUpdatePrivateGroupsInput>;
};


export type MutationBulkUpdatePromosArgs = {
  input: Array<BulkUpdatePromoInput>;
};


export type MutationBulkUpdateTourExcursionPriceRulesArgs = {
  input: Array<BulkUpdateTourExcursionPriceRulesInput>;
};


export type MutationBulkUpdateTourExcursionsArgs = {
  input: Array<BulkUpdateTourExcursionInput>;
};


export type MutationBulkUpdateTourExtensionPriceRulesArgs = {
  input: Array<BulkUpdateTourExtensionPriceRulesInput>;
};


export type MutationBulkUpdateTourExtensionRoomPriceRulesArgs = {
  input: Array<BulkUpdateTourExtensionRoomPriceRulesInput>;
};


export type MutationBulkUpdateTourExtensionRoomsArgs = {
  input: Array<BulkUpdateTourExtensionRoomInput>;
};


export type MutationBulkUpdateTourExtensionsArgs = {
  input: Array<BulkUpdateTourExtensionInput>;
};


export type MutationBulkUpdateTourPriceRulesArgs = {
  input: Array<BulkUpdateTourPriceRulesInput>;
};


export type MutationBulkUpdateTourRoomPriceRulesArgs = {
  input: Array<BulkUpdateTourRoomPriceRulesInput>;
};


export type MutationBulkUpdateTourRoomsArgs = {
  input: Array<BulkUpdateTourRoomInput>;
};


export type MutationBulkUpdateToursArgs = {
  input: Array<BulkUpdateTourInput>;
};


export type MutationCalculatePaymentScheduleArgs = {
  draftOrderId: Scalars['ObjectId']['input'];
  input: CalculatePaymentScheduleInput;
};


export type MutationCancelDraftBookingArgs = {
  input: CancelDraftBookingInput;
};


export type MutationCancelDraftBookingPaymentScheduleArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationCancelDraftBookingTripsArgs = {
  input: CancelDraftBookingTripsInput;
};


export type MutationCancelGcDepartureArgs = {
  input: CancelGcDepartureInput;
};


export type MutationChangeVoucherExpirationArgs = {
  input: ChangeVoucherExpirationInput;
};


export type MutationCheckTripChecklistItemArgs = {
  checklistItemTemplateId: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
};


export type MutationConfirmGcDepartureArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationCreateAdjustmentArgs = {
  input: CreateAdjustmentInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateChatTokenArgs = {
  businessCode: BusinessCode;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateDepartureExcursionArgs = {
  _id: Scalars['ObjectId']['input'];
  input: CreateDepartureExcursionInput;
};


export type MutationCreateDepartureExtensionArgs = {
  _id: Scalars['ObjectId']['input'];
  input: CreateDepartureExtensionInput;
};


export type MutationCreateDepartureExtensionExcursionArgs = {
  _id: Scalars['ObjectId']['input'];
  extensionId: Scalars['ObjectId']['input'];
  input: CreateDepartureExtensionExcursionInput;
};


export type MutationCreateDepartureExtensionRoomArgs = {
  _id: Scalars['ObjectId']['input'];
  extensionId: Scalars['ObjectId']['input'];
  input: CreateDepartureExtensionRoomInput;
};


export type MutationCreateDepartureRoomArgs = {
  _id: Scalars['ObjectId']['input'];
  input: CreateDepartureRoomInput;
};


export type MutationCreateDraftOrderArgs = {
  orderId: Scalars['ObjectId']['input'];
};


export type MutationCreateDraftTermArgs = {
  input: CreateDraftTermInput;
};


export type MutationCreateExtendedStayArgs = {
  input: CreateExtendedStayInput;
};


export type MutationCreateFeeArgs = {
  input: CreateFeeInput;
};


export type MutationCreateFlightPackageArgs = {
  input: CreateFlightPackageInput;
};


export type MutationCreateGcDepartureArgs = {
  input: CreateGcDepartureInput;
};


export type MutationCreateInsuranceExtensionArgs = {
  _id: Scalars['ObjectId']['input'];
  basePrice: Array<MoneyInput>;
};


export type MutationCreateInsurancePlanArgs = {
  input: CreateInsurancePlanInput;
};


export type MutationCreateInsurancePlanAddonArgs = {
  _id: Scalars['ObjectId']['input'];
  input: CreateInsurancePlanAddonInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreatePromoArgs = {
  input: CreatePromoInput;
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateServiceRecoveryPromoArgs = {
  input: CreateServiceRecoveryPromoInput;
};


export type MutationCreateSupportTicketArgs = {
  businessCode: BusinessCode;
  input: SupportTicketInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTourArgs = {
  input: CreateTourInput;
};


export type MutationCreateTourExcursionArgs = {
  input: CreateTourExcursionInput;
};


export type MutationCreateTourExtensionArgs = {
  input: CreateTourExtensionInput;
};


export type MutationCreateTourExtensionRoomArgs = {
  input: CreateTourExtensionRoomInput;
  tourExtensionId: Scalars['ObjectId']['input'];
};


export type MutationCreateTourRoomArgs = {
  input: CreateTourRoomInput;
  tourId: Scalars['ObjectId']['input'];
};


export type MutationCreateTripChecklistItemTemplateArgs = {
  input: CreateTripChecklistItemTemplateInput;
};


export type MutationCreateVoucherFromBookingArgs = {
  input: CreateVoucherFromBookingInput;
};


export type MutationCreateVoucherFromExternalArgs = {
  input: CreateVoucherFromExternalInput;
};


export type MutationCreateWishlistItemArgs = {
  input: CreateWishlistItemInput;
};


export type MutationDeleteCategoryArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationDeleteGcDepartureProspectArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationDeleteReviewImageArgs = {
  reviewId: Scalars['ObjectId']['input'];
  reviewImageIds: Array<Scalars['ObjectId']['input']>;
};


export type MutationDeleteTagArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationDeleteWishlistItemArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationForkBookingArgs = {
  input: ForkBookingInput;
};


export type MutationIncreaseVoucherArgs = {
  input: IncreaseVoucherInput;
};


export type MutationIssueARefundArgs = {
  bookingId: Scalars['ObjectId']['input'];
  overrideOrderBalanceRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  refundInput: RefundInput;
};


export type MutationMakeAPaymentArgs = {
  bookingId: Scalars['ObjectId']['input'];
  payments: Array<PaymentInput>;
};


export type MutationMatchRoommatesArgs = {
  departureId: Scalars['ObjectId']['input'];
  roomTourType: RoomTourType;
  tripIds: Array<Scalars['ObjectId']['input']>;
};


export type MutationMergeBookingArgs = {
  input: MergeBookingInput;
};


export type MutationMergeCustomerArgs = {
  input: MergeCustomerInput;
};


export type MutationPayAndBookArgs = {
  input: PayAndBookInput;
  quoteId: Scalars['ObjectId']['input'];
};


export type MutationPublishDraftBookingArgs = {
  _id: Scalars['ObjectId']['input'];
  input?: InputMaybe<PublishDraftBookingInput>;
};


export type MutationPublishDraftQuoteArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationPublishDraftTermArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationReconcileCardOrAchPaymentArgs = {
  bookingId: Scalars['ObjectId']['input'];
  settlementDate?: InputMaybe<Scalars['Date']['input']>;
  status: PaymentTransactionStatus;
  transactionId: Scalars['ObjectId']['input'];
};


export type MutationReconcileCheckPaymentArgs = {
  bookingId: Scalars['ObjectId']['input'];
  checkPaymentMethodInput?: InputMaybe<CheckPaymentMethodInput>;
  checkTransactionId: Scalars['ObjectId']['input'];
  status: PaymentTransactionStatus;
};


export type MutationReconcilePaymentArgs = {
  bookingId: Scalars['ObjectId']['input'];
  settlementDate?: InputMaybe<Scalars['Date']['input']>;
  status: PaymentTransactionStatus;
  transactionId: Scalars['ObjectId']['input'];
};


export type MutationReconcilePaymentsArgs = {
  businessCode: BusinessCode;
  correlationId: Scalars['String']['input'];
  currencyCode: CurrencyCode;
  sourceProcessorOrAcquirer: SourceProcessorOrAcquirer;
  transactions: Array<ReconcileTransactionInput>;
};


export type MutationReduceVoucherArgs = {
  input: ReduceVoucherInput;
};


export type MutationRefundVoucherArgs = {
  input: RefundVoucherInput;
};


export type MutationReinstateVoucherArgs = {
  input: ReinstateVoucherInput;
};


export type MutationRemoveCampaignPromosArgs = {
  _id: Scalars['ObjectId']['input'];
  input: RemoveCampaignPromosInput;
};


export type MutationRemoveDraftOrderAdjustmentsArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<RemoveDraftOrderAdjustmentInput>;
};


export type MutationRemoveDraftOrderAirportTransferArgs = {
  _id: Scalars['ObjectId']['input'];
  input: Array<RemoveDraftOrderAirportTransferInput>;
};


export type MutationRemoveDraftOrderExcursionArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  lineItemCode: Scalars['LineItemCode']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftOrderExcursionsArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tourTypes: Array<ExcursionTourType>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftOrderExtensionArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftOrderFeesArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  inputs: Array<RemoveDraftOrderFeesInput>;
};


export type MutationRemoveDraftOrderInsuranceArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftOrderInsuranceAddonArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  lineItemCode: Scalars['LineItemCode']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftOrderInsuranceExtensionArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftOrderPostStayArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftOrderPreStayArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftOrderPrivateGroupArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftOrderPromoArgs = {
  _id: Scalars['ObjectId']['input'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  lineItemCode: Scalars['LineItemCode']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationRemoveDraftQuoteTripsArgs = {
  _id: Scalars['ObjectId']['input'];
  tripIds: Array<Scalars['ObjectId']['input']>;
};


export type MutationRemoveEmployeesFromRoleArgs = {
  _id: Scalars['ObjectId']['input'];
  input: RemoveEmployeesFromRoleInput;
};


export type MutationRemovePrivateGroupArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationRemovePromoAudienceMemberArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationRemovePromoCodesArgs = {
  _id: Scalars['ObjectId']['input'];
  input: RemovePromoCodesInput;
};


export type MutationRemovePromoCustomersArgs = {
  _id: Scalars['ObjectId']['input'];
  input: RemovePromoCustomersInput;
};


export type MutationRemovePromoGcDeparturesArgs = {
  _id: Scalars['ObjectId']['input'];
  input: RemovePromoGcDeparturesInput;
};


export type MutationRemovePromoTargetsArgs = {
  _id: Scalars['ObjectId']['input'];
  input: RemovePromoTargetsInput;
};


export type MutationSaveEvaluationArgs = {
  _id: Scalars['ObjectId']['input'];
  freeTextQuestions?: InputMaybe<Array<AnswerFreeTextQuestionInput>>;
  matrixQuestions?: InputMaybe<Array<AnswerMatrixQuestionInput>>;
  multipleChoiceQuestions?: InputMaybe<Array<AnswerMultipleChoiceQuestionInput>>;
};


export type MutationSendMagicLinkArgs = {
  input: SendMagicLinkInput;
};


export type MutationSetDraftQuoteCustomerArgs = {
  _id: Scalars['ObjectId']['input'];
  existingCustomerInput?: InputMaybe<TripExistingCustomerInput>;
  newCustomerInput?: InputMaybe<TripNewCustomerInput>;
  tripId: Scalars['ObjectId']['input'];
};


export type MutationSetReviewFeaturedArgs = {
  _id: Scalars['ObjectId']['input'];
  isFeatured: Scalars['Boolean']['input'];
};


export type MutationSigninCustomerWithMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationSigninCustomerWithPasswordArgs = {
  input: SigninWithPasswordInput;
};


export type MutationSigninTourDirectorWithMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationSignupCustomerArgs = {
  input: SignupCustomerInput;
  skipSessionCookie?: Scalars['Boolean']['input'];
};


export type MutationStartQuoteArgs = {
  input: StartQuoteInput;
};


export type MutationStartRebookingArgs = {
  input: StartRebookingInput;
};


export type MutationStartRebookingQuoteArgs = {
  input: StartRebookingQuoteInput;
};


export type MutationSubmitEvaluationArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type MutationTransferVoucherExternalArgs = {
  input: TransferVoucherExternalInput;
};


export type MutationTransferVoucherInternalArgs = {
  input: TransferVoucherInternalInput;
};


export type MutationUncheckTripChecklistItemArgs = {
  checklistItemTemplateId: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
};


export type MutationUnmatchRoommatesArgs = {
  departureId: Scalars['ObjectId']['input'];
  roomTourType: RoomTourType;
  tripIds: Array<Scalars['ObjectId']['input']>;
};


export type MutationUpdateAdjustmentArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateAdjustmentInput;
};


export type MutationUpdateAdjustmentStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateAdjustmentStatusInput;
};


export type MutationUpdateBusinessSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateBusinessSettingsInput;
};


export type MutationUpdateCampaignArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateCampaignInput;
};


export type MutationUpdateCampaignStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateCampaignStatusInput;
};


export type MutationUpdateCategoryArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateCategoryInput;
};


export type MutationUpdateCustomerAddressArgs = {
  customerId: Scalars['ObjectId']['input'];
  input: UpdateCustomerAddressInput;
};


export type MutationUpdateCustomerEmailArgs = {
  customerId: Scalars['ObjectId']['input'];
  input: UpdateCustomerEmailInput;
};


export type MutationUpdateCustomerGlobalRewardsIdArgs = {
  _id: Scalars['ObjectId']['input'];
  globalRewardsId: Scalars['String']['input'];
};


export type MutationUpdateCustomerNameArgs = {
  customerId: Scalars['ObjectId']['input'];
  input: UpdateCustomerNameInput;
};


export type MutationUpdateCustomerPasswordArgs = {
  input: UpdateCustomerPasswordInput;
};


export type MutationUpdateCustomerPhoneNumberArgs = {
  customerId: Scalars['ObjectId']['input'];
  input: UpdateCustomerPhoneNumberInput;
};


export type MutationUpdateCustomerProfileBioArgs = {
  _id: Scalars['ObjectId']['input'];
  bio: Scalars['String']['input'];
};


export type MutationUpdateCustomerProfileImageArgs = {
  _id: Scalars['ObjectId']['input'];
  profileImageAssetId: Scalars['ObjectId']['input'];
};


export type MutationUpdateCustomerProfilePrivacyArgs = {
  _id: Scalars['ObjectId']['input'];
  isPrivate: Scalars['Boolean']['input'];
};


export type MutationUpdateCustomerProfileSocialMediaArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateCustomerProfileSocialMediaInput;
};


export type MutationUpdateDepartureArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateDepartureInput;
};


export type MutationUpdateDepartureExcursionArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateDepartureExcursionInput;
};


export type MutationUpdateDepartureExtensionArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateDepartureExtensionInput;
};


export type MutationUpdateDepartureExtensionExcursionArgs = {
  _id: Scalars['ObjectId']['input'];
  extensionId: Scalars['ObjectId']['input'];
  input: UpdateDepartureExtensionExcursionInput;
};


export type MutationUpdateDepartureExtensionRoomArgs = {
  _id: Scalars['ObjectId']['input'];
  extensionId: Scalars['ObjectId']['input'];
  input: UpdateDepartureExtensionRoomInput;
};


export type MutationUpdateDepartureItemStatusArgs = {
  departureId: Scalars['ObjectId']['input'];
  input: Array<UpdateDepartureItemStatusInput>;
};


export type MutationUpdateDepartureRoomArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateDepartureRoomInput;
};


export type MutationUpdateDraftBookingPaymentScheduleArgs = {
  _id: Scalars['ObjectId']['input'];
  frequency: PaymentScheduleFrequency;
  startDate: Scalars['Date']['input'];
};


export type MutationUpdateDraftBookingPaymentSchedulePaymentMethodArgs = {
  _id: Scalars['ObjectId']['input'];
  paymentSchedulePaymentMethod: PaymentSchedulePaymentMethodInput;
};


export type MutationUpdateDraftBookingTripLineItemStatusesArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftBookingTripLineItemStatusesInput>;
};


export type MutationUpdateDraftBookingTripStatusesArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftBookingTripStatusesInput>;
};


export type MutationUpdateDraftOrderAddressArgs = {
  _id: Scalars['ObjectId']['input'];
  address: AddressInput;
  tripId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDraftOrderAdjustmentPricesArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftOrderAdjustmentPricesInput>;
};


export type MutationUpdateDraftOrderAirportTransferArgs = {
  _id: Scalars['ObjectId']['input'];
  input: Array<UpdateDraftOrderAirportTransferInput>;
};


export type MutationUpdateDraftOrderEmergencyContactsArgs = {
  _id: Scalars['ObjectId']['input'];
  emergencyContacts: Array<EmergencyContactInput>;
  tripId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDraftOrderExtensionRoomsArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftOrderRoomInput>;
};


export type MutationUpdateDraftOrderFeePricesArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftOrderFeePricesInput>;
};


export type MutationUpdateDraftOrderFinalInstallmentDeadlineArgs = {
  _id: Scalars['ObjectId']['input'];
  finalInstallmentDeadline: Scalars['Date']['input'];
};


export type MutationUpdateDraftOrderFinalPaymentDeadlineArgs = {
  _id: Scalars['ObjectId']['input'];
  finalPaymentDeadline: Scalars['Date']['input'];
};


export type MutationUpdateDraftOrderFlightPackagesArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftOrderFlightPackageInput>;
};


export type MutationUpdateDraftOrderInsuranceArgs = {
  _id: Scalars['ObjectId']['input'];
  addOnLineItemCodes?: InputMaybe<Array<Scalars['LineItemCode']['input']>>;
  lineItemCode: Scalars['LineItemCode']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};


export type MutationUpdateDraftOrderPrimaryTripArgs = {
  _id: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDraftOrderPromoPricesArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftOrderPromoPricesInput>;
};


export type MutationUpdateDraftOrderRequestedRoommatesArgs = {
  _id: Scalars['ObjectId']['input'];
  requestedRoommates: Array<Scalars['String']['input']>;
  tripId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDraftOrderRequestedTravelCompanionsArgs = {
  _id: Scalars['ObjectId']['input'];
  requestedTravelCompanions: Array<Scalars['String']['input']>;
  tripId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDraftOrderRoomsArgs = {
  _id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftOrderRoomInput>;
};


export type MutationUpdateDraftOrderTravelerNotesArgs = {
  _id: Scalars['ObjectId']['input'];
  input: TravelerNotesInput;
  tripId: Scalars['ObjectId']['input'];
};


export type MutationUpdateDraftOrderTsaInformationArgs = {
  _id: Scalars['ObjectId']['input'];
  overrideExpirationDateCheck?: Scalars['Boolean']['input'];
  tripId: Scalars['ObjectId']['input'];
  tsaInformation: TsaInformationInput;
};


export type MutationUpdateDraftQuoteSavedArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateDraftQuoteSavedInput;
};


export type MutationUpdateDraftTermArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateDraftTermInput;
};


export type MutationUpdateExtendedStayArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateExtendedStayInput;
};


export type MutationUpdateExtendedStayStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateExtendedStayStatusInput;
};


export type MutationUpdateFeeArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateFeeInput;
};


export type MutationUpdateFeeStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateFeeStatusInput;
};


export type MutationUpdateFlightPackageArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateFlightPackageInput;
};


export type MutationUpdateFlightPackageStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateFlightPackageStatusInput;
};


export type MutationUpdateGcDepartureArgs = {
  input: UpdateGcDepartureInput;
};


export type MutationUpdateGcDepartureProspectArgs = {
  input: UpdateGcDepartureProspectInput;
};


export type MutationUpdateGcDepartureStipendDetailArgs = {
  input: UpdateGcDepartureStipendDetailInput;
};


export type MutationUpdateInsuranceExtensionArgs = {
  input: UpdateInsuranceExtensionInput;
  insurancePlanId: Scalars['ObjectId']['input'];
};


export type MutationUpdateInsuranceExtensionStatusArgs = {
  input: UpdateInsuranceExtensionStatusInput;
  insurancePlanId: Scalars['ObjectId']['input'];
};


export type MutationUpdateInsurancePlanArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateInsurancePlanInput;
};


export type MutationUpdateInsurancePlanAddonArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateInsurancePlanAddonInput;
  insurancePlanId: Scalars['ObjectId']['input'];
};


export type MutationUpdateInsurancePlanAddonStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateInsurancePlanAddonStatusInput;
};


export type MutationUpdateInsurancePlanStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateInsurancePlanStatusInput;
};


export type MutationUpdateNoteArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateNoteInput;
};


export type MutationUpdatePrivateGroupArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdatePrivateGroupInput;
};


export type MutationUpdatePrivateGroupStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdatePrivateGroupStatusInput;
};


export type MutationUpdatePromoArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdatePromoInput;
};


export type MutationUpdatePromoStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdatePromoStatusInput;
};


export type MutationUpdatePromoTargetsArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdatePromoTargetsInput;
};


export type MutationUpdateQuoteExpiryArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateQuoteExpiryInput;
};


export type MutationUpdateQuoteSavedArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateQuoteSavedInput;
};


export type MutationUpdateReviewArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateReviewInput;
};


export type MutationUpdateReviewDetailResponseArgs = {
  input?: InputMaybe<UpdateReviewDetailResponseInput>;
  reviewId: Scalars['ObjectId']['input'];
};


export type MutationUpdateReviewDetailStatusArgs = {
  reviewId: Scalars['ObjectId']['input'];
  status: ReviewStatus;
};


export type MutationUpdateReviewImagesStatusArgs = {
  input: Array<UpdateReviewImagesStatusInput>;
  reviewId: Scalars['ObjectId']['input'];
};


export type MutationUpdateRoleArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateRoleInput;
};


export type MutationUpdateServiceRecoveryPromoArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateServiceRecoveryPromoInput;
};


export type MutationUpdateServiceRecoveryPromoStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateServiceRecoveryPromoStatusInput;
};


export type MutationUpdateTagArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTagInput;
};


export type MutationUpdateTourArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourInput;
};


export type MutationUpdateTourDirectorProfileArgs = {
  _id: Scalars['ObjectId']['input'];
  input: SetTourDirectorProfileInput;
};


export type MutationUpdateTourExcursionArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourExcursionInput;
};


export type MutationUpdateTourExcursionStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourExcursionStatusInput;
};


export type MutationUpdateTourExtensionArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourExtensionInput;
};


export type MutationUpdateTourExtensionRoomArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourExtensionRoomInput;
};


export type MutationUpdateTourExtensionRoomStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourExtensionRoomStatusInput;
};


export type MutationUpdateTourExtensionStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourExtensionStatusInput;
};


export type MutationUpdateTourPricingArgs = {
  input: UpdateTourPricingInput;
};


export type MutationUpdateTourRoomArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourRoomInput;
};


export type MutationUpdateTourRoomStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourRoomStatusInput;
};


export type MutationUpdateTourStatusArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTourStatusInput;
};


export type MutationUpdateTripChecklistItemTemplateArgs = {
  _id: Scalars['ObjectId']['input'];
  input: UpdateTripChecklistItemTemplateInput;
};


export type MutationUpdateVoucherRefundDetailArgs = {
  input: UpdateVoucherRefundDetailInput;
};


export type MutationVoidBookingTransferPaymentArgs = {
  bookingId: Scalars['ObjectId']['input'];
  transferTransactionId: Scalars['ObjectId']['input'];
};


export type MutationVoidVoucherArgs = {
  input: VoidVoucherInput;
};

/** The CurrentUser is not authorized to perform the requested action */
export type NotAuthorizedError = DomainError & {
  __typename?: 'NotAuthorizedError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** A required entity was not found during a mutation process */
export type NotFoundError = DomainError & {
  __typename?: 'NotFoundError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Notes attached to any other entity type */
export type Note = {
  __typename?: 'Note';
  _id: Scalars['ObjectId']['output'];
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  employee?: Maybe<Employee>;
  employeeId: Scalars['ObjectId']['output'];
  targetId: Scalars['ObjectId']['output'];
};

export type NotePaginatedResult = {
  __typename?: 'NotePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Note>;
};

export type OffsetPaginateInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** A pre-2018 legacy trip that does not contain as much information as a BookingTrip */
export type OldTrip = {
  __typename?: 'OldTrip';
  _id: Scalars['ID']['output'];
  businessCode: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  isValidForLoyalty: Scalars['Boolean']['output'];
  legacyTripId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  tourCode: Scalars['String']['output'];
  tourInternalName?: Maybe<Scalars['String']['output']>;
};

export type OpportunityQuotePaginatedResult = {
  __typename?: 'OpportunityQuotePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Quote>;
};

/** An order */
export type Order = {
  _id: Scalars['ObjectId']['output'];
  /** Sum of total successful transactions */
  amountPaid: Money;
  /** Grand total less the amount already paid */
  balance: Money;
  businessCode: BusinessCode;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The currency code of the order. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer who initiated the booking. */
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  departure?: Maybe<Departure>;
  /** The departure id of the order. */
  departureId: Scalars['ObjectId']['output'];
  /** The extended date the final payment is due for the order. */
  extendedFinalPaymentDate?: Maybe<Scalars['Date']['output']>;
  /** The date the final installment for app is due for the order. */
  finalInstallmentDate: Scalars['Date']['output'];
  /** The date the final payment is due for the order. */
  finalPaymentDate: Scalars['Date']['output'];
  gcDeparture?: Maybe<GcDeparture>;
  /** The id of the gc departure associated with the order. */
  gcDepartureId?: Maybe<Scalars['ObjectId']['output']>;
  /** Sum of all line item prices */
  grandTotal: Money;
  /** Sum of all line item prices without discounts applied */
  grandTotalBeforeDiscount: Money;
  /** Sum of all line items excluding flights */
  grandTotalWithoutFlights: Money;
  /** Indicates if the final payment date has been extended. */
  isFinalPaymentDateExtended: Scalars['Boolean']['output'];
  /** The latest date the final installment for app is due for the order. */
  latestFinalInstallmentDate: Scalars['Date']['output'];
  /** The latest date the final payment is due for the order. */
  latestFinalPaymentDate: Scalars['Date']['output'];
  opportunityId?: Maybe<Scalars['String']['output']>;
  /** The order that this order was rebooked from. */
  rebookedFromOrder?: Maybe<Order>;
  /** The order id that this order was rebooked from. */
  rebookedFromOrderId?: Maybe<Scalars['ObjectId']['output']>;
  /** The stage of the order. */
  stage: OrderStage;
  /** Sum of all discount line items */
  totalDiscount: Money;
  tourLineItemCode?: Maybe<Scalars['LineItemCode']['output']>;
  /** The transactions applied to the order, sorted by ascending transaction date. */
  transactions: Array<PaymentTransaction>;
  /** The trips of the order. */
  trips: Array<Trip>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The version of the order. */
  versionId: Scalars['Int']['output'];
};

export enum OrderLineItemHistoryAction {
  Added = 'ADDED',
  AddedFlights = 'ADDED_FLIGHTS',
  AddedLo1Flights = 'ADDED_LO1_FLIGHTS',
  AddedLo1Transfer = 'ADDED_LO1_TRANSFER',
  AmountChanged = 'AMOUNT_CHANGED',
  DateGatewayChange = 'DATE_GATEWAY_CHANGE',
  Lo1TransferChange = 'LO1_TRANSFER_CHANGE',
  Removed = 'REMOVED',
  RoommateChanged = 'ROOMMATE_CHANGED',
  RoomTypeChanged = 'ROOM_TYPE_CHANGED',
  StatusChanged = 'STATUS_CHANGED',
  SwitchedFlightsToLo1 = 'SWITCHED_FLIGHTS_TO_LO1',
  SwitchedLo1ToFlights = 'SWITCHED_LO1_TO_FLIGHTS'
}

export type OrderLineItemHistoryChange = {
  __typename?: 'OrderLineItemHistoryChange';
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  lineItem: LineItem;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type OrderLineItemHistoryEntry = {
  __typename?: 'OrderLineItemHistoryEntry';
  /** The action that was taken on the line item */
  action: OrderLineItemHistoryAction;
  /** The changes that were made to the line item */
  changeSet: Array<OrderLineItemHistoryChange>;
  /** The customer id of the trip that the line item belongs to */
  customerIds: Array<Scalars['ObjectId']['output']>;
  customers: Array<Customer>;
  /** The date the change was made */
  date: Scalars['DateTime']['output'];
  /** The line item type that the history entry is for */
  lineItemType: TripComponentType;
  /** The user that made the change */
  modifiedBy?: Maybe<AuditIdentity>;
  orderId: Scalars['ObjectId']['output'];
};

export type OrderPaginatedResult = {
  __typename?: 'OrderPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Order>;
};

/** Settings related to the order management. */
export type OrderSettings = {
  __typename?: 'OrderSettings';
  achCheck: PaymentMethodSettings;
  bypassErrorOnProcessorDown: Scalars['Boolean']['output'];
  creditCard: PaymentMethodSettings;
  daysToMeetMinimumInstallments: Scalars['Int']['output'];
  debitCard: PaymentMethodSettings;
  departurePriorityWindowDpd: Scalars['Int']['output'];
  earliestPaymentScheduleStartDays: Scalars['Int']['output'];
  /** Number of days prior to departure that the emergency contact information is no longer allowed to be submitted by the user */
  emergencyContactSelfServiceDeadlineDpd: Scalars['Int']['output'];
  expiresInMinutes: Scalars['Int']['output'];
  /** Number of days prior to departure that health notes are no longer allowed to be submitted by the user */
  healthNotesSelfServiceDeadlineDpd: Scalars['Int']['output'];
  latestPaymentScheduleStartDays: Scalars['Int']['output'];
  maximumAgeForTraveler?: Maybe<Scalars['Int']['output']>;
  maximumPerTripPromotionAmount: Amount;
  minimumAgeForTraveler?: Maybe<Scalars['Int']['output']>;
  nbMaximumAutopayAttempts: Scalars['Int']['output'];
  /** Number of days prior to departure that passport information is no longer allowed to be submitted by the user */
  passportInformationSelfServiceDeadlineDpd: Scalars['Int']['output'];
  physicalCheck: PaymentMethodSettings;
  riskFreePeriodSettings: RiskFreePeriodSettings;
  /** Number of days prior to departure that tsa identifiers is no longer allowed to be submitted by the user */
  tsaIdentifiersSelfServiceDeadlineDpd: Scalars['Int']['output'];
};

export enum OrderStage {
  Booking = 'BOOKING',
  Quote = 'QUOTE'
}

export enum OrderTsaHistoryAction {
  Added = 'ADDED',
  Updated = 'UPDATED'
}

export type OrderTsaHistoryChange = {
  __typename?: 'OrderTSAHistoryChange';
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  fieldName: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  tsaInformation: TsaInformation;
};

export type OrderTsaHistoryEntry = {
  __typename?: 'OrderTSAHistoryEntry';
  /** The action that was taken on the tsa information */
  action: OrderTsaHistoryAction;
  /** The changes that were made to the tsa information */
  changeSet: Array<OrderTsaHistoryChange>;
  /** The customer id of the trip that the tsa information belongs to */
  customerIds: Array<Scalars['ObjectId']['output']>;
  customers: Array<Customer>;
  /** The date the change was made */
  date: Scalars['DateTime']['output'];
  /** The type of information that was changed, ID or TSA */
  infoType: OrderTsaInfoType;
  /** The user that made the change */
  modifiedBy?: Maybe<AuditIdentity>;
  orderId: Scalars['ObjectId']['output'];
};

export enum OrderTsaInfoType {
  Id = 'ID',
  Tsa = 'TSA'
}

export type PaginateInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  next?: InputMaybe<Scalars['String']['input']>;
  previous?: InputMaybe<Scalars['String']['input']>;
};

export type PassportInformationChecklistItem = SystemChecklistItem & {
  __typename?: 'PassportInformationChecklistItem';
  dueDate?: Maybe<Scalars['Date']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  status?: Maybe<TripChecklistItemStatus>;
};

export type PayAndBookInput = {
  acceptWaitlist?: Scalars['Boolean']['input'];
  /** Where this booking was made. */
  bookingMethod: BookingMethod;
  paymentSchedule?: InputMaybe<PaymentScheduleInput>;
  payments: Array<PaymentInput>;
  staffMinimumBalanceOverrideRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayAndBookResult = Booking | BusinessNotSpecifiedError | DepartureNotBookableError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidOrderError | InvalidPaymentError | NotAuthorizedError | NotFoundError | ValidationError;

export type PaymentBalanceByPaymentMethod = {
  __typename?: 'PaymentBalanceByPaymentMethod';
  amount: Money;
  customerId: Scalars['ObjectId']['output'];
  paymentMethod: TransactionPaymentMethod;
  paymentMethodHash: Scalars['String']['output'];
  savedPaymentMethodId?: Maybe<Scalars['ObjectId']['output']>;
};

export type PaymentInput = {
  amount: Scalars['Float']['input'];
  method: PaymentMethodInput;
};

export type PaymentInstallment = {
  __typename?: 'PaymentInstallment';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  /** The date the payment is scheduled to be processed on. */
  scheduledDate: Scalars['Date']['output'];
  status: PaymentInstallmentStatus;
};

export enum PaymentInstallmentStatus {
  /** The payment installment has been attempted. */
  Attempted = 'ATTEMPTED',
  /** The payment installment has been cancelled. */
  Cancelled = 'CANCELLED',
  /** The payment installment has been processed. */
  Processed = 'PROCESSED',
  /** The payment installment has been skipped. */
  Skipped = 'SKIPPED',
  /** The payment installment has not been processed. */
  Unprocessed = 'UNPROCESSED'
}

/** Payment method input. Only specify one of the payment methods. */
export type PaymentMethodInput = {
  /** Affirm payment method */
  affirm?: InputMaybe<AffirmPaymentMethodInput>;
  /** Physical check payment method */
  check?: InputMaybe<CheckPaymentMethodInput>;
  /** Saved payment method */
  savedPayment?: InputMaybe<SavedPaymentMethodInput>;
  /** Tokenized payment method. Provided by the tokenizer iframe */
  tokenized?: InputMaybe<TokenizedPaymentMethodInput>;
  /** Transfer funds from another booking */
  transfer?: InputMaybe<TransferPaymentMethodInput>;
  /** Voucher payment method */
  voucher?: InputMaybe<VoucherPaymentMethodInput>;
};

/** Payment method settings for the order. */
export type PaymentMethodSettings = {
  __typename?: 'PaymentMethodSettings';
  isAutopayAllowed: Scalars['Boolean']['output'];
  isManualAllowed: Scalars['Boolean']['output'];
};

/** A summary info for a single reconciled payment */
export type PaymentReconciliationTransaction = {
  __typename?: 'PaymentReconciliationTransaction';
  acquirerId?: Maybe<Scalars['String']['output']>;
  amount: Money;
  bookingId?: Maybe<Scalars['ObjectId']['output']>;
  businessCode: BusinessCode;
  processDate: Scalars['Date']['output'];
  processorMerchantReferenceNumber?: Maybe<Scalars['String']['output']>;
  reconciliationStatus: ReconciliationStatus;
  reconciliationStatusMessage?: Maybe<Scalars['String']['output']>;
  returnReasonCode?: Maybe<Scalars['String']['output']>;
  returnReasonString?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['Int']['output']>;
  transactionType: ReconciliationTransactionType;
  uploadId: Scalars['ObjectId']['output'];
};

export type PaymentReconciliationTransactionPaginatedResult = {
  __typename?: 'PaymentReconciliationTransactionPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<PaymentReconciliationTransaction>;
};

export enum PaymentReconciliationTransactionSortField {
  BookingId = 'bookingId',
  ReconciliationStatus = 'reconciliationStatus',
  TransactionId = 'transactionId'
}

/** A summary info for a single reconciled payment */
export type PaymentReconciliationUpload = {
  __typename?: 'PaymentReconciliationUpload';
  _id: Scalars['ObjectId']['output'];
  businessCode: BusinessCode;
  correlationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  nbFailedTransactions: Scalars['Int']['output'];
  nbSkippedTransactions: Scalars['Int']['output'];
  nbSuccessfulTransactions: Scalars['Int']['output'];
  nbUnprocessedTransactions: Scalars['Int']['output'];
  sourceProcessorOrAcquirer: SourceProcessorOrAcquirer;
};

export type PaymentReconciliationUploadPaginatedResult = {
  __typename?: 'PaymentReconciliationUploadPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<PaymentReconciliationUpload>;
};

export type PaymentSchedule = {
  __typename?: 'PaymentSchedule';
  _id: Scalars['ObjectId']['output'];
  /** The plan's installments which are either in status UNPROCESSED or PROCESSED. Most customer or sales/service facing applications will want to use this. */
  activeInstallments: Array<PaymentInstallment>;
  /** The current payment plan balance for unprocessed installments. */
  balance?: Maybe<Money>;
  /** The frequency of the payment plan. */
  frequency: PaymentScheduleFrequency;
  /** The payment plan installments, regardless of status. If you are displaying installments to a customer or sales/service staff, consider using activeInstallments instead. */
  installments: Array<PaymentInstallment>;
  /** The maximum number of attempts to process the payment installment. */
  maxAttempts: Scalars['Int']['output'];
  /** The plan's installments in status PROCESSED. */
  processedInstallments: Array<PaymentInstallment>;
  /** The saved payment method. */
  savedPaymentMethod?: Maybe<SavedPaymentMethod>;
  savedPaymentMethodId?: Maybe<Scalars['ObjectId']['output']>;
  /** The date the payment plan starts. */
  startDate: Scalars['Date']['output'];
  /** The status of the payment plan. */
  status: PaymentScheduleStatus;
  /** The payment plan total, from the first installment to the last. */
  total?: Maybe<Money>;
  /** The plan's installments in status UNPROCESSED. */
  unprocessedInstallments: Array<PaymentInstallment>;
};

export enum PaymentScheduleFrequency {
  /** The payment installment is processed biweekly. */
  Biweekly = 'BIWEEKLY',
  /** The payment installment is processed monthly. */
  Monthly = 'MONTHLY'
}

export type PaymentScheduleInput = {
  frequency: PaymentScheduleFrequency;
  method: PaymentSchedulePaymentMethodInput;
  startDate: Scalars['Date']['input'];
};

export type PaymentSchedulePaymentMethodInput = {
  /** Saved payment method */
  savedPayment?: InputMaybe<SavedPaymentMethodInput>;
  /** Tokenized payment method. Provided by the tokenizer iframe */
  tokenized?: InputMaybe<TokenizedPaymentMethodInput>;
};

export enum PaymentScheduleStatus {
  /** The payment plan is active */
  Active = 'ACTIVE',
  /** The payment plan is cancelled and payment may have been refunded. */
  Cancelled = 'CANCELLED',
  /** The payment plan is completed and all payments have been made. */
  Completed = 'COMPLETED',
  /** The payment plan is pending */
  Pending = 'PENDING',
  PendingWithdrawal = 'PENDING_WITHDRAWAL',
  /** The payment plan is withdrawn */
  Withdrawn = 'WITHDRAWN'
}

export type PaymentTransaction = {
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  /** The customer of this transaction. */
  customerId: Scalars['ObjectId']['output'];
  displayStatus: PaymentTransactionDisplayStatus;
  /** The user who initiated the transaction */
  initiatedBy?: Maybe<User>;
  paymentMethod: TransactionPaymentMethod;
  paymentSysResponseCode?: Maybe<Scalars['String']['output']>;
  paymentSysResponseMessage?: Maybe<Scalars['String']['output']>;
  processorTransactionId?: Maybe<Scalars['Int']['output']>;
  reconciledBy?: Maybe<Employee>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  settlementDate?: Maybe<Scalars['Date']['output']>;
  /** The status of this transaction. */
  status: PaymentTransactionStatus;
  transactionDate: Scalars['DateTime']['output'];
};

/** The display status of a transaction */
export enum PaymentTransactionDisplayStatus {
  /** The transaction was succesfully processed. */
  Accepted = 'ACCEPTED',
  /** The transaction has not been processed yet. */
  Pending = 'PENDING',
  /** The transaction was rejected. */
  Rejected = 'REJECTED'
}

export type PaymentTransactionPaginatedResult = {
  __typename?: 'PaymentTransactionPaginatedResult';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  results: Array<PaymentTransaction>;
};

/** The status of a transaction */
export enum PaymentTransactionStatus {
  /** The transaction was attempted, but something went wrong during processing. */
  Attempted = 'ATTEMPTED',
  /**  The transactions was settled by the processor, the amount was successfully processed. */
  Confirmed = 'CONFIRMED',
  /** The transaction failed at the processor. See the fields: `paymentSysResponseCode` and `paymentSysReponseMessage` for details. */
  Failed = 'FAILED',
  /** The transaction is pending, yet to be processed. */
  Pending = 'PENDING',
  /** (ACH transactions only) The check was returned by the bank (due to insufficient funds). */
  Returned = 'RETURNED',
  /** The pending transaction was voided thus never processed by payment processor. */
  Voided = 'VOIDED'
}

export type Permission = {
  __typename?: 'Permission';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: PermissionKey;
  name: Scalars['String']['output'];
};

export enum PermissionKey {
  /** Allows you to create a adjustment */
  AdjustmentCreate = 'ADJUSTMENT_CREATE',
  /** Allows you to manage adjustments */
  AdjustmentManageAll = 'ADJUSTMENT_MANAGE_ALL',
  /** Allows you to manage adjustment prices */
  AdjustmentManagePricing = 'ADJUSTMENT_MANAGE_PRICING',
  /** Allows you to read adjustments */
  AdjustmentReadAll = 'ADJUSTMENT_READ_ALL',
  /** Admins have full access to the business and pass all permissions checks for that business */
  Admin = 'ADMIN',
  /** Allows you to create a booking */
  BookingCreate = 'BOOKING_CREATE',
  /** Allows you to read bookings */
  BookingReadAll = 'BOOKING_READ_ALL',
  /** Allows you to update business settings */
  BusinessUpdateSettings = 'BUSINESS_UPDATE_SETTINGS',
  /** Allows you to create a campaign */
  CampaignCreate = 'CAMPAIGN_CREATE',
  /** Allows you to manage campaigns */
  CampaignManageAll = 'CAMPAIGN_MANAGE_ALL',
  /** Allows you to read campaigns */
  CampaignReadAll = 'CAMPAIGN_READ_ALL',
  /** Allows you to merge customers */
  CustomerManageMerge = 'CUSTOMER_MANAGE_MERGE',
  /** Allows you to read customer data */
  CustomerRead = 'CUSTOMER_READ',
  /** Allows you to create a departure */
  DepartureCreate = 'DEPARTURE_CREATE',
  /** Allows you to create a departure excursion */
  DepartureExcursionCreate = 'DEPARTURE_EXCURSION_CREATE',
  /** Allows you to manage departure excursions */
  DepartureExcursionManageAll = 'DEPARTURE_EXCURSION_MANAGE_ALL',
  /** Allows you to manage departure excursion prices */
  DepartureExcursionManagePricing = 'DEPARTURE_EXCURSION_MANAGE_PRICING',
  /** Allows you to create a departure extension */
  DepartureExtensionCreate = 'DEPARTURE_EXTENSION_CREATE',
  /** Allows you to manage departure extensions */
  DepartureExtensionManageAll = 'DEPARTURE_EXTENSION_MANAGE_ALL',
  /** Allows you to manage departure extension prices */
  DepartureExtensionManagePricing = 'DEPARTURE_EXTENSION_MANAGE_PRICING',
  /** Allows you to manage departures */
  DepartureManageAll = 'DEPARTURE_MANAGE_ALL',
  /** Allows you to change the status of a CLOSED departure */
  DepartureManageClosed = 'DEPARTURE_MANAGE_CLOSED',
  /** Allows you to change the departure owner */
  DepartureManageOwner = 'DEPARTURE_MANAGE_OWNER',
  /** Allows you to manage departure prices */
  DepartureManagePricing = 'DEPARTURE_MANAGE_PRICING',
  /** Allows you to view the departure TDI report */
  DepartureManageViewTdi = 'DEPARTURE_MANAGE_VIEW_TDI',
  /** Allows you to read departures */
  DepartureReadAll = 'DEPARTURE_READ_ALL',
  /** Allows you to create a departure room */
  DepartureRoomCreate = 'DEPARTURE_ROOM_CREATE',
  /** Allows you to manage departure rooms */
  DepartureRoomManageAll = 'DEPARTURE_ROOM_MANAGE_ALL',
  /** Allows you to manage departure room prices */
  DepartureRoomManagePricing = 'DEPARTURE_ROOM_MANAGE_PRICING',
  /** Allows you to create a new extended stay */
  ExtendedStayCreate = 'EXTENDED_STAY_CREATE',
  /** Allows you to create a fee */
  FeeCreate = 'FEE_CREATE',
  /** Allows you to manage fees */
  FeeManageAll = 'FEE_MANAGE_ALL',
  /** Allows you to manage fee prices */
  FeeManagePricing = 'FEE_MANAGE_PRICING',
  /** Allows you to read fees */
  FeeReadAll = 'FEE_READ_ALL',
  /** Allows you to create a flight package */
  FlightPackageCreate = 'FLIGHT_PACKAGE_CREATE',
  /** Allows you to manage flight packages */
  FlightPackageManageAll = 'FLIGHT_PACKAGE_MANAGE_ALL',
  /** Allows you to manage flight package prices */
  FlightPackageManagePricing = 'FLIGHT_PACKAGE_MANAGE_PRICING',
  /** Allows you to read flight packages */
  FlightPackageReadAll = 'FLIGHT_PACKAGE_READ_ALL',
  /** Allows you to book flights */
  FlightShoppingBook = 'FLIGHT_SHOPPING_BOOK',
  /** Allows you to search for flights */
  FlightShoppingSearch = 'FLIGHT_SHOPPING_SEARCH',
  /** Allows you to cancel a GC Departure */
  GcDepartureCancel = 'GC_DEPARTURE_CANCEL',
  /** Allows you to create a new GC Departure */
  GcDepartureCreate = 'GC_DEPARTURE_CREATE',
  /** Allows you to update a GC Departure */
  GcDepartureManage = 'GC_DEPARTURE_MANAGE',
  /** Allows you to create a insurance */
  InsuranceCreate = 'INSURANCE_CREATE',
  /** Allows you to manage insurances */
  InsuranceManageAll = 'INSURANCE_MANAGE_ALL',
  /** Allows you to manage insurance prices */
  InsuranceManagePricing = 'INSURANCE_MANAGE_PRICING',
  /** Allows you to read insurances */
  InsuranceReadAll = 'INSURANCE_READ_ALL',
  /** Allows you to create a draft order */
  OrderDraft = 'ORDER_DRAFT',
  /** Allows you to read draft orders */
  OrderDraftReadAll = 'ORDER_DRAFT_READ_ALL',
  /** Allows you to manage adjustments on orders */
  OrderManageAdjustments = 'ORDER_MANAGE_ADJUSTMENTS',
  /** Allows you to manage cancelling orders */
  OrderManageCancel = 'ORDER_MANAGE_CANCEL',
  /** Allows you to manage closed excursions on orders */
  OrderManageClosedExcursions = 'ORDER_MANAGE_CLOSED_EXCURSIONS',
  /** Allows you to manage closed extensions on orders */
  OrderManageClosedExtensions = 'ORDER_MANAGE_CLOSED_EXTENSIONS',
  /** Allows you to manage excursions on orders */
  OrderManageExcursions = 'ORDER_MANAGE_EXCURSIONS',
  /** Allows you to manage extended stays on orders */
  OrderManageExtendedStays = 'ORDER_MANAGE_EXTENDED_STAYS',
  /** Allows you to manage extensions on orders */
  OrderManageExtensions = 'ORDER_MANAGE_EXTENSIONS',
  /** Allows you to manage fees on orders */
  OrderManageFees = 'ORDER_MANAGE_FEES',
  /** Allows you to manage flights on orders */
  OrderManageFlights = 'ORDER_MANAGE_FLIGHTS',
  /** Allows you to manage forking orders */
  OrderManageFork = 'ORDER_MANAGE_FORK',
  /** Allows you to manage insurance on orders */
  OrderManageInsurance = 'ORDER_MANAGE_INSURANCE',
  /** Allows you to remove insurance after the removal window */
  OrderManageInsuranceOverrideRemovalWindow = 'ORDER_MANAGE_INSURANCE_OVERRIDE_REMOVAL_WINDOW',
  /** Allows you to manage merging orders */
  OrderManageMerge = 'ORDER_MANAGE_MERGE',
  /** Allows you to change the primary trip on orders */
  OrderManagePrimaryTrip = 'ORDER_MANAGE_PRIMARY_TRIP',
  /** Allows you to manage private group fees on orders */
  OrderManagePrivateGroup = 'ORDER_MANAGE_PRIVATE_GROUP',
  /** Allows you to manage promos on orders */
  OrderManagePromos = 'ORDER_MANAGE_PROMOS',
  /** Allows you to manage rebooking orders */
  OrderManageRebook = 'ORDER_MANAGE_REBOOK',
  /** Allows you to manage roommates on orders */
  OrderManageRoommates = 'ORDER_MANAGE_ROOMMATES',
  /** Allows you to manage rooms on orders */
  OrderManageRooms = 'ORDER_MANAGE_ROOMS',
  /** Allows you to manually change the status of a trip on an order */
  OrderManageStatus = 'ORDER_MANAGE_STATUS',
  /** Allows you to manage traveler information on orders */
  OrderManageTravelerInformation = 'ORDER_MANAGE_TRAVELER_INFORMATION',
  /** Allows you to override TSA expiration date check */
  OrderOverrideTsaExpiration = 'ORDER_OVERRIDE_TSA_EXPIRATION',
  /** Allows you to adjust an orders' autopay */
  OrderPaymentsAutopay = 'ORDER_PAYMENTS_AUTOPAY',
  /** Allows you to make payments for an order */
  OrderPaymentsMakePayment = 'ORDER_PAYMENTS_MAKE_PAYMENT',
  /** Allows you to set a later final installment date for a booking */
  OrderPaymentsOverrideFinalInstallmentDate = 'ORDER_PAYMENTS_OVERRIDE_FINAL_INSTALLMENT_DATE',
  /** Allows you to set a later final payment date for a booking */
  OrderPaymentsOverrideFinalPaymentDate = 'ORDER_PAYMENTS_OVERRIDE_FINAL_PAYMENT_DATE',
  /** Allows you to take a payment for less than the minimum due on booking */
  OrderPaymentsOverrideMinimum = 'ORDER_PAYMENTS_OVERRIDE_MINIMUM',
  /** Allows you to read the transactions on an order */
  OrderPaymentsReadAll = 'ORDER_PAYMENTS_READ_ALL',
  /** Allows you to manually change the status of a payment on an order */
  OrderPaymentsReconcile = 'ORDER_PAYMENTS_RECONCILE',
  /** Allows you to make a refund from an order */
  OrderPaymentsRefund = 'ORDER_PAYMENTS_REFUND',
  /** Allows you to make a refund from an order that would take the order below the minimum balance owed */
  OrderPaymentsRefundOverrideMinimumBalance = 'ORDER_PAYMENTS_REFUND_OVERRIDE_MINIMUM_BALANCE',
  /** Allows you to make payment transfers between orders */
  OrderPaymentsTransfer = 'ORDER_PAYMENTS_TRANSFER',
  /** Allows you to read orders */
  OrderReadAll = 'ORDER_READ_ALL',
  /** Allows you to read order related documents */
  OrderReadDocument = 'ORDER_READ_DOCUMENT',
  /** Allows you to create a tour private group fee */
  PrivateGroupFeeCreate = 'PRIVATE_GROUP_FEE_CREATE',
  /** Allows you to manage tour private group fees */
  PrivateGroupFeeManageAll = 'PRIVATE_GROUP_FEE_MANAGE_ALL',
  /** Allows you to manage tour private group fee prices */
  PrivateGroupFeeManagePricing = 'PRIVATE_GROUP_FEE_MANAGE_PRICING',
  /** Allows you to create a promo */
  PromoCreate = 'PROMO_CREATE',
  /** Allows you to manage promos */
  PromoManageAll = 'PROMO_MANAGE_ALL',
  /** Allows you to manage promo prices */
  PromoManagePricing = 'PROMO_MANAGE_PRICING',
  /** Allows you to read promos */
  PromoReadAll = 'PROMO_READ_ALL',
  /** Allows you to create a quote */
  QuoteCreate = 'QUOTE_CREATE',
  /** Allows you to read quotes */
  QuoteReadAll = 'QUOTE_READ_ALL',
  /** Allows you to manage reviews */
  ReviewManageAll = 'REVIEW_MANAGE_ALL',
  /** Allows you to create a service recovery promo */
  ServiceRecoveryCreate = 'SERVICE_RECOVERY_CREATE',
  /** Allows you to update support ticket */
  SupportTicketUpdate = 'SUPPORT_TICKET_UPDATE',
  /** Allows you to create a new term */
  TermCreate = 'TERM_CREATE',
  /** Allows you to create a tour */
  TourCreate = 'TOUR_CREATE',
  /** Allows you to create a tour excursion */
  TourExcursionCreate = 'TOUR_EXCURSION_CREATE',
  /** Allows you to manage tour excursions */
  TourExcursionManageAll = 'TOUR_EXCURSION_MANAGE_ALL',
  /** Allows you to manage tour excursion prices */
  TourExcursionManagePricing = 'TOUR_EXCURSION_MANAGE_PRICING',
  /** Allows you to create a tour extension */
  TourExtensionCreate = 'TOUR_EXTENSION_CREATE',
  /** Allows you to manage tour extensions */
  TourExtensionManageAll = 'TOUR_EXTENSION_MANAGE_ALL',
  /** Allows you to manage tour extension prices */
  TourExtensionManagePricing = 'TOUR_EXTENSION_MANAGE_PRICING',
  /** Allows you to manage tours */
  TourManageAll = 'TOUR_MANAGE_ALL',
  /** Allows you to manage tour prices */
  TourManagePricing = 'TOUR_MANAGE_PRICING',
  /** Allows you to read tours */
  TourReadAll = 'TOUR_READ_ALL',
  /** Allows you to create a tour room */
  TourRoomCreate = 'TOUR_ROOM_CREATE',
  /** Allows you to manage tour rooms */
  TourRoomManageAll = 'TOUR_ROOM_MANAGE_ALL',
  /** Allows you to manage tour room prices */
  TourRoomManagePricing = 'TOUR_ROOM_MANAGE_PRICING',
  /** Allows you to read the TSA information for a trip */
  TripReadTsaInformation = 'TRIP_READ_TSA_INFORMATION',
  /** Allows you to create a new voucher */
  VoucherCreate = 'VOUCHER_CREATE',
  /** Allows you to update the expiration date of a voucher */
  VoucherManageExpiration = 'VOUCHER_MANAGE_EXPIRATION',
  /** Allows you to increase the balance of a voucher outside the context of a booking */
  VoucherManageIncrease = 'VOUCHER_MANAGE_INCREASE',
  /** Allows you to lower the balance of a voucher outside the context of a booking */
  VoucherManageReduce = 'VOUCHER_MANAGE_REDUCE',
  /** Allows you to mark part of all of the balance of a refundable voucher as refunded to a customer, and edit refund details */
  VoucherManageRefund = 'VOUCHER_MANAGE_REFUND',
  /** Allows you to reinstate a voided voucher */
  VoucherManageReinstate = 'VOUCHER_MANAGE_REINSTATE',
  /** Allows you to transfer the balance of a voucher to another voucher or outside of WOJO */
  VoucherManageTransfer = 'VOUCHER_MANAGE_TRANSFER',
  /** Allows you to void a voucher */
  VoucherManageVoid = 'VOUCHER_MANAGE_VOID'
}

export type Place = {
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
  type: PlaceType;
};

/** Filters for places query */
export type PlaceFilterInput = {
  parentId?: InputMaybe<Scalars['ObjectId']['input']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PlaceType>;
};

/** A paginated result of Places */
export type PlacePaginatedResult = {
  __typename?: 'PlacePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Place>;
};

export enum PlaceSortField {
  Name = 'name'
}

export type PlaceSortInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: PlaceSortField;
};

/** The type of place. E.g. country, city, continent, etc. */
export enum PlaceType {
  City = 'CITY',
  Continent = 'CONTINENT',
  Country = 'COUNTRY',
  CountryRegion = 'COUNTRY_REGION',
  GeographicRegion = 'GEOGRAPHIC_REGION'
}

export type PriceRule = {
  __typename?: 'PriceRule';
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  departureDateFrom?: Maybe<Scalars['Date']['output']>;
  departureDateTo?: Maybe<Scalars['Date']['output']>;
  dpdFrom?: Maybe<Scalars['Int']['output']>;
  dpdTo?: Maybe<Scalars['Int']['output']>;
  effectiveFrom?: Maybe<Scalars['Date']['output']>;
  effectiveTo?: Maybe<Scalars['Date']['output']>;
  nbSpotsBookedFrom?: Maybe<Scalars['Int']['output']>;
  nbSpotsBookedTo?: Maybe<Scalars['Int']['output']>;
  nbSpotsLeftFrom?: Maybe<Scalars['Int']['output']>;
  nbSpotsLeftTo?: Maybe<Scalars['Int']['output']>;
  price: Amount;
  tripLengthFrom?: Maybe<Scalars['Int']['output']>;
  tripLengthTo?: Maybe<Scalars['Int']['output']>;
  tripPriceFrom?: Maybe<Amount>;
  tripPriceTo?: Maybe<Amount>;
};

export type PriceRuleInput = {
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  departureDateFrom?: InputMaybe<Scalars['Date']['input']>;
  departureDateTo?: InputMaybe<Scalars['Date']['input']>;
  dpdFrom?: InputMaybe<Scalars['Int']['input']>;
  dpdTo?: InputMaybe<Scalars['Int']['input']>;
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
  nbSpotsBookedFrom?: InputMaybe<Scalars['Int']['input']>;
  nbSpotsBookedTo?: InputMaybe<Scalars['Int']['input']>;
  nbSpotsLeftFrom?: InputMaybe<Scalars['Int']['input']>;
  nbSpotsLeftTo?: InputMaybe<Scalars['Int']['input']>;
  prices: Array<MoneyInput>;
  tripLengthFrom?: InputMaybe<Scalars['Int']['input']>;
  tripLengthTo?: InputMaybe<Scalars['Int']['input']>;
  tripPriceFrom?: InputMaybe<Array<MoneyInput>>;
  tripPriceTo?: InputMaybe<Array<MoneyInput>>;
};

export type PriceYear = {
  __typename?: 'PriceYear';
  year: Scalars['Int']['output'];
  yearCode: Scalars['String']['output'];
  yearEnd: Scalars['Date']['output'];
  yearStart: Scalars['Date']['output'];
};

/** Root fields for all priced trip components */
export type PricedTripComponent = {
  _id: Scalars['ObjectId']['output'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  hasPriceRules: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};

export type PrivateGroup = PricedTripComponent & TripComponent & {
  __typename?: 'PrivateGroup';
  _id: Scalars['ObjectId']['output'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  hasPriceRules: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  priceRules: Array<PriceRule>;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: TripComponentStatus;
  tourCode: Scalars['String']['output'];
  type: TripComponentType;
};

export type PrivateGroupLineItem = LineItem & {
  __typename?: 'PrivateGroupLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

export type ProcessorPaymentMethodRefundInput = {
  amount: Scalars['Float']['input'];
  paymentMethodHash: Scalars['String']['input'];
  /** @deprecated Use paymentMethodHash instead */
  processorPaymentMethodId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBadgeContent = {
  __typename?: 'ProductBadgeContent';
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** A promotion. */
export type Promo = TripComponent & {
  __typename?: 'Promo';
  _id: Scalars['ObjectId']['output'];
  audienceMemberTypes?: Maybe<Array<PromoAudienceMemberType>>;
  businessCode?: Maybe<BusinessCode>;
  /** When present this promo can only be redeemed by this specific customer. */
  customerIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  customers: Array<Customer>;
  /** The name of the promo. */
  displayName: Scalars['String']['output'];
  /** The date when the promo is applicable and can be used */
  effectiveFrom: Scalars['DateTime']['output'];
  /** The date when the promo expires and is no longer valid. */
  effectiveTo: Scalars['DateTime']['output'];
  /** Determines the combinability of promotion */
  exclusivity: PromoExclusivity;
  gcDepartureIds?: Maybe<Array<Scalars['ObjectId']['output']>>;
  gcDepartures: Array<GcDeparture>;
  isGroupsOnly: Scalars['Boolean']['output'];
  isHiddenFromSales: Scalars['Boolean']['output'];
  isIndiesOnly: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  /** If true and the promotion targets specific customers, the promotion can be shared with all trips on the customers order. */
  isShareable: Scalars['Boolean']['output'];
  /** Is the promo valid for use. */
  isValid: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  /** The maximum number of times the promo can be used. */
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  nbAudienceMembers: Scalars['Int']['output'];
  /** The promo offer's unique code. */
  offerCode: Scalars['String']['output'];
  /** Denotes the promotion as either marketing, service recovery, loyalty, or none. */
  promoCategory: PromoCategory;
  /** The promo codes used to apply the promotion. */
  promoCodes: Array<Scalars['String']['output']>;
  /** The number of times the promo has been used. */
  redemptions: Scalars['Int']['output'];
  status: TripComponentStatus;
  /** The targets of the promo. */
  targets: Array<PromoTarget>;
  type: TripComponentType;
};

export type PromoAudienceMember = {
  _id: Scalars['ObjectId']['output'];
  offerCode: Scalars['String']['output'];
};

/** A paginated result of promo audience members. */
export type PromoAudienceMemberPaginatedResult = {
  __typename?: 'PromoAudienceMemberPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<PromoAudienceMember>;
};

export enum PromoAudienceMemberType {
  Customer = 'CUSTOMER',
  Email = 'EMAIL'
}

export enum PromoCategory {
  Loyalty = 'LOYALTY',
  Marketing = 'MARKETING',
  None = 'NONE',
  ServiceRecovery = 'SERVICE_RECOVERY'
}

export type PromoConfigContent = {
  __typename?: 'PromoConfigContent';
  campaignCode?: Maybe<Scalars['String']['output']>;
  groupsCampaignCode?: Maybe<Scalars['String']['output']>;
  groupsPromoCode?: Maybe<Scalars['String']['output']>;
  maxSpotsRemainingThreshold?: Maybe<Scalars['Int']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
};

/** A customer audience member for a promo */
export type PromoCustomerAudienceMember = PromoAudienceMember & {
  __typename?: 'PromoCustomerAudienceMember';
  _id: Scalars['ObjectId']['output'];
  customerId: Scalars['ObjectId']['output'];
  offerCode: Scalars['String']['output'];
};

/** An email audience member for a promo */
export type PromoEmailAudienceMember = PromoAudienceMember & {
  __typename?: 'PromoEmailAudienceMember';
  _id: Scalars['ObjectId']['output'];
  email: Scalars['Email']['output'];
  offerCode: Scalars['String']['output'];
};

export enum PromoExclusivity {
  Exclusive = 'EXCLUSIVE',
  None = 'NONE',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  SecondaryExclusive = 'SECONDARY_EXCLUSIVE'
}

export type PromoLineItem = LineItem & {
  __typename?: 'PromoLineItem';
  _id: Scalars['ObjectId']['output'];
  campaignCode?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  offerCode: Scalars['String']['output'];
  price: Money;
  promoCode: Scalars['String']['output'];
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemCode?: Maybe<Scalars['LineItemCode']['output']>;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  targetType?: Maybe<TripComponentType>;
  type: TripComponentType;
};

export type PromoPaginatedResult = {
  __typename?: 'PromoPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Promo>;
};

/** Settings related to promotions and service recovery. */
export type PromoSettings = {
  __typename?: 'PromoSettings';
  advancedRepeatPromoCode: Scalars['String']['output'];
  advancedRepeatPromoName: Scalars['String']['output'];
  repeatThresholds: Array<RepeatThresholdSettings>;
  /** List of reasons for service recovery promotions. */
  serviceRecoveryReasons: Array<Scalars['String']['output']>;
  useAdvancedRepeatPromo: Scalars['Boolean']['output'];
};

/** A product promo target. */
export type PromoTarget = {
  __typename?: 'PromoTarget';
  _id: Scalars['ObjectId']['output'];
  /** The amount of the discount. */
  amount?: Maybe<Amount>;
  /** The offer code of the associated promo offer. */
  componentType: Scalars['String']['output'];
  departureDateFrom?: Maybe<Scalars['Date']['output']>;
  departureDateTo?: Maybe<Scalars['Date']['output']>;
  /** The line item code being targeted. */
  lineItemCode?: Maybe<Scalars['LineItemCode']['output']>;
  series?: Maybe<Scalars['Series']['output']>;
};

export type PublishDraftBookingInput = {
  payments?: InputMaybe<Array<PaymentInput>>;
};

export type PublishDraftBookingResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidOrderError | InvalidPaymentError | NotAuthorizedError | NotFoundError | ValidationError;

export type PublishDraftQuoteResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidOrderError | NotAuthorizedError | NotFoundError | Quote | ValidationError;

export type PublishDraftTermResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ImmutableTermError | InvalidDateError | NotAuthorizedError | NotFoundError | Term | ValidationError;

export type Query = {
  __typename?: 'Query';
  adjustment?: Maybe<Adjustment>;
  adjustmentByLineItemCode?: Maybe<Adjustment>;
  adjustments: AdjustmentPaginatedResult;
  airline?: Maybe<Airline>;
  /** Get an API key metadata by _id */
  apiKey?: Maybe<ApiKey>;
  asset?: Maybe<Asset>;
  /** Filter and paginate Assets */
  assets: AssetPaginatedResult;
  /** Returns a single booking by id */
  booking?: Maybe<Booking>;
  /** Returns a single trip by id */
  bookingTrip?: Maybe<BookingTrip>;
  /**
   * Returns a single trip by legacy id
   * @deprecated Use bookingTripById instead
   */
  bookingTripByLegacyId?: Maybe<BookingTrip>;
  /** Returns a paginated list of bookings */
  bookings: BookingPaginatedResult;
  /** Get a business by its code */
  business?: Maybe<Business>;
  /** Return all businesses */
  businesses: Array<Business>;
  campaign?: Maybe<Campaign>;
  /** Returns a paginated list of campaigns. */
  campaigns: CampaignPaginatedResult;
  /** Get a paginated list of categories */
  categories: CategoryPaginatedResult;
  category?: Maybe<Category>;
  checkCustomerEmail?: Maybe<CustomerCredentialOptions>;
  checkTourDirectorEmail?: Maybe<TourDirectorCredentialOptions>;
  /** Contact information for the business and customer-facing departments */
  contactInfoContent?: Maybe<ContactInfoContent>;
  contentAncestors: Array<ContentAncestor>;
  /** Get a customer by id */
  customer?: Maybe<Customer>;
  /** Get a customer by id or legacy id */
  customerByLegacyId?: Maybe<Customer>;
  customerEvaluation?: Maybe<CustomerEvaluation>;
  /** Returns a paginated list of customers */
  customers: CustomerPaginatedResult;
  departure?: Maybe<Departure>;
  departureByProdTour?: Maybe<Departure>;
  departureBySalesTour?: Maybe<Departure>;
  departures: DeparturePaginatedResult;
  /** Returns a single draft order by id */
  draftOrder?: Maybe<DraftOrder>;
  employee?: Maybe<Employee>;
  employees: EmployeePaginatedResult;
  evaluation?: Maybe<EvaluationResult>;
  extendedStay?: Maybe<ExtendedStay>;
  extendedStays: ExtendedStayPaginatedResult;
  faqContent?: Maybe<FaqContent>;
  fee?: Maybe<Fee>;
  feeByType?: Maybe<Fee>;
  fees: FeePaginatedResult;
  flightPackage?: Maybe<FlightPackage>;
  flightPackageByLineItemCode?: Maybe<FlightPackage>;
  flightPackages: FlightPackagePaginatedResult;
  futureGCDepartureProspects: Array<GcDepartureProspect>;
  futureGCDepartureProspectsByGCAndProspect: Array<GcDepartureProspect>;
  gateway?: Maybe<Gateway>;
  gateways: GatewayPaginatedResult;
  gcDeparture?: Maybe<GcDeparture>;
  gcDepartureProspect?: Maybe<GcDepartureProspect>;
  gcDepartureProspects: GcDepartureProspectPaginatedResult;
  gcDepartureQuoteSummary?: Maybe<GcDepartureQuoteSummary>;
  gcDepartures: GcDeparturePaginatedResult;
  gcProfileContent?: Maybe<GcProfileContent>;
  /** Get a summary of a customer's global rewards status and points. Returns null if the provided ID is invalid or not enrolled in Global Rewards */
  globalRewardsSummary?: Maybe<GlobalRewardsSummary>;
  insurancePlan?: Maybe<InsurancePlan>;
  insurancePlans: InsurancePlanPaginatedResult;
  /** Find the latest published term by market and type. */
  latestTerm?: Maybe<Term>;
  /** Returns the current user associated with the given session */
  me?: Maybe<User>;
  micrositeContent?: Maybe<MicrositeContent>;
  /** Get a summary of the current customer. Returns null if the current user is not a customer or the customer is not enrolled in Global Rewards */
  myGlobalRewardsSummary?: Maybe<GlobalRewardsSummary>;
  notes: NotePaginatedResult;
  /** Returns a single pre-2018 trip by id */
  oldTrip?: Maybe<OldTrip>;
  /** Returns a paginated list of quotes suitable for display on an opportunity, whether the quote belongs to the opportunity or the customer to whom the opportunity is assigned */
  opportunityQuotes: OpportunityQuotePaginatedResult;
  /** Returns a single order by id */
  order?: Maybe<Order>;
  /**
   * Returns line item history for a single order by order id
   * @deprecated Use orderLineItemHistory instead
   */
  orderHistory?: Maybe<Array<OrderLineItemHistoryEntry>>;
  /** Returns line item history for a single order by order id */
  orderLineItemHistory?: Maybe<Array<OrderLineItemHistoryEntry>>;
  /** Returns tsa history for a single order by order id */
  orderTSAHistory?: Maybe<Array<OrderTsaHistoryEntry>>;
  /** Returns a paginated list of orders */
  orders: OrderPaginatedResult;
  pastGCDepartureProspects: Array<GcDepartureProspect>;
  paymentReconciliationTransactions: PaymentReconciliationTransactionPaginatedResult;
  paymentReconciliationUpload?: Maybe<PaymentReconciliationUpload>;
  paymentReconciliationUploads: PaymentReconciliationUploadPaginatedResult;
  /** Returns a single trip by id */
  paymentTransactions: PaymentTransactionPaginatedResult;
  permissions: Array<Permission>;
  /** Get a place by _id */
  place?: Maybe<Place>;
  /** Get a list of places */
  places: PlacePaginatedResult;
  promo?: Maybe<Promo>;
  promoAudienceMember?: Maybe<PromoAudienceMember>;
  /** Returns a paginated list of promo audience members. */
  promoAudienceMembers: PromoAudienceMemberPaginatedResult;
  promoConfigContent?: Maybe<PromoConfigContent>;
  /** Returns a paginated list of promos. */
  promos: PromoPaginatedResult;
  /** Returns a single quote by id */
  quote?: Maybe<Quote>;
  /** Returns a paginated list of quotes */
  quotes: QuotePaginatedResult;
  /** Returns a set of reservation document file metadata. */
  reservationDocuments: Array<ReservationDocument>;
  /** Returns a single review */
  review?: Maybe<Review>;
  /** Get the summary of reviews for a set of tours codes */
  reviewAggregate?: Maybe<ReviewAggregate>;
  reviews: ReviewPaginatedResult;
  role?: Maybe<Role>;
  roles: RolePaginatedResult;
  savedPaymentMethod?: Maybe<SavedPaymentMethod>;
  searchFeeCategoryCodes: Array<Scalars['String']['output']>;
  /** Get public help center articles that match the query string. */
  searchHelpCenter?: Maybe<HelpCenterArticleResponse>;
  /** Returns a paginated list of service recoveries. */
  serviceRecoveries: ServiceRecoveryPaginatedResult;
  serviceRecovery?: Maybe<ServiceRecovery>;
  tag?: Maybe<Tag>;
  /** Get a paginated list of tags */
  tags: TagPaginatedResult;
  term?: Maybe<Term>;
  /** Get terms paginated with filters */
  terms: TermPaginatedResult;
  tour?: Maybe<Tour>;
  tourContent?: Maybe<TourContent>;
  tourContentByFullSlug?: Maybe<TourContent>;
  tourContentByTourCode?: Maybe<TourContent>;
  /** Get a tour director by id */
  tourDirector?: Maybe<TourDirector>;
  tourDirectorDepartureEvaluationSummary?: Maybe<DepartureEvaluationSummary>;
  tourDirectorEvaluationSummary?: Maybe<TourDirectorEvaluationSummary>;
  tourDirectorTourEndReport?: Maybe<TourDirectorTourEndReport>;
  /** Get a list of tour end reports based on the provided filters */
  tourDirectorTourEndReports?: Maybe<TourEndReportPaginatedResult>;
  /** Get a list of tour directors based on the provided filters */
  tourDirectors: TourDirectorPaginatedResult;
  tourExcursion?: Maybe<TourExcursion>;
  tourExcursionSpec?: Maybe<TourExcursionSpec>;
  tourExcursionSpecs: TourExcursionSpecPaginatedResult;
  tourExcursions: TourExcursionPaginatedResult;
  tourExtension?: Maybe<TourExtension>;
  /** Get a paginated list of Tour Extensions */
  tourExtensions: TourExtensionPaginatedResult;
  tourPageContent?: Maybe<TourPageContent>;
  tourPagesContent: TourPagePaginatedResult;
  tourSpec?: Maybe<TourSpec>;
  tourSpecs: TourSpecPaginatedResult;
  tours: TourPaginatedResult;
  /** Returns a paginated list of TripChecklistItemTemplates */
  tripChecklistItemTemplates: TripChecklistItemTemplatePaginatedResult;
  voucher?: Maybe<Voucher>;
  vouchers: VoucherPaginatedResult;
};


export type QueryAdjustmentArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryAdjustmentByLineItemCodeArgs = {
  lineItemCode: Scalars['LineItemCode']['input'];
};


export type QueryAdjustmentsArgs = {
  filter?: InputMaybe<FilterAdjustmentInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortAdjustmentInput>;
};


export type QueryAirlineArgs = {
  code: Scalars['String']['input'];
};


export type QueryApiKeyArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryAssetArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryAssetsArgs = {
  filter?: InputMaybe<AssetFilterInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryBookingArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryBookingTripArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryBookingTripByLegacyIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryBookingsArgs = {
  filter?: InputMaybe<FilterBookingInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortBookingInput>;
};


export type QueryBusinessArgs = {
  code: BusinessCode;
};


export type QueryCampaignArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryCampaignsArgs = {
  filter?: InputMaybe<FilterCampaignInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryCategoriesArgs = {
  filter?: InputMaybe<FilterCategoryInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryCategoryArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryCheckCustomerEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryCheckTourDirectorEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryContactInfoContentArgs = {
  businessCode: BusinessCode;
  language: Scalars['String']['input'];
};


export type QueryContentAncestorsArgs = {
  businessCode: BusinessCode;
  fullSlug: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QueryCustomerArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryCustomerByLegacyIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerEvaluationArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<FilterCustomerInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryDepartureArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryDepartureByProdTourArgs = {
  prodTourId: Scalars['Int']['input'];
};


export type QueryDepartureBySalesTourArgs = {
  salesTourId: Scalars['String']['input'];
};


export type QueryDeparturesArgs = {
  filter?: InputMaybe<FilterDepartureInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortDepartureInput>;
};


export type QueryDraftOrderArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryEmployeeArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryEmployeesArgs = {
  filter?: InputMaybe<FilterEmployeeInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortEmployeeInput>;
};


export type QueryEvaluationArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryExtendedStayArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryExtendedStaysArgs = {
  filter?: InputMaybe<FilterExtendedStayInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryFaqContentArgs = {
  businessCode: BusinessCode;
  language: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type QueryFeeArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryFeeByTypeArgs = {
  businessCode: BusinessCode;
  categoryCode: Scalars['String']['input'];
  typeCode: FeeTypeCode;
};


export type QueryFeesArgs = {
  filter?: InputMaybe<FilterFeeInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortFeeInput>;
};


export type QueryFlightPackageArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryFlightPackageByLineItemCodeArgs = {
  lineItemCode: Scalars['LineItemCode']['input'];
};


export type QueryFlightPackagesArgs = {
  filter?: InputMaybe<FilterFlightPackageInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryFutureGcDepartureProspectsArgs = {
  businessCode: BusinessCode;
  groupCoordinatorCustomerId: Scalars['ObjectId']['input'];
};


export type QueryFutureGcDepartureProspectsByGcAndProspectArgs = {
  groupCoordinatorCustomerId: Scalars['ObjectId']['input'];
  prospectCustomerId: Scalars['ObjectId']['input'];
};


export type QueryGatewayArgs = {
  code: Scalars['String']['input'];
};


export type QueryGatewaysArgs = {
  filter?: InputMaybe<FilterGatewayInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryGcDepartureArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryGcDepartureProspectArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryGcDepartureProspectsArgs = {
  filter?: InputMaybe<FilterGcDepartureProspectInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortGcDepartureProspectInput>;
};


export type QueryGcDepartureQuoteSummaryArgs = {
  input: GcDepartureQuoteSummaryInput;
};


export type QueryGcDeparturesArgs = {
  filter?: InputMaybe<FilterGcDepartureInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortGcDepartureInput>;
};


export type QueryGcProfileContentArgs = {
  businessCode: BusinessCode;
  fullSlug: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QueryGlobalRewardsSummaryArgs = {
  globalRewardsId: Scalars['String']['input'];
};


export type QueryInsurancePlanArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryInsurancePlansArgs = {
  filter?: InputMaybe<FilterInsurancePlanInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortInsurancePlanInput>;
};


export type QueryLatestTermArgs = {
  businessCode: BusinessCode;
  market: TermMarket;
  termType: TermType;
};


export type QueryMicrositeContentArgs = {
  businessCode: BusinessCode;
  fullSlug: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QueryNotesArgs = {
  filter?: InputMaybe<FilterNoteInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryOldTripArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryOpportunityQuotesArgs = {
  filter: FilterOpportunityQuotesInput;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortOpportunityQuoteInput>;
};


export type QueryOrderArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryOrderHistoryArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryOrderLineItemHistoryArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryOrderTsaHistoryArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<FilterOrderInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryPastGcDepartureProspectsArgs = {
  businessCodes?: InputMaybe<Array<BusinessCode>>;
  groupCoordinatorCustomerId: Scalars['ObjectId']['input'];
};


export type QueryPaymentReconciliationTransactionsArgs = {
  filter?: InputMaybe<FilterPaymentReconciliationTransactionInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortPaymentReconciliationTransactionInput>;
};


export type QueryPaymentReconciliationUploadArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryPaymentReconciliationUploadsArgs = {
  filter?: InputMaybe<FilterPaymentReconciliationUploadInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryPaymentTransactionsArgs = {
  filter?: InputMaybe<FilterPaymentTransactionInput>;
  pagination?: InputMaybe<OffsetPaginateInput>;
};


export type QueryPlaceArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryPlacesArgs = {
  filter?: InputMaybe<PlaceFilterInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<PlaceSortInput>;
};


export type QueryPromoArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryPromoAudienceMemberArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryPromoAudienceMembersArgs = {
  filter?: InputMaybe<FilterPromoAudienceMemberInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryPromoConfigContentArgs = {
  businessCode: BusinessCode;
  language: Scalars['String']['input'];
};


export type QueryPromosArgs = {
  filter?: InputMaybe<FilterPromoInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryQuoteArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryQuotesArgs = {
  filter?: InputMaybe<FilterQuoteInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortQuoteInput>;
};


export type QueryReservationDocumentsArgs = {
  reservationIds: Array<Scalars['Int']['input']>;
};


export type QueryReviewArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryReviewAggregateArgs = {
  businessCode: BusinessCode;
  tourCodes: Array<Scalars['String']['input']>;
};


export type QueryReviewsArgs = {
  filter?: InputMaybe<ReviewFilterInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<ReviewSortInput>;
};


export type QueryRoleArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryRolesArgs = {
  filter?: InputMaybe<FilterRoleInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QuerySavedPaymentMethodArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QuerySearchFeeCategoryCodesArgs = {
  businessCode?: InputMaybe<BusinessCode>;
  query: Scalars['String']['input'];
};


export type QuerySearchHelpCenterArgs = {
  businessCode: BusinessCode;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryServiceRecoveriesArgs = {
  filter?: InputMaybe<FilterServiceRecoveryInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryServiceRecoveryArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTagArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTagsArgs = {
  filter?: InputMaybe<FilterTagInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryTermArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTermsArgs = {
  filter?: InputMaybe<TermFilterInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<TermSortInput>;
};


export type QueryTourArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTourContentArgs = {
  businessCode: BusinessCode;
  id: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QueryTourContentByFullSlugArgs = {
  businessCode: BusinessCode;
  fullSlug: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QueryTourContentByTourCodeArgs = {
  businessCode: BusinessCode;
  language: Scalars['String']['input'];
  tourCode: Scalars['String']['input'];
  tourYear: Scalars['Int']['input'];
};


export type QueryTourDirectorArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTourDirectorDepartureEvaluationSummaryArgs = {
  departureId: Scalars['ObjectId']['input'];
  tourDirectorId: Scalars['ObjectId']['input'];
};


export type QueryTourDirectorEvaluationSummaryArgs = {
  businessCode?: InputMaybe<BusinessCode>;
  tourDirectorId: Scalars['ObjectId']['input'];
};


export type QueryTourDirectorTourEndReportArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTourDirectorTourEndReportsArgs = {
  filter?: InputMaybe<FilterTourEndReportInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourEndReportInput>;
};


export type QueryTourDirectorsArgs = {
  filter?: InputMaybe<FilterTourDirectorInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourDirectorInput>;
};


export type QueryTourExcursionArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTourExcursionSpecArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTourExcursionSpecsArgs = {
  filter?: InputMaybe<FilterTourExcursionSpecInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryTourExcursionsArgs = {
  filter?: InputMaybe<FilterTourExcursionInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourExcursionInput>;
};


export type QueryTourExtensionArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTourExtensionsArgs = {
  filter?: InputMaybe<FilterTourExtensionInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourExtensionInput>;
};


export type QueryTourPageContentArgs = {
  alternateYearTourId?: InputMaybe<Scalars['String']['input']>;
  businessCode: BusinessCode;
  fullSlug: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QueryTourPagesContentArgs = {
  filter: FilterTourPageContentInput;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryTourSpecArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryTourSpecsArgs = {
  filter?: InputMaybe<FilterTourSpecInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryToursArgs = {
  filter?: InputMaybe<FilterTourInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourInput>;
};


export type QueryTripChecklistItemTemplatesArgs = {
  filter?: InputMaybe<FilterTripChecklistItemTemplateInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryVoucherArgs = {
  _id: Scalars['ObjectId']['input'];
};


export type QueryVouchersArgs = {
  filter?: InputMaybe<FilterVoucherInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortVoucherInput>;
};

/** An order in the Quote stage */
export type Quote = Order & {
  __typename?: 'Quote';
  _id: Scalars['ObjectId']['output'];
  /** Sum of total successful transactions */
  amountPaid: Money;
  averageTotalPerTrip: Money;
  /** Grand total less the amount already paid */
  balance: Money;
  businessCode: BusinessCode;
  checkoutOptions: Array<QuoteCheckoutOption>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The currency code of the order. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer who initiated the booking. */
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  departure?: Maybe<Departure>;
  /** The departure id of the order. */
  departureId: Scalars['ObjectId']['output'];
  expirationDate: Scalars['DateTime']['output'];
  /** The extended date the final payment is due for the order. */
  extendedFinalPaymentDate?: Maybe<Scalars['Date']['output']>;
  /** The date the final installment for app is due for the order. */
  finalInstallmentDate: Scalars['Date']['output'];
  /** The date the final payment is due for the order. */
  finalPaymentDate: Scalars['Date']['output'];
  gcDeparture?: Maybe<GcDeparture>;
  /** The id of the gc departure associated with the order. */
  gcDepartureId?: Maybe<Scalars['ObjectId']['output']>;
  /** Sum of all line item prices */
  grandTotal: Money;
  /** Sum of all line item prices without discounts applied */
  grandTotalBeforeDiscount: Money;
  /** Sum of all line items excluding flights */
  grandTotalWithoutFlights: Money;
  isExpired: Scalars['Boolean']['output'];
  /** Indicates if the final payment date has been extended. */
  isFinalPaymentDateExtended: Scalars['Boolean']['output'];
  /** Whether the quote has been flagged to be revisited by or shared with the customer */
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  /** The latest date the final installment for app is due for the order. */
  latestFinalInstallmentDate: Scalars['Date']['output'];
  /** The latest date the final payment is due for the order. */
  latestFinalPaymentDate: Scalars['Date']['output'];
  opportunityId?: Maybe<Scalars['String']['output']>;
  /** The order that this order was rebooked from. */
  rebookedFromOrder?: Maybe<Order>;
  /** The order id that this order was rebooked from. */
  rebookedFromOrderId?: Maybe<Scalars['ObjectId']['output']>;
  /** The stage of the order. */
  stage: OrderStage;
  /** Sum of all discount line items */
  totalDiscount: Money;
  tourLineItemCode?: Maybe<Scalars['LineItemCode']['output']>;
  /** The transactions applied to the order, sorted by ascending transaction date. */
  transactions: Array<PaymentTransaction>;
  trips: Array<QuoteTrip>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Validation errors that will prevent the quote from being booked */
  validationErrors: Array<QuoteBookingDepartureValidationError>;
  /** The version of the order. */
  versionId: Scalars['Int']['output'];
  /** Whether the quote will be waitlisted based on whether waitlist is allowed and the remaining capacity. If waitlist is accepted when booking and capacities have not changed, the booking will be waitlisted */
  willWaitlist: Scalars['Boolean']['output'];
};

export type QuoteAutopayCheckoutOption = {
  __typename?: 'QuoteAutopayCheckoutOption';
  allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>;
  amount: Money;
  earliestPaymentScheduleStartDate: Scalars['Date']['output'];
  latestPaymentScheduleStartDate: Scalars['Date']['output'];
  riskFreePeriodEndDate: Scalars['Date']['output'];
  type: QuoteCheckoutType;
};

/** A validation error that will prevent a quote from being booked */
export type QuoteBookingDepartureValidationError = {
  __typename?: 'QuoteBookingDepartureValidationError';
  code: QuoteBookingDepartureValidationErrorCode;
  message: Scalars['String']['output'];
};

export enum QuoteBookingDepartureValidationErrorCode {
  DuplicateCustomerOnTrip = 'DUPLICATE_CUSTOMER_ON_TRIP',
  UnbookableDepartureCapacity = 'UNBOOKABLE_DEPARTURE_CAPACITY',
  UnbookableDepartureStatus = 'UNBOOKABLE_DEPARTURE_STATUS',
  WaitlistNotAccepted = 'WAITLIST_NOT_ACCEPTED'
}

/** The type of payment methods allows for a checkout option for a Quote */
export enum QuoteCheckoutAllowedPaymentMethodType {
  Ach = 'ACH',
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD'
}

export type QuoteCheckoutOption = QuoteAutopayCheckoutOption | QuoteManualCheckoutOption;

/** The type of checkout option for a Quote */
export enum QuoteCheckoutType {
  AutoPay = 'AUTO_PAY',
  Manual = 'MANUAL',
  PayInFull = 'PAY_IN_FULL'
}

export type QuoteManualCheckoutOption = {
  __typename?: 'QuoteManualCheckoutOption';
  allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>;
  /** The amount required to book based on checkout option. For AUTO_PAY, this is the APP deposit. For PAY_IN_FULL, this is the grand total. */
  amount: Money;
  commonFees: Array<FeeApplicationInfo>;
  riskFreePeriodEndDate: Scalars['Date']['output'];
  type: QuoteCheckoutType;
};

export type QuotePaginatedResult = {
  __typename?: 'QuotePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Quote>;
};

export enum QuoteSortField {
  CreatedAt = 'createdAt',
  DepartureDate = 'departureDate',
  ExpirationDate = 'expirationDate',
  UpdatedAt = 'updatedAt'
}

/** A trip on a quote */
export type QuoteTrip = Trip & {
  __typename?: 'QuoteTrip';
  _id: Scalars['ObjectId']['output'];
  /** The address for the trip. */
  address?: Maybe<Address>;
  businessCode?: Maybe<BusinessCode>;
  /** Offers that can be applied to the trip but are not specific to a single component. Flight package offers are not included. */
  conditionalOffers: Array<ConditionalOffer>;
  /** The currency code of the trip. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer id of the trip. */
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  customerType: TripCustomerType;
  /** Offers for departing flights that can be added to the trip. */
  departingFlightOffers: Array<FlightOffer>;
  departure?: Maybe<Departure>;
  departureDate: Scalars['Date']['output'];
  /** The deposit amount for the trip. */
  depositAmount: Money;
  /** The emergency contacts for the trip. */
  emergencyContacts?: Maybe<Array<EmergencyContact>>;
  endDate: Scalars['Date']['output'];
  /** Offers for excursions that can be added to the trip. Includes extension excursions if the trip is booked on the extension. */
  excursionOffers: Array<DepartureExcursionOffer>;
  /** The departure excursions and extension excursions for the open excursion line items on this trip */
  excursions: Array<DepartureExcursion>;
  /** Sum of all open excursion line items */
  excursionsTotal: Money;
  /** The departure extension for the open extension line item on this trip */
  extension?: Maybe<DepartureExtension>;
  /** Offer for an extension that can be added to the trip. */
  extensionOffer?: Maybe<DepartureExtensionOffer>;
  /** The departure room for the open extension room line item on this trip */
  extensionRoom?: Maybe<DepartureRoom>;
  flightPackagePrice?: Maybe<Money>;
  grandTotal: Money;
  hasAddress: Scalars['Boolean']['output'];
  hasDepartingFlightDeviation: Scalars['Boolean']['output'];
  hasEmergencyContacts: Scalars['Boolean']['output'];
  /** Whether the trip has an open line item for an extension */
  hasExtension: Scalars['Boolean']['output'];
  hasInsurance: Scalars['Boolean']['output'];
  hasReturningFlightDeviation: Scalars['Boolean']['output'];
  hasTsaInformation: Scalars['Boolean']['output'];
  insurancePlanOffers: Array<InsurancePlanOffer>;
  /** Whether the trip is cancelled. */
  isCancelled: Scalars['Boolean']['output'];
  /** Whether the trip is confirmed. */
  isConfirmed: Scalars['Boolean']['output'];
  isLandOnly: Scalars['Boolean']['output'];
  /** Whether the trip is open. */
  isOpen: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  /** Whether the trip is quoted. */
  isQuoted: Scalars['Boolean']['output'];
  /** Whether the trip is rebooked. */
  isRebooked: Scalars['Boolean']['output'];
  /** Whether the trip is requested. */
  isRequested: Scalars['Boolean']['output'];
  /** Whether the trip is waitlisted. */
  isWaitlisted: Scalars['Boolean']['output'];
  /** The line items that compose the trip. */
  lineItems: Array<LineItem>;
  /** The REBOOKED + OPEN line items if the trip is rebooked, the CANCELLED + OPEN line items with PARENT_TRIP_CANCELLED cancellation metadata if the trip is cancelled, or the open line items in all other cases.  */
  lineItemsMatchingTripStatus: Array<LineItem>;
  openAdjustmentLineItems: Array<AdjustmentLineItem>;
  openDepartingFlightLineItem?: Maybe<FlightPackageLineItem>;
  openExcursionLineItems: Array<TourExcursionLineItem>;
  openExtensionLineItem?: Maybe<TourExtensionLineItem>;
  openExtensionRoomLineItem?: Maybe<TourRoomLineItem>;
  openFeeLineItems: Array<FeeLineItem>;
  openInsuranceAddonLineItems: Array<InsuranceAddonLineItem>;
  openInsuranceLineItem?: Maybe<InsuranceLineItem>;
  /** The line items that compose the trip which are not CANCELLED or REBOOKED */
  openLineItems: Array<LineItem>;
  openPostStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPreStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPrivateGroupLineItem?: Maybe<PrivateGroupLineItem>;
  openPromoLineItems: Array<PromoLineItem>;
  openReturningFlightLineItem?: Maybe<FlightPackageLineItem>;
  openRoomLineItem?: Maybe<TourRoomLineItem>;
  /** The trip ID for the trip that this trip was rebooked from. */
  rebookedFromTripId?: Maybe<Scalars['ObjectId']['output']>;
  requestedRoommates?: Maybe<Array<Scalars['String']['output']>>;
  requestedTravelCompanions?: Maybe<Array<Scalars['String']['output']>>;
  /** Offers for returning flights that can be added to the trip. */
  returningFlightOffers: Array<FlightOffer>;
  /** The departure room for the open room line item on this trip */
  room?: Maybe<DepartureRoom>;
  /** Offers for rooms that can be added to the trip. Includes extension rooms if the trip is booked on the extension. */
  roomOffers: Array<DepartureRoomOffer>;
  /** The status of the trip */
  status: TripStatus;
  timingStatus: TripTimingStatus;
  tourLineItem?: Maybe<TourLineItem>;
  travelerNotes?: Maybe<TravelerNotes>;
  tripCustomer?: Maybe<TripCustomer>;
  /** The TSA information for the trip. */
  tsaInformation?: Maybe<TsaInformation>;
};

export enum RebookingReasonCategory {
  Financial = 'FINANCIAL',
  LifeEvent = 'LIFE_EVENT',
  ProductTransition = 'PRODUCT_TRANSITION',
  TravelerDiscontent = 'TRAVELER_DISCONTENT',
  TravelRequirementNotMet = 'TRAVEL_REQUIREMENT_NOT_MET',
  Unknown = 'UNKNOWN',
  WojoCancellation = 'WOJO_CANCELLATION',
  WorldEvent = 'WORLD_EVENT'
}

export type ReconcileCardOrAchPaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type ReconcileCheckPaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type ReconcilePaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type ReconcilePaymentsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | PaymentReconciliationUpload | ValidationError;

export type ReconcileTransactionInput = {
  amount: MoneyInput;
  processDate: Scalars['Date']['input'];
  processorMerchantReferenceNumber: Scalars['String']['input'];
  returnReasonCode?: InputMaybe<Scalars['String']['input']>;
  returnReasonString?: InputMaybe<Scalars['String']['input']>;
  transactionType: ReconciliationTransactionType;
};

export enum ReconciliationStatus {
  Failure = 'FAILURE',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS',
  Unprocessed = 'UNPROCESSED'
}

export enum ReconciliationTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Return = 'RETURN'
}

export type RedeemedPromoType = {
  __typename?: 'RedeemedPromoType';
  /** Amount of discount. */
  discountAmount: Money;
  /** The promo offer's unique code. */
  discountOfferCode: Scalars['String']['output'];
  /** The maximum number of times the promo can be used. */
  maxRedemptions: Scalars['Int']['output'];
  /** Price after discount. */
  salePrice: Money;
};

/** Reduces the  non-expired voucher by a dollar amount */
export type ReduceVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId']['input'];
  /** The amount to reduce the Voucher by */
  amount: MoneyInput;
  /** The reason that the voucher is being reduced */
  reason: Scalars['String']['input'];
};

export type ReduceVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

export type RefundInput = {
  checkRefundAmount?: InputMaybe<Scalars['Float']['input']>;
  processorPaymentMethodRefunds?: InputMaybe<Array<ProcessorPaymentMethodRefundInput>>;
  refundReason: RefundReasonCode;
  savedPaymentMethodRefunds?: InputMaybe<Array<SavedPaymentMethodRefundInput>>;
  voucherRefunds?: InputMaybe<Array<VoucherRefundInput>>;
};

export enum RefundReasonCode {
  Cancellation = 'CANCELLATION',
  Optional = 'OPTIONAL',
  Overpayment = 'OVERPAYMENT'
}

export type RefundVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId']['input'];
  /** The date the check was issued */
  checkIssuedOn?: InputMaybe<Scalars['Date']['input']>;
  /** The check number */
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  /** Information about the employee who approved the refund check */
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the refund */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The amount to refund. If not provided, the remaining amount of the voucher will be used */
  refundAmount?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Reinstates a voided voucher */
export type ReinstateVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId']['input'];
  /** The reason that the voucher is being reinstated */
  reason: Scalars['String']['input'];
};

export type ReinstateVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

export type ReleaseDetails = {
  __typename?: 'ReleaseDetails';
  isReleased: Scalars['Boolean']['output'];
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
  releaseEndDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Removes promos to a campaign */
export type RemoveCampaignPromosInput = {
  promoIds: Array<Scalars['ObjectId']['input']>;
};

export type RemoveCampaignPromosResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderAdjustmentInput = {
  /** The adjustment lineItemIds to remove from this trip. */
  adjustmentLineItemIds: Array<Scalars['ObjectId']['input']>;
  /** The reason for removing the adjustment. */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** The trip to remove the adjustment(s) from. */
  tripId: Scalars['ObjectId']['input'];
};

export type RemoveDraftOrderAdjustmentsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderAirportTransferInput = {
  flightType: FlightType;
  tripId: Scalars['ObjectId']['input'];
};

export type RemoveDraftOrderAirportTransferResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderExcursionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderExcursionsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderExtensionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderFeesInput = {
  /** The fee lineItemIds to remove from this trip */
  feeLineItemIds: Array<Scalars['ObjectId']['input']>;
  /** The trip to remove the fee(s) from */
  tripId: Scalars['ObjectId']['input'];
};

export type RemoveDraftOrderFeesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderInsuranceAddonResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderInsuranceExtensionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidInsuranceExtensionError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderInsuranceResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderPostStayResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderPreStayResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderPrivateGroupResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderPromoResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftQuoteTripsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveEmployeesFromRoleInput = {
  employeeIds: Array<Scalars['ObjectId']['input']>;
};

export type RemoveEmployeesFromRoleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Role | ValidationError;

export type RemovePrivateGroupResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type RemovePromoAudienceMemberResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | RemovePromoAudienceMemberSuccess | ValidationError;

export type RemovePromoAudienceMemberSuccess = {
  __typename?: 'RemovePromoAudienceMemberSuccess';
  data: PromoAudienceMember;
};

export type RemovePromoCodesInput = {
  promoCodes: Array<Scalars['String']['input']>;
};

export type RemovePromoCodesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type RemovePromoCustomersInput = {
  customerIds: Array<Scalars['ObjectId']['input']>;
};

export type RemovePromoCustomersResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type RemovePromoGcDeparturesInput = {
  gcDepartureIds: Array<Scalars['ObjectId']['input']>;
};

export type RemovePromoGcDeparturesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type RemovePromoTargetsInput = {
  targetIds: Array<Scalars['ObjectId']['input']>;
};

export type RemovePromoTargetsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Settings related to repeat promo thresholds. */
export type RepeatThresholdSettings = {
  __typename?: 'RepeatThresholdSettings';
  discount: Amount;
  nbTrips: Scalars['Int']['output'];
  repeatBonus: Amount;
  repeatBonusExpiresAfterDays: Scalars['Int']['output'];
};

/** The reservation of a departure itinerary component */
export type Reservation = {
  __typename?: 'Reservation';
  reservationId?: Maybe<Scalars['Int']['output']>;
  timeFrom?: Maybe<Scalars['Time']['output']>;
};

/** Reservation document file metadata. */
export type ReservationDocument = {
  __typename?: 'ReservationDocument';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  externalDocumentId: Scalars['String']['output'];
  externalReservationId: Scalars['Int']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  removedAt?: Maybe<Scalars['DateTime']['output']>;
  sizeInBytes?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/** A review consists of a rating and an optional review detail */
export type Review = {
  __typename?: 'Review';
  _id: Scalars['ObjectId']['output'];
  businessCode?: Maybe<BusinessCode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['ObjectId']['output'];
  detail?: Maybe<ReviewDetail>;
  images: Array<ReviewImage>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  nbPastTrips: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
  tour?: Maybe<Tour>;
  tourCode: Scalars['String']['output'];
  travelDate: Scalars['Date']['output'];
  tripId: Scalars['ObjectId']['output'];
};


/** A review consists of a rating and an optional review detail */
export type ReviewImagesArgs = {
  status?: InputMaybe<ReviewStatus>;
};

/** Summary of reviews for a tour */
export type ReviewAggregate = {
  __typename?: 'ReviewAggregate';
  avgRating: Scalars['Float']['output'];
  nbReviews: Scalars['Int']['output'];
};

/** Details of a review by a customer */
export type ReviewDetail = {
  __typename?: 'ReviewDetail';
  _id: Scalars['ObjectId']['output'];
  author?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  response?: Maybe<ReviewResponse>;
  status: ReviewStatus;
  title?: Maybe<Scalars['String']['output']>;
};

/** Filters for review query */
export type ReviewFilterInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  hasDetail?: InputMaybe<Scalars['Boolean']['input']>;
  hasImages?: InputMaybe<Scalars['Boolean']['input']>;
  hasResponse?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  ratingFrom?: InputMaybe<Scalars['Int']['input']>;
  ratingTo?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReviewStatus>;
  tourCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  travelDateFrom?: InputMaybe<Scalars['Date']['input']>;
  travelDateTo?: InputMaybe<Scalars['Date']['input']>;
};

/** Images that have been uploaded as part of a review */
export type ReviewImage = {
  __typename?: 'ReviewImage';
  _id: Scalars['ObjectId']['output'];
  asset?: Maybe<Asset>;
  assetId: Scalars['ObjectId']['output'];
  status: ReviewStatus;
};

/** A paginated set of Reviews */
export type ReviewPaginatedResult = {
  __typename?: 'ReviewPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Review>;
};

/** A response to the customer about their review */
export type ReviewResponse = {
  __typename?: 'ReviewResponse';
  author: Scalars['String']['output'];
  body: Scalars['String']['output'];
};

/** Review settings */
export type ReviewSettings = {
  __typename?: 'ReviewSettings';
  /** Number of days post departure after which a review can be submitted */
  reviewCutoffDays: Scalars['Int']['output'];
};

export enum ReviewSortField {
  IsFeatured = 'isFeatured',
  Rating = 'rating',
  TravelDate = 'travelDate'
}

export type ReviewSortInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: ReviewSortField;
};

/** The detail and images of a review need to be moderated before being visible publicly */
export enum ReviewStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Risk free period settings for the order. */
export type RiskFreePeriodSettings = {
  __typename?: 'RiskFreePeriodSettings';
  minimumEligibleDpd: Scalars['Int']['output'];
  nbAutopayDays: Scalars['Int']['output'];
  nbManualDays: Scalars['Int']['output'];
  nbPayInFullDays: Scalars['Int']['output'];
  preserveRiskFreePeriodOnRebooking: Scalars['Boolean']['output'];
  useMinimumEligibleDpd: Scalars['Boolean']['output'];
};

/** A collection of permissions that can be assigned to a user */
export type Role = {
  __typename?: 'Role';
  _id: Scalars['ObjectId']['output'];
  businessCode?: Maybe<BusinessCode>;
  name: Scalars['String']['output'];
  permissionKeys: Array<PermissionKey>;
  permissions: Array<Permission>;
};

/** A paginated result of Roles */
export type RolePaginatedResult = {
  __typename?: 'RolePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Role>;
};

export type RoomContent = {
  __typename?: 'RoomContent';
  bedCode?: Maybe<Scalars['String']['output']>;
  cabinCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum RoomTourType {
  Extension = 'EXTENSION',
  MainTour = 'MAIN_TOUR'
}

/** Status, ID and occupants of a room */
export type Roommate = {
  __typename?: 'Roommate';
  roommateId: Scalars['ObjectId']['output'];
  status: RoommateStatus;
};

export enum RoommateStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export type SaveEvaluationResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidEvaluationError | NotAuthorizedError | NotFoundError | SaveEvaluationSuccess | ValidationError;

export type SaveEvaluationSuccess = {
  __typename?: 'SaveEvaluationSuccess';
  data: Evaluation;
};

export type SaveablePaymentMethod = AchPaymentMethod | CardPaymentMethod;

/** Saved payment method for a customer */
export type SavedPaymentMethod = {
  __typename?: 'SavedPaymentMethod';
  _id: Scalars['ObjectId']['output'];
  customerId: Scalars['ObjectId']['output'];
  /** Whether the payment method is active, returns false if the payment method is expired */
  isActive: Scalars['Boolean']['output'];
  /** Whether the payment method is expired */
  isExpired: Scalars['Boolean']['output'];
  paymentMethod: SaveablePaymentMethod;
};

export type SavedPaymentMethodInput = {
  savedPaymentMethodId: Scalars['ObjectId']['input'];
};

export type SavedPaymentMethodRefundInput = {
  amount: Scalars['Float']['input'];
  savedPaymentMethodId: Scalars['ObjectId']['input'];
};

/** Generate a magic link, and send to a customer or tour director */
export type SendMagicLinkInput = {
  email: Scalars['String']['input'];
  emailTemplateId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  isTourDirector?: InputMaybe<Scalars['Boolean']['input']>;
  returnURL: Scalars['String']['input'];
};

export type SendMagicLinkResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | EmailSendFailedError | InvalidDateError | InvalidMagicLinkError | MagicLinkResult | NotAuthorizedError | NotFoundError | ValidationError;

/** A service recovery promotion. */
export type ServiceRecovery = {
  __typename?: 'ServiceRecovery';
  _id: Scalars['ObjectId']['output'];
  bookingTrip?: Maybe<BookingTrip>;
  businessCode: BusinessCode;
  orderId: Scalars['ObjectId']['output'];
  promo?: Maybe<Promo>;
  promoId: Scalars['ObjectId']['output'];
  recoveryReason: Scalars['String']['output'];
  recoveryReasons?: Maybe<Array<Scalars['String']['output']>>;
  tripId: Scalars['ObjectId']['output'];
};

export type ServiceRecoveryPaginatedResult = {
  __typename?: 'ServiceRecoveryPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<ServiceRecovery>;
};

export type SetDraftQuoteCustomerResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type SetTourDirectorProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  hideEmail?: InputMaybe<Scalars['Boolean']['input']>;
  hidePhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  profileImageAssetId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type SigninCustomerWithMagicLinkResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidSigninError | NotAuthorizedError | NotFoundError | SigninResult | ValidationError;

export type SigninCustomerWithPasswordResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidSigninError | NotAuthorizedError | NotFoundError | SigninResult | ValidationError;

export type SigninResult = {
  __typename?: 'SigninResult';
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  token: Scalars['String']['output'];
  tokenExpiresAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type SigninTourDirectorWithMagicLinkResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidSigninError | NotAuthorizedError | NotFoundError | SigninResult | ValidationError;

/** Signin with a password */
export type SigninWithPasswordInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignoutResult = {
  __typename?: 'SignoutResult';
  success: Scalars['Boolean']['output'];
};

/** Signup as a new customer */
export type SignupCustomerInput = {
  email: Scalars['Email']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type SignupCustomerResult = BusinessNotSpecifiedError | CustomerSignupResult | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type SortAdjustmentInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: AdjustmentSortField;
};

export type SortBookingInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: BookingSortField;
};

export type SortDepartureInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: DepartureSortField;
};

export type SortEmployeeInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: EmployeeSortField;
};

export type SortFeeInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: FeeSortField;
};

export type SortGcDepartureInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: GcDepartureSortField;
};

export type SortGcDepartureProspectInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: GcDepartureProspectSortField;
};

export type SortInsurancePlanInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: InsurancePlanSortField;
};

export type SortOpportunityQuoteInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: QuoteSortField;
};

export type SortPaymentReconciliationTransactionInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: PaymentReconciliationTransactionSortField;
};

export type SortQuoteInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: QuoteSortField;
};

export type SortTourDirectorInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: TourDirectorSortField;
};

export type SortTourEndReportInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: TourEndReportSortField;
};

export type SortTourExcursionInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: TourExcursionSortField;
};

export type SortTourExtensionInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: TourExtensionSortField;
};

export type SortTourInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: TourSortField;
};

export type SortVoucherInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: VoucherSortField;
};

export enum SourceProcessorOrAcquirer {
  Cybersource = 'CYBERSOURCE',
  Telecheck = 'TELECHECK',
  Worldpaycreditcard = 'WORLDPAYCREDITCARD',
  Worldpayecheck = 'WORLDPAYECHECK'
}

export type StartQuoteInput = {
  applyAdvancedRepeatPromo?: InputMaybe<Scalars['Boolean']['input']>;
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyCode;
  /** The Customer ID for the primary traveler, if such a Customer ID already exists.  */
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  departureId: Scalars['ObjectId']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  gatewayCode?: InputMaybe<Scalars['String']['input']>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** The number of additional Trips to create beyond the primary Trip. If omitted, only the primary Trip will be created. */
  nbSecondaryTravelers?: InputMaybe<Scalars['Int']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type StartQuoteResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidAdjustmentError | InvalidDateError | InvalidDepartureError | InvalidGcDepartureError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

/** Puts a booking into `PENDING_REBOOKING` status */
export type StartRebookingInput = {
  /** The booking ID */
  _id: Scalars['ObjectId']['input'];
  /** The amount to charge as a rebooking fee for extensions */
  extensionsRebookingFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The amount to charge as a rebooking fee for flights */
  flightRebookingFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The categorization of the rebooking reason */
  rebookingReasonCategory: RebookingReasonCategory;
  /** The rebooking reason */
  rebookingReasonDescription: Scalars['String']['input'];
  /** Whether or not to waive the rebooking fee */
  waiveFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartRebookingQuoteInput = {
  currency: CurrencyCode;
  departureId: Scalars['ObjectId']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  gatewayCode?: InputMaybe<Scalars['String']['input']>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  rebookingFromOrderId: Scalars['ObjectId']['input'];
};

export type StartRebookingQuoteResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidGcDepartureError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type StartRebookingResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type StopOver = {
  __typename?: 'StopOver';
  endDate: Scalars['Date']['output'];
  gatewayCode: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
};

export type StopOverInput = {
  /** Stop over end date */
  endDate: Scalars['Date']['input'];
  /** Stop over gateway code */
  gatewayCode: Scalars['String']['input'];
  /** Stop over start date */
  startDate: Scalars['Date']['input'];
};

export type SubmitEvaluationResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidEvaluationError | NotAuthorizedError | NotFoundError | SubmitEvaluationSuccess | ValidationError;

export type SubmitEvaluationSuccess = {
  __typename?: 'SubmitEvaluationSuccess';
  data: Evaluation;
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean']['output'];
};

/** The supplier of a departure itinerary component */
export type Supplier = {
  __typename?: 'Supplier';
  addresses: Array<Address>;
  code?: Maybe<Scalars['String']['output']>;
  contacts: Array<SupplierContact>;
  name?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** The contact details of a supplier */
export type SupplierContact = {
  __typename?: 'SupplierContact';
  emails: Array<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumbers: Array<Scalars['String']['output']>;
};

/** Invalid support ticket query */
export type SupportTicketError = DomainError & {
  __typename?: 'SupportTicketError';
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SupportTicketInput = {
  body: Scalars['String']['input'];
  customFields?: InputMaybe<Array<SupportTicketInputCustomField>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  requesterEmail: Scalars['String']['input'];
  requesterName: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  ticketFormId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type SupportTicketInputCustomField = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Support Ticket Settings */
export type SupportTicketSettings = {
  __typename?: 'SupportTicketSettings';
  /** The external ID of support ticket business. */
  businessExternalId: Scalars['String']['output'];
  /** Whether auto approved late add tickets creation is enabled. */
  isAutoApprovedLateAddEnabled: Scalars['Boolean']['output'];
};

/** Response from the support ticket API */
export type SupportTicketSuccess = {
  __typename?: 'SupportTicketSuccess';
  ticketId: Scalars['String']['output'];
};

export type SystemChecklistItem = {
  dueDate?: Maybe<Scalars['Date']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  status?: Maybe<TripChecklistItemStatus>;
};

export enum TsaGender {
  F = 'F',
  M = 'M',
  X = 'X'
}

/** TSA information for a traveler */
export type TsaInformation = {
  __typename?: 'TSAInformation';
  _id: Scalars['ObjectId']['output'];
  confirmationDate?: Maybe<Scalars['DateTime']['output']>;
  countryOfIssue?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<TsaGender>;
  hasCompletedPassportInformation: Scalars['Boolean']['output'];
  hasConfirmedTsaIdentifiers: Scalars['Boolean']['output'];
  identityDocumentNumber?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['Date']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maskedIdentityDocumentNumber?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  stateOfIssue?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  type?: Maybe<IdentityDocumentType>;
};

/** A tag that can be associated to a variety of other entities */
export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['ObjectId']['output'];
  businessCode?: Maybe<BusinessCode>;
  category?: Maybe<Category>;
  categoryId: Scalars['ObjectId']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** A paginated set of Tags */
export type TagPaginatedResult = {
  __typename?: 'TagPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Tag>;
};

/** Terms that can be signed */
export type Term = {
  __typename?: 'Term';
  _id: Scalars['ObjectId']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  certificationText?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  market: TermMarket;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stage: TermStage;
  termType: TermType;
};

/** Apply filters to a terms query */
export type TermFilterInput = {
  businessCode?: InputMaybe<BusinessCode>;
  market?: InputMaybe<TermMarket>;
  stage?: InputMaybe<TermStage>;
  termType?: InputMaybe<TermType>;
};

/** The market the term is applicable to */
export enum TermMarket {
  Ca = 'CA',
  Us = 'US'
}

/** A paginated result of Terms */
export type TermPaginatedResult = {
  __typename?: 'TermPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Term>;
};

export enum TermSignatureMethod {
  Mobile = 'MOBILE',
  Offline = 'OFFLINE',
  Web = 'WEB'
}

/** The status of the signature */
export enum TermSignatureStatus {
  Accepted = 'ACCEPTED',
  Invalidated = 'INVALIDATED'
}

export enum TermSortField {
  PublishedAt = 'publishedAt'
}

export type TermSortInput = {
  sortAscending: Scalars['Boolean']['input'];
  sortBy: TermSortField;
};

/** Whether the term is published, draft, or archived */
export enum TermStage {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** The type of term */
export enum TermType {
  General = 'GENERAL',
  GroupCoordinator = 'GROUP_COORDINATOR'
}

/** Signature for terms and conditions */
export type TermsSignature = {
  __typename?: 'TermsSignature';
  acceptanceMethod?: Maybe<TermSignatureMethod>;
  acceptedAt: Scalars['DateTime']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Employee that recorded this signature if there was an employee */
  recordedByEmployee?: Maybe<Employee>;
  /** Id of the employee that recorded this signature if there was an employee */
  recordedByEmployeeId?: Maybe<Scalars['ObjectId']['output']>;
  /** Customer that accepted these terms */
  signingCustomer?: Maybe<Customer>;
  /** Id of the customer that accepted these terms */
  signingCustomerId?: Maybe<Scalars['ObjectId']['output']>;
  status?: Maybe<TermSignatureStatus>;
  termId: Scalars['ObjectId']['output'];
};

export type TermsSignatureChecklistItem = SystemChecklistItem & {
  __typename?: 'TermsSignatureChecklistItem';
  dueDate?: Maybe<Scalars['Date']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  status?: Maybe<TripChecklistItemStatus>;
};

export type TokenizedPaymentMethodInput = {
  token: Scalars['String']['input'];
};

/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type Tour = PricedTripComponent & TripComponent & {
  __typename?: 'Tour';
  _id: Scalars['ObjectId']['output'];
  activityLevel: Scalars['Int']['output'];
  activityLevelContent?: Maybe<TourActivityLevelContent>;
  allowedStopoverGatewayCodes?: Maybe<Array<Scalars['String']['output']>>;
  autoApproveDeadlineDpd: Scalars['Int']['output'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  classLevel: Scalars['Int']['output'];
  classLevelContent?: Maybe<TourClassLevelContent>;
  content?: Maybe<TourContent>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultCapacity?: Maybe<Scalars['Int']['output']>;
  departures: Array<Departure>;
  deposit: Amount;
  depositForAutomaticPlan: Amount;
  depositForLateAdd: Amount;
  endGateway?: Maybe<Gateway>;
  endGatewayCode: Scalars['String']['output'];
  excursionIds: Array<Scalars['ObjectId']['output']>;
  excursions: Array<TourExcursion>;
  extendedFamilyCode: Scalars['String']['output'];
  extensionIds: Array<Scalars['ObjectId']['output']>;
  extensions: Array<TourExtension>;
  familyCode: Scalars['String']['output'];
  feeCategoryCode?: Maybe<Scalars['FeeCategoryCode']['output']>;
  feePrice?: Maybe<Money>;
  fees: Array<Fee>;
  finalInstallmentDeadlineDpd: Scalars['Int']['output'];
  finalPaymentDeadlineDpd: Scalars['Int']['output'];
  hasPriceRules: Scalars['Boolean']['output'];
  internalName: Scalars['String']['output'];
  isFlightShoppingAllowed: Scalars['Boolean']['output'];
  isNonRevenueTour: Scalars['Boolean']['output'];
  isPassportRequired: Scalars['Boolean']['output'];
  isPostStayAllowed: Scalars['Boolean']['output'];
  isPreStayAllowed: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isVisaRequired: Scalars['Boolean']['output'];
  isWaitlistAllowed: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  minimumCapacity?: Maybe<Scalars['Int']['output']>;
  /** Returns the list of tour excursions that are valid for the given tour's spec but are not yet associated with it. */
  missingExcursions: Array<TourExcursion>;
  nbCruiseNights: Scalars['Int']['output'];
  nbDepartureFlightDays: Scalars['Int']['output'];
  nbHotelNights: Scalars['Int']['output'];
  nbReturningFlightDays: Scalars['Int']['output'];
  nbTourDays: Scalars['Int']['output'];
  overnightCountries: Array<Country>;
  placeIds: Array<Scalars['ObjectId']['output']>;
  places: Array<Place>;
  /** Places saved on the tour, including their resolved ancestors (e.g. parent places, grandparent places, etc.) */
  placesWithAncestry: Array<Place>;
  priceRules: Array<PriceRule>;
  priceYear: PriceYear;
  privateGroup?: Maybe<PrivateGroup>;
  /**
   * The url of the tour itinerary page on the website. This will be null if the tour is CTT. Use the GC Departure microsite url instead.
   * @deprecated Use publicWebsiteUrls instead
   */
  publicWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** The url of the tour itinerary page on the website. This will be null if the tour is CTT. Use the GC Departure microsite url instead. */
  publicWebsiteUrls: TourPublicUrls;
  rooms: Array<TourRoom>;
  startGateway?: Maybe<Gateway>;
  startGatewayCode: Scalars['String']['output'];
  status: TripComponentStatus;
  tagIds: Array<Scalars['ObjectId']['output']>;
  tags: Array<Tag>;
  tourCode: Scalars['String']['output'];
  tourDivisionSpecId: Scalars['Int']['output'];
  tourSpecId: Scalars['Int']['output'];
  tourType: TourType;
  tourTypeCode: TourTypeCode;
  type: TripComponentType;
};


/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type TourActivityLevelContentArgs = {
  language: Scalars['String']['input'];
};


/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type TourClassLevelContentArgs = {
  language: Scalars['String']['input'];
};


/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type TourContentArgs = {
  language: Scalars['String']['input'];
};


/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type TourFeePriceArgs = {
  currencyCode: CurrencyCode;
  departureDate: Scalars['Date']['input'];
  typeCode: FeeTypeCode;
};

/** Accommodation content of a Tour */
export type TourAccommodationContent = {
  __typename?: 'TourAccommodationContent';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ContentAsset>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TourActivityLevelContent = {
  __typename?: 'TourActivityLevelContent';
  activityLevel?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<ContentAsset>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TourAssetUnion = TourImage | TourVideo;

export type TourBed = {
  __typename?: 'TourBed';
  capacity: Scalars['Int']['output'];
  code: TourBedCode;
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum TourBedCode {
  /** Double */
  Db = 'DB',
  /** Family */
  Fa = 'FA',
  /** Quad */
  Qu = 'QU',
  /** Single */
  Si = 'SI',
  /** Student */
  St = 'ST',
  /** Twin */
  Tw = 'TW'
}

export type TourClassLevelContent = {
  __typename?: 'TourClassLevelContent';
  classLevel?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<ContentAsset>;
  name?: Maybe<Scalars['String']['output']>;
  roomingDescription?: Maybe<Scalars['String']['output']>;
  roomingDetailedDescription?: Maybe<Scalars['String']['output']>;
  roomingUpgradeDescription?: Maybe<Scalars['String']['output']>;
  tripBuilderSelectedMessage?: Maybe<Scalars['String']['output']>;
};

/** Content describing a Tour for a specific year */
export type TourContent = {
  __typename?: 'TourContent';
  accommodationIds?: Maybe<Array<Scalars['String']['output']>>;
  accommodations: Array<TourAccommodationContent>;
  assets: Array<TourAssetUnion>;
  badge?: Maybe<ProductBadgeContent>;
  badgeId?: Maybe<Scalars['String']['output']>;
  businessCode?: Maybe<BusinessCode>;
  cardImage?: Maybe<ContentAsset>;
  /** Equipment offered on the tour */
  equipment?: Maybe<Array<TourEquipmentContent>>;
  equipmentDescription?: Maybe<Scalars['String']['output']>;
  /** Summary of the types of equipment offered on the tour */
  equipmentSummary?: Maybe<TourDetailSummaryContent>;
  extension?: Maybe<TourExtensionContent>;
  extensionId?: Maybe<Scalars['String']['output']>;
  /** Marketing FAQ content */
  faq?: Maybe<FaqContent>;
  faqId?: Maybe<Scalars['String']['output']>;
  highlights: Array<TourHighlightContent>;
  id: Scalars['String']['output'];
  includesBreakfast?: Maybe<Scalars['Boolean']['output']>;
  inclusions: Array<TourHighlightContent>;
  itineraryItems: Array<TourItineraryElementUnion>;
  language?: Maybe<Scalars['String']['output']>;
  mapImage?: Maybe<ContentAsset>;
  maximumGroupSize?: Maybe<Scalars['Int']['output']>;
  minimumGroupSize?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nbCities?: Maybe<Scalars['Int']['output']>;
  nbDays?: Maybe<Scalars['Int']['output']>;
  nbDaysWithExtension?: Maybe<Scalars['Int']['output']>;
  overviewDescription?: Maybe<Scalars['String']['output']>;
  overviewTitle?: Maybe<Scalars['String']['output']>;
  pace?: Maybe<Scalars['String']['output']>;
  /** FAQ content for customers who are booked */
  postBookingFaq?: Maybe<FaqContent>;
  priceYear?: Maybe<Scalars['Int']['output']>;
  publicDepartures: Array<Departure>;
  specialDeparturesIcon?: Maybe<ContentAsset>;
  tour?: Maybe<Tour>;
  tourCode?: Maybe<Scalars['String']['output']>;
  tourPartnershipLogo?: Maybe<ContentAsset>;
};

/** Itinerary day content of a Tour */
export type TourDayContent = {
  __typename?: 'TourDayContent';
  /** Day number of the tour. For example, '1' is the first day of tour */
  day?: Maybe<Scalars['Int']['output']>;
  /** Number of days this day spans inclusive of the day itself */
  dayRangeLength?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  excursionIds: Array<Scalars['String']['output']>;
  excursions?: Maybe<Array<TourExcursionContent>>;
  freeTimeSuggestions?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Scalars['String']['output']>;
  /** Whether this day spans multiple days */
  isRange?: Maybe<Scalars['Boolean']['output']>;
  kind: Scalars['String']['output'];
  meals: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  physicalActivity?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use day, isRange, and dayRangeLength instead */
  prefix?: Maybe<Scalars['String']['output']>;
};

export type TourDetailSummaryContent = {
  __typename?: 'TourDetailSummaryContent';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Tour Director */
export type TourDirector = User & {
  __typename?: 'TourDirector';
  _id: Scalars['ObjectId']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  /** Get the chat user ID for the Tour Director for the given business code */
  chatUserId?: Maybe<Scalars['String']['output']>;
  /** The Departures with which the Tour Director is associated */
  departures?: Maybe<Array<Departure>>;
  /** Email, not returned to a customer if hidden by the TD */
  email?: Maybe<Scalars['Email']['output']>;
  entraId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hideEmail?: Maybe<Scalars['Boolean']['output']>;
  hidePhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone number, not returned to a customer if hidden by the TD */
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  /** The tour director's profile image asset */
  profileImageAsset?: Maybe<Asset>;
  supplierId: Scalars['Int']['output'];
  tourDirectorId: Scalars['ObjectId']['output'];
};


/** Tour Director */
export type TourDirectorChatUserIdArgs = {
  businessCode: BusinessCode;
};


/** Tour Director */
export type TourDirectorDeparturesArgs = {
  businessCodes?: InputMaybe<Array<BusinessCode>>;
};

/** Tour director annual evaluation summary */
export type TourDirectorAnnualEvaluationSummary = {
  __typename?: 'TourDirectorAnnualEvaluationSummary';
  /** The average percentage based on the average score and the maximum score */
  averagePercentage: Scalars['Float']['output'];
  /** The average score based on all questions for a give year */
  averageScore: Scalars['Float']['output'];
  /** Departure evaluation statistics */
  departureEvaluationSummaries: Array<DepartureEvaluationSummary>;
  /** List of departures */
  departures: Array<Departure>;
  /** List of score ranges, based on the average score of each departure */
  ranges: Array<EvaluationScoreRange>;
  /** Year of the evaluation */
  year: Scalars['String']['output'];
};

export type TourDirectorCredentialOptions = {
  __typename?: 'TourDirectorCredentialOptions';
  hasEntra: Scalars['Boolean']['output'];
};

/** Tour director evaluation summary */
export type TourDirectorEvaluationSummary = {
  __typename?: 'TourDirectorEvaluationSummary';
  /** List of annual evaluation summaries */
  annualEvaluationSummaries: Array<TourDirectorAnnualEvaluationSummary>;
  /** Tour director ID */
  tourDirectorId: Scalars['ObjectId']['output'];
};

/** A paginated result of Tour Directors */
export type TourDirectorPaginatedResult = {
  __typename?: 'TourDirectorPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<TourDirector>;
};

export enum TourDirectorSortField {
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  SupplierId = 'supplierId'
}

/** Tour director tour end report */
export type TourDirectorTourEndReport = Evaluation & {
  __typename?: 'TourDirectorTourEndReport';
  _id: Scalars['ObjectId']['output'];
  /** The date that the evaluation is available */
  availabilityDate: Scalars['DateTime']['output'];
  businessCode?: Maybe<BusinessCode>;
  /** The date that the evaluation is due */
  deadlineDate: Scalars['DateTime']['output'];
  /** The departure ID of the departure that this evaluation belong to */
  departureId: Scalars['ObjectId']['output'];
  evaluationType: EvaluationType;
  /** The date that the evaluation was finalized */
  finalizationDate?: Maybe<Scalars['DateTime']['output']>;
  hasAnsweredQuestions: Scalars['Boolean']['output'];
  questions: Array<EvaluationQuestion>;
  /** The date that the evaluation was submitted */
  submissionDate?: Maybe<Scalars['DateTime']['output']>;
  templateId: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

/** Tour director tour end report settings */
export type TourDirectorTourEndReportSettings = {
  __typename?: 'TourDirectorTourEndReportSettings';
  /** List component types to make tour director tour end report questions for. */
  componentTypeCodes: Array<Scalars['String']['output']>;
  /** the number of days before a departure or before a departure end that eval availabilityDate should be set */
  nbDaysUntilEvaluationAvailable?: Maybe<Scalars['Int']['output']>;
  /** the number of days after a departure that an eval is due */
  nbDaysUntilEvaluationDue?: Maybe<Scalars['Int']['output']>;
  /** Determines if component questions should be generated on the tour end report */
  shouldGenerateComponentQuestions?: Maybe<Scalars['Boolean']['output']>;
};

/** A paginated result of Tour Directors */
export type TourEndReportPaginatedResult = {
  __typename?: 'TourEndReportPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<TourDirectorTourEndReport>;
};

export enum TourEndReportSortField {
  AvailabilityDate = 'availabilityDate'
}

export type TourEquipmentContent = {
  __typename?: 'TourEquipmentContent';
  assets: Array<TourAssetUnion>;
  cardImage?: Maybe<ContentAsset>;
  description?: Maybe<Scalars['String']['output']>;
  detailedName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Scalars['String']['output']>;
};

/** Excursion belonging to either a tour or extension */
export type TourExcursion = PricedTripComponent & TripComponent & {
  __typename?: 'TourExcursion';
  _id: Scalars['ObjectId']['output'];
  autoApproveDeadlineDpd: Scalars['Int']['output'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  content?: Maybe<TourExcursionContent>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hasPriceRules: Scalars['Boolean']['output'];
  internalName: Scalars['String']['output'];
  /** Whether or not this excursion has a restricted purchase window. */
  isPrebook: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  matchCode: Scalars['String']['output'];
  /** The minimum number of travelers required for this excursion to be confirmed. */
  minNbTravelersRequired: Scalars['Int']['output'];
  nbTourExtensions: Scalars['Int']['output'];
  nbTours: Scalars['Int']['output'];
  placeIds: Array<Scalars['ObjectId']['output']>;
  places: Array<Place>;
  priceRules: Array<PriceRule>;
  priceYear: PriceYear;
  status: TripComponentStatus;
  tagIds: Array<Scalars['ObjectId']['output']>;
  tags: Array<Tag>;
  tourExtensions: Array<TourExtension>;
  tours: Array<Tour>;
  type: TripComponentType;
};


/** Excursion belonging to either a tour or extension */
export type TourExcursionContentArgs = {
  language: Scalars['String']['input'];
};

/** Content describing a tour excursion */
export type TourExcursionContent = {
  __typename?: 'TourExcursionContent';
  departureInfo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<ContentAsset>;
  /** The lowest price for this excursion on a future, SELL departure. */
  lowestPrice?: Maybe<Money>;
  matchCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};


/** Content describing a tour excursion */
export type TourExcursionContentLowestPriceArgs = {
  currencyCode: CurrencyCode;
};

export type TourExcursionLineItem = LineItem & {
  __typename?: 'TourExcursionLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  departureExcursionId: Scalars['ObjectId']['output'];
  excursionTourType: ExcursionTourType;
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

/** A paginated result of Tour excursions */
export type TourExcursionPaginatedResult = {
  __typename?: 'TourExcursionPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<TourExcursion>;
};

export enum TourExcursionSortField {
  AutoApproveDeadlineDpd = 'autoApproveDeadlineDpd',
  BasePriceCad = 'basePriceCAD',
  BasePriceUsd = 'basePriceUSD',
  CreatedAt = 'createdAt',
  InternalName = 'internalName',
  LineItemCode = 'lineItemCode',
  MatchCode = 'matchCode',
  MinNbTravelersRequired = 'minNbTravelersRequired',
  PriceYear = 'priceYear'
}

export type TourExcursionSpec = {
  __typename?: 'TourExcursionSpec';
  _id: Scalars['ObjectId']['output'];
  businessCode: BusinessCode;
  internalName: Scalars['String']['output'];
  matchCode: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

/** A paginated result of Tour Excursion Specs */
export type TourExcursionSpecPaginatedResult = {
  __typename?: 'TourExcursionSpecPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<TourExcursionSpec>;
};

/** Pre or Post extension */
export type TourExtension = PricedTripComponent & TripComponent & {
  __typename?: 'TourExtension';
  _id: Scalars['ObjectId']['output'];
  autoApproveDeadlineDpd: Scalars['Int']['output'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  content?: Maybe<TourExtensionContent>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultCapacity: Scalars['Int']['output'];
  endGatewayCode: Scalars['String']['output'];
  excursionIds: Array<Scalars['ObjectId']['output']>;
  excursions: Array<TourExcursion>;
  extendedFamilyCode: Scalars['String']['output'];
  familyCode: Scalars['String']['output'];
  hasPriceRules: Scalars['Boolean']['output'];
  internalName: Scalars['String']['output'];
  isFlightShoppingAllowed: Scalars['Boolean']['output'];
  isPreExtension: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  minimumCapacity?: Maybe<Scalars['Int']['output']>;
  /** Returns tue list of tour extension excursions that are valid for the given tour's extension spec but are not yet associated with it. */
  missingExcursions: Array<TourExcursion>;
  nbTourDays: Scalars['Int']['output'];
  overnightCountries: Array<Country>;
  placeIds: Array<Scalars['ObjectId']['output']>;
  places: Array<Place>;
  priceRules: Array<PriceRule>;
  priceYear: PriceYear;
  rooms: Array<TourRoom>;
  startGatewayCode: Scalars['String']['output'];
  status: TripComponentStatus;
  tagIds: Array<Scalars['ObjectId']['output']>;
  tags: Array<Tag>;
  tour?: Maybe<Tour>;
  tourCode: Scalars['String']['output'];
  tourSpecId: Scalars['Int']['output'];
  tourType: TourType;
  tourTypeCode: TourTypeCode;
  type: TripComponentType;
};


/** Pre or Post extension */
export type TourExtensionContentArgs = {
  language: Scalars['String']['input'];
};

export type TourExtensionContent = {
  __typename?: 'TourExtensionContent';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<ContentAsset>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isPreExtension?: Maybe<Scalars['Boolean']['output']>;
  itineraryItems: Array<TourItineraryElementUnion>;
  name?: Maybe<Scalars['String']['output']>;
  nbDaysOverlap?: Maybe<Scalars['Int']['output']>;
  nbNights?: Maybe<Scalars['Int']['output']>;
  tourCode?: Maybe<Scalars['String']['output']>;
};

/** Line item for the extension of a trip */
export type TourExtensionLineItem = LineItem & {
  __typename?: 'TourExtensionLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  departureDate: Scalars['Date']['output'];
  departureExtensionId: Scalars['ObjectId']['output'];
  endDate: Scalars['Date']['output'];
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

/** A paginated result of Tours */
export type TourExtensionPaginatedResult = {
  __typename?: 'TourExtensionPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<TourExtension>;
};

export enum TourExtensionSortField {
  AutoApproveDeadlineDpd = 'autoApproveDeadlineDpd',
  BasePriceCad = 'basePriceCAD',
  BasePriceUsd = 'basePriceUSD',
  CreatedAt = 'createdAt',
  DefaultCapacity = 'defaultCapacity',
  EndGatewayCode = 'endGatewayCode',
  InternalName = 'internalName',
  LineItemCode = 'lineItemCode',
  NbTourDays = 'nbTourDays',
  PriceYear = 'priceYear',
  StartGatewayCode = 'startGatewayCode',
  TourCode = 'tourCode',
  TourType = 'tourType',
  TourTypeCode = 'tourTypeCode'
}

/** Highlight content of a Tour */
export type TourHighlightContent = {
  __typename?: 'TourHighlightContent';
  isPrintable?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Image asset of a Tour */
export type TourImage = {
  __typename?: 'TourImage';
  caption?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ContentAsset>;
  kind: Scalars['String']['output'];
};

export type TourItineraryElementUnion = TourDayContent | TourItineraryItemContent;

/** Itinerary item content of a Tour */
export type TourItineraryItemContent = {
  __typename?: 'TourItineraryItemContent';
  days: Array<TourDayContent>;
  kind: Scalars['String']['output'];
  nbNights?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Line item that represents the main tour */
export type TourLineItem = LineItem & {
  __typename?: 'TourLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  departureDate: Scalars['Date']['output'];
  departureId: Scalars['ObjectId']['output'];
  endDate: Scalars['Date']['output'];
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

/** Content describing a tour page */
export type TourPageContent = {
  __typename?: 'TourPageContent';
  alternateYears: Array<TourPageContentAlternateYear>;
  breadcrumbParent?: Maybe<TourPageContentBreadcrumbParent>;
  breadcrumbParentId?: Maybe<Scalars['String']['output']>;
  colorPalette?: Maybe<Scalars['String']['output']>;
  fullSlug: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isHiddenFromSearch?: Maybe<Scalars['Boolean']['output']>;
  primaryMessageBody?: Maybe<Scalars['String']['output']>;
  primaryMessageStatus?: Maybe<Scalars['String']['output']>;
  primaryMessageTitle?: Maybe<Scalars['String']['output']>;
  reviewAggregate: ReviewAggregate;
  specialDepartures?: Maybe<Array<ContentTextLink>>;
  tourCodes: Array<Scalars['String']['output']>;
  tourContent?: Maybe<TourContent>;
  tourId?: Maybe<Scalars['String']['output']>;
  tripBuilderContentId?: Maybe<Scalars['String']['output']>;
  tripBuilderPriceHelpText?: Maybe<Scalars['String']['output']>;
};


/** Content describing a tour page */
export type TourPageContentTourContentArgs = {
  alternateYearTourId?: InputMaybe<Scalars['String']['input']>;
};

/** Alternate year for a tour page */
export type TourPageContentAlternateYear = {
  __typename?: 'TourPageContentAlternateYear';
  tourId?: Maybe<Scalars['String']['output']>;
  yearLabel?: Maybe<Scalars['String']['output']>;
};

/** Parent of tour page used to create its ancestry */
export type TourPageContentBreadcrumbParent = {
  __typename?: 'TourPageContentBreadcrumbParent';
  ancestors: Array<ContentAncestor>;
  fullSlug: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** A paginated result of TourPageContent */
export type TourPagePaginatedResult = {
  __typename?: 'TourPagePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<TourPageContent>;
};

/** A paginated result of Tours */
export type TourPaginatedResult = {
  __typename?: 'TourPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Tour>;
};

export type TourPublicUrls = {
  __typename?: 'TourPublicUrls';
  ca?: Maybe<Scalars['String']['output']>;
  us?: Maybe<Scalars['String']['output']>;
};

/** Room belonging to either a tour or extension */
export type TourRoom = PricedTripComponent & TripComponent & {
  __typename?: 'TourRoom';
  _id: Scalars['ObjectId']['output'];
  basePrice: Amount;
  bed: TourBed;
  businessCode?: Maybe<BusinessCode>;
  cabinCode?: Maybe<Scalars['TourCabinCode']['output']>;
  defaultCapacity: Scalars['Int']['output'];
  enableRoommateMatching: Scalars['Boolean']['output'];
  hasPriceRules: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  priceRules: Array<PriceRule>;
  priceYear: PriceYear;
  status: TripComponentStatus;
  type: TripComponentType;
};

/** Rooming for main tour or extension */
export type TourRoomLineItem = LineItem & {
  __typename?: 'TourRoomLineItem';
  _id: Scalars['ObjectId']['output'];
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean']['output'];
  isPurchased: Scalars['Boolean']['output'];
  isQuoted: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean']['output'];
  roomTourType: RoomTourType;
  roommate?: Maybe<Roommate>;
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']['output']>;
  type: TripComponentType;
};

export enum TourSortField {
  AutoApproveDeadlineDpd = 'autoApproveDeadlineDpd',
  CreatedAt = 'createdAt',
  DefaultCapacity = 'defaultCapacity',
  FinalPaymentDeadlineDpd = 'finalPaymentDeadlineDpd',
  InternalName = 'internalName',
  LineItemCode = 'lineItemCode',
  NbCruiseNights = 'nbCruiseNights',
  NbDepartureFlightDays = 'nbDepartureFlightDays',
  NbHotelNights = 'nbHotelNights',
  NbReturningFlightDays = 'nbReturningFlightDays',
  NbTourDays = 'nbTourDays',
  PriceYear = 'priceYear',
  TourCode = 'tourCode',
  TourType = 'tourType',
  TourTypeCode = 'tourTypeCode'
}

export type TourSpec = {
  __typename?: 'TourSpec';
  _id: Scalars['ObjectId']['output'];
  businessCode: BusinessCode;
  endGatewayCode: Scalars['String']['output'];
  excursionMatchCodes: Array<Scalars['String']['output']>;
  extendedFamilyCode: Scalars['String']['output'];
  familyCode: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
  isExtension: Scalars['Boolean']['output'];
  nbCruiseNights: Scalars['Int']['output'];
  nbHotelNights: Scalars['Int']['output'];
  nbTourDays: Scalars['Int']['output'];
  overnightCountryCodes: Array<Scalars['String']['output']>;
  startGatewayCode: Scalars['String']['output'];
  tourCode: Scalars['String']['output'];
  tourDivisionSpecId: Scalars['Int']['output'];
  tourSpecId: Scalars['Int']['output'];
  typeCode: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

/** A paginated result of Tours */
export type TourSpecPaginatedResult = {
  __typename?: 'TourSpecPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<TourSpec>;
};

export enum TourType {
  Cruise = 'CRUISE',
  Land = 'LAND'
}

export enum TourTypeCode {
  Bro = 'BRO',
  Ctt = 'CTT'
}

/** Video asset of a Tour */
export type TourVideo = {
  __typename?: 'TourVideo';
  caption?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  wistiaVideoId?: Maybe<Scalars['String']['output']>;
};

export type TransactionPaymentMethod = AchPaymentMethod | AffirmPaymentMethod | CardPaymentMethod | CheckPaymentMethod | EfTransferPaymentMethod | TransferPaymentMethod | VoucherPaymentMethod;

/** Settings for transactional emails. */
export type TransactionalEmailSettings = {
  __typename?: 'TransactionalEmailSettings';
  campaignId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  internalCode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  nbNotificationDaysInAdvance?: Maybe<Scalars['Int']['output']>;
};

export type TransferPaymentMethod = {
  __typename?: 'TransferPaymentMethod';
  destinationOrderId: Scalars['ObjectId']['output'];
  reasonCode: TransferReasonCode;
  sourceOrderId: Scalars['ObjectId']['output'];
  sourcePaymentMethod: TransactionPaymentMethod;
};

export type TransferPaymentMethodInput = {
  paymentMethodHash?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Please begin using paymentMethodHash */
  savedPaymentMethodId?: InputMaybe<Scalars['ObjectId']['input']>;
  transferFromBookingId: Scalars['ObjectId']['input'];
};

/** The reason code for a transfer payment */
export enum TransferReasonCode {
  /** The transfer was the result of a fork. */
  Fork = 'FORK',
  /** The transfer was the result of a merge. */
  Merge = 'MERGE',
  /** The transfer was the result of a rebooking. */
  Rebooking = 'REBOOKING',
  /** The transfer was done adhoc. */
  Transfer = 'TRANSFER'
}

/** Transfer part of all of the balance from one WOJO Voucher to another */
export type TransferVoucherExternalInput = {
  /** The ID of the source voucher to transfer from */
  fromVoucherId: Scalars['ObjectId']['input'];
  /** The product that the voucher is being transferred to */
  transferBusinessUnit: Scalars['String']['input'];
};

export type TransferVoucherExternalResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Transfer part of all of the balance from one WOJO Voucher to another */
export type TransferVoucherInternalInput = {
  /** The amount to transfer. Cannot exceed the balance of the source voucher */
  amount: MoneyInput;
  /** The ID of the source voucher to transfer from */
  fromVoucherId: Scalars['ObjectId']['input'];
  /** The ID of the target voucher to transfer to */
  toVoucherId: Scalars['ObjectId']['input'];
};

export type TransferVoucherInternalResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | TransferVoucherSuccess | ValidationError;

/** The result of a voucher transfer, consisting of the source and target vouchers */
export type TransferVoucherSuccess = {
  __typename?: 'TransferVoucherSuccess';
  /** The voucher which had its balance transferred */
  fromVoucher: Voucher;
  /** The voucher which the balance was transferred to */
  toVoucher: Voucher;
};

export type TransferableAmount = {
  __typename?: 'TransferableAmount';
  /** The payment methods used in transactions that could be transfered or should retain costs on the original booking */
  paymentMethods: Array<TransferableAmountByPaymentMethod>;
  /** The total non transferable amount for fees and persisted adjustments that stays on the original booking */
  totalNonTransferable: Money;
  /** The total amount of confirmed and pending transactions */
  totalPaid: Money;
  /** The total amount of pending transactions */
  totalPending: Money;
  /** The total amount available to transfer after retaining pending transactions and non transferrable funds. Returns 0 if negative after retention. */
  totalTransferable: Money;
};

export type TransferableAmountByPaymentMethod = {
  __typename?: 'TransferableAmountByPaymentMethod';
  /** The sum of confirmed and pending transactions made with this payment method */
  amountPaid: Money;
  /** The sum of pending transactions made with this payment method */
  amountPending: Money;
  customerId: Scalars['ObjectId']['output'];
  /** The non transferable amount for fees and persisted adjustment on this payment method that stays on the original booking */
  nonTransferableAmount: Money;
  paymentMethod: TransactionPaymentMethod;
  paymentMethodHash: Scalars['String']['output'];
  /** The amount available to transfer for this payment method after retaining pending transactions and non transferrable funds */
  transferableAmount: Money;
};

export type TravelerNote = {
  __typename?: 'TravelerNote';
  acknowledged: Scalars['Boolean']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type TravelerNoteInput = {
  acknowledged: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TravelerNotes = {
  __typename?: 'TravelerNotes';
  _id: Scalars['ObjectId']['output'];
  dietaryNotes?: Maybe<TravelerNote>;
  generalNotes?: Maybe<TravelerNote>;
  hasCompletedHealthNotes?: Maybe<Scalars['Boolean']['output']>;
  medicalNotes?: Maybe<TravelerNote>;
  mobilityNotes?: Maybe<TravelerNote>;
  roomingNotes?: Maybe<TravelerNote>;
};

export type TravelerNotesInput = {
  dietaryNotes?: InputMaybe<TravelerNoteInput>;
  generalNotes?: InputMaybe<TravelerNoteInput>;
  medicalNotes?: InputMaybe<TravelerNoteInput>;
  mobilityNotes?: InputMaybe<TravelerNoteInput>;
  roomingNotes?: InputMaybe<TravelerNoteInput>;
};

/** Base of QuoteTrip or BookingTrip */
export type Trip = {
  _id: Scalars['ObjectId']['output'];
  /** The address for the trip. */
  address?: Maybe<Address>;
  businessCode?: Maybe<BusinessCode>;
  /** Offers that can be applied to the trip but are not specific to a single component. Flight package offers are not included. */
  conditionalOffers: Array<ConditionalOffer>;
  /** The currency code of the trip. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer id of the trip. */
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  customerType: TripCustomerType;
  /** Offers for departing flights that can be added to the trip. */
  departingFlightOffers: Array<FlightOffer>;
  departure?: Maybe<Departure>;
  departureDate: Scalars['Date']['output'];
  /** The deposit amount for the trip. */
  depositAmount: Money;
  /** The emergency contacts for the trip. */
  emergencyContacts?: Maybe<Array<EmergencyContact>>;
  endDate: Scalars['Date']['output'];
  /** Offers for excursions that can be added to the trip. Includes extension excursions if the trip is booked on the extension. */
  excursionOffers: Array<DepartureExcursionOffer>;
  /** The departure excursions and extension excursions for the open excursion line items on this trip */
  excursions: Array<DepartureExcursion>;
  /** Sum of all open excursion line items */
  excursionsTotal: Money;
  /** The departure extension for the open extension line item on this trip */
  extension?: Maybe<DepartureExtension>;
  /** Offer for an extension that can be added to the trip. */
  extensionOffer?: Maybe<DepartureExtensionOffer>;
  /** The departure room for the open extension room line item on this trip */
  extensionRoom?: Maybe<DepartureRoom>;
  flightPackagePrice?: Maybe<Money>;
  grandTotal: Money;
  hasAddress: Scalars['Boolean']['output'];
  hasDepartingFlightDeviation: Scalars['Boolean']['output'];
  hasEmergencyContacts: Scalars['Boolean']['output'];
  /** Whether the trip has an open line item for an extension */
  hasExtension: Scalars['Boolean']['output'];
  hasInsurance: Scalars['Boolean']['output'];
  hasReturningFlightDeviation: Scalars['Boolean']['output'];
  hasTsaInformation: Scalars['Boolean']['output'];
  /** Whether the trip is cancelled. */
  isCancelled: Scalars['Boolean']['output'];
  /** Whether the trip is confirmed. */
  isConfirmed: Scalars['Boolean']['output'];
  isLandOnly: Scalars['Boolean']['output'];
  /** Whether the trip is open. */
  isOpen: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  /** Whether the trip is quoted. */
  isQuoted: Scalars['Boolean']['output'];
  /** Whether the trip is rebooked. */
  isRebooked: Scalars['Boolean']['output'];
  /** Whether the trip is requested. */
  isRequested: Scalars['Boolean']['output'];
  /** Whether the trip is waitlisted. */
  isWaitlisted: Scalars['Boolean']['output'];
  /** The line items that compose the trip. */
  lineItems: Array<LineItem>;
  /** The REBOOKED + OPEN line items if the trip is rebooked, the CANCELLED + OPEN line items with PARENT_TRIP_CANCELLED cancellation metadata if the trip is cancelled, or the open line items in all other cases.  */
  lineItemsMatchingTripStatus: Array<LineItem>;
  openAdjustmentLineItems: Array<AdjustmentLineItem>;
  openDepartingFlightLineItem?: Maybe<FlightPackageLineItem>;
  openExcursionLineItems: Array<TourExcursionLineItem>;
  openExtensionLineItem?: Maybe<TourExtensionLineItem>;
  openExtensionRoomLineItem?: Maybe<TourRoomLineItem>;
  openFeeLineItems: Array<FeeLineItem>;
  openInsuranceAddonLineItems: Array<InsuranceAddonLineItem>;
  openInsuranceLineItem?: Maybe<InsuranceLineItem>;
  /** The line items that compose the trip which are not CANCELLED or REBOOKED */
  openLineItems: Array<LineItem>;
  openPostStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPreStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPrivateGroupLineItem?: Maybe<PrivateGroupLineItem>;
  openPromoLineItems: Array<PromoLineItem>;
  openReturningFlightLineItem?: Maybe<FlightPackageLineItem>;
  openRoomLineItem?: Maybe<TourRoomLineItem>;
  /** The trip ID for the trip that this trip was rebooked from. */
  rebookedFromTripId?: Maybe<Scalars['ObjectId']['output']>;
  requestedRoommates?: Maybe<Array<Scalars['String']['output']>>;
  requestedTravelCompanions?: Maybe<Array<Scalars['String']['output']>>;
  /** Offers for returning flights that can be added to the trip. */
  returningFlightOffers: Array<FlightOffer>;
  /** The departure room for the open room line item on this trip */
  room?: Maybe<DepartureRoom>;
  /** Offers for rooms that can be added to the trip. Includes extension rooms if the trip is booked on the extension. */
  roomOffers: Array<DepartureRoomOffer>;
  /** The status of the trip */
  status: TripStatus;
  timingStatus: TripTimingStatus;
  tourLineItem?: Maybe<TourLineItem>;
  travelerNotes?: Maybe<TravelerNotes>;
  /** The TSA information for the trip. */
  tsaInformation?: Maybe<TsaInformation>;
};

export enum TripCancellationCategory {
  Financial = 'FINANCIAL',
  LifeEvent = 'LIFE_EVENT',
  ProductTransition = 'PRODUCT_TRANSITION',
  StaffOnTour = 'STAFF_ON_TOUR',
  TravelerDiscontent = 'TRAVELER_DISCONTENT',
  TravelRequirementNotMet = 'TRAVEL_REQUIREMENT_NOT_MET',
  Unknown = 'UNKNOWN',
  WojoCancellation = 'WOJO_CANCELLATION',
  WorldEvent = 'WORLD_EVENT'
}

/** Meta information for a trip cancellation */
export type TripCancellationMeta = {
  __typename?: 'TripCancellationMeta';
  cancellationCategory: TripCancellationCategory;
  cancellationDate: Scalars['DateTime']['output'];
  cancellationReason: Scalars['String']['output'];
  cancelledBy?: Maybe<Scalars['ObjectId']['output']>;
};

export type TripChecklistItem = {
  __typename?: 'TripChecklistItem';
  checklistItemTemplateId: Scalars['ObjectId']['output'];
  description: Scalars['String']['output'];
  dueDate: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  importanceLevel: CheckListItemImportanceLevel;
  internalName: Scalars['String']['output'];
  isChecked: Scalars['Boolean']['output'];
  status: TripChecklistItemStatus;
  title: Scalars['String']['output'];
};

/** Checklist item state */
export type TripChecklistItemState = {
  __typename?: 'TripChecklistItemState';
  _id: Scalars['ObjectId']['output'];
  checklistItemTemplateId: Scalars['ObjectId']['output'];
  isChecked: Scalars['Boolean']['output'];
  tripId: Scalars['ObjectId']['output'];
};

export enum TripChecklistItemStatus {
  Complete = 'COMPLETE',
  DueInFuture = 'DUE_IN_FUTURE',
  Overdue = 'OVERDUE'
}

/** Template for items that appear on trip checklists */
export type TripChecklistItemTemplate = {
  __typename?: 'TripChecklistItemTemplate';
  _id: Scalars['ObjectId']['output'];
  businessCode?: Maybe<BusinessCode>;
  description: Scalars['String']['output'];
  dpd: Scalars['Int']['output'];
  effectiveFrom: Scalars['Date']['output'];
  effectiveTo: Scalars['Date']['output'];
  excludeTourCodes?: Maybe<Array<Scalars['String']['output']>>;
  importanceLevel: CheckListItemImportanceLevel;
  includeTourCodes?: Maybe<Array<Scalars['String']['output']>>;
  internalName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TripChecklistItemTemplatePaginatedResult = {
  __typename?: 'TripChecklistItemTemplatePaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<TripChecklistItemTemplate>;
};

/** Trip checklist settings */
export type TripChecklistSettings = {
  __typename?: 'TripChecklistSettings';
  emergencyContactDueAtDpd?: Maybe<Scalars['Int']['output']>;
  healthNotesDueAtDpd?: Maybe<Scalars['Int']['output']>;
  passportInformationDueAtDpd?: Maybe<Scalars['Int']['output']>;
  termsSignatureDaysDueAfterBooking?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use the tsa identifier and passport info settings */
  travelerInfoDueAtDpd?: Maybe<Scalars['Int']['output']>;
  tsaIdentifiersDueAtDpd?: Maybe<Scalars['Int']['output']>;
};

export type TripComponent = {
  _id: Scalars['ObjectId']['output'];
  businessCode?: Maybe<BusinessCode>;
  isPublished: Scalars['Boolean']['output'];
  lineItemCode: Scalars['LineItemCode']['output'];
  status: TripComponentStatus;
  type: TripComponentType;
};

export enum TripComponentStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum TripComponentType {
  Adjustment = 'Adjustment',
  ExtendedInsurance = 'ExtendedInsurance',
  ExtendedStay = 'ExtendedStay',
  Fee = 'Fee',
  FlightPackage = 'FlightPackage',
  Insurance = 'Insurance',
  InsuranceAddon = 'InsuranceAddon',
  PrivateGroup = 'PrivateGroup',
  Promo = 'Promo',
  Tour = 'Tour',
  TourExcursion = 'TourExcursion',
  TourExtension = 'TourExtension',
  TourRoom = 'TourRoom'
}

export type TripCustomer = TripExistingCustomer | TripNewCustomer;

/** The type of customer on the trip. This is as it applies to the trip itself. For example, a GC traveling on their own not leading a group would be an Individual */
export enum TripCustomerType {
  /** This is the trip for the group coordinator. */
  GroupCoordinator = 'GROUP_COORDINATOR',
  /** A member of the group on the tour for a Group Coordinator */
  GroupMember = 'GROUP_MEMBER',
  /** A member of the tour who is not part of the group trip. This does not mean they are a solo traveler. */
  Individual = 'INDIVIDUAL'
}

export type TripExistingCustomer = {
  __typename?: 'TripExistingCustomer';
  customerId: Scalars['ObjectId']['output'];
};

export type TripExistingCustomerInput = {
  customerId: Scalars['ObjectId']['input'];
};

/** The reservation system used to book the PNR this flight belongs to. */
export enum TripFlightReservationSystem {
  /** The flight was booked and provided to World Journeys by Atlas, and was either booked by a staff member manually, or using another system such as the RightRez autobooker */
  Atlas = 'ATLAS',
  /** The flight was booked with Hitchhiker, a sales and service facing system used to help customers select their own flights from 2018-2023 */
  Hitchhiker = 'HITCHHIKER',
  /** The flight was booked with RightFlight, a RightRez product similar to Hitchhiker that allows customers to select their own flights */
  RightFlight = 'RIGHT_FLIGHT'
}

/** Represents an actualized flight with a flight number, departure and arrival gateways, etc. that is booked for a customer on a booking trip */
export type TripFlightSegment = {
  __typename?: 'TripFlightSegment';
  /** The record locator used to check in with the carrier corresponding to this flight segment's carrierCode */
  airlineLocator?: Maybe<Scalars['String']['output']>;
  /** Additional information about the arrival gateway for this flight segment */
  arrivalGateway?: Maybe<Gateway>;
  /** The IATA airport code for the arrival gateway for this flight */
  arrivalGatewayCode: Scalars['String']['output'];
  /** A string representing the time (in local airport time) that the flight arrives at the arrival gateway. This string should be displayed by converting it to a date with no time zone adjustment, before formatting */
  arrivesAtLocalTime: Scalars['String']['output'];
  /** The cabin that was purchased when this flight was reserved. May not be populated depending on the booking system used, so should not be relied upon */
  cabinClass?: Maybe<Scalars['String']['output']>;
  /** Ticketing carrier */
  carrier?: Maybe<Airline>;
  /** The primary airline for this flight */
  carrierCode: Scalars['String']['output'];
  /** The class of service, which is an internal representation of the type of ticket being sold by the airline. If you are looking for ECONOMY, PREMIUM, BUSINESS, please see cabinClass instead */
  classOfService?: Maybe<Scalars['String']['output']>;
  /** A string representing the time (in local airport time) that the flight departs from the departure gateway. This string should be displayed by converting it to a date with no time zone adjustment, before formatting */
  departsAtLocalTime: Scalars['String']['output'];
  /** Additional information about the departure gateway for this flight segment */
  departureGateway?: Maybe<Gateway>;
  /** The IATA airport code for the departure gateway for this flight */
  departureGatewayCode: Scalars['String']['output'];
  /** The flight number for this flight */
  flightNumber: Scalars['String']['output'];
  /** Operating carrier */
  operatedByCarrier?: Maybe<Airline>;
  /** The carrier that is operating this flight in the case of a code share flight */
  operatedByCarrierCode?: Maybe<Scalars['String']['output']>;
  /** The internal record locator issued by the ticketing airline */
  pnrLocator: Scalars['String']['output'];
  /** An ordering tool used to sort flights that share the same pnrLocator. Ordering flights within the same pnrLocator by pnrSegmentNumber will be ordered chronologically, since time-based ordering cannot be done without UTC timestamps */
  pnrSegmentNumber: Scalars['Int']['output'];
  /** The reservation system used to book the PNR that this flight belongs to */
  reservationSystem: TripFlightReservationSystem;
  /** The e-ticket number, populated once this PNR is ticketed. Will usually be nullish until much closer to the departure date */
  ticketNumber?: Maybe<Scalars['String']['output']>;
  /** The type or 'direction' of the flight. Another way of saying, 'Along what leg of the journey does this flight take place' */
  type: TripFlightType;
};

export enum TripFlightType {
  /** The flight happens at the start of tour from the traveler's home gateway to begin their tour */
  Departing = 'DEPARTING',
  /** The flight is 'internal' to the tour, used to move travelers from one country to another as part of the tour's itinerary. e.g. CDG to FCO for a London, Paris, Rome tour */
  Internal = 'INTERNAL',
  /** The flight happens at the end of their tour back to their home gateway */
  Returning = 'RETURNING'
}

/** The top level object containing metadata and information about the flights on a booking trip */
export type TripFlights = {
  __typename?: 'TripFlights';
  _id: Scalars['ObjectId']['output'];
  bookingTrip?: Maybe<BookingTrip>;
  /** The traveler's flights from their home gateway to begin their tour, sorted by pnrSegmentNumber and departure date, when possible */
  departingFlights: Array<TripFlightSegment>;
  /** The unfiltered list of all known flight segments known for this trip. If specific flights are needed, consider using another resolver. Sorted by pnrSegmentNumber and departure date, when possible */
  flightSegments?: Maybe<Array<TripFlightSegment>>;
  /** Returns true if this trip has at least one DEPARTING and at least one RETURNING flight segment */
  hasFullItinerary: Scalars['Boolean']['output'];
  /** Flights that are 'internal' to the tour, used to move travelers from one country to another as part of the tour's itinerary, sorted by pnrSegmentNumber and departure date, when possible. e.g. CDG to FCO for a London, Paris, Rome tour. */
  internalFlights: Array<TripFlightSegment>;
  /** Returns true if every flight segment for this trip has been assigned a ticket number */
  isFullyTicketed: Scalars['Boolean']['output'];
  /** The traveler's flights from the end of their tour back to their home gateway, sorted by pnrSegmentNumber and departure date, when possible */
  returningFlights: Array<TripFlightSegment>;
  /** The trip ID of the booking trip that these flights belong to */
  tripId: Scalars['ObjectId']['output'];
};

/** A hotel belonging to a trip. */
export type TripHotel = {
  __typename?: 'TripHotel';
  /** The addresses of the hotel. Suppliers can have more than one address. */
  address?: Maybe<Array<Address>>;
  /** The end date of the hotel stay. */
  endDate: Scalars['Date']['output'];
  /** The name of the hotel. */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone numbers of the hotel. Suppliers can have more than one phone number */
  phoneNumber?: Maybe<Array<Scalars['PhoneNumber']['output']>>;
  /** The start date of the hotel stay. */
  startDate: Scalars['Date']['output'];
  /** The type of the hotel. */
  type: TripHotelType;
  /** The website of the hotel. */
  website?: Maybe<Scalars['String']['output']>;
};

export enum TripHotelType {
  Base = 'BASE',
  Layover = 'LAYOVER',
  Poststay = 'POSTSTAY',
  Prestay = 'PRESTAY'
}

export type TripNewCustomer = {
  __typename?: 'TripNewCustomer';
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type TripNewCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Meta information for a trip rebooking */
export type TripRebookingMeta = {
  __typename?: 'TripRebookingMeta';
  pendingRebookingDate: Scalars['DateTime']['output'];
  rebookedBy?: Maybe<Scalars['ObjectId']['output']>;
  rebookingDate?: Maybe<Scalars['DateTime']['output']>;
  rebookingReasonCategory: RebookingReasonCategory;
  rebookingReasonDescription: Scalars['String']['output'];
};

export enum TripStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  PendingCancellation = 'PENDING_CANCELLATION',
  PendingRebooking = 'PENDING_REBOOKING',
  Quoted = 'QUOTED',
  Rebooked = 'REBOOKED',
  Requested = 'REQUESTED',
  Waitlisted = 'WAITLISTED'
}

export enum TripTimingStatus {
  OnTour = 'OnTour',
  PostTour = 'PostTour',
  PreTour = 'PreTour'
}

export type TsaIdentifiersChecklistItem = SystemChecklistItem & {
  __typename?: 'TsaIdentifiersChecklistItem';
  dueDate?: Maybe<Scalars['Date']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  status?: Maybe<TripChecklistItemStatus>;
};

export type TsaInformationInput = {
  confirmationDate?: InputMaybe<Scalars['DateTime']['input']>;
  countryOfIssue?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<TsaGender>;
  identityDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['Date']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  stateOfIssue?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IdentityDocumentType>;
};

/** TSA Settings */
export type TsaSettings = {
  __typename?: 'TsaSettings';
  /** Number of years in the future relative to the current date for valid date range */
  yearsInTheFuture: Scalars['Int']['output'];
  /** Number of years in the past relative to the current date for valid date range */
  yearsInThePast: Scalars['Int']['output'];
};

/** A list of unassigned travelers and their requested room type */
export type UnassignedTravelers = {
  __typename?: 'UnassignedTravelers';
  requestedBedCode: Scalars['String']['output'];
  trips: Array<BookingTrip>;
};

export type UncheckTripChecklistItemResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTripChecklistItemTemplateError | NotAuthorizedError | NotFoundError | TripChecklistItemState | ValidationError;

export type UnmatchRoommatesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | UnmatchRoommatesSuccess | ValidationError;

export type UnmatchRoommatesSuccess = {
  __typename?: 'UnmatchRoommatesSuccess';
  data: Array<Booking>;
};

export type UpdateAdjustmentInput = {
  displayName: Scalars['String']['input'];
  isCompanionDiscount: Scalars['Boolean']['input'];
  isFreePlace: Scalars['Boolean']['input'];
  isRefundable?: InputMaybe<Scalars['Boolean']['input']>;
  isStaffOnTour: Scalars['Boolean']['input'];
  persistsOnCancelAndRebook?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds: Array<Scalars['ObjectId']['input']>;
};

export type UpdateAdjustmentResult = Adjustment | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateAdjustmentStatusInput = {
  status: TripComponentStatus;
};

export type UpdateAdjustmentStatusResult = Adjustment | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessSettingsInput = {
  departures?: InputMaybe<UpdateDepartureSettingsInput>;
  fees?: InputMaybe<UpdateFeeSettingsInput>;
  gcDepartures?: InputMaybe<UpdateGcDepartureSettingsInput>;
  insurance?: InputMaybe<UpdateInsuranceSettingsInput>;
  integrations?: InputMaybe<UpdateIntegrationSettingsInput>;
  orders?: InputMaybe<UpdateOrderSettingsInput>;
  promos?: InputMaybe<UpdatePromoSettingsInput>;
  reviews?: InputMaybe<UpdateReviewSettingsInput>;
  supportTickets?: InputMaybe<UpdateSupportSettingsInput>;
  tripChecklists?: InputMaybe<UpdateTripChecklistSettingsInput>;
};

export type UpdateBusinessSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Update the details of a campaign */
export type UpdateCampaignInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCampaignResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateCampaignStatusInput = {
  status: CampaignStatus;
};

export type UpdateCampaignStatusResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Update the basic details of a category */
export type UpdateCategoryInput = {
  /** Passing null, undefined, or empty string will remove the description */
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateCategoryResult = BusinessNotSpecifiedError | Category | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Passing null or undefined will set the address to null */
export type UpdateCustomerAddressInput = {
  address?: InputMaybe<AddressInput>;
};

export type UpdateCustomerAddressResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** You must provide a unique email address. */
export type UpdateCustomerEmailInput = {
  email: Scalars['Email']['input'];
};

export type UpdateCustomerEmailResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Setting a last name to null or undefined will set it to null */
export type UpdateCustomerNameInput = {
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerNameResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Update customer password input */
export type UpdateCustomerPasswordInput = {
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  reset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCustomerPasswordResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidSigninError | NotAuthorizedError | NotFoundError | UpdatePasswordResult | ValidationError;

/** Passing null or undefined will set the phone to null */
export type UpdateCustomerPhoneNumberInput = {
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type UpdateCustomerPhoneNumberResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateCustomerProfileSocialMediaInput = {
  facebookUsername: Scalars['String']['input'];
  instagramUsername: Scalars['String']['input'];
  snapchatUsername: Scalars['String']['input'];
  tiktokUsername: Scalars['String']['input'];
  xUsername: Scalars['String']['input'];
};

export type UpdateDepartureDocumentMetadataSettingsInput = {
  /** The type of document */
  documentType: DocumentType;
  /** The url path to download the document */
  downloadPath: Scalars['String']['input'];
  /** The title of the document to be displayed by clients */
  title: Scalars['String']['input'];
};

export type UpdateDepartureExcursionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  minNbTravelersRequired?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDepartureExcursionResult = BusinessNotSpecifiedError | DepartureExcursion | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureExtensionExcursionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']['input']>;
  /** The maximum number of travelers that can reserve this excursion type for this Departure. */
  capacity: Scalars['Int']['input'];
  minNbTravelersRequired?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDepartureExtensionExcursionResult = BusinessNotSpecifiedError | DepartureExcursion | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureExtensionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDepartureExtensionResult = BusinessNotSpecifiedError | DepartureExtension | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureExtensionRoomInput = {
  /** The maximum number of travelers that can reserve this room type for this Departure. */
  capacity: Scalars['Int']['input'];
};

export type UpdateDepartureExtensionRoomResult = BusinessNotSpecifiedError | DepartureRoom | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureInput = {
  addonPrice?: InputMaybe<Array<MoneyInput>>;
  autoApproveDeadline?: InputMaybe<Scalars['Date']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  exclusivityType?: InputMaybe<DepartureExclusivityType>;
  finalInstallmentDeadline?: InputMaybe<Scalars['Date']['input']>;
  finalPaymentDeadline?: InputMaybe<Scalars['Date']['input']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['ObjectId']['input']>;
  reservedCapacity?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DepartureStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type UpdateDepartureItemStatusInput = {
  _id: Scalars['ObjectId']['input'];
  status: DepartureStatus;
};

export type UpdateDepartureItemStatusResult = BusinessNotSpecifiedError | Departure | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureResult = BusinessNotSpecifiedError | Departure | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureRoomInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DepartureStatus>;
};

export type UpdateDepartureRoomResult = BusinessNotSpecifiedError | DepartureRoom | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureSettingsInput = {
  /** List document metadata settings */
  documentMetadata?: InputMaybe<Array<UpdateDepartureDocumentMetadataSettingsInput>>;
  eTicketsAvailabilityDpd?: InputMaybe<Scalars['Int']['input']>;
  flightsReleasedDpd?: InputMaybe<Scalars['Int']['input']>;
  flightsRequestDpd?: InputMaybe<Scalars['Int']['input']>;
  flightsRequestMessagingDpd?: InputMaybe<Scalars['Int']['input']>;
  hotelsReleasedDpd?: InputMaybe<Scalars['Int']['input']>;
  hotelsRequestDpd?: InputMaybe<Scalars['Int']['input']>;
  nbEstimatedDaysForFlightRelease?: InputMaybe<Scalars['Int']['input']>;
  publicDepartureMinDpd?: InputMaybe<Scalars['Int']['input']>;
  tourDirectorFutureToursGateDpd?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDraftBookingPaymentSchedulePaymentMethodResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | InvalidPaymentError | InvalidPaymentScheduleError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftBookingPaymentScheduleResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | InvalidPaymentError | InvalidPaymentScheduleError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftBookingTripLineItemStatusesInput = {
  /** The business reason for the cancellation */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** The line item code on the draft order to modify the status of. */
  lineItemId: Scalars['ObjectId']['input'];
  /** The new line item status. */
  status: LineItemStatus;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId']['input'];
};

export type UpdateDraftBookingTripLineItemStatusesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftBookingTripStatusesInput = {
  status: TripStatus;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId']['input'];
};

export type UpdateDraftBookingTripStatusesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderAddressResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderAdjustmentPricesInput = {
  /** The adjustment lineItemId to update */
  adjustmentLineItemId: Scalars['ObjectId']['input'];
  /** The adjustment amount. Will override the results of buildPrice(). */
  overrideAmount: Scalars['Float']['input'];
  /** The trip to override the adjustment price on. */
  tripId: Scalars['ObjectId']['input'];
};

export type UpdateDraftOrderAdjustmentPricesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderAirportTransferInput = {
  arriving?: InputMaybe<AirportTransferInput>;
  returning?: InputMaybe<AirportTransferInput>;
  tripId: Scalars['ObjectId']['input'];
};

export type UpdateDraftOrderAirportTransferResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderEmergencyContactsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderExtensionRoomsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDepartureError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderFeePricesInput = {
  /** The fee lineItemId to update */
  feeLineItemId: Scalars['ObjectId']['input'];
  /** The fee amount. Will override the results of buildPrice(). */
  overrideAmount: Scalars['Float']['input'];
  /** The trip to override the fee price on. */
  tripId: Scalars['ObjectId']['input'];
};

export type UpdateDraftOrderFeePricesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderFinalInstallmentDeadlineResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderFinalPaymentDeadlineResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderFlightPackageInput = {
  /** The reason for updating the flights. */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** Departing flight package input */
  departing: UpdateDraftOrderFlightPackageItemInput;
  /** Returning flight package input */
  returning: UpdateDraftOrderFlightPackageItemInput;
  /** Trip to set flight packages on */
  tripId: Scalars['ObjectId']['input'];
};

export type UpdateDraftOrderFlightPackageItemInput = {
  /**
   * Flight departure date. If an extension exists, it defaults to the extension's flight date, otherwise, it defaults to departure's corresponding flight date.
   * @deprecated Use requestedDate instead
   */
  departureDate?: InputMaybe<Scalars['Date']['input']>;
  /** Flight package product code */
  lineItemCode: Scalars['LineItemCode']['input'];
  /** Date to extend the request to. If departing sets the departure date and will default to earlier of the tour or extensions departure date. If returning, sets the end date and will default to the later of the tour or extensions end dates. */
  requestedDate?: InputMaybe<Scalars['Date']['input']>;
  /** Stop over information */
  stopOver?: InputMaybe<StopOverInput>;
};

export type UpdateDraftOrderFlightPackagesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidFlightPackageError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderInsuranceResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderPrimaryTripResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderPromoPricesInput = {
  /** The promo amount. Will override the results of buildPrice(). */
  overrideAmount: Scalars['Float']['input'];
  /** The promo lineItemId to update */
  promoLineItemId: Scalars['ObjectId']['input'];
  /** The trip to override the fee price on. */
  tripId: Scalars['ObjectId']['input'];
};

export type UpdateDraftOrderPromoPricesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderRequestedRoommatesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderRequestedTravelCompanionsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderRoomInput = {
  /** The reason for cancelling the room */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** The lineItemCode of the room. */
  lineItemCode: Scalars['LineItemCode']['input'];
  tripId: Scalars['ObjectId']['input'];
};

export type UpdateDraftOrderRoomsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderTravelerNotesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderTsaInformationResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftQuoteSavedInput = {
  isSaved: Scalars['Boolean']['input'];
};

export type UpdateDraftQuoteSavedResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | ValidationError;

/** Update a draft term */
export type UpdateDraftTermInput = {
  certificationText?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['JSON']['input'];
  market: TermMarket;
  termType: TermType;
};

export type UpdateDraftTermResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ImmutableTermError | InvalidDateError | NotAuthorizedError | NotFoundError | Term | ValidationError;

export type UpdateExtendedStayInput = {
  basePrice: Array<MoneyInput>;
};

export type UpdateExtendedStayResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExtendedStay | InvalidDateError | InvalidFlightPackageError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateExtendedStayStatusInput = {
  status: TripComponentStatus;
};

export type UpdateExtendedStayStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExtendedStay | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFeeCalculationRuleInput = {
  /** Defines the maximum DPD value for this rule to match */
  maxDpd: Scalars['Int']['input'];
  /** The strategy to use when calculating the fee */
  strategy: FeeCalculationStrategy;
  /** The percentage of the trip cost to use for the fee */
  tripPercent: Scalars['Int']['input'];
};

export type UpdateFeeCancellationSettingsInput = {
  /** Category specific rules for calculating the fee */
  categorySpecificRules?: InputMaybe<Array<UpdateFeeCategorySpecificCalculationRuleInput>>;
  /** Default rules for calculating the fee */
  defaultRules?: InputMaybe<Array<UpdateFeeCalculationRuleInput>>;
};

export type UpdateFeeCategorySpecificCalculationRuleInput = {
  /** List of fee category codes that should use the calculation rules */
  categoryCodes: Array<Scalars['FeeCategoryCode']['input']>;
  /** List of calculation rules for the category codes */
  rules: Array<UpdateFeeCalculationRuleInput>;
};

/** Update a fee */
export type UpdateFeeInput = {
  basePrice: Array<MoneyInput>;
  isRefundable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFeeResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | Fee | InvalidDateError | InvalidFeeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFeeSettingsInput = {
  /** Settings for calculating the cancellation fee amount. */
  cancellationSettings?: InputMaybe<UpdateFeeCancellationSettingsInput>;
  /** When using percentage cancellation fees and this is also set, uses the effective DPD based on all rebooked trips to determine the cancellation fee. */
  useLowestDpdInRebookingChain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFeeStatusInput = {
  status: TripComponentStatus;
};

export type UpdateFeeStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | Fee | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFlightPackageInput = {
  basePrice: Array<MoneyInput>;
  isCustomGateway: Scalars['Boolean']['input'];
};

export type UpdateFlightPackageResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightPackage | InvalidDateError | InvalidFlightPackageError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFlightPackageStatusInput = {
  status: TripComponentStatus;
};

export type UpdateFlightPackageStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightPackage | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Used to update the auto applied adjustments, or is passed as empty to remove the adjustments */
export type UpdateGcDepartureAdjustmentInput = {
  amount: Array<MoneyInput>;
  lineItemCode: Scalars['LineItemCode']['input'];
  /** @deprecated Do not use this field. This field is no longer in use and will be removed in a future release. We're keeping it for backward compatibility. Use amount instead. */
  price?: MoneyInput;
};

export type UpdateGcDepartureInput = {
  /** The ID of the GC Departure to update */
  _id: Scalars['ObjectId']['input'];
  /** The adjustments to apply to GM quotes for this GC departure */
  autoAppliedAdjustments?: InputMaybe<Array<UpdateGcDepartureAdjustmentInput>>;
  /** The percentage of the average program price that counts towards a companion discount per qualifying traveler. Limited to 2 decimal places */
  companionDiscountRate: Scalars['Float']['input'];
  /** The expected volume for the GC Departure, used as a stretch goal to track progress by the GC */
  expectedVolume: Scalars['Int']['input'];
  /** The rate at which the GC earns free places for insurance packages based on on the number of paying travelers. Expressed as an integer */
  freeInsuranceRatio: Scalars['FreePlaceRatio']['input'];
  /** The rate at which the GC earns free places for the tour, extension, and excursions based on the number of paying travelers. Expressed as an integer */
  freePlaceRatio: Scalars['FreePlaceRatio']['input'];
  /** An estimate of the number of travelers on the GC Departure, used by account managers to estimate things like the private group fee */
  groupSizeEstimate: Scalars['Int']['input'];
  /** Whether or not trips on this GC Departure should be assessed the private group fee during reconciliation. */
  includePrivateGroupFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** The rules that determine the line items that are available to the GC for the GCDeparture */
  lineItemRules?: InputMaybe<Array<UpdateGcDepartureSettingsLineItemRuleInput>>;
  /** The URL of the microsite where GMs can quote and book */
  micrositeUrl?: InputMaybe<Scalars['String']['input']>;
  /** The date of a recruitment meeting for the GC to promote the GCDeparture to potential group members */
  recruitmentMeetingDate?: InputMaybe<Scalars['Date']['input']>;
  /** The percentage of the average program price that counts towards a GC stipend payment per qualifying traveler. Limited to 2 decimal places */
  stipendRate: Scalars['Float']['input'];
};

/** Input for updating a gc departure prospect */
export type UpdateGcDepartureProspectInput = {
  _id: Scalars['ObjectId']['input'];
  address?: InputMaybe<AddressInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  levelOfInterest?: InputMaybe<GcDepartureProspectLevelOfInterest>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGcDepartureProspectResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureProspect | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateGcDepartureResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidAdjustmentError | InvalidDateError | InvalidMoneyError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateGcDepartureSettingsInput = {
  eTicketsAvailabilityDpd?: InputMaybe<Scalars['Int']['input']>;
  flightsReleasedDpd?: InputMaybe<Scalars['Int']['input']>;
  nbEstimatedDaysForFlightRelease?: InputMaybe<Scalars['Int']['input']>;
  reconciliationDpd?: InputMaybe<Scalars['Int']['input']>;
};

/** Used to update GC Departure Line Item Rules */
export type UpdateGcDepartureSettingsLineItemRuleInput = {
  level: GcDepartureRuleLevel;
  lineItemCode: Scalars['LineItemCode']['input'];
  lineItemType: GcDepartureRuleLineItemType;
};

/** Input fields to set GC Departure Stipend detail */
export type UpdateGcDepartureStipendDetailInput = {
  /** The ID of the GC Departure to update */
  _id: Scalars['ObjectId']['input'];
  /** The dollar amount of the check being issued */
  amount?: InputMaybe<MoneyInput>;
  /** A date to record the cancellation of the stipend benefit */
  cancelledDate?: InputMaybe<Scalars['Date']['input']>;
  /** The check number of the issued check */
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  /** The date the check was issued */
  issuedDate?: InputMaybe<Scalars['Date']['input']>;
  /** The current status of the stipend */
  status: GcDepartureStipendDetailStatus;
};

export type UpdateGcDepartureStipendDetailResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidMoneyError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsuranceExtensionInput = {
  basePrice: Array<MoneyInput>;
};

export type UpdateInsuranceExtensionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsuranceExtension | InvalidDateError | InvalidInsurancePlanError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsuranceExtensionStatusInput = {
  status: TripComponentStatus;
};

export type UpdateInsuranceExtensionStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsuranceExtension | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePlanAddonInput = {
  basePrice: Array<MoneyInput>;
  includedWithinDays?: InputMaybe<Scalars['Int']['input']>;
  internalName: Scalars['String']['input'];
  preventPurchaseAfterDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateInsurancePlanAddonResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlanAddon | InvalidDateError | InvalidInsurancePlanError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePlanAddonStatusInput = {
  _id: Scalars['ObjectId']['input'];
  status: TripComponentStatus;
};

export type UpdateInsurancePlanAddonStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlanAddon | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePlanInput = {
  basePrice: Array<MoneyInput>;
  internalName: Scalars['String']['input'];
  isEligibleForRolloverOnRebooking?: InputMaybe<Scalars['Boolean']['input']>;
  policyCoversPreExistingConditions?: InputMaybe<Scalars['Boolean']['input']>;
  policyNumber: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
  /** The insurance plan will become available starting from the specified number of days after the booking date */
  purchasableAfterDays?: InputMaybe<Scalars['Int']['input']>;
  /** The insurance plan will be available during the quote process and for the specified number of days after booking */
  purchasableWithinDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateInsurancePlanResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlan | InvalidDateError | InvalidInsurancePlanError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePlanStatusInput = {
  status: TripComponentStatus;
};

export type UpdateInsurancePlanStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlan | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsuranceSettingsInput = {
  nbMaximumDaysToExtend?: InputMaybe<Scalars['Int']['input']>;
  removalWindowDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateIntegrationSettingsInput = {
  cybersourceMerchantIdCA?: InputMaybe<Scalars['String']['input']>;
  cybersourceMerchantIdUS?: InputMaybe<Scalars['String']['input']>;
  mailroom?: InputMaybe<UpdateMailroomSettingsInput>;
  micrositeUrlCA?: InputMaybe<Scalars['String']['input']>;
  micrositeUrlUS?: InputMaybe<Scalars['String']['input']>;
  productMarketCodeCA?: InputMaybe<Scalars['String']['input']>;
  productMarketCodeUS?: InputMaybe<Scalars['String']['input']>;
  rightFlightBrandIdCA?: InputMaybe<Scalars['String']['input']>;
  rightFlightBrandIdUS?: InputMaybe<Scalars['String']['input']>;
  transactionalEmails?: InputMaybe<Array<UpdateTransactionalEmailSettingsInput>>;
  websiteUrlCA?: InputMaybe<Scalars['String']['input']>;
  websiteUrlUS?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMailroomSettingsInput = {
  isActive: Scalars['Boolean']['input'];
  nbPreDepartureMailDaysFrom: Scalars['Int']['input'];
  nbPreDepartureMailDaysTo: Scalars['Int']['input'];
  preDepartureMailMinimumBalance: Array<MoneyInput>;
};

export type UpdateNoteInput = {
  content: Scalars['String']['input'];
};

export type UpdateNoteResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Note | ValidationError;

export type UpdateOrderSettingsInput = {
  achCheck?: InputMaybe<UpdatePaymentPlanSettingsInput>;
  bypassErrorOnProcessorDown?: InputMaybe<Scalars['Boolean']['input']>;
  creditCard?: InputMaybe<UpdatePaymentPlanSettingsInput>;
  daysToMeetMinimumInstallments?: InputMaybe<Scalars['Int']['input']>;
  debitCard?: InputMaybe<UpdatePaymentPlanSettingsInput>;
  departurePriorityWindowDpd?: InputMaybe<Scalars['Int']['input']>;
  earliestPaymentScheduleStartDays?: InputMaybe<Scalars['Int']['input']>;
  emergencyContactSelfServiceDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  expiresInMinutes?: InputMaybe<Scalars['Int']['input']>;
  healthNotesSelfServiceDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  latestPaymentScheduleStartDays?: InputMaybe<Scalars['Int']['input']>;
  maximumAgeForTraveler?: InputMaybe<Scalars['Int']['input']>;
  maximumPerTripPromotionAmount?: InputMaybe<Array<MoneyInput>>;
  minimumAgeForTraveler?: InputMaybe<Scalars['Int']['input']>;
  nbMaximumAutopayAttempts?: InputMaybe<Scalars['Int']['input']>;
  passportInformationSelfServiceDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  physicalCheck?: InputMaybe<UpdatePaymentPlanSettingsInput>;
  riskFreePeriod?: InputMaybe<UpdateRiskFreePeriodSettingsInput>;
  tsaIdentifiersSelfServiceDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePasswordResult = {
  __typename?: 'UpdatePasswordResult';
  success: Scalars['Boolean']['output'];
};

export type UpdatePaymentPlanSettingsInput = {
  isAutopayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isManualAllowed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Update a private group */
export type UpdatePrivateGroupInput = {
  basePrice: Array<MoneyInput>;
};

export type UpdatePrivateGroupResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPrivateGroupError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type UpdatePrivateGroupStatusInput = {
  status: TripComponentStatus;
};

export type UpdatePrivateGroupStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPrivateGroupError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

/** Update the details of a promo */
export type UpdatePromoInput = {
  audienceMemberTypes?: InputMaybe<Array<PromoAudienceMemberType>>;
  displayName: Scalars['String']['input'];
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo: Scalars['DateTime']['input'];
  exclusivity: PromoExclusivity;
  isGroupsOnly?: Scalars['Boolean']['input'];
  isHiddenFromSales?: Scalars['Boolean']['input'];
  isIndiesOnly?: Scalars['Boolean']['input'];
  isShareable?: Scalars['Boolean']['input'];
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  promoCategory?: InputMaybe<PromoCategory>;
};

export type UpdatePromoResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type UpdatePromoSettingsInput = {
  /** Promo code to use for the advanced repeat promo feature */
  advancedRepeatPromoCode?: InputMaybe<Scalars['String']['input']>;
  /** Customer facing name for the advanced repeat promo */
  advancedRepeatPromoName?: InputMaybe<Scalars['String']['input']>;
  /** List of trip thresholds for higher repeat promo code discounts */
  repeatThresholds?: InputMaybe<Array<UpdateRepeatThresholdSettingsInput>>;
  /** List of reasons for service recovery promotions. */
  serviceRecoveryReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Enable advanced behavior for the REPEAT promo code. */
  useAdvancedRepeatPromo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePromoStatusInput = {
  status: TripComponentStatus;
};

export type UpdatePromoStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Update the targets of a promo */
export type UpdatePromoTargetsInput = {
  targets: Array<CreatePromoTargetInput>;
};

export type UpdatePromoTargetsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type UpdateQuoteExpiryInput = {
  expirationDate: Scalars['DateTime']['input'];
};

export type UpdateQuoteExpiryResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | Quote | ValidationError;

export type UpdateQuoteSavedInput = {
  isSaved: Scalars['Boolean']['input'];
};

export type UpdateQuoteSavedResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidOrderError | NotAuthorizedError | NotFoundError | Quote | ValidationError;

export type UpdateRepeatThresholdSettingsInput = {
  discount: Array<MoneyInput>;
  /** Number of trips required for discount */
  nbTrips: Scalars['Int']['input'];
  /** Additional amount to discount if applied before repeatBonusExpiresAfterDays */
  repeatBonus: Array<MoneyInput>;
  /** Number of days after the last trip to earn the repeat bonus */
  repeatBonusExpiresAfterDays: Scalars['Int']['input'];
};

/** Updates a review detail */
export type UpdateReviewDetailInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReviewDetailResponseInput = {
  author: Scalars['String']['input'];
  body: Scalars['String']['input'];
};

export type UpdateReviewDetailResponseResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidRatingError | InvalidReviewError | InvalidReviewResponseError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type UpdateReviewDetailStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidRatingError | InvalidReviewError | InvalidReviewResponseError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type UpdateReviewImagesStatusInput = {
  imageId: Scalars['ObjectId']['input'];
  status: ReviewStatus;
};

export type UpdateReviewImagesStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidReviewError | NotAuthorizedError | NotFoundError | Review | ValidationError;

/** Update a review input. Passing null or undefined will ignore the update */
export type UpdateReviewInput = {
  detail?: InputMaybe<UpdateReviewDetailInput>;
  rating: Scalars['Int']['input'];
};

export type UpdateReviewResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidRatingError | InvalidReviewError | InvalidReviewResponseError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type UpdateReviewSettingsInput = {
  /** Number of days after the departure that reviews are allowed to be submitted */
  reviewCutoffDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRiskFreePeriodSettingsInput = {
  minimumEligibleDpd?: InputMaybe<Scalars['Int']['input']>;
  nbAutopayDays?: InputMaybe<Scalars['Int']['input']>;
  nbManualDays?: InputMaybe<Scalars['Int']['input']>;
  nbPayInFullDays?: InputMaybe<Scalars['Int']['input']>;
  preserveRiskFreePeriodOnRebooking?: InputMaybe<Scalars['Boolean']['input']>;
  useMinimumEligibleDpd?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRoleInput = {
  name: Scalars['String']['input'];
  permissionKeys: Array<PermissionKey>;
};

export type UpdateRoleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Role | ValidationError;

/** Update the details of a service recovery promo. */
export type UpdateServiceRecoveryPromoInput = {
  expiryDate: Scalars['DateTime']['input'];
  recoveryReason: Scalars['String']['input'];
};

export type UpdateServiceRecoveryPromoResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ServiceRecovery | ValidationError;

export type UpdateServiceRecoveryPromoStatusInput = {
  status: TripComponentStatus;
};

export type UpdateServiceRecoveryPromoStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ServiceRecovery | ValidationError;

export type UpdateSupportSettingsInput = {
  /** The external ID of support ticket business. */
  businessExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Enable auto approved late add support ticket creation. */
  isAutoApprovedLateAddEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Update the basic details of a tag */
export type UpdateTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateTagResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | Tag | ValidationError;

export type UpdateTourExcursionInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  /** The minimum number of travelers required for this excursion to be confirmed. */
  minNbTravelersRequired?: InputMaybe<Scalars['Int']['input']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type UpdateTourExcursionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | TourExcursion | ValidationError;

export type UpdateTourExcursionStatusInput = {
  status: TripComponentStatus;
};

export type UpdateTourExcursionStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | TourExcursion | ValidationError;

export type UpdateTourExtensionInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  /** The default capacity that will set for departures created from this Extension. */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPreExtension?: InputMaybe<Scalars['Boolean']['input']>;
  minimumCapacity?: InputMaybe<Scalars['Int']['input']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type UpdateTourExtensionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

export type UpdateTourExtensionRoomInput = {
  /** The _id of the tour extension room to update. */
  _id: Scalars['ObjectId']['input'];
  basePrice?: InputMaybe<Array<MoneyInput>>;
  bedCode?: InputMaybe<TourBedCode>;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']['input']>;
  /** The capacity that will set for Departure Rooms created from this Tour Room.  */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not roommate matching is needed for this room */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type UpdateTourExtensionRoomResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type UpdateTourExtensionRoomStatusInput = {
  /** The _id of the tour extension room to update. */
  _id: Scalars['ObjectId']['input'];
  status: TripComponentStatus;
};

export type UpdateTourExtensionRoomStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type UpdateTourExtensionStatusInput = {
  /** Include all the extension rooms statuses */
  includeRooms?: Scalars['Boolean']['input'];
  status: TripComponentStatus;
};

export type UpdateTourExtensionStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

export type UpdateTourInput = {
  activityLevel?: InputMaybe<Scalars['Int']['input']>;
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  classLevel?: InputMaybe<Scalars['Int']['input']>;
  /** The default capacity that will set for Departures created from this Tour. */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  deposit?: InputMaybe<Array<MoneyInput>>;
  depositForAutomaticPlan?: InputMaybe<Array<MoneyInput>>;
  depositForLateAdd?: InputMaybe<Array<MoneyInput>>;
  feeCategoryCode?: InputMaybe<Scalars['FeeCategoryCode']['input']>;
  finalInstallmentDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  finalPaymentDeadlineDpd?: InputMaybe<Scalars['Int']['input']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isNonRevenueTour?: InputMaybe<Scalars['Boolean']['input']>;
  isPassportRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isVisaRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  minimumCapacity?: InputMaybe<Scalars['Int']['input']>;
  nbDepartureFlightDays?: InputMaybe<Scalars['Int']['input']>;
  nbReturningFlightDays?: InputMaybe<Scalars['Int']['input']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type UpdateTourPricingInput = {
  lineItemCode: Scalars['LineItemCode']['input'];
  priceRules: Array<PriceRuleInput>;
};

export type UpdateTourPricingResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPriceYearError | InvalidPricingError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type UpdateTourProductStatusInput = {
  includeChildProducts?: Scalars['Boolean']['input'];
  lineItemCode: Scalars['String']['input'];
  status: TripComponentStatus;
};

export type UpdateTourResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type UpdateTourRoomDetailsInput = {
  /** The default capacity that will set for Departures Rooms created from this Tour Room. Defaults to the Tour capacity or Tour Extension capacity if the extensionLineItemCode was provided. */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTourRoomInput = {
  /** The _id of the tour room to update. */
  _id: Scalars['ObjectId']['input'];
  basePrice?: InputMaybe<Array<MoneyInput>>;
  /** The capacity that will set for Departure Rooms created from this Tour Room.  */
  defaultCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not roommate matching is needed for this room */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type UpdateTourRoomResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTourError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type UpdateTourRoomStatusInput = {
  /** The _id of the tour room to update. */
  _id: Scalars['ObjectId']['input'];
  status: TripComponentStatus;
};

export type UpdateTourRoomStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type UpdateTourStatusInput = {
  /** Include all the tour rooms */
  includeRooms?: Scalars['Boolean']['input'];
  status: TripComponentStatus;
};

export type UpdateTourStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidPricingError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type UpdateTransactionalEmailSettingsInput = {
  campaignId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  internalCode: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  nbNotificationDaysInAdvance?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTripChecklistItemTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dpd?: InputMaybe<Scalars['Int']['input']>;
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
  excludeTourCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  importanceLevel?: InputMaybe<CheckListItemImportanceLevel>;
  includeTourCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTripChecklistItemTemplateResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidTripChecklistItemTemplateError | NotAuthorizedError | NotFoundError | TripChecklistItemTemplate | ValidationError;

export type UpdateTripChecklistSettingsInput = {
  emergencyContactDueAtDpd?: InputMaybe<Scalars['Int']['input']>;
  healthNotesDueAtDpd?: InputMaybe<Scalars['Int']['input']>;
  passportInformationDueAtDpd?: InputMaybe<Scalars['Int']['input']>;
  termsSignatureDaysDueAfterBooking?: InputMaybe<Scalars['Int']['input']>;
  tsaIdentifiersDueAtDpd?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateVoucherRefundDetailInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId']['input'];
  /** The date the check was issued */
  checkIssuedOn?: InputMaybe<Scalars['Date']['input']>;
  /** The check number */
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  /** Information about the employee who approved the refund check */
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the refund */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the VoucherRefundedTransaction to edit on this Voucher */
  refundTransactionId: Scalars['ObjectId']['input'];
};

export type UpdateVoucherRefundDetailResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** A user */
export type User = {
  _id: Scalars['ObjectId']['output'];
};

/** The input parameters are invalid. */
export type ValidationError = DomainError & {
  __typename?: 'ValidationError';
  allErrors: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ObjectId']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type VoidBookingTransferPaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | NotAuthorizedError | NotFoundError | ValidationError;

/** Voids a non-expired voucher */
export type VoidVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId']['input'];
  /** The reason that the voucher is being voided */
  reason: Scalars['String']['input'];
};

export type VoidVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** A voucher which contains its rules and transactions */
export type Voucher = {
  __typename?: 'Voucher';
  _id: Scalars['ObjectId']['output'];
  balance: Money;
  booking?: Maybe<Booking>;
  businessCode?: Maybe<BusinessCode>;
  customer?: Maybe<Customer>;
  customerId: Scalars['ObjectId']['output'];
  expirationDate: Scalars['Date']['output'];
  /** Whether the voucher has at least one refund transaction */
  hasRefunds: Scalars['Boolean']['output'];
  isExternal: Scalars['Boolean']['output'];
  isRefundable: Scalars['Boolean']['output'];
  issueDate: Scalars['Date']['output'];
  orderId?: Maybe<Scalars['ObjectId']['output']>;
  reason: VoucherReason;
  status: VoucherStatus;
  transactions: Array<VoucherTransaction>;
  transferBusinessUnit?: Maybe<Scalars['String']['output']>;
};

/** Arbitrary increase of voucher value, usually associated with correcting balance issues */
export type VoucherIncreasedTransaction = VoucherTransaction & {
  __typename?: 'VoucherIncreasedTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']['output']>;
  reason: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

/** The initial issuance transaction when the voucher is first created */
export type VoucherIssuedTransaction = VoucherTransaction & {
  __typename?: 'VoucherIssuedTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  orderId: Scalars['ObjectId']['output'];
  reason: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

/** A paginated set of Vouchers and their transactions */
export type VoucherPaginatedResult = {
  __typename?: 'VoucherPaginatedResult';
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  results: Array<Voucher>;
};

export type VoucherPaymentMethod = {
  __typename?: 'VoucherPaymentMethod';
  isRefundable: Scalars['Boolean']['output'];
  voucher?: Maybe<Voucher>;
  voucherId: Scalars['ObjectId']['output'];
  voucherTransactionId?: Maybe<Scalars['ObjectId']['output']>;
};

export type VoucherPaymentMethodInput = {
  voucherId: Scalars['ObjectId']['input'];
};

/** Why the voucher was issued */
export enum VoucherReason {
  AnyReasonProtection = 'ANY_REASON_PROTECTION',
  ExternalTransfer = 'EXTERNAL_TRANSFER',
  Other = 'OTHER',
  SevereFlightDisruption = 'SEVERE_FLIGHT_DISRUPTION',
  WorldEvents = 'WORLD_EVENTS'
}

/** Logging that a voucher has been used against an order */
export type VoucherRedeemedTransaction = VoucherTransaction & {
  __typename?: 'VoucherRedeemedTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  orderId: Scalars['ObjectId']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

/** Arbitrary reduction used to correct balances */
export type VoucherReducedTransaction = VoucherTransaction & {
  __typename?: 'VoucherReducedTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']['output']>;
  reason: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

export type VoucherRefundInput = {
  amount: Scalars['Float']['input'];
  voucherId: Scalars['ObjectId']['input'];
};

/** When a voucher's balance is refunded back to the customer */
export type VoucherRefundedTransaction = VoucherTransaction & {
  __typename?: 'VoucherRefundedTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  /** The ID of the employee who recorded the refund */
  approvedBy?: Maybe<Scalars['ObjectId']['output']>;
  /** @deprecated Deprecated, source data does not contain time information. Use checkIssuedOn instead */
  checkIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date the check was issued */
  checkIssuedOn?: Maybe<Scalars['Date']['output']>;
  /** The check number */
  checkNumber?: Maybe<Scalars['String']['output']>;
  /** Information about the employee or team who issued or approved the refund check */
  issuedBy?: Maybe<Scalars['String']['output']>;
  /** The reason for the refund */
  reason?: Maybe<Scalars['String']['output']>;
  transactionDate: Scalars['DateTime']['output'];
};

/** When the voucher is reinstated, this transaction restores the voided balance */
export type VoucherReinstatedTransaction = VoucherTransaction & {
  __typename?: 'VoucherReinstatedTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']['output']>;
  reason: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

export enum VoucherSortField {
  ExpirationDate = 'expirationDate'
}

export enum VoucherStatus {
  Approved = 'APPROVED',
  Voided = 'VOIDED'
}

/** Base type for all voucher transactions */
export type VoucherTransaction = {
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  transactionDate: Scalars['DateTime']['output'];
};

export enum VoucherTransferDirection {
  In = 'IN',
  Out = 'OUT'
}

/** Used when a voucher is transferred from or to a non WOJO EF product */
export type VoucherTransferExternalTransaction = VoucherTransaction & {
  __typename?: 'VoucherTransferExternalTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']['output']>;
  direction: VoucherTransferDirection;
  transactionDate: Scalars['DateTime']['output'];
  transferBusinessUnit: Scalars['String']['output'];
};

/** When a voucher is transferred to another customer within WOJO */
export type VoucherTransferInternalTransaction = VoucherTransaction & {
  __typename?: 'VoucherTransferInternalTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']['output']>;
  transactionDate: Scalars['DateTime']['output'];
  transferVoucherId: Scalars['ObjectId']['output'];
};

/** When the voucher is voided, this transaction is clearing the balance */
export type VoucherVoidedTransaction = VoucherTransaction & {
  __typename?: 'VoucherVoidedTransaction';
  _id: Scalars['ObjectId']['output'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']['output']>;
  reason: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

/** A Tour that a Customer has added to their Wishlist */
export type WishlistItem = {
  __typename?: 'WishlistItem';
  _id: Scalars['ObjectId']['output'];
  businessCode?: Maybe<BusinessCode>;
  customerId: Scalars['ObjectId']['output'];
  tourCode: Scalars['String']['output'];
};

export type WishlistItemRemovedResult = {
  __typename?: 'WishlistItemRemovedResult';
  removedId: Scalars['ObjectId']['output'];
};

export type MobileAppCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type MobileAppCustomerQuery = { __typename?: 'Query', me?: { __typename?: 'Customer', _id: string, savedPaymentMethods: Array<{ __typename?: 'SavedPaymentMethod', _id: string, isActive: boolean, isExpired: boolean, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } }> } | { __typename?: 'Employee', _id: string } | { __typename?: 'TourDirector', _id: string } | null };

export type BookingQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type BookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', _id: string, customer?: { __typename?: 'Customer', email?: string | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, salesTourId: string, status: DepartureStatus, tourCode: string, startGatewayCode: string, finalInstallmentDeadline: string, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, nbDaysWithExtension?: number | null, includesBreakfast?: boolean | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null, equipment?: Array<{ __typename?: 'TourEquipmentContent', name?: string | null }> | null, tour?: { __typename?: 'Tour', _id: string, places: Array<{ __typename?: 'City', _id: string, type: PlaceType } | { __typename?: 'Continent', _id: string, type: PlaceType } | { __typename?: 'Country', _id: string, type: PlaceType } | { __typename?: 'CountryRegion', _id: string, type: PlaceType } | { __typename?: 'GeographicRegion', _id: string, type: PlaceType }>, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, description?: string | null, roomingDescription?: string | null, roomingDetailedDescription?: string | null, roomingUpgradeDescription?: string | null } | null, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', name?: string | null, description?: string | null, nbNights?: number | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, isLandOnly: boolean, isPrimary: boolean, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string } }>, insurancePlan: { __typename?: 'InsurancePlan', _id: string } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, grandTotal: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null } | null };

export type BookingDepartureFragment = { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, salesTourId: string, status: DepartureStatus, tourCode: string, startGatewayCode: string, finalInstallmentDeadline: string, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, nbDaysWithExtension?: number | null, includesBreakfast?: boolean | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null, equipment?: Array<{ __typename?: 'TourEquipmentContent', name?: string | null }> | null, tour?: { __typename?: 'Tour', _id: string, places: Array<{ __typename?: 'City', _id: string, type: PlaceType } | { __typename?: 'Continent', _id: string, type: PlaceType } | { __typename?: 'Country', _id: string, type: PlaceType } | { __typename?: 'CountryRegion', _id: string, type: PlaceType } | { __typename?: 'GeographicRegion', _id: string, type: PlaceType }>, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, description?: string | null, roomingDescription?: string | null, roomingDetailedDescription?: string | null, roomingUpgradeDescription?: string | null } | null, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', name?: string | null, description?: string | null, nbNights?: number | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null };

export type BookingFragmentFragment = { __typename?: 'Booking', _id: string, customer?: { __typename?: 'Customer', email?: string | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, salesTourId: string, status: DepartureStatus, tourCode: string, startGatewayCode: string, finalInstallmentDeadline: string, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, nbDaysWithExtension?: number | null, includesBreakfast?: boolean | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null, equipment?: Array<{ __typename?: 'TourEquipmentContent', name?: string | null }> | null, tour?: { __typename?: 'Tour', _id: string, places: Array<{ __typename?: 'City', _id: string, type: PlaceType } | { __typename?: 'Continent', _id: string, type: PlaceType } | { __typename?: 'Country', _id: string, type: PlaceType } | { __typename?: 'CountryRegion', _id: string, type: PlaceType } | { __typename?: 'GeographicRegion', _id: string, type: PlaceType }>, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, description?: string | null, roomingDescription?: string | null, roomingDetailedDescription?: string | null, roomingUpgradeDescription?: string | null } | null, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', name?: string | null, description?: string | null, nbNights?: number | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, isLandOnly: boolean, isPrimary: boolean, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string } }>, insurancePlan: { __typename?: 'InsurancePlan', _id: string } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, grandTotal: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null };

export type BookingTripFragment = { __typename?: 'BookingTrip', _id: string, departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, isLandOnly: boolean, isPrimary: boolean, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string } }>, insurancePlan: { __typename?: 'InsurancePlan', _id: string } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> };

export type CheckoutDepartureQueryVariables = Exact<{
  departureId: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type CheckoutDepartureQuery = { __typename?: 'Query', departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, salesTourId: string, status: DepartureStatus, tourCode: string, autoApproveDeadline: string, flightsRequestDeadline?: string | null, startGatewayCode: string, finalInstallmentDeadline: string, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, isPurchasable: boolean, capacity: number, nbSpotsBooked: number, lineItemCode: string, cabinCode?: any | null, status: DepartureStatus, bed: { __typename?: 'TourBed', code: TourBedCode, capacity: number, count: number, name: string }, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, content?: { __typename?: 'RoomContent', name?: string | null, description?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, lineItemCode: string, status: DepartureStatus, isPreExtension: boolean, endDate: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, isPurchasable: boolean, capacity: number, nbSpotsBooked: number, lineItemCode: string, cabinCode?: any | null, status: DepartureStatus, bed: { __typename?: 'TourBed', code: TourBedCode, capacity: number, count: number, name: string }, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, content?: { __typename?: 'RoomContent', name?: string | null, description?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', status: DepartureStatus, lineItemCode: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', name?: string | null, description?: string | null, nbNights?: number | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', status: DepartureStatus, lineItemCode: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, nbDaysWithExtension?: number | null, includesBreakfast?: boolean | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null, equipment?: Array<{ __typename?: 'TourEquipmentContent', name?: string | null }> | null, tour?: { __typename?: 'Tour', _id: string, places: Array<{ __typename?: 'City', _id: string, type: PlaceType } | { __typename?: 'Continent', _id: string, type: PlaceType } | { __typename?: 'Country', _id: string, type: PlaceType } | { __typename?: 'CountryRegion', _id: string, type: PlaceType } | { __typename?: 'GeographicRegion', _id: string, type: PlaceType }>, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, description?: string | null, roomingDescription?: string | null, roomingDetailedDescription?: string | null, roomingUpgradeDescription?: string | null } | null, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null };

export type CheckoutDepartureFragment = { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, salesTourId: string, status: DepartureStatus, tourCode: string, autoApproveDeadline: string, flightsRequestDeadline?: string | null, startGatewayCode: string, finalInstallmentDeadline: string, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, isPurchasable: boolean, capacity: number, nbSpotsBooked: number, lineItemCode: string, cabinCode?: any | null, status: DepartureStatus, bed: { __typename?: 'TourBed', code: TourBedCode, capacity: number, count: number, name: string }, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, content?: { __typename?: 'RoomContent', name?: string | null, description?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, lineItemCode: string, status: DepartureStatus, isPreExtension: boolean, endDate: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, isPurchasable: boolean, capacity: number, nbSpotsBooked: number, lineItemCode: string, cabinCode?: any | null, status: DepartureStatus, bed: { __typename?: 'TourBed', code: TourBedCode, capacity: number, count: number, name: string }, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, content?: { __typename?: 'RoomContent', name?: string | null, description?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', status: DepartureStatus, lineItemCode: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', name?: string | null, description?: string | null, nbNights?: number | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', status: DepartureStatus, lineItemCode: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, nbDaysWithExtension?: number | null, includesBreakfast?: boolean | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null, equipment?: Array<{ __typename?: 'TourEquipmentContent', name?: string | null }> | null, tour?: { __typename?: 'Tour', _id: string, places: Array<{ __typename?: 'City', _id: string, type: PlaceType } | { __typename?: 'Continent', _id: string, type: PlaceType } | { __typename?: 'Country', _id: string, type: PlaceType } | { __typename?: 'CountryRegion', _id: string, type: PlaceType } | { __typename?: 'GeographicRegion', _id: string, type: PlaceType }>, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, description?: string | null, roomingDescription?: string | null, roomingDetailedDescription?: string | null, roomingUpgradeDescription?: string | null } | null, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null };

export type DraftQuoteQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type DraftQuoteQuery = { __typename?: 'Query', draftOrder?: { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | null };

export type GuardBookingQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type GuardBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', _id: string } | null };

export type SetDraftQuoteCustomerMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
  existingCustomerInput?: InputMaybe<TripExistingCustomerInput>;
  newCustomerInput?: InputMaybe<TripNewCustomerInput>;
  language: Scalars['String']['input'];
}>;


export type SetDraftQuoteCustomerMutation = { __typename?: 'Mutation', setDraftQuoteCustomer: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type UpdateDraftQuoteSavedMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  input: UpdateDraftQuoteSavedInput;
}>;


export type UpdateDraftQuoteSavedMutation = { __typename?: 'Mutation', updateDraftQuoteSaved: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type AddDraftOrderPromoMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  promoCode: Scalars['String']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  language: Scalars['String']['input'];
}>;


export type AddDraftOrderPromoMutation = { __typename?: 'Mutation', addDraftOrderPromo: { __typename: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename: 'InvalidDateError', code: string, message: string } | { __typename: 'InvalidOrderError', code: string, message: string } | { __typename: 'InvalidPromoError', code: string, message: string } | { __typename: 'NotAuthorizedError', code: string, message: string } | { __typename: 'NotFoundError', code: string, message: string } | { __typename: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type RemoveDraftOrderPromoMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  lineItemCode: Scalars['LineItemCode']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  language: Scalars['String']['input'];
}>;


export type RemoveDraftOrderPromoMutation = { __typename?: 'Mutation', removeDraftOrderPromo: { __typename: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename: 'InvalidDateError', code: string, message: string } | { __typename: 'InvalidOrderError', code: string, message: string } | { __typename: 'NotAuthorizedError', code: string, message: string } | { __typename: 'NotFoundError', code: string, message: string } | { __typename: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type UpdateDraftOrderRequestedRoommatesMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  requestedRoommates: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tripId: Scalars['ObjectId']['input'];
}>;


export type UpdateDraftOrderRequestedRoommatesMutation = { __typename?: 'Mutation', updateDraftOrderRequestedRoommates: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type AddDraftOrderInsuranceAddonMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderInsuranceAddonInput> | AddDraftOrderInsuranceAddonInput;
  language: Scalars['String']['input'];
}>;


export type AddDraftOrderInsuranceAddonMutation = { __typename?: 'Mutation', addDraftOrderInsuranceAddon: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type RemoveDraftOrderInsuranceMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  language: Scalars['String']['input'];
}>;


export type RemoveDraftOrderInsuranceMutation = { __typename?: 'Mutation', removeDraftOrderInsurance: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type RemoveDraftOrderInsuranceAddonMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  lineItemCode: Scalars['LineItemCode']['input'];
  language: Scalars['String']['input'];
}>;


export type RemoveDraftOrderInsuranceAddonMutation = { __typename?: 'Mutation', removeDraftOrderInsuranceAddon: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type UpdateDraftOrderInsuranceMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  addOnLineItemCodes?: InputMaybe<Array<Scalars['LineItemCode']['input']> | Scalars['LineItemCode']['input']>;
  lineItemCode: Scalars['LineItemCode']['input'];
  language: Scalars['String']['input'];
}>;


export type UpdateDraftOrderInsuranceMutation = { __typename?: 'Mutation', updateDraftOrderInsurance: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type AddDraftOrderExcursionMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderExcursionInput> | AddDraftOrderExcursionInput;
  language: Scalars['String']['input'];
}>;


export type AddDraftOrderExcursionMutation = { __typename?: 'Mutation', addDraftOrderExcursions: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type AddDraftOrderExcursionsMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderExcursionInput> | AddDraftOrderExcursionInput;
  language: Scalars['String']['input'];
}>;


export type AddDraftOrderExcursionsMutation = { __typename?: 'Mutation', addDraftOrderExcursions: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type RemoveDraftOrderExcursionMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  lineItemCode: Scalars['LineItemCode']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  language: Scalars['String']['input'];
}>;


export type RemoveDraftOrderExcursionMutation = { __typename?: 'Mutation', removeDraftOrderExcursion: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type RemoveDraftOrderExcursionsMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tourTypes: Array<ExcursionTourType> | ExcursionTourType;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  language: Scalars['String']['input'];
}>;


export type RemoveDraftOrderExcursionsMutation = { __typename?: 'Mutation', removeDraftOrderExcursions: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type UpdateDraftOrderFlightPackagesMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftOrderFlightPackageInput> | UpdateDraftOrderFlightPackageInput;
  language: Scalars['String']['input'];
}>;


export type UpdateDraftOrderFlightPackagesMutation = { __typename?: 'Mutation', updateDraftOrderFlightPackages: { __typename: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename: 'InvalidDateError', code: string, message: string } | { __typename: 'InvalidFlightPackageError', code: string, message: string } | { __typename: 'InvalidOrderError', code: string, message: string } | { __typename: 'NotAuthorizedError', code: string, message: string } | { __typename: 'NotFoundError', code: string, message: string } | { __typename: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type UpdateDraftOrderExtensionRoomsMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftOrderRoomInput> | UpdateDraftOrderRoomInput;
  language: Scalars['String']['input'];
}>;


export type UpdateDraftOrderExtensionRoomsMutation = { __typename?: 'Mutation', updateDraftOrderExtensionRooms: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidDepartureError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type UpdateDraftOrderRoomsMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  inputs: Array<UpdateDraftOrderRoomInput> | UpdateDraftOrderRoomInput;
  language: Scalars['String']['input'];
}>;


export type UpdateDraftOrderRoomsMutation = { __typename?: 'Mutation', updateDraftOrderRooms: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type AddDraftOrderExtensionMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  lineItemCode: Scalars['LineItemCode']['input'];
  language: Scalars['String']['input'];
}>;


export type AddDraftOrderExtensionMutation = { __typename?: 'Mutation', addDraftOrderExtension: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type RemoveDraftOrderExtensionMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  language: Scalars['String']['input'];
}>;


export type RemoveDraftOrderExtensionMutation = { __typename?: 'Mutation', removeDraftOrderExtension: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type AcceptTripTermsAtCheckoutMutationVariables = Exact<{
  bookingId: Scalars['ObjectId']['input'];
  termId: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
}>;


export type AcceptTripTermsAtCheckoutMutation = { __typename?: 'Mutation', acceptTripTerms: { __typename?: 'Booking', _id: string } | { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidTermError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError', message: string } };

export type PayAndBookMutationVariables = Exact<{
  input: PayAndBookInput;
  quoteId: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type PayAndBookMutation = { __typename?: 'Mutation', payAndBook: { __typename?: 'Booking', _id: string, customer?: { __typename?: 'Customer', email?: string | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, salesTourId: string, status: DepartureStatus, tourCode: string, startGatewayCode: string, finalInstallmentDeadline: string, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, nbDaysWithExtension?: number | null, includesBreakfast?: boolean | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null, equipment?: Array<{ __typename?: 'TourEquipmentContent', name?: string | null }> | null, tour?: { __typename?: 'Tour', _id: string, places: Array<{ __typename?: 'City', _id: string, type: PlaceType } | { __typename?: 'Continent', _id: string, type: PlaceType } | { __typename?: 'Country', _id: string, type: PlaceType } | { __typename?: 'CountryRegion', _id: string, type: PlaceType } | { __typename?: 'GeographicRegion', _id: string, type: PlaceType }>, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, description?: string | null, roomingDescription?: string | null, roomingDetailedDescription?: string | null, roomingUpgradeDescription?: string | null } | null, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', name?: string | null, description?: string | null, nbNights?: number | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, isLandOnly: boolean, isPrimary: boolean, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string } }>, insurancePlan: { __typename?: 'InsurancePlan', _id: string } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, grandTotal: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null } | { __typename?: 'BusinessNotSpecifiedError', message: string } | { __typename?: 'DepartureNotBookableError', message: string } | { __typename?: 'DuplicateUniqueKeyError', message: string } | { __typename?: 'InvalidDateError', message: string } | { __typename?: 'InvalidDepartureError', message: string } | { __typename?: 'InvalidOrderError', message: string } | { __typename?: 'InvalidPaymentError', message: string } | { __typename?: 'NotAuthorizedError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'ValidationError', message: string } };

export type PublishDraftQuoteMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type PublishDraftQuoteMutation = { __typename?: 'Mutation', publishDraftQuote: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidDepartureError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'Quote', _id: string, rebookedFromOrderId?: string | null, balance: { __typename?: 'Money', value: number }, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type SetDraftQuoteTravelerWithAddressMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
  tsaInformation: TsaInformationInput;
  address: AddressInput;
  language: Scalars['String']['input'];
}>;


export type SetDraftQuoteTravelerWithAddressMutation = { __typename?: 'Mutation', updateDraftOrderTsaInformation: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string }, updateDraftOrderAddress: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type CheckoutUpdateDraftOrderTsaInformationMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
  tsaInformation: TsaInformationInput;
  language: Scalars['String']['input'];
}>;


export type CheckoutUpdateDraftOrderTsaInformationMutation = { __typename?: 'Mutation', updateDraftOrderTsaInformation: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type UpdatePrimaryTripCustomerPhoneNumberMutationVariables = Exact<{
  customerId: Scalars['ObjectId']['input'];
  input: UpdateCustomerPhoneNumberInput;
}>;


export type UpdatePrimaryTripCustomerPhoneNumberMutation = { __typename?: 'Mutation', updateCustomerPhoneNumber: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type RebookingQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type RebookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', _id: string, stage: OrderStage, customer?: { __typename?: 'Customer', _id: string } | null, departure?: { __typename?: 'Departure', _id: string, tourContent?: { __typename?: 'TourContent', name?: string | null } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', name?: string | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, status: TripStatus, isPrimary: boolean, isRebooked: boolean, hasExtension: boolean, departureDate: string, endDate: string }> } | null };

export type EntryRequirementsToursQueryVariables = Exact<{
  filter?: InputMaybe<FilterTourInput>;
  language: Scalars['String']['input'];
  pagination?: InputMaybe<PaginateInput>;
}>;


export type EntryRequirementsToursQuery = { __typename?: 'Query', tours: { __typename?: 'TourPaginatedResult', results: Array<{ __typename?: 'Tour', _id: string, overnightCountries: Array<{ __typename?: 'Country', _id: string, alpha3Code: string }>, content?: { __typename?: 'TourContent', id: string, name?: string | null } | null, extensions: Array<{ __typename?: 'TourExtension', _id: string, overnightCountries: Array<{ __typename?: 'Country', _id: string, alpha3Code: string }>, content?: { __typename?: 'TourExtensionContent', id: string, name?: string | null } | null }> }> } };

export type AcceptGcDepartureTermsMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  termId: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type AcceptGcDepartureTermsMutation = { __typename?: 'Mutation', acceptGCDepartureTerms: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'InvalidTermError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type AcceptTripTermsMutationVariables = Exact<{
  bookingId: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
  termId: Scalars['ObjectId']['input'];
}>;


export type AcceptTripTermsMutation = { __typename?: 'Mutation', acceptTripTerms: { __typename?: 'Booking', _id: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, hasSignedTerms: boolean, termsAcceptedAt?: string | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null }> } | { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidTermError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type AddDraftBookingPaymentScheduleMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  paymentSchedule: PaymentScheduleInput;
}>;


export type AddDraftBookingPaymentScheduleMutation = { __typename?: 'Mutation', addDraftBookingPaymentSchedule: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'InvalidPaymentError' } | { __typename?: 'InvalidPaymentScheduleError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type BasicCustomerFragment = { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null };

export type BasicOldTripFragment = { __typename?: 'OldTrip', _id: string, tourInternalName?: string | null, tourCode: string, startDate?: string | null, endDate?: string | null };

export type BookingCustomerFragment = { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null };

export type BookingSummaryInsurancePlanOfferFragment = { __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, name?: string | null }> } | null };

export type CancelPaymentScheduleMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type CancelPaymentScheduleMutation = { __typename?: 'Mutation', cancelDraftBookingPaymentSchedule: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'InvalidPaymentError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type CustomerWithPaymentFragment = { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, savedPaymentMethods: Array<{ __typename?: 'SavedPaymentMethod', _id: string, isActive: boolean, isExpired: boolean, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, loyaltyLevel?: { __typename?: 'LoyaltyLevel', _id: string, repeatPromoCode?: string | null, content?: { __typename?: 'LoyaltyLevelContent', name?: string | null, icon?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, repeatDiscount?: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } | null, returnWindowDiscount?: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } | null } | null };

export type EmergencyContactFragment = { __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship };

export type FeePriceQueryVariables = Exact<{
  departureId: Scalars['ObjectId']['input'];
  currencyCode: CurrencyCode;
  departureDate: Scalars['Date']['input'];
  feeTypeCode: FeeTypeCode;
}>;


export type FeePriceQuery = { __typename?: 'Query', departure?: { __typename?: 'Departure', _id: string, tour?: { __typename?: 'Tour', _id: string, feePrice?: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } | null } | null } | null };

export type GcDepartureFragment = { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null };

export type LightMeQueryVariables = Exact<{
  businessCode: BusinessCode;
  language: Scalars['String']['input'];
}>;


export type LightMeQuery = { __typename?: 'Query', me?: { __typename?: 'Customer', hasGCDepartures: boolean, _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, confirmedTrips: Array<{ __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, dateBooked: string, departureDate: string, endDate: string, isLandOnly: boolean, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, dpd: number, tourCode: string, timingStatus: DepartureTimingStatus, status: DepartureStatus, activeExtension?: { __typename?: 'DepartureExtension', _id: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, gcDeparture?: { __typename?: 'GCDeparture', _id: string, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, isPrimary: boolean, customerType: TripCustomerType, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null }> } | null, review?: { __typename?: 'Review', _id: string } | null, evaluationRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean, releaseDate?: string | null } | null, evaluation?: { __typename?: 'CustomerEvaluation', _id: string, hasBeenStarted: boolean, submissionDate?: string | null, finalizationDate?: string | null, deadlineDate: string, availabilityDate: string } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, flights?: { __typename?: 'TripFlights', hasFullItinerary: boolean, isFullyTicketed: boolean, departingFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }>, returningFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }> } | null }>, waitlistedTrips: Array<{ __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, dateBooked: string, departureDate: string, endDate: string, isLandOnly: boolean, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, dpd: number, tourCode: string, timingStatus: DepartureTimingStatus, status: DepartureStatus, activeExtension?: { __typename?: 'DepartureExtension', _id: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, gcDeparture?: { __typename?: 'GCDeparture', _id: string, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, isPrimary: boolean, customerType: TripCustomerType, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null }> } | null, review?: { __typename?: 'Review', _id: string } | null, evaluationRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean, releaseDate?: string | null } | null, evaluation?: { __typename?: 'CustomerEvaluation', _id: string, hasBeenStarted: boolean, submissionDate?: string | null, finalizationDate?: string | null, deadlineDate: string, availabilityDate: string } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, flights?: { __typename?: 'TripFlights', hasFullItinerary: boolean, isFullyTicketed: boolean, departingFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }>, returningFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }> } | null }>, requestedTrips: Array<{ __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, dateBooked: string, departureDate: string, endDate: string, isLandOnly: boolean, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, dpd: number, tourCode: string, timingStatus: DepartureTimingStatus, status: DepartureStatus, activeExtension?: { __typename?: 'DepartureExtension', _id: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, gcDeparture?: { __typename?: 'GCDeparture', _id: string, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, isPrimary: boolean, customerType: TripCustomerType, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null }> } | null, review?: { __typename?: 'Review', _id: string } | null, evaluationRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean, releaseDate?: string | null } | null, evaluation?: { __typename?: 'CustomerEvaluation', _id: string, hasBeenStarted: boolean, submissionDate?: string | null, finalizationDate?: string | null, deadlineDate: string, availabilityDate: string } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, flights?: { __typename?: 'TripFlights', hasFullItinerary: boolean, isFullyTicketed: boolean, departingFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }>, returningFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }> } | null }>, pendingRebookingTrips: Array<{ __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, dateBooked: string, departureDate: string, endDate: string, isLandOnly: boolean, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, dpd: number, tourCode: string, timingStatus: DepartureTimingStatus, status: DepartureStatus, activeExtension?: { __typename?: 'DepartureExtension', _id: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, gcDeparture?: { __typename?: 'GCDeparture', _id: string, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, isPrimary: boolean, customerType: TripCustomerType, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null }> } | null, review?: { __typename?: 'Review', _id: string } | null, evaluationRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean, releaseDate?: string | null } | null, evaluation?: { __typename?: 'CustomerEvaluation', _id: string, hasBeenStarted: boolean, submissionDate?: string | null, finalizationDate?: string | null, deadlineDate: string, availabilityDate: string } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, flights?: { __typename?: 'TripFlights', hasFullItinerary: boolean, isFullyTicketed: boolean, departingFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }>, returningFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }> } | null }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null } | { __typename?: 'Employee', _id: string } | { __typename?: 'TourDirector', _id: string } | null };

export type MakeAPaymentMutationVariables = Exact<{
  bookingId: Scalars['ObjectId']['input'];
  payments: Array<PaymentInput> | PaymentInput;
  language: Scalars['String']['input'];
}>;


export type MakeAPaymentMutation = { __typename?: 'Mutation', makeAPayment: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, finalPaymentDate: string, latestFinalPaymentDate: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, transactions: Array<{ __typename?: 'CreditPaymentTransaction', reasonCode: CreditReasonCode, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } } | { __typename?: 'DebitPaymentTransaction', paymentScheduleId?: string | null, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } }>, activePaymentSchedule?: { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> } | null, gcDeparture?: { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, type: BookingPaymentOptionType } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, balance: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, amountPaid: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, minimumAmountDue: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } } | { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidAmountError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'InvalidPaymentError' } | { __typename?: 'InvalidPaymentScheduleError' } | { __typename?: 'InvalidVoucherError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type MeBookingDepartureFragment = { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, startGatewayCode: string, tourCode: string, finalInstallmentDeadline: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null };

export type BookingDepartureRoomFragment = { __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null };

export type MeBookingFragment = { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, finalPaymentDate: string, latestFinalPaymentDate: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, transactions: Array<{ __typename?: 'CreditPaymentTransaction', reasonCode: CreditReasonCode, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } } | { __typename?: 'DebitPaymentTransaction', paymentScheduleId?: string | null, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } }>, activePaymentSchedule?: { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> } | null, gcDeparture?: { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, type: BookingPaymentOptionType } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, balance: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, amountPaid: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, minimumAmountDue: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } };

export type MeBookingTripQueryVariables = Exact<{
  tripId: Scalars['ObjectId']['input'];
}>;


export type MeBookingTripQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } } | null };

export type MeBookingTripFragment = { __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } };

export type MeBookingTripWithBookingQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type MeBookingTripWithBookingQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, startGatewayCode: string, tourCode: string, finalInstallmentDeadline: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, finalPaymentDate: string, latestFinalPaymentDate: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, transactions: Array<{ __typename?: 'CreditPaymentTransaction', reasonCode: CreditReasonCode, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } } | { __typename?: 'DebitPaymentTransaction', paymentScheduleId?: string | null, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } }>, activePaymentSchedule?: { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> } | null, gcDeparture?: { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, type: BookingPaymentOptionType } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, balance: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, amountPaid: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, minimumAmountDue: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, name?: string | null }> } | null }>, review?: { __typename?: 'Review', _id: string } | null } | null };

export type MeBookingTripWithBookingFragment = { __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, startGatewayCode: string, tourCode: string, finalInstallmentDeadline: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, finalPaymentDate: string, latestFinalPaymentDate: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, transactions: Array<{ __typename?: 'CreditPaymentTransaction', reasonCode: CreditReasonCode, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } } | { __typename?: 'DebitPaymentTransaction', paymentScheduleId?: string | null, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } }>, activePaymentSchedule?: { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> } | null, gcDeparture?: { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, type: BookingPaymentOptionType } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, balance: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, amountPaid: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, minimumAmountDue: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, name?: string | null }> } | null }>, review?: { __typename?: 'Review', _id: string } | null };

export type MeBookingTripWithDepartureQueryVariables = Exact<{
  tripId: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type MeBookingTripWithDepartureQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, startGatewayCode: string, tourCode: string, finalInstallmentDeadline: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } } | null };

export type MyAccountBasicBookingFragment = { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, gcDeparture?: { __typename?: 'GCDeparture', _id: string, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, isPrimary: boolean, customerType: TripCustomerType, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null }> };

export type MyAccountBasicDepartureFragment = { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, dpd: number, tourCode: string, timingStatus: DepartureTimingStatus, status: DepartureStatus, activeExtension?: { __typename?: 'DepartureExtension', _id: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null };

export type MyAccountBasicMyTripFragment = { __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, dateBooked: string, departureDate: string, endDate: string, isLandOnly: boolean, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, dpd: number, tourCode: string, timingStatus: DepartureTimingStatus, status: DepartureStatus, activeExtension?: { __typename?: 'DepartureExtension', _id: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, gcDeparture?: { __typename?: 'GCDeparture', _id: string, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, isPrimary: boolean, customerType: TripCustomerType, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null }> } | null, review?: { __typename?: 'Review', _id: string } | null, evaluationRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean, releaseDate?: string | null } | null, evaluation?: { __typename?: 'CustomerEvaluation', _id: string, hasBeenStarted: boolean, submissionDate?: string | null, finalizationDate?: string | null, deadlineDate: string, availabilityDate: string } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null } | null, flights?: { __typename?: 'TripFlights', hasFullItinerary: boolean, isFullyTicketed: boolean, departingFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }>, returningFlights: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }> } | null };

export type MyAccountTripWithChecklistFragment = { __typename?: 'BookingTrip', _id: string, isPrimary: boolean, customerType: TripCustomerType, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null };

export type MyGcDeparturesQueryVariables = Exact<{
  language: Scalars['String']['input'];
  filter?: InputMaybe<FilterGcDepartureInput>;
}>;


export type MyGcDeparturesQuery = { __typename?: 'Query', gcDepartures: { __typename?: 'GCDeparturePaginatedResult', results: Array<{ __typename?: 'GCDeparture', _id: string, isNonBookedGroupCoordinator: boolean, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, dpd: number, tourCode: string, timingStatus: DepartureTimingStatus, status: DepartureStatus, activeExtension?: { __typename?: 'DepartureExtension', _id: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null }> } };

export type MyGlobalRewardsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGlobalRewardsSummaryQuery = { __typename?: 'Query', myGlobalRewardsSummary?: { __typename?: 'GlobalRewardsSummary', id: string, membershipLevelId: number, pointsActive: number, pointsPending: number } | null };

export type NoteFragment = { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null };

export type OldTripsQueryVariables = Exact<{
  businessCode: BusinessCode;
}>;


export type OldTripsQuery = { __typename?: 'Query', me?: { __typename?: 'Customer', _id: string, confirmedOldTrips: Array<{ __typename?: 'OldTrip', _id: string, tourInternalName?: string | null, tourCode: string, startDate?: string | null, endDate?: string | null }> } | { __typename?: 'Employee', _id: string } | { __typename?: 'TourDirector', _id: string } | null };

export type PaymentAndAddressQueryVariables = Exact<{
  businessCode: BusinessCode;
}>;


export type PaymentAndAddressQuery = { __typename?: 'Query', me?: { __typename?: 'Customer', _id: string, savedPaymentMethods: Array<{ __typename?: 'SavedPaymentMethod', _id: string, isActive: boolean, isExpired: boolean, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | { __typename?: 'Employee', _id: string } | { __typename?: 'TourDirector', _id: string } | null };

export type SavedQuoteFragment = { __typename?: 'Quote', _id: string, businessCode: BusinessCode, gcDepartureId?: string | null, isSaved?: boolean | null, expirationDate: string, isExpired: boolean, stage: OrderStage, customer?: { __typename?: 'Customer', _id: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', id?: number | null, filename?: string | null, alt?: string | null } | null } | null, tour?: { __typename?: 'Tour', _id: string, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', _id: string, isPrimary: boolean, hasExtension: boolean, departureDate: string, endDate: string, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer' } | null }> };

export type SavedQuoteDetailsQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type SavedQuoteDetailsQuery = { __typename?: 'Query', quote?: { __typename?: 'Quote', _id: string, businessCode: BusinessCode, gcDepartureId?: string | null, isSaved?: boolean | null, expirationDate: string, isExpired: boolean, stage: OrderStage, customer?: { __typename?: 'Customer', _id: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', id?: number | null, filename?: string | null, alt?: string | null } | null } | null, tour?: { __typename?: 'Tour', _id: string, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', _id: string, isPrimary: boolean, hasExtension: boolean, departureDate: string, endDate: string, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer' } | null }> } | null };

export type SavedQuotesQueryVariables = Exact<{
  filter?: InputMaybe<FilterQuoteInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortQuoteInput>;
  language: Scalars['String']['input'];
}>;


export type SavedQuotesQuery = { __typename?: 'Query', quotes: { __typename?: 'QuotePaginatedResult', hasNext: boolean, hasPrevious: boolean, next?: string | null, previous?: string | null, results: Array<{ __typename?: 'Quote', _id: string, businessCode: BusinessCode, gcDepartureId?: string | null, isSaved?: boolean | null, expirationDate: string, isExpired: boolean, stage: OrderStage, customer?: { __typename?: 'Customer', _id: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', id?: number | null, filename?: string | null, alt?: string | null } | null } | null, tour?: { __typename?: 'Tour', _id: string, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', _id: string, isPrimary: boolean, hasExtension: boolean, departureDate: string, endDate: string, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer' } | null }> }> } };

export type TermContentQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type TermContentQuery = { __typename?: 'Query', term?: { __typename?: 'Term', content?: { } | null } | null };

export type TooMuchDataMeQueryVariables = Exact<{
  businessCode: BusinessCode;
  language: Scalars['String']['input'];
}>;


export type TooMuchDataMeQuery = { __typename?: 'Query', me?: { __typename?: 'Customer', hasGCDepartures: boolean, _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, confirmedTrips: Array<{ __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, startGatewayCode: string, tourCode: string, finalInstallmentDeadline: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, finalPaymentDate: string, latestFinalPaymentDate: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, transactions: Array<{ __typename?: 'CreditPaymentTransaction', reasonCode: CreditReasonCode, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } } | { __typename?: 'DebitPaymentTransaction', paymentScheduleId?: string | null, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } }>, activePaymentSchedule?: { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> } | null, gcDeparture?: { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, type: BookingPaymentOptionType } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, balance: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, amountPaid: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, minimumAmountDue: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, name?: string | null }> } | null }>, review?: { __typename?: 'Review', _id: string } | null }>, waitlistedTrips: Array<{ __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, startGatewayCode: string, tourCode: string, finalInstallmentDeadline: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, finalPaymentDate: string, latestFinalPaymentDate: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, transactions: Array<{ __typename?: 'CreditPaymentTransaction', reasonCode: CreditReasonCode, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } } | { __typename?: 'DebitPaymentTransaction', paymentScheduleId?: string | null, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } }>, activePaymentSchedule?: { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> } | null, gcDeparture?: { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, type: BookingPaymentOptionType } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, balance: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, amountPaid: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, minimumAmountDue: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, name?: string | null }> } | null }>, review?: { __typename?: 'Review', _id: string } | null }>, requestedTrips: Array<{ __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, startGatewayCode: string, tourCode: string, finalInstallmentDeadline: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, finalPaymentDate: string, latestFinalPaymentDate: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, transactions: Array<{ __typename?: 'CreditPaymentTransaction', reasonCode: CreditReasonCode, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } } | { __typename?: 'DebitPaymentTransaction', paymentScheduleId?: string | null, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } }>, activePaymentSchedule?: { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> } | null, gcDeparture?: { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, type: BookingPaymentOptionType } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, balance: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, amountPaid: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, minimumAmountDue: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, name?: string | null }> } | null }>, review?: { __typename?: 'Review', _id: string } | null }>, pendingRebookingTrips: Array<{ __typename?: 'BookingTrip', _id: string, timingStatus: TripTimingStatus, customerType: TripCustomerType, status: TripStatus, hasSignedTerms: boolean, canBeReviewed?: boolean | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, endDate: string, endGatewayCode: string, startGatewayCode: string, tourCode: string, finalInstallmentDeadline: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, status: DepartureStatus, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }> } | null, activeExtensionContent?: { __typename?: 'TourExtensionContent', id: string, tourCode?: string | null, name?: string | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null } | null }>, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, hotelsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, priceYear: { __typename?: 'PriceYear', year: number }, tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null } | null, tour?: { __typename?: 'Tour', _id: string, nbTourDays: number, classLevel: number, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null } | null, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, finalPaymentDate: string, latestFinalPaymentDate: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, customerType: TripCustomerType, currencyCode: CurrencyCode, timingStatus: TripTimingStatus, tsaIdentifiersSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, endDate: string, passportInformationSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, checklistItems: Array<{ __typename?: 'TripChecklistItem', description: string, dueDate: string, id: string, checklistItemTemplateId: string, importanceLevel: CheckListItemImportanceLevel, internalName: string, isChecked: boolean, status: TripChecklistItemStatus, title: string }>, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', departureDate: string, endDate: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openFeeLineItems: Array<{ __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openPrivateGroupLineItem?: { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openAdjustmentLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, departureGateway?: { __typename?: 'Gateway', internalCityName: string, cityCode: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openPromoLineItems: Array<{ __typename?: 'PromoLineItem', promoCode: string, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, transactions: Array<{ __typename?: 'CreditPaymentTransaction', reasonCode: CreditReasonCode, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } } | { __typename?: 'DebitPaymentTransaction', paymentScheduleId?: string | null, _id: string, transactionDate: string, displayStatus: PaymentTransactionDisplayStatus, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'AffirmPaymentMethod' } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CheckPaymentMethod' } | { __typename?: 'EFTransferPaymentMethod' } | { __typename?: 'TransferPaymentMethod' } | { __typename?: 'VoucherPaymentMethod' } }>, activePaymentSchedule?: { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> } | null, gcDeparture?: { __typename?: 'GCDeparture', _id: string, nbTravelersWithExtension: number, nbTravelersConfirmed: number, nbTravelersCancelled: number, departure?: { __typename?: 'Departure', nbSpotsLeft: number } | null, micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null } | null } | null, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, type: BookingPaymentOptionType } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, balance: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, amountPaid: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, grandTotal: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode }, minimumAmountDue: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, name?: string | null }> } | null }>, review?: { __typename?: 'Review', _id: string } | null }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, savedPaymentMethods: Array<{ __typename?: 'SavedPaymentMethod', _id: string, isActive: boolean, isExpired: boolean, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, loyaltyLevel?: { __typename?: 'LoyaltyLevel', _id: string, repeatPromoCode?: string | null, content?: { __typename?: 'LoyaltyLevelContent', name?: string | null, icon?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, repeatDiscount?: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } | null, returnWindowDiscount?: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } | null } | null } | { __typename?: 'Employee', _id: string } | { __typename?: 'TourDirector', _id: string } | null };

export type TsaInfoFragmentFragment = { __typename?: 'TSAInformation', _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null };

export type UpdateDraftBookingPaymentScheduleMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  frequency: PaymentScheduleFrequency;
  startDate: Scalars['Date']['input'];
}>;


export type UpdateDraftBookingPaymentScheduleMutation = { __typename?: 'Mutation', updateDraftBookingPaymentSchedule: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string } } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'InvalidPaymentError' } | { __typename?: 'InvalidPaymentScheduleError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type UpdateDraftBookingPaymentSchedulePaymentMethodMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  paymentSchedulePaymentMethod: PaymentSchedulePaymentMethodInput;
}>;


export type UpdateDraftBookingPaymentSchedulePaymentMethodMutation = { __typename?: 'Mutation', updateDraftBookingPaymentSchedulePaymentMethod: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string } } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'InvalidPaymentError' } | { __typename?: 'InvalidPaymentScheduleError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type UpdateDraftOrderEmergencyContactsMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  emergencyContacts: Array<EmergencyContactInput> | EmergencyContactInput;
  tripId: Scalars['ObjectId']['input'];
}>;


export type UpdateDraftOrderEmergencyContactsMutation = { __typename?: 'Mutation', updateDraftOrderEmergencyContacts: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type UpdateDraftOrderTravelerNotesMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
  input: TravelerNotesInput;
}>;


export type UpdateDraftOrderTravelerNotesMutation = { __typename?: 'Mutation', updateDraftOrderTravelerNotes: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', trips: Array<{ __typename?: 'BookingTrip', travelerNotes?: { __typename?: 'TravelerNotes', _id: string } | null }> } | { __typename?: 'Quote', trips: Array<{ __typename?: 'QuoteTrip', travelerNotes?: { __typename?: 'TravelerNotes', _id: string } | null }> } } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type UpdateDraftOrderTsaInformationMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
  tsaInformation: TsaInformationInput;
}>;


export type UpdateDraftOrderTsaInformationMutation = { __typename?: 'Mutation', updateDraftOrderTsaInformation: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type UpdateQuoteSavedMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  input: UpdateQuoteSavedInput;
}>;


export type UpdateQuoteSavedMutation = { __typename?: 'Mutation', updateQuoteSaved: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'Quote', _id: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type BookedGroupMembersTripsQueryVariables = Exact<{
  gcDepartureId: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type BookedGroupMembersTripsQuery = { __typename?: 'Query', gcDeparture?: { __typename?: 'GCDeparture', _id: string, flightsReleasedDate?: string | null, groupCoordinatorCustomerId: string, nbTravelersConfirmed: number, nbTravelersCancelled: number, nbTravelersWithExtension: number, nbTravelersWithInsurance: number, departure?: { __typename?: 'Departure', _id: string, departureDate: string, nbSpotsLeft: number, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', id: string, name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', id: string, name?: string | null } | null }>, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, bed: { __typename?: 'TourBed', code: TourBedCode, name: string } }> } | null, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null, isReleased: boolean } | null, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, bed: { __typename?: 'TourBed', code: TourBedCode, name: string } }> } | null, confirmedTrips?: Array<{ __typename?: 'BookingTrip', _id: string, status: TripStatus, isPrimary: boolean, dateBooked: string, isLandOnly: boolean, hasInsurance: boolean, hasSignedTerms: boolean, hasTsaInformation: boolean, customer?: { __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNumber?: string | null, address?: { __typename?: 'Address', street1: string, street2?: string | null, city: string, state: string, country: string, postalCode: string } | null } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', lineItemCode: string } | null, openRoomLineItem?: { __typename?: 'TourRoomLineItem', lineItemCode: string } | null, booking?: { __typename?: 'Booking', _id: string, finalPaymentDate: string, latestFinalPaymentDate: string, isEnrolledInAutopay: boolean, balance: { __typename?: 'Money', formatted: string } } | null, lineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'FeeLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'InsuranceExtensionLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'PromoLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, departureGatewayCode: string, departureDate: string, departureGateway?: { __typename?: 'Gateway', _id: string, stateCode?: string | null, internalCityName: string } | null } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, departureDate: string } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, isPurchased: boolean, lineItemCode: string } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', isPurchased: boolean, type: TripComponentType, lineItemCode: string, _id: string }>, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string, type: TripComponentType, _id: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string, type: TripComponentType, _id: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null }> } | null }>, roommates?: Array<{ __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null }> | null, extensionRoommates?: Array<{ __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null }> | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, isPurchased: boolean, status: LineItemStatus } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, status: LineItemStatus, isPurchased: boolean, lineItemCode: string }> }> | null, requestedTrips?: Array<{ __typename?: 'BookingTrip', _id: string, status: TripStatus, isPrimary: boolean, dateBooked: string, isLandOnly: boolean, hasInsurance: boolean, hasSignedTerms: boolean, hasTsaInformation: boolean, customer?: { __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNumber?: string | null, address?: { __typename?: 'Address', street1: string, street2?: string | null, city: string, state: string, country: string, postalCode: string } | null } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', lineItemCode: string } | null, openRoomLineItem?: { __typename?: 'TourRoomLineItem', lineItemCode: string } | null, booking?: { __typename?: 'Booking', _id: string, finalPaymentDate: string, latestFinalPaymentDate: string, isEnrolledInAutopay: boolean, balance: { __typename?: 'Money', formatted: string } } | null, lineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'FeeLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'InsuranceExtensionLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'PromoLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, departureGatewayCode: string, departureDate: string, departureGateway?: { __typename?: 'Gateway', _id: string, stateCode?: string | null, internalCityName: string } | null } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, departureDate: string } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, isPurchased: boolean, lineItemCode: string } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', isPurchased: boolean, type: TripComponentType, lineItemCode: string, _id: string }>, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string, type: TripComponentType, _id: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string, type: TripComponentType, _id: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null }> } | null }>, roommates?: Array<{ __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null }> | null, extensionRoommates?: Array<{ __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null }> | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, isPurchased: boolean, status: LineItemStatus } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, status: LineItemStatus, isPurchased: boolean, lineItemCode: string }> }> | null, cancelledTrips?: Array<{ __typename?: 'BookingTrip', _id: string, dateBooked: string, customer?: { __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null, phoneNumber?: string | null, email?: string | null, address?: { __typename?: 'Address', street1: string, street2?: string | null, city: string, state: string, postalCode: string, country: string } | null } | null, cancellationMeta?: { __typename?: 'TripCancellationMeta', cancellationDate: string } | null }> | null } | null };

export type BulkCreateGroupMembersProspectsMutationVariables = Exact<{
  groupCoordinatorCustomerId: Scalars['ObjectId']['input'];
  input: Array<BulkCreateGcDepartureProspectsInput> | BulkCreateGcDepartureProspectsInput;
}>;


export type BulkCreateGroupMembersProspectsMutation = { __typename?: 'Mutation', bulkCreateGCDepartureProspects: { __typename?: 'BulkCreateGCDepartureProspectsSuccess', data: Array<{ __typename?: 'GCDepartureProspect', _id: string }> } | { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidGCDepartureError' } | { __typename?: 'InvalidGCDepartureProspectError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type CanceledGroupMemberDetailsFragment = { __typename?: 'BookingTrip', _id: string, dateBooked: string, customer?: { __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null, phoneNumber?: string | null, email?: string | null, address?: { __typename?: 'Address', street1: string, street2?: string | null, city: string, state: string, postalCode: string, country: string } | null } | null, cancellationMeta?: { __typename?: 'TripCancellationMeta', cancellationDate: string } | null };

export type ConfirmedRequestedGroupMemberTripsFragment = { __typename?: 'BookingTrip', _id: string, status: TripStatus, isPrimary: boolean, dateBooked: string, isLandOnly: boolean, hasInsurance: boolean, hasSignedTerms: boolean, hasTsaInformation: boolean, customer?: { __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNumber?: string | null, address?: { __typename?: 'Address', street1: string, street2?: string | null, city: string, state: string, country: string, postalCode: string } | null } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', lineItemCode: string } | null, openRoomLineItem?: { __typename?: 'TourRoomLineItem', lineItemCode: string } | null, booking?: { __typename?: 'Booking', _id: string, finalPaymentDate: string, latestFinalPaymentDate: string, isEnrolledInAutopay: boolean, balance: { __typename?: 'Money', formatted: string } } | null, lineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'FeeLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'InsuranceExtensionLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'PromoLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType } | { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, status: LineItemStatus, type: TripComponentType }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, departureGatewayCode: string, departureDate: string, departureGateway?: { __typename?: 'Gateway', _id: string, stateCode?: string | null, internalCityName: string } | null } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, departureDate: string } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, isPurchased: boolean, lineItemCode: string } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', isPurchased: boolean, type: TripComponentType, lineItemCode: string, _id: string }>, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', lineItemCode: string, type: TripComponentType, _id: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', lineItemCode: string, insurancePlanAddonCode: string, type: TripComponentType, _id: string } }>, content?: { __typename?: 'InsurancePlanContent', id: string, name?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null }> } | null }>, roommates?: Array<{ __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null }> | null, extensionRoommates?: Array<{ __typename?: 'Customer', _id: string, lastName?: string | null, firstName?: string | null }> | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, isPurchased: boolean, status: LineItemStatus } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, status: LineItemStatus, isPurchased: boolean, lineItemCode: string }> };

export type GroupDepartureExtensionExcursionFragment = { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', id: string, name?: string | null } | null };

export type GroupMemberProspectDetailsFragment = { __typename?: 'GCDepartureProspect', _id: string, firstName: string, lastName?: string | null, email?: string | null, phoneNumber?: string | null, createdAt?: string | null, levelOfInterest?: GcDepartureProspectLevelOfInterest | null, address?: { __typename?: 'Address', street1: string, street2?: string | null, city: string, state: string, postalCode: string, country: string } | null };

export type GroupMembersDepartureFragment = { __typename?: 'Departure', _id: string, departureDate: string, nbSpotsLeft: number, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', id: string, name?: string | null } | null }>, activeExtension?: { __typename?: 'DepartureExtension', _id: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', id: string, name?: string | null } | null }>, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, bed: { __typename?: 'TourBed', code: TourBedCode, name: string } }> } | null, flightsRelease?: { __typename?: 'ReleaseDetails', releaseDate?: string | null, isReleased: boolean } | null, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, bed: { __typename?: 'TourBed', code: TourBedCode, name: string } }> };

export type GroupMembersProspectsQueryVariables = Exact<{
  gcDepartureId: Scalars['ObjectId']['input'];
}>;


export type GroupMembersProspectsQuery = { __typename?: 'Query', gcDepartureProspects: { __typename?: 'GCDepartureProspectPaginatedResult', results: Array<{ __typename?: 'GCDepartureProspect', _id: string, firstName: string, lastName?: string | null, email?: string | null, phoneNumber?: string | null, createdAt?: string | null, levelOfInterest?: GcDepartureProspectLevelOfInterest | null, address?: { __typename?: 'Address', street1: string, street2?: string | null, city: string, state: string, postalCode: string, country: string } | null }> } };

export type TravelerDetailBookingQueryVariables = Exact<{
  bookingId: Scalars['ObjectId']['input'];
}>;


export type TravelerDetailBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', _id: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, currencyCode: CurrencyCode, endDate: string, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customerType: TripCustomerType, tsaIdentifiersSelfServiceDeadline?: string | null, passportInformationSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, departure?: { __typename?: 'Departure', _id: string } | null, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, termsSignature?: { __typename?: 'TermsSignature', termId: string, signingCustomer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null } | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null }> } | null };

export type TravelerDetailBookingTripWithDepartureIdFragment = { __typename?: 'BookingTrip', _id: string, currencyCode: CurrencyCode, endDate: string, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customerType: TripCustomerType, tsaIdentifiersSelfServiceDeadline?: string | null, passportInformationSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, departure?: { __typename?: 'Departure', _id: string } | null, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, termsSignature?: { __typename?: 'TermsSignature', termId: string, signingCustomer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null } | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null };

export type TravelerDetailBookingTripWithDepartureFragment = { __typename?: 'BookingTrip', _id: string, currencyCode: CurrencyCode, endDate: string, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customerType: TripCustomerType, tsaIdentifiersSelfServiceDeadline?: string | null, passportInformationSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, tour?: { __typename?: 'Tour', _id: string, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null, content?: { __typename?: 'TourContent', id: string, name?: string | null } | null } | null } | null, booking?: { __typename?: 'Booking', gcDeparture?: { __typename?: 'GCDeparture', _id: string } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, termsSignature?: { __typename?: 'TermsSignature', termId: string, signingCustomer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null } | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null };

export type TravelerDetailBookingTripFragment = { __typename?: 'BookingTrip', _id: string, currencyCode: CurrencyCode, endDate: string, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customerType: TripCustomerType, tsaIdentifiersSelfServiceDeadline?: string | null, passportInformationSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, termsSignature?: { __typename?: 'TermsSignature', termId: string, signingCustomer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null } | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null };

export type TravelerDetailBookingTripTermsSignatureFragment = { __typename?: 'TermsSignature', termId: string, signingCustomer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null };

export type TravelerDetailBookingTripWithDepartureQueryVariables = Exact<{
  tripId: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type TravelerDetailBookingTripWithDepartureQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', _id: string, currencyCode: CurrencyCode, endDate: string, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isPrimary: boolean, customerType: TripCustomerType, tsaIdentifiersSelfServiceDeadline?: string | null, passportInformationSelfServiceDeadline?: string | null, emergencyContactsSelfServiceDeadline?: string | null, healthNotesSelfServiceDeadline?: string | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, tour?: { __typename?: 'Tour', _id: string, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null, content?: { __typename?: 'TourContent', id: string, name?: string | null } | null } | null } | null, booking?: { __typename?: 'Booking', gcDeparture?: { __typename?: 'GCDeparture', _id: string } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', hasCompletedPassportInformation: boolean, hasConfirmedTsaIdentifiers: boolean, _id: string, confirmationDate?: string | null, countryOfIssue?: string | null, dateOfBirth?: string | null, expirationDate?: string | null, firstName?: string | null, gender?: TsaGender | null, issueDate?: string | null, lastName?: string | null, maskedIdentityDocumentNumber?: string | null, middleName?: string | null, suffix?: string | null, type?: IdentityDocumentType | null } | null, signedTerms?: { __typename?: 'Term', _id: string } | null, termsSignature?: { __typename?: 'TermsSignature', termId: string, signingCustomer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null } | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, termsSignatureChecklistItem?: { __typename?: 'TermsSignatureChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, tsaIdentifiersChecklistItem?: { __typename?: 'TsaIdentifiersChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, passportInformationChecklistItem?: { __typename?: 'PassportInformationChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', dueDate?: string | null, isCompleted: boolean, status?: TripChecklistItemStatus | null } | null, emergencyContacts?: Array<{ __typename?: 'EmergencyContact', _id: string, confirmationDate?: string | null, email?: string | null, firstName: string, lastName: string, phone?: string | null, relationship: EmergencyContactRelationship }> | null, travelerNotes?: { __typename?: 'TravelerNotes', _id: string, dietaryNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', acknowledged: boolean, text?: string | null } | null } | null } | null };

export type TravelerDetailDepartureQueryVariables = Exact<{
  departureId: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type TravelerDetailDepartureQuery = { __typename?: 'Query', departure?: { __typename?: 'Departure', _id: string, departureDate: string, tour?: { __typename?: 'Tour', _id: string, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null, content?: { __typename?: 'TourContent', id: string, name?: string | null } | null } | null } | null };

export type TravelerDetailDepartureFragment = { __typename?: 'Departure', _id: string, departureDate: string, tour?: { __typename?: 'Tour', _id: string, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null, content?: { __typename?: 'TourContent', id: string, name?: string | null } | null } | null };

export type BookingTripHotelsQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type BookingTripHotelsQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', _id: string, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string } | null, hotels?: Array<{ __typename?: 'TripHotel', endDate: string, name?: string | null, phoneNumber?: Array<string> | null, startDate: string, type: TripHotelType, website?: string | null, address?: Array<{ __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null }> | null }> | null, tsaInformation?: { __typename?: 'TSAInformation', _id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null } | null, openPreStayLineItem?: { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, departureDate: string, endDate: string, bedCode?: TourBedCode | null, cityGateway?: { __typename?: 'Gateway', _id: string, internalCityLongName: string } | null } | null, openPostStayLineItem?: { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, departureDate: string, endDate: string, bedCode?: TourBedCode | null, cityGateway?: { __typename?: 'Gateway', _id: string, internalCityLongName: string } | null } | null, departure?: { __typename?: 'Departure', _id: string, hotelsRequestDeadlineDate?: string | null, hotelsRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean, releaseDate?: string | null } | null, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null, description?: string | null } | null, bed: { __typename?: 'TourBed', capacity: number } }> } | null } | null };

export type BookingTripRequestedRoommatesQueryVariables = Exact<{
  tripId: Scalars['ObjectId']['input'];
}>;


export type BookingTripRequestedRoommatesQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', _id: string, requestedRoommates?: Array<string> | null } | null };

export type ExtendedStayFragment = { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, departureDate: string, endDate: string, bedCode?: TourBedCode | null, cityGateway?: { __typename?: 'Gateway', _id: string, internalCityLongName: string } | null };

export type HotelDepartureRoomFragment = { __typename?: 'DepartureRoom', _id: string, lineItemCode: string, content?: { __typename?: 'RoomContent', name?: string | null, description?: string | null } | null, bed: { __typename?: 'TourBed', capacity: number } };

export type HotelFragment = { __typename?: 'TripHotel', endDate: string, name?: string | null, phoneNumber?: Array<string> | null, startDate: string, type: TripHotelType, website?: string | null, address?: Array<{ __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null }> | null };

export type RequestRoommatesMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  requestedRoommates: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tripId: Scalars['ObjectId']['input'];
}>;


export type RequestRoommatesMutation = { __typename?: 'Mutation', updateDraftOrderRequestedRoommates: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string, trips: Array<{ __typename?: 'BookingTrip', requestedRoommates?: Array<string> | null }> } | { __typename?: 'Quote', _id: string, trips: Array<{ __typename?: 'QuoteTrip', requestedRoommates?: Array<string> | null }> } } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type CheckTripChecklistItemMutationVariables = Exact<{
  checklistItemTemplateId: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
}>;


export type CheckTripChecklistItemMutation = { __typename?: 'Mutation', checkTripChecklistItem: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidTripChecklistItemTemplateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'TripChecklistItemState', _id: string, isChecked: boolean } | { __typename?: 'ValidationError' } };

export type UncheckTripChecklistItemMutationVariables = Exact<{
  checklistItemTemplateId: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
}>;


export type UncheckTripChecklistItemMutation = { __typename?: 'Mutation', uncheckTripChecklistItem: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidTripChecklistItemTemplateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'TripChecklistItemState', _id: string, isChecked: boolean } | { __typename?: 'ValidationError' } };

export type BookingTripCustomizationsQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type BookingTripCustomizationsQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', departure?: { __typename?: 'Departure', timingStatus: DepartureTimingStatus, finalPaymentDeadline: string, activeExtensionContent?: { __typename?: 'TourExtensionContent', description?: string | null, isHidden?: boolean | null, name?: string | null, nbNights?: number | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, activeExtension?: { __typename?: 'DepartureExtension', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> }, excursions: Array<{ __typename?: 'DepartureExcursion', status: DepartureStatus, _id: string, autoApproveDeadline: string, isPurchasable: boolean, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null, focus?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, value: number }> }, tourExcursion?: { __typename?: 'TourExcursion', isPrebook: boolean } | null }> } | null, excursions: Array<{ __typename?: 'DepartureExcursion', status: DepartureStatus, _id: string, autoApproveDeadline: string, isPurchasable: boolean, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null, focus?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, value: number }> }, tourExcursion?: { __typename?: 'TourExcursion', isPrebook: boolean } | null }> } | null, booking?: { __typename?: 'Booking', trips: Array<{ __typename?: 'BookingTrip', _id: string, lineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'FeeLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'InsuranceExtensionLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'PromoLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'TourLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null }>, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null }>, balance: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null } | null };

export type CustomizationActiveExtensionFragment = { __typename?: 'DepartureExtension', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> }, excursions: Array<{ __typename?: 'DepartureExcursion', status: DepartureStatus, _id: string, autoApproveDeadline: string, isPurchasable: boolean, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null, focus?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, value: number }> }, tourExcursion?: { __typename?: 'TourExcursion', isPrebook: boolean } | null }> };

export type CustomizationExcursionFragment = { __typename?: 'DepartureExcursion', status: DepartureStatus, _id: string, autoApproveDeadline: string, isPurchasable: boolean, lineItemCode: string, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null, focus?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, value: number }> }, tourExcursion?: { __typename?: 'TourExcursion', isPrebook: boolean } | null };

export type CustomizationExtensionContentFragment = { __typename?: 'TourExtensionContent', description?: string | null, isHidden?: boolean | null, name?: string | null, nbNights?: number | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null };

export type CustomizationTripFragment = { __typename?: 'BookingTrip', _id: string, lineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'FeeLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'InsuranceExtensionLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'PromoLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'TourLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null } | { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, type: TripComponentType, status: LineItemStatus, isOpen: boolean, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null }>, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null };

export type DraftBookingCustomizationsQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type DraftBookingCustomizationsQuery = { __typename?: 'Query', draftOrder?: { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string, isEnrolledInAutopay: boolean, currencyCode: CurrencyCode, trips: Array<{ __typename?: 'BookingTrip', _id: string, isPrimary: boolean, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null }>, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, openLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }> }>, minimumAmountDue: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption' } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, paymentSchedules: Array<{ __typename?: 'PaymentSchedule', _id: string, status: PaymentScheduleStatus, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, amount: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }> }>, balance: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'Quote' } } | null };

export type DraftBookingCustomizationsOrderFragment = { __typename?: 'Booking', _id: string, isEnrolledInAutopay: boolean, currencyCode: CurrencyCode, trips: Array<{ __typename?: 'BookingTrip', _id: string, isPrimary: boolean, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null }>, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, openLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }> }>, minimumAmountDue: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption' } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, paymentSchedules: Array<{ __typename?: 'PaymentSchedule', _id: string, status: PaymentScheduleStatus, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, amount: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }> }>, balance: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

export type DraftBookingCustomizationsTourExcursionLineItemFragment = { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null };

export type DraftBookingCustomizationsTripFragment = { __typename?: 'BookingTrip', _id: string, isPrimary: boolean, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }, cancellationMeta?: { __typename?: 'LineItemCancellationMeta', cancellationReason: LineItemCancellationReason } | null }>, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, openLineItems: Array<{ __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, isQuoted: boolean, status: LineItemStatus, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }> };

export type BookingTripFlightsQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type BookingTripFlightsQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', _id: string, departure?: { __typename?: 'Departure', _id: string, flightsRequestMessagingDeadlineDate?: string | null, flightsRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean, releaseDate?: string | null, releaseEndDate?: string | null } | null, eTicketsRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean } | null } | null, gcDeparture?: { __typename?: 'GCDeparture', _id: string, flightsRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean, releaseDate?: string | null, releaseEndDate?: string | null } | null, eTicketsRelease?: { __typename?: 'ReleaseDetails', isReleased: boolean } | null } | null, trips: Array<{ __typename?: 'BookingTrip', _id: string, isLandOnly: boolean, flights?: { __typename?: 'TripFlights', hasFullItinerary: boolean, isFullyTicketed: boolean, flightSegments?: Array<{ __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null }> | null } | null, tsaInformation?: { __typename?: 'TSAInformation', _id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null } | null }> } | null };

export type BookingTripRequestedTravelCompanionsQueryVariables = Exact<{
  tripId: Scalars['ObjectId']['input'];
}>;


export type BookingTripRequestedTravelCompanionsQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', requestedTravelCompanions?: Array<string> | null } | null };

export type RequestTravelCompanionsMutationVariables = Exact<{
  bookingId: Scalars['ObjectId']['input'];
  requestedTravelCompanions: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tripId: Scalars['ObjectId']['input'];
}>;


export type RequestTravelCompanionsMutation = { __typename?: 'Mutation', updateDraftOrderRequestedTravelCompanions: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string, trips: Array<{ __typename?: 'BookingTrip', _id: string, requestedTravelCompanions?: Array<string> | null }> } | { __typename?: 'Quote', _id: string, trips: Array<{ __typename?: 'QuoteTrip', _id: string, requestedTravelCompanions?: Array<string> | null }> } } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type TripFlightSegmentFragment = { __typename?: 'TripFlightSegment', airlineLocator?: string | null, arrivesAtLocalTime: string, departsAtLocalTime: string, flightNumber: string, pnrLocator: string, pnrSegmentNumber: number, ticketNumber?: string | null, type: TripFlightType, arrivalGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, departureGateway?: { __typename?: 'Gateway', code: string, internalCityName: string, stateCode?: string | null } | null, carrier?: { __typename?: 'Airline', _id: string, code: string, iataCode?: string | null, icaoCode?: string | null, name: string, phoneNumber?: string | null, shortName?: string | null, websiteUrl?: string | null } | null, operatedByCarrier?: { __typename?: 'Airline', _id: string, code: string, name: string, shortName?: string | null } | null };

export type PostBookingFaqQueryVariables = Exact<{
  tripId: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type PostBookingFaqQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', _id: string, departure?: { __typename?: 'Departure', tourContent?: { __typename?: 'TourContent', id: string, name?: string | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null } | null } | null } | null };

export type ItineraryDepartureExcursionFragment = { __typename?: 'DepartureExcursion', _id: string, autoApproveDeadline: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', departureInfo?: string | null, description?: string | null, duration?: string | null, id: string, name?: string | null, shortDescription?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null, focus?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, tourExcursion?: { __typename?: 'TourExcursion', isPrebook: boolean } | null };

export type ItineraryDepartureExtensionFragment = { __typename?: 'DepartureExtension', _id: string, lineItemCode: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, autoApproveDeadline: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', departureInfo?: string | null, description?: string | null, duration?: string | null, id: string, name?: string | null, shortDescription?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null, focus?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, tourExcursion?: { __typename?: 'TourExcursion', isPrebook: boolean } | null }>, tourExtensionContent?: { __typename?: 'TourExtensionContent', id: string, isPreExtension?: boolean | null, nbDaysOverlap?: number | null, tourCode?: string | null, itineraryItems: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null } | { __typename?: 'TourItineraryItemContent', nbNights?: number | null, title?: string | null, days: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null }> }> } | null };

export type ItineraryTourContentFragment = { __typename?: 'TourContent', id: string, priceYear?: number | null, tourCode?: string | null, itineraryItems: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null } | { __typename?: 'TourItineraryItemContent', nbNights?: number | null, title?: string | null, days: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null }> }>, mapImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null, focus?: string | null, name?: string | null } | null };

export type ItineraryTourDayContentFragment = { __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null };

type ItineraryTourItineraryElementUnion_TourDayContent_Fragment = { __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null };

type ItineraryTourItineraryElementUnion_TourItineraryItemContent_Fragment = { __typename?: 'TourItineraryItemContent', nbNights?: number | null, title?: string | null, days: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null }> };

export type ItineraryTourItineraryElementUnionFragment = ItineraryTourItineraryElementUnion_TourDayContent_Fragment | ItineraryTourItineraryElementUnion_TourItineraryItemContent_Fragment;

export type ItineraryTourItineraryItemContentFragment = { __typename?: 'TourItineraryItemContent', nbNights?: number | null, title?: string | null, days: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null }> };

export type MyAccountItineraryQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type MyAccountItineraryQuery = { __typename?: 'Query', bookingTrip?: { __typename?: 'BookingTrip', _id: string, hasExtension: boolean, booking?: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, gcDeparture?: { __typename?: 'GCDeparture', _id: string, micrositeContent?: { __typename?: 'MicrositeContent', fullSlug?: string | null } | null } | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: string, departureDateWithExtension: string, activeExtension?: { __typename?: 'DepartureExtension', _id: string, lineItemCode: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, autoApproveDeadline: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', departureInfo?: string | null, description?: string | null, duration?: string | null, id: string, name?: string | null, shortDescription?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null, focus?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, tourExcursion?: { __typename?: 'TourExcursion', isPrebook: boolean } | null }>, tourExtensionContent?: { __typename?: 'TourExtensionContent', id: string, isPreExtension?: boolean | null, nbDaysOverlap?: number | null, tourCode?: string | null, itineraryItems: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null } | { __typename?: 'TourItineraryItemContent', nbNights?: number | null, title?: string | null, days: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null }> }> } | null } | null, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, autoApproveDeadline: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', departureInfo?: string | null, description?: string | null, duration?: string | null, id: string, name?: string | null, shortDescription?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null, focus?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, tourExcursion?: { __typename?: 'TourExcursion', isPrebook: boolean } | null }>, extensions: Array<{ __typename?: 'DepartureExtension', _id: string, lineItemCode: string, excursions: Array<{ __typename?: 'DepartureExcursion', _id: string, autoApproveDeadline: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', departureInfo?: string | null, description?: string | null, duration?: string | null, id: string, name?: string | null, shortDescription?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null, focus?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, tourExcursion?: { __typename?: 'TourExcursion', isPrebook: boolean } | null }>, tourExtensionContent?: { __typename?: 'TourExtensionContent', id: string, isPreExtension?: boolean | null, nbDaysOverlap?: number | null, tourCode?: string | null, itineraryItems: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null } | { __typename?: 'TourItineraryItemContent', nbNights?: number | null, title?: string | null, days: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null }> }> } | null }>, tourContent?: { __typename?: 'TourContent', id: string, priceYear?: number | null, tourCode?: string | null, itineraryItems: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null } | { __typename?: 'TourItineraryItemContent', nbNights?: number | null, title?: string | null, days: Array<{ __typename?: 'TourDayContent', description?: string | null, excursionIds: Array<string>, freeTimeSuggestions?: string | null, highlights?: string | null, meals: Array<string>, name?: string | null, physicalActivity?: string | null, day?: number | null, isRange?: boolean | null, dayRangeLength?: number | null }> }>, mapImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null, focus?: string | null, name?: string | null } | null } | null } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string } | null } | null };

export type CustomerEvalFragment = { __typename?: 'CustomerEvaluation', _id: string, deadlineDate: string, submissionDate?: string | null, availabilityDate: string, finalizationDate?: string | null, hasBeenStarted: boolean, hasAnsweredQuestions: boolean, questions: Array<{ __typename: 'EvaluationFreeTextQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationFreeTextAnswer', additionalComments?: string | null, nullableValue?: string | null } | null, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null } | { __typename: 'EvaluationMatrixQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null, rows: Array<{ __typename?: 'EvaluationMatrixRow', _id: string, text: string, answer?: { __typename?: 'EvaluationMatrixAnswer', additionalComments?: string | null, choiceId: string, value: string } | null }> } | { __typename: 'EvaluationMultipleChoiceQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationMultipleChoiceAnswer', additionalComments?: string | null, choiceId: string, value: string } | null, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null }> };

export type CustomerTourEvalQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  tripId: Scalars['ObjectId']['input'];
}>;


export type CustomerTourEvalQuery = { __typename?: 'Query', customerEvaluation?: { __typename?: 'CustomerEvaluation', _id: string, deadlineDate: string, submissionDate?: string | null, availabilityDate: string, finalizationDate?: string | null, hasBeenStarted: boolean, hasAnsweredQuestions: boolean, questions: Array<{ __typename: 'EvaluationFreeTextQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationFreeTextAnswer', additionalComments?: string | null, nullableValue?: string | null } | null, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null } | { __typename: 'EvaluationMatrixQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null, rows: Array<{ __typename?: 'EvaluationMatrixRow', _id: string, text: string, answer?: { __typename?: 'EvaluationMatrixAnswer', additionalComments?: string | null, choiceId: string, value: string } | null }> } | { __typename: 'EvaluationMultipleChoiceQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationMultipleChoiceAnswer', additionalComments?: string | null, choiceId: string, value: string } | null, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null }> } | null, bookingTrip?: { __typename?: 'BookingTrip', _id: string, endDate: string, departureDate: string } | null };

export type EvaluationFreeTextQuestionFragment = { __typename?: 'EvaluationFreeTextQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationFreeTextAnswer', additionalComments?: string | null, nullableValue?: string | null } | null, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null };

export type EvaluationMatrixQuestionFragment = { __typename?: 'EvaluationMatrixQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null, rows: Array<{ __typename?: 'EvaluationMatrixRow', _id: string, text: string, answer?: { __typename?: 'EvaluationMatrixAnswer', additionalComments?: string | null, choiceId: string, value: string } | null }> };

export type EvaluationMultipleChoiceQuestionFragment = { __typename?: 'EvaluationMultipleChoiceQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationMultipleChoiceAnswer', additionalComments?: string | null, choiceId: string, value: string } | null, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null };

export type SaveCustomerEvaluationMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  freeTextQuestions?: InputMaybe<Array<AnswerFreeTextQuestionInput> | AnswerFreeTextQuestionInput>;
  matrixQuestions?: InputMaybe<Array<AnswerMatrixQuestionInput> | AnswerMatrixQuestionInput>;
  multipleChoiceQuestions?: InputMaybe<Array<AnswerMultipleChoiceQuestionInput> | AnswerMultipleChoiceQuestionInput>;
}>;


export type SaveCustomerEvaluationMutation = { __typename?: 'Mutation', saveEvaluation: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidEvaluationError', message: string } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'SaveEvaluationSuccess', data: { __typename?: 'CustomerEvaluation', _id: string, deadlineDate: string, submissionDate?: string | null, availabilityDate: string, finalizationDate?: string | null, hasBeenStarted: boolean, hasAnsweredQuestions: boolean, questions: Array<{ __typename: 'EvaluationFreeTextQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationFreeTextAnswer', additionalComments?: string | null, nullableValue?: string | null } | null, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null } | { __typename: 'EvaluationMatrixQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null, rows: Array<{ __typename?: 'EvaluationMatrixRow', _id: string, text: string, answer?: { __typename?: 'EvaluationMatrixAnswer', additionalComments?: string | null, choiceId: string, value: string } | null }> } | { __typename: 'EvaluationMultipleChoiceQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationMultipleChoiceAnswer', additionalComments?: string | null, choiceId: string, value: string } | null, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null }> } | { __typename?: 'TourDirectorTourEndReport' } } | { __typename?: 'ValidationError' } };

export type SubmitCustomerEvaluationMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type SubmitCustomerEvaluationMutation = { __typename?: 'Mutation', submitEvaluation: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidEvaluationError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'SubmitEvaluationSuccess', data: { __typename?: 'CustomerEvaluation', _id: string, deadlineDate: string, submissionDate?: string | null, availabilityDate: string, finalizationDate?: string | null, hasBeenStarted: boolean, hasAnsweredQuestions: boolean, questions: Array<{ __typename: 'EvaluationFreeTextQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationFreeTextAnswer', additionalComments?: string | null, nullableValue?: string | null } | null, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null } | { __typename: 'EvaluationMatrixQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null, rows: Array<{ __typename?: 'EvaluationMatrixRow', _id: string, text: string, answer?: { __typename?: 'EvaluationMatrixAnswer', additionalComments?: string | null, choiceId: string, value: string } | null }> } | { __typename: 'EvaluationMultipleChoiceQuestion', _id: string, canonicalId: string, hasBeenAnswered: boolean, isRequired?: boolean | null, text: string, answer?: { __typename?: 'EvaluationMultipleChoiceAnswer', additionalComments?: string | null, choiceId: string, value: string } | null, choices: Array<{ __typename?: 'EvaluationChoice', _id: string, label: string, value: string }>, meta?: { __typename?: 'EvaluationQuestionMeta', componentEndDate?: string | null, componentStartTime?: any | null, placementType?: EvaluationQuestionPlacementType | null } | null }> } | { __typename?: 'TourDirectorTourEndReport' } } | { __typename?: 'ValidationError' } };

export type CreateTourReviewMutationVariables = Exact<{
  input: CreateReviewInput;
}>;


export type CreateTourReviewMutation = { __typename?: 'Mutation', createReview: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidRatingError' } | { __typename?: 'InvalidReviewError' } | { __typename?: 'InvalidReviewResponseError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'Review', _id: string, customerId: string, nbPastTrips: number, isFeatured: boolean, isEditable?: boolean | null, rating: number, travelDate: string, tourCode: string, createdAt?: string | null, detail?: { __typename?: 'ReviewDetail', _id: string, author?: string | null, body: string, status: ReviewStatus, title?: string | null, response?: { __typename?: 'ReviewResponse', author: string, body: string } | null } | null, images: Array<{ __typename?: 'ReviewImage', _id: string, asset?: { __typename?: 'Asset', _id: string, filename: string, location: string, key: string } | null }> } | { __typename?: 'ValidationError' } };

export type UpdateTourReviewMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  input: UpdateReviewInput;
}>;


export type UpdateTourReviewMutation = { __typename?: 'Mutation', updateReview: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidRatingError' } | { __typename?: 'InvalidReviewError' } | { __typename?: 'InvalidReviewResponseError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'Review', _id: string, customerId: string, nbPastTrips: number, isFeatured: boolean, isEditable?: boolean | null, rating: number, travelDate: string, tourCode: string, createdAt?: string | null, detail?: { __typename?: 'ReviewDetail', _id: string, author?: string | null, body: string, status: ReviewStatus, title?: string | null, response?: { __typename?: 'ReviewResponse', author: string, body: string } | null } | null, images: Array<{ __typename?: 'ReviewImage', _id: string, asset?: { __typename?: 'Asset', _id: string, filename: string, location: string, key: string } | null }> } | { __typename?: 'ValidationError' } };

export type DeleteReviewImageMutationVariables = Exact<{
  reviewId: Scalars['ObjectId']['input'];
  reviewImageIds: Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input'];
}>;


export type DeleteReviewImageMutation = { __typename?: 'Mutation', deleteReviewImage: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'Review', _id: string, customerId: string, nbPastTrips: number, isFeatured: boolean, isEditable?: boolean | null, rating: number, travelDate: string, tourCode: string, createdAt?: string | null, detail?: { __typename?: 'ReviewDetail', _id: string, author?: string | null, body: string, status: ReviewStatus, title?: string | null, response?: { __typename?: 'ReviewResponse', author: string, body: string } | null } | null, images: Array<{ __typename?: 'ReviewImage', _id: string, asset?: { __typename?: 'Asset', _id: string, filename: string, location: string, key: string } | null }> } | { __typename?: 'ValidationError' } };

export type TourReviewFragment = { __typename?: 'Review', _id: string, customerId: string, nbPastTrips: number, isFeatured: boolean, isEditable?: boolean | null, rating: number, travelDate: string, tourCode: string, createdAt?: string | null, detail?: { __typename?: 'ReviewDetail', _id: string, author?: string | null, body: string, status: ReviewStatus, title?: string | null, response?: { __typename?: 'ReviewResponse', author: string, body: string } | null } | null, images: Array<{ __typename?: 'ReviewImage', _id: string, asset?: { __typename?: 'Asset', _id: string, filename: string, location: string, key: string } | null }> };

export type TourReviewGetReviewQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type TourReviewGetReviewQuery = { __typename?: 'Query', review?: { __typename?: 'Review', _id: string, customerId: string, nbPastTrips: number, isFeatured: boolean, isEditable?: boolean | null, rating: number, travelDate: string, tourCode: string, createdAt?: string | null, detail?: { __typename?: 'ReviewDetail', _id: string, author?: string | null, body: string, status: ReviewStatus, title?: string | null, response?: { __typename?: 'ReviewResponse', author: string, body: string } | null } | null, images: Array<{ __typename?: 'ReviewImage', _id: string, asset?: { __typename?: 'Asset', _id: string, filename: string, location: string, key: string } | null }> } | null };

export type TravelProtectionAddDraftOrderInsuranceAddonMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  inputs: Array<AddDraftOrderInsuranceAddonInput> | AddDraftOrderInsuranceAddonInput;
}>;


export type TravelProtectionAddDraftOrderInsuranceAddonMutation = { __typename?: 'Mutation', addDraftOrderInsuranceAddon: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type TravelProtectionBookingQueryVariables = Exact<{
  bookingId: Scalars['ObjectId']['input'];
  language: Scalars['String']['input'];
}>;


export type TravelProtectionBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', _id: string, dateBooked: string, currencyCode: CurrencyCode, balance: { __typename?: 'Money', value: number }, departure?: { __typename?: 'Departure', _id: string, finalPaymentDeadline: string, tourCode: string } | null, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption' } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, trips: Array<{ __typename?: 'BookingTrip', _id: string, hasInsurance: boolean, isPrimary: boolean, currencyCode: CurrencyCode, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null, tsaInformation?: { __typename?: 'TSAInformation', countryOfIssue?: string | null } | null, address?: { __typename?: 'Address', country: string } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, travelerInsuranceIdCreationDate: string, lineItemCode: string, price: { __typename?: 'Money', value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, price: { __typename?: 'Money', value: number } }>, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }> }> } | null };

export type TravelProtectionCreateDraftOrderMutationVariables = Exact<{
  orderId: Scalars['ObjectId']['input'];
}>;


export type TravelProtectionCreateDraftOrderMutation = { __typename?: 'Mutation', createDraftOrder: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type TravelProtectionDraftOrderQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type TravelProtectionDraftOrderQuery = { __typename?: 'Query', draftOrder?: { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, balance: { __typename?: 'Money', value: number }, minimumAmountDue: { __typename?: 'Money', value: number }, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption' } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, paymentSchedules: Array<{ __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, status: PaymentScheduleStatus, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, amount: { __typename?: 'Money', value: number } }> }> } | { __typename?: 'Quote' } } | null };

export type TravelProtectionDraftOrderBookingFragment = { __typename?: 'Booking', _id: string, currencyCode: CurrencyCode, isEnrolledInAutopay: boolean, balance: { __typename?: 'Money', value: number }, minimumAmountDue: { __typename?: 'Money', value: number }, paymentOptions: Array<{ __typename?: 'BookingAutopayPaymentOption' } | { __typename?: 'BookingManualPaymentOption', allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>, type: BookingPaymentOptionType }>, paymentSchedules: Array<{ __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, status: PaymentScheduleStatus, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, amount: { __typename?: 'Money', value: number } }> }> };

export type TravelProtectionUpdateDraftOrderInsuranceMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
  lineItemCode: Scalars['LineItemCode']['input'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  addOnLineItemCodes?: InputMaybe<Array<Scalars['LineItemCode']['input']> | Scalars['LineItemCode']['input']>;
}>;


export type TravelProtectionUpdateDraftOrderInsuranceMutation = { __typename?: 'Mutation', updateDraftOrderInsurance: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DraftOrder', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidOrderError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type ProfileMeQueryVariables = Exact<{
  businessCode: BusinessCode;
  language: Scalars['String']['input'];
}>;


export type ProfileMeQuery = { __typename?: 'Query', me?: { __typename?: 'Customer', hasGCDepartures: boolean, _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, savedPaymentMethods: Array<{ __typename?: 'SavedPaymentMethod', _id: string, isActive: boolean, isExpired: boolean, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, loyaltyLevel?: { __typename?: 'LoyaltyLevel', _id: string, repeatPromoCode?: string | null, content?: { __typename?: 'LoyaltyLevelContent', name?: string | null, icon?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null } | null, repeatDiscount?: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } | null, returnWindowDiscount?: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } | null } | null } | { __typename?: 'Employee', _id: string } | { __typename?: 'TourDirector', _id: string } | null };

export type UpdateCustomerAddressMutationVariables = Exact<{
  customerId: Scalars['ObjectId']['input'];
  input: UpdateCustomerAddressInput;
}>;


export type UpdateCustomerAddressMutation = { __typename?: 'Mutation', updateCustomerAddress: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'Customer', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type UpdateCustomerNameMutationVariables = Exact<{
  customerId: Scalars['ObjectId']['input'];
  input: UpdateCustomerNameInput;
}>;


export type UpdateCustomerNameMutation = { __typename?: 'Mutation', updateCustomerName: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'Customer', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type UpdateCustomerPasswordMutationVariables = Exact<{
  input: UpdateCustomerPasswordInput;
}>;


export type UpdateCustomerPasswordMutation = { __typename?: 'Mutation', updateCustomerPassword: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'InvalidSigninError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'UpdatePasswordResult', success: boolean } | { __typename?: 'ValidationError' } };

export type UpdateCustomerPhoneNumberMutationVariables = Exact<{
  customerId: Scalars['ObjectId']['input'];
  input: UpdateCustomerPhoneNumberInput;
}>;


export type UpdateCustomerPhoneNumberMutation = { __typename?: 'Mutation', updateCustomerPhoneNumber: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'Customer', _id: string } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } };

export type CreateWishlistItemMutationVariables = Exact<{
  input: CreateWishlistItemInput;
}>;


export type CreateWishlistItemMutation = { __typename?: 'Mutation', createWishlistItem: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } | { __typename?: 'WishlistItem', tourCode: string } };

export type DeleteWishlistItemMutationVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type DeleteWishlistItemMutation = { __typename?: 'Mutation', deleteWishlistItem: { __typename?: 'BusinessNotSpecifiedError' } | { __typename?: 'DuplicateUniqueKeyError' } | { __typename?: 'InvalidDateError' } | { __typename?: 'NotAuthorizedError' } | { __typename?: 'NotFoundError' } | { __typename?: 'ValidationError' } | { __typename?: 'WishlistItemRemovedResult', removedId: string } };

export type CreateHelpCenterLoginTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateHelpCenterLoginTokenMutation = { __typename?: 'Mutation', createHelpCenterLoginToken?: { __typename?: 'ExternalToken', token: string } | null };

export type ContentAncestorsQueryVariables = Exact<{
  businessCode: BusinessCode;
  fullSlug: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type ContentAncestorsQuery = { __typename?: 'Query', contentAncestors: Array<{ __typename?: 'ContentAncestor', fullSlug: string, name: string }> };

export type ActivityLevelContentFragment = { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null };

export type AddressFragment = { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string };

export type AutopayCheckoutOptionFragment = { __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } };

type BasicLineItem_AdjustmentLineItem_Fragment = { __typename?: 'AdjustmentLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_ExtendedStayLineItem_Fragment = { __typename?: 'ExtendedStayLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_FeeLineItem_Fragment = { __typename?: 'FeeLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_FlightPackageLineItem_Fragment = { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_InsuranceAddonLineItem_Fragment = { __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_InsuranceExtensionLineItem_Fragment = { __typename?: 'InsuranceExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_InsuranceLineItem_Fragment = { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_PrivateGroupLineItem_Fragment = { __typename?: 'PrivateGroupLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_PromoLineItem_Fragment = { __typename?: 'PromoLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_TourExcursionLineItem_Fragment = { __typename?: 'TourExcursionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_TourExtensionLineItem_Fragment = { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_TourLineItem_Fragment = { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

type BasicLineItem_TourRoomLineItem_Fragment = { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } };

export type BasicLineItemFragment = BasicLineItem_AdjustmentLineItem_Fragment | BasicLineItem_ExtendedStayLineItem_Fragment | BasicLineItem_FeeLineItem_Fragment | BasicLineItem_FlightPackageLineItem_Fragment | BasicLineItem_InsuranceAddonLineItem_Fragment | BasicLineItem_InsuranceExtensionLineItem_Fragment | BasicLineItem_InsuranceLineItem_Fragment | BasicLineItem_PrivateGroupLineItem_Fragment | BasicLineItem_PromoLineItem_Fragment | BasicLineItem_TourExcursionLineItem_Fragment | BasicLineItem_TourExtensionLineItem_Fragment | BasicLineItem_TourLineItem_Fragment | BasicLineItem_TourRoomLineItem_Fragment;

export type CheckoutQuoteFragment = { __typename?: 'Quote', rebookedFromOrderId?: string | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> };

export type ClassLevelRoomingContentFragment = { __typename?: 'TourClassLevelContent', name?: string | null, description?: string | null, roomingDescription?: string | null, roomingDetailedDescription?: string | null, roomingUpgradeDescription?: string | null };

export type ContactInfoContentQueryVariables = Exact<{
  businessCode: BusinessCode;
  language: Scalars['String']['input'];
}>;


export type ContactInfoContentQuery = { __typename?: 'Query', contactInfoContent?: { __typename?: 'ContactInfoContent', address: { __typename?: 'ContactInfoContentAddress', addressName?: string | null, city?: string | null, state?: string | null, street?: string | null, zip?: string | null }, groupSales?: { __typename?: 'ContactInfoContentDepartment', phoneNumber?: string | null, phoneNumberFormatted?: string | null } | null, indiesSales?: { __typename?: 'ContactInfoContentDepartment', phoneNumber?: string | null, phoneNumberFormatted?: string | null } | null } | null };

export type CreateDraftOrderMutationVariables = Exact<{
  orderId: Scalars['ObjectId']['input'];
}>;


export type CreateDraftOrderMutation = { __typename?: 'Mutation', createDraftOrder: { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', trips: Array<{ __typename?: 'BookingTrip', _id: string }> } | { __typename?: 'Quote', trips: Array<{ __typename?: 'QuoteTrip', _id: string }> } } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type CustomerFragment = { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null };

export type DepartureExcursionFragment = { __typename?: 'DepartureExcursion', status: DepartureStatus, lineItemCode: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } };

export type DepartureExtensionFragment = { __typename?: 'DepartureExtension', _id: string, lineItemCode: string, status: DepartureStatus, isPreExtension: boolean, endDate: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, isPurchasable: boolean, capacity: number, nbSpotsBooked: number, lineItemCode: string, cabinCode?: any | null, status: DepartureStatus, bed: { __typename?: 'TourBed', code: TourBedCode, capacity: number, count: number, name: string }, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, content?: { __typename?: 'RoomContent', name?: string | null, description?: string | null } | null }>, excursions: Array<{ __typename?: 'DepartureExcursion', status: DepartureStatus, lineItemCode: string, isPurchasable: boolean, content?: { __typename?: 'TourExcursionContent', name?: string | null, id: string, description?: string | null, departureInfo?: string | null, duration?: string | null, image?: { __typename?: 'ContentAsset', filename?: string | null } | null } | null, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> } }> };

export type DepartureRoomFragment = { __typename?: 'DepartureRoom', _id: string, isPurchasable: boolean, capacity: number, nbSpotsBooked: number, lineItemCode: string, cabinCode?: any | null, status: DepartureStatus, bed: { __typename?: 'TourBed', code: TourBedCode, capacity: number, count: number, name: string }, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number }> }, content?: { __typename?: 'RoomContent', name?: string | null, description?: string | null } | null };

export type DepartureTourContentFragment = { __typename?: 'TourContent', id: string, name?: string | null, nbDaysWithExtension?: number | null, includesBreakfast?: boolean | null, cardImage?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null, postBookingFaq?: { __typename?: 'FaqContent', items: Array<{ __typename?: 'FaqContentItem', answer?: string | null, question?: string | null }> } | null, equipment?: Array<{ __typename?: 'TourEquipmentContent', name?: string | null }> | null, tour?: { __typename?: 'Tour', _id: string, places: Array<{ __typename?: 'City', _id: string, type: PlaceType } | { __typename?: 'Continent', _id: string, type: PlaceType } | { __typename?: 'Country', _id: string, type: PlaceType } | { __typename?: 'CountryRegion', _id: string, type: PlaceType } | { __typename?: 'GeographicRegion', _id: string, type: PlaceType }>, classLevelContent?: { __typename?: 'TourClassLevelContent', name?: string | null, description?: string | null, roomingDescription?: string | null, roomingDetailedDescription?: string | null, roomingUpgradeDescription?: string | null } | null, activityLevelContent?: { __typename?: 'TourActivityLevelContent', activityLevel?: number | null, name?: string | null, description?: string | null, icon?: { __typename?: 'ContentAsset', filename?: string | null, alt?: string | null } | null } | null } | null };

export type DepartureTourExtensionContentFragment = { __typename?: 'TourExtensionContent', name?: string | null, description?: string | null, nbNights?: number | null, image?: { __typename?: 'ContentAsset', alt?: string | null, filename?: string | null } | null };

export type DraftBookingFragmentFragment = { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', balance: { __typename?: 'Money', value: number } } | { __typename?: 'Quote' } };

export type DraftQuoteFragmentFragment = { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, finalPaymentDate: string, departureId: string, currencyCode: CurrencyCode, isExpired: boolean, isSaved?: boolean | null, expirationDate: string, createdAt?: string | null, rebookedFromOrderId?: string | null, averageTotalPerTrip: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, departure?: { __typename?: 'Departure', _id: string, tourCode: string } | null, grandTotal: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, totalDiscount: { __typename?: 'Money', formatted: string, currencyCode: CurrencyCode, value: number }, balance: { __typename?: 'Money', value: number, currencyCode: CurrencyCode, formatted: string }, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, trips: Array<{ __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> }>, gcDeparture?: { __typename?: 'GCDeparture', micrositeContent?: { __typename?: 'MicrositeContent', title?: string | null, fullSlug?: string | null } | null, lineItemRules?: Array<{ __typename?: 'GCDepartureRule', level: GcDepartureRuleLevel, lineItemCode: string, lineItemType: GcDepartureRuleLineItemType }> | null } | null, rebookedFromOrder?: { __typename?: 'Booking', _id: string, transferableAmounts: { __typename?: 'TransferableAmount', totalTransferable: { __typename?: 'Money', value: number } } } | { __typename?: 'Quote', _id: string } | null, checkoutOptions: Array<{ __typename?: 'QuoteAutopayCheckoutOption', type: QuoteCheckoutType, earliestPaymentScheduleStartDate: string, latestPaymentScheduleStartDate: string, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number } } | { __typename?: 'QuoteManualCheckoutOption', type: QuoteCheckoutType, allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>, amount: { __typename?: 'Money', value: number }, commonFees: Array<{ __typename?: 'FeeApplicationInfo', applyTo: FeeApplicationInstructions, fee: { __typename?: 'FeeLineItem', price: { __typename?: 'Money', value: number } } }> }> } };

export type FlightPackageLineItemFragment = { __typename?: 'FlightPackageLineItem', _id: string, status: LineItemStatus, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null };

export type FlightPriceFragment = { __typename?: 'DepartureFlightPackagePrice', lineItemCode: string, isCustomGateway: boolean, prices: Array<{ __typename?: 'Money', currencyCode: CurrencyCode, value: number }>, homeGateway?: { __typename?: 'Gateway', code: string, stateCode?: string | null, internalCityName: string } | null };

export type GatewayFragment = { __typename?: 'Gateway', code: string, stateCode?: string | null, internalCityName: string };

export type InsurancePlanContentAddonFragment = { __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> };

export type InsurancePlanOfferFragment = { __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null };

export type LatestGeneralTermsQueryVariables = Exact<{
  businessCode: BusinessCode;
  market: TermMarket;
}>;


export type LatestGeneralTermsQuery = { __typename?: 'Query', latestTerm?: { __typename?: 'Term', _id: string, content?: { } | null, certificationText?: string | null } | null };

export type LatestTermQueryVariables = Exact<{
  businessCode: BusinessCode;
  market: TermMarket;
  termType: TermType;
}>;


export type LatestTermQuery = { __typename?: 'Query', latestTerm?: { __typename?: 'Term', _id: string, content?: { } | null, certificationText?: string | null, termType: TermType } | null };

export type MoneyFragmentFragment = { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode };

type PaymentMethodFragment_AchPaymentMethod_Fragment = { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null };

type PaymentMethodFragment_AffirmPaymentMethod_Fragment = { __typename?: 'AffirmPaymentMethod' };

type PaymentMethodFragment_CardPaymentMethod_Fragment = { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null };

type PaymentMethodFragment_CheckPaymentMethod_Fragment = { __typename?: 'CheckPaymentMethod' };

type PaymentMethodFragment_EfTransferPaymentMethod_Fragment = { __typename?: 'EFTransferPaymentMethod' };

type PaymentMethodFragment_TransferPaymentMethod_Fragment = { __typename?: 'TransferPaymentMethod' };

type PaymentMethodFragment_VoucherPaymentMethod_Fragment = { __typename?: 'VoucherPaymentMethod' };

export type PaymentMethodFragmentFragment = PaymentMethodFragment_AchPaymentMethod_Fragment | PaymentMethodFragment_AffirmPaymentMethod_Fragment | PaymentMethodFragment_CardPaymentMethod_Fragment | PaymentMethodFragment_CheckPaymentMethod_Fragment | PaymentMethodFragment_EfTransferPaymentMethod_Fragment | PaymentMethodFragment_TransferPaymentMethod_Fragment | PaymentMethodFragment_VoucherPaymentMethod_Fragment;

export type PaymentScheduleMutationVariables = Exact<{
  draftOrderId: Scalars['ObjectId']['input'];
  input: CalculatePaymentScheduleInput;
}>;


export type PaymentScheduleMutation = { __typename?: 'Mutation', calculatePaymentSchedule: { __typename?: 'BusinessNotSpecifiedError', message: string } | { __typename?: 'DuplicateUniqueKeyError', message: string } | { __typename?: 'InvalidDateError', message: string } | { __typename?: 'InvalidPaymentScheduleError', message: string } | { __typename?: 'NotAuthorizedError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> } | { __typename?: 'ValidationError', message: string } };

export type PaymentScheduleFragment = { __typename?: 'PaymentSchedule', _id: string, frequency: PaymentScheduleFrequency, startDate: string, status: PaymentScheduleStatus, installments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }>, unprocessedInstallments: Array<{ __typename?: 'PaymentInstallment', _id: string, scheduledDate: string, amount: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } }> };

export type PublishDraftBookingMutationVariables = Exact<{
  publishDraftBookingId: Scalars['ObjectId']['input'];
  input?: InputMaybe<PublishDraftBookingInput>;
}>;


export type PublishDraftBookingMutation = { __typename?: 'Mutation', publishDraftBooking: { __typename?: 'Booking', _id: string } | { __typename?: 'BusinessNotSpecifiedError', code: string, message: string } | { __typename?: 'DuplicateUniqueKeyError', code: string, message: string } | { __typename?: 'InvalidDateError', code: string, message: string } | { __typename?: 'InvalidDepartureError', code: string, message: string } | { __typename?: 'InvalidOrderError', code: string, message: string } | { __typename?: 'InvalidPaymentError', code: string, message: string } | { __typename?: 'NotAuthorizedError', code: string, message: string } | { __typename?: 'NotFoundError', code: string, message: string } | { __typename?: 'ValidationError', allErrors: Array<string>, code: string, message: string } };

export type QuoteTripDepartingFlightOffersFragmentFragment = { __typename?: 'FlightOffer', salePrice?: { __typename?: 'Money', value: number } | null, discountAmount?: { __typename?: 'Money', value: number } | null, flight: { __typename?: 'FlightPackage', _id: string, lineItemCode: string, isLandOnly: boolean, departureGateway?: { __typename?: 'Gateway', code: string, stateCode?: string | null, internalCityName: string } | null } };

export type QuoteTripFlightOffersQueryVariables = Exact<{
  id: Scalars['ObjectId']['input'];
}>;


export type QuoteTripFlightOffersQuery = { __typename?: 'Query', draftOrder?: { __typename?: 'DraftOrder', _id: string, order: { __typename?: 'Booking', _id: string } | { __typename?: 'Quote', _id: string, trips: Array<{ __typename?: 'QuoteTrip', _id: string, isPrimary: boolean, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, departureGatewayCode: string, isLandOnly: boolean } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, arrivalGatewayCode: string, isLandOnly: boolean } | null, departingFlightOffers: Array<{ __typename?: 'FlightOffer', salePrice?: { __typename?: 'Money', value: number } | null, discountAmount?: { __typename?: 'Money', value: number } | null, flight: { __typename?: 'FlightPackage', _id: string, lineItemCode: string, isLandOnly: boolean, departureGateway?: { __typename?: 'Gateway', code: string, stateCode?: string | null, internalCityName: string } | null } }>, returningFlightOffers: Array<{ __typename?: 'FlightOffer', salePrice?: { __typename?: 'Money', value: number } | null, discountAmount?: { __typename?: 'Money', value: number } | null, flight: { __typename?: 'FlightPackage', _id: string, lineItemCode: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', code: string, stateCode?: string | null, internalCityName: string } | null } }> }> } } | null };

export type QuoteTripFlightOffersFragmentFragment = { __typename?: 'QuoteTrip', _id: string, isPrimary: boolean, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, departureGatewayCode: string, isLandOnly: boolean } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, arrivalGatewayCode: string, isLandOnly: boolean } | null, departingFlightOffers: Array<{ __typename?: 'FlightOffer', salePrice?: { __typename?: 'Money', value: number } | null, discountAmount?: { __typename?: 'Money', value: number } | null, flight: { __typename?: 'FlightPackage', _id: string, lineItemCode: string, isLandOnly: boolean, departureGateway?: { __typename?: 'Gateway', code: string, stateCode?: string | null, internalCityName: string } | null } }>, returningFlightOffers: Array<{ __typename?: 'FlightOffer', salePrice?: { __typename?: 'Money', value: number } | null, discountAmount?: { __typename?: 'Money', value: number } | null, flight: { __typename?: 'FlightPackage', _id: string, lineItemCode: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', code: string, stateCode?: string | null, internalCityName: string } | null } }> };

export type QuoteTripFragment = { __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, tripCustomer?: { __typename?: 'TripExistingCustomer', customerId: string } | { __typename?: 'TripNewCustomer', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null, insurancePlanOffers: Array<{ __typename?: 'InsurancePlanOffer', insurancePlan: { __typename?: 'InsurancePlan', _id: string, lineItemCode: string, planCode: string, purchasableAfterDays?: number | null, purchasableWithinDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string }, addons: Array<{ __typename?: 'InsurancePlanAddonOffer', insurancePlanAddon: { __typename?: 'InsurancePlanAddon', _id: string, lineItemCode: string, insurancePlanAddonCode: string, includedWithinDays?: number | null, preventPurchaseAfterDays?: number | null }, price: { __typename?: 'Money', currencyCode: CurrencyCode, value: number, formatted: string } }>, content?: { __typename?: 'InsurancePlanContent', description?: string | null, id: string, name?: string | null, includedAddonsTitle?: string | null, includedAddonsSubtitle?: string | null, includedAddonsDescription?: string | null, underwriterDescription?: string | null, planCode?: string | null, addons: Array<{ __typename?: 'InsurancePlanContentAddon', addonCode?: string | null, description?: string | null, name?: string | null, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', name?: string | null, description?: string | null, limitMessage?: string | null }> }>, benefits: Array<{ __typename?: 'InsurancePlanContentBenefit', description?: string | null, limitMessage?: string | null, name?: string | null }>, planSummaryDocument?: { __typename?: 'ContentAsset', filename?: string | null } | null, planSummaryLink?: { __typename?: 'ContentLink', url?: string | null, linkType?: string | null, cachedUrl?: string | null } | null } | null }>, extensionOffer?: { __typename?: 'DepartureExtensionOffer', appliedToTrip: boolean, discountAmount?: { __typename?: 'Money', value: number } | null, extension: { __typename?: 'DepartureExtension', lineItemCode: string }, salePrice?: { __typename?: 'Money', value: number } | null } | null, excursionOffers: Array<{ __typename?: 'DepartureExcursionOffer', discountAmount?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, salePrice?: { __typename?: 'Money', value: number, currencyCode: CurrencyCode } | null, excursion: { __typename?: 'DepartureExcursion', _id: string, lineItemCode: string, price: { __typename?: 'Amount', value: Array<{ __typename?: 'Money', value: number, currencyCode: CurrencyCode }> } } }>, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> };

export type QuoteTripReturningFlightOffersFragmentFragment = { __typename?: 'FlightOffer', salePrice?: { __typename?: 'Money', value: number } | null, discountAmount?: { __typename?: 'Money', value: number } | null, flight: { __typename?: 'FlightPackage', _id: string, lineItemCode: string, isLandOnly: boolean, arrivalGateway?: { __typename?: 'Gateway', code: string, stateCode?: string | null, internalCityName: string } | null } };

export type ReviewAggregateQueryVariables = Exact<{
  tourCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  businessCode: BusinessCode;
}>;


export type ReviewAggregateQuery = { __typename?: 'Query', reviewAggregate?: { __typename?: 'ReviewAggregate', avgRating: number } | null };

export type SavedPaymentMethodFragment = { __typename?: 'SavedPaymentMethod', _id: string, isActive: boolean, isExpired: boolean, paymentMethod: { __typename?: 'ACHPaymentMethod', accountNumberMask: string, firstName: string, lastName: string, routingNumber: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } | { __typename?: 'CardPaymentMethod', cardBrand: CardBrand, cardType: CardType, cardNumberMask: string, expirationMonth: number, expirationYear: number, firstName: string, lastName: string, address?: { __typename?: 'Address', city: string, state: string, street1: string, street2?: string | null, postalCode: string, country: string } | null } };

export type TermFragment = { __typename?: 'Term', _id: string, content?: { } | null, certificationText?: string | null, termType: TermType };

export type TourExcursionLineItemFragmentFragment = { __typename?: 'TourExcursionLineItem', lineItemCode: string, price: { __typename?: 'Money', value: number, formatted: string, currencyCode: CurrencyCode } };

type Trip_BookingTrip_Fragment = { __typename?: 'BookingTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> };

type Trip_QuoteTrip_Fragment = { __typename?: 'QuoteTrip', departureDate: string, endDate: string, customerId?: string | null, customerType: TripCustomerType, hasExtension: boolean, requestedRoommates?: Array<string> | null, _id: string, isLandOnly: boolean, isPrimary: boolean, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null, customer?: { __typename?: 'Customer', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, wishlist: Array<{ __typename?: 'WishlistItem', _id: string, tourCode: string }>, profileImageAsset?: { __typename?: 'Asset', location: string, _id: string } | null, address?: { __typename?: 'Address', city: string, country: string, postalCode: string, state: string, street1: string, street2?: string | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', suffix?: string | null, identityDocumentNumber?: string | null, middleName?: string | null, maskedIdentityDocumentNumber?: string | null, lastName?: string | null, issueDate?: string | null, gender?: TsaGender | null, firstName?: string | null, expirationDate?: string | null, dateOfBirth?: string | null, countryOfIssue?: string | null, confirmationDate?: string | null } | null, tourLineItem?: { __typename?: 'TourLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExcursionLineItems: Array<{ __typename?: 'TourExcursionLineItem', lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, openRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openExtensionRoomLineItem?: { __typename?: 'TourRoomLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceLineItem?: { __typename?: 'InsuranceLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | null, openInsuranceAddonLineItems: Array<{ __typename?: 'InsuranceAddonLineItem', _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, lineItems: Array<{ __typename?: 'AdjustmentLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'ExtendedStayLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FeeLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'FlightPackageLineItem', status: LineItemStatus, _id: string, isQuoted: boolean, lineItemCode: string, arrivalGatewayCode: string, departureGatewayCode: string, flightType: FlightType, departureDate: string, isLandOnly: boolean, targetLineItemId?: string | null, rollsUpToTarget: boolean, arrivalGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, departureGateway?: { __typename?: 'Gateway', cityCode: string, stateCode?: string | null, code: string, internalCityName: string } | null, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceAddonLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'InsuranceLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PrivateGroupLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'PromoLineItem', lineItemCode: string, promoCode: string, targetType?: TripComponentType | null, campaignCode?: string | null, status: LineItemStatus, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExcursionLineItem', status: LineItemStatus, lineItemCode: string, _id: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourExtensionLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } } | { __typename?: 'TourRoomLineItem', status: LineItemStatus, _id: string, lineItemCode: string, targetLineItemId?: string | null, rollsUpToTarget: boolean, price: { __typename?: 'Money', currencyCode: CurrencyCode, formatted: string, value: number } }>, roomOffers: Array<{ __typename?: 'DepartureRoomOffer', discountAmount?: { __typename?: 'Money', value: number } | null, salePrice?: { __typename?: 'Money', value: number } | null, room: { __typename?: 'DepartureRoom', _id: string, lineItemCode: string } }> };

export type TripFragment = Trip_BookingTrip_Fragment | Trip_QuoteTrip_Fragment;

export const ClassLevelRoomingContentFragmentDoc = gql`
    fragment ClassLevelRoomingContent on TourClassLevelContent {
  name
  description
  roomingDescription
  roomingDetailedDescription
  roomingUpgradeDescription
}
    `;
export const ActivityLevelContentFragmentDoc = gql`
    fragment ActivityLevelContent on TourActivityLevelContent {
  activityLevel
  name
  description
  icon {
    filename
    alt
  }
}
    `;
export const DepartureTourContentFragmentDoc = gql`
    fragment DepartureTourContent on TourContent {
  id
  name
  nbDaysWithExtension
  cardImage {
    alt
    filename
  }
  includesBreakfast
  postBookingFaq {
    items {
      answer
      question
    }
  }
  equipment {
    name
  }
  tour {
    _id
    places {
      _id
      type
    }
    classLevelContent(language: $language) {
      ...ClassLevelRoomingContent
    }
    activityLevelContent(language: $language) {
      ...ActivityLevelContent
    }
  }
}
    ${ClassLevelRoomingContentFragmentDoc}
${ActivityLevelContentFragmentDoc}`;
export const DepartureTourExtensionContentFragmentDoc = gql`
    fragment DepartureTourExtensionContent on TourExtensionContent {
  name
  description
  image {
    alt
    filename
  }
  nbNights
}
    `;
export const BookingDepartureFragmentDoc = gql`
    fragment BookingDeparture on Departure {
  _id
  departureDate
  endDate
  endGatewayCode
  salesTourId
  status
  tourCode
  startGatewayCode
  tourContent(language: $language) {
    ...DepartureTourContent
  }
  activeExtensionContent(language: $language) {
    ...DepartureTourExtensionContent
  }
  tour {
    _id
    nbTourDays
    activityLevelContent(language: $language) {
      ...ActivityLevelContent
    }
    classLevel
  }
  finalInstallmentDeadline
}
    ${DepartureTourContentFragmentDoc}
${DepartureTourExtensionContentFragmentDoc}
${ActivityLevelContentFragmentDoc}`;
export const CustomerFragmentDoc = gql`
    fragment Customer on Customer {
  _id
  email
  firstName
  lastName
  phoneNumber
  wishlist {
    _id
    tourCode
  }
  profileImageAsset {
    location
    _id
  }
  address {
    city
    country
    postalCode
    state
    street1
    street2
  }
}
    `;
export const BasicLineItemFragmentDoc = gql`
    fragment BasicLineItem on LineItem {
  _id
  lineItemCode
  targetLineItemId
  rollsUpToTarget
  price {
    currencyCode
    formatted
    value
  }
}
    `;
export const MoneyFragmentFragmentDoc = gql`
    fragment MoneyFragment on Money {
  value
  formatted
  currencyCode
}
    `;
export const TourExcursionLineItemFragmentFragmentDoc = gql`
    fragment TourExcursionLineItemFragment on TourExcursionLineItem {
  lineItemCode
  price {
    ...MoneyFragment
  }
}
    ${MoneyFragmentFragmentDoc}`;
export const FlightPackageLineItemFragmentDoc = gql`
    fragment FlightPackageLineItem on FlightPackageLineItem {
  _id
  status
  isQuoted
  lineItemCode
  arrivalGatewayCode
  departureGatewayCode
  flightType
  departureDate
  isLandOnly
  arrivalGateway {
    cityCode
    stateCode
    code
    internalCityName
  }
  departureGateway {
    cityCode
    stateCode
    code
    internalCityName
  }
}
    `;
export const TripFragmentDoc = gql`
    fragment Trip on Trip {
  address {
    city
    country
    postalCode
    state
    street1
    street2
  }
  customer {
    ...Customer
  }
  departureDate
  endDate
  customerId
  customerType
  hasExtension
  tsaInformation {
    suffix
    identityDocumentNumber
    middleName
    maskedIdentityDocumentNumber
    lastName
    issueDate
    gender
    firstName
    expirationDate
    dateOfBirth
    countryOfIssue
    confirmationDate
  }
  requestedRoommates
  _id
  isLandOnly
  isPrimary
  tourLineItem {
    ...BasicLineItem
  }
  openExcursionLineItems {
    ...TourExcursionLineItemFragment
    ...BasicLineItem
  }
  openRoomLineItem {
    ...BasicLineItem
  }
  openExtensionLineItem {
    ...BasicLineItem
  }
  openDepartingFlightLineItem {
    ...BasicLineItem
  }
  openExtensionRoomLineItem {
    ...BasicLineItem
  }
  openInsuranceLineItem {
    ...BasicLineItem
  }
  openInsuranceAddonLineItems {
    ...BasicLineItem
  }
  lineItems {
    ...BasicLineItem
    status
    ... on FlightPackageLineItem {
      ...FlightPackageLineItem
    }
    ... on TourExcursionLineItem {
      ...TourExcursionLineItemFragment
    }
    ... on PromoLineItem {
      lineItemCode
      promoCode
      targetType
      campaignCode
    }
  }
  roomOffers {
    discountAmount {
      value
    }
    salePrice {
      value
    }
    room {
      _id
      lineItemCode
    }
  }
}
    ${CustomerFragmentDoc}
${BasicLineItemFragmentDoc}
${TourExcursionLineItemFragmentFragmentDoc}
${FlightPackageLineItemFragmentDoc}`;
export const BookingTripFragmentDoc = gql`
    fragment BookingTrip on BookingTrip {
  _id
  ...Trip
  insurancePlanOffers {
    addons {
      insurancePlanAddon {
        _id
      }
    }
    insurancePlan {
      _id
    }
  }
}
    ${TripFragmentDoc}`;
export const BookingFragmentFragmentDoc = gql`
    fragment BookingFragment on Booking {
  _id
  customer {
    email
  }
  departure {
    ...BookingDeparture
  }
  trips {
    ...BookingTrip
  }
  grandTotal {
    currencyCode
    formatted
    value
  }
  gcDeparture {
    micrositeContent(language: $language) {
      title
    }
  }
}
    ${BookingDepartureFragmentDoc}
${BookingTripFragmentDoc}`;
export const DepartureRoomFragmentDoc = gql`
    fragment DepartureRoom on DepartureRoom {
  _id
  isPurchasable
  capacity
  nbSpotsBooked
  lineItemCode
  cabinCode
  bed {
    code
    capacity
    count
    name
  }
  price {
    value {
      currencyCode
      formatted
      value
    }
  }
  content(language: $language) {
    name
    description
  }
  status
}
    `;
export const DepartureExcursionFragmentDoc = gql`
    fragment DepartureExcursion on DepartureExcursion {
  status
  content(language: $language) {
    name
    id
    description
    departureInfo
    duration
    image {
      filename
    }
  }
  lineItemCode
  price {
    value {
      currencyCode
      formatted
      value
    }
  }
  isPurchasable
}
    `;
export const DepartureExtensionFragmentDoc = gql`
    fragment DepartureExtension on DepartureExtension {
  _id
  lineItemCode
  status
  isPreExtension
  endDate
  price {
    value {
      currencyCode
      formatted
      value
    }
  }
  rooms {
    ...DepartureRoom
  }
  excursions {
    ...DepartureExcursion
  }
}
    ${DepartureRoomFragmentDoc}
${DepartureExcursionFragmentDoc}`;
export const CheckoutDepartureFragmentDoc = gql`
    fragment CheckoutDeparture on Departure {
  _id
  departureDate
  endDate
  endGatewayCode
  salesTourId
  status
  tourCode
  autoApproveDeadline
  rooms {
    ...DepartureRoom
  }
  activeExtension {
    ...DepartureExtension
  }
  activeExtensionContent(language: $language) {
    ...DepartureTourExtensionContent
  }
  excursions {
    ...DepartureExcursion
  }
  flightsRelease {
    releaseDate
  }
  hotelsRelease {
    releaseDate
  }
  flightsRequestDeadline
  price {
    value {
      currencyCode
      formatted
      value
    }
  }
  priceYear {
    year
  }
  departureDate
  startGatewayCode
  tourCode
  tourContent(language: $language) {
    ...DepartureTourContent
  }
  tour {
    _id
    nbTourDays
    activityLevelContent(language: $language) {
      ...ActivityLevelContent
    }
    classLevel
  }
  finalInstallmentDeadline
}
    ${DepartureRoomFragmentDoc}
${DepartureExtensionFragmentDoc}
${DepartureTourExtensionContentFragmentDoc}
${DepartureExcursionFragmentDoc}
${DepartureTourContentFragmentDoc}
${ActivityLevelContentFragmentDoc}`;
export const BasicCustomerFragmentDoc = gql`
    fragment BasicCustomer on Customer {
  _id
  email
  firstName
  lastName
  profileImageAsset {
    location
    _id
  }
}
    `;
export const BasicOldTripFragmentDoc = gql`
    fragment BasicOldTrip on OldTrip {
  ... on OldTrip {
    _id
    tourInternalName
    tourCode
    startDate
    endDate
  }
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  city
  state
  street1
  street2
  postalCode
  country
}
    `;
export const PaymentMethodFragmentFragmentDoc = gql`
    fragment PaymentMethodFragment on TransactionPaymentMethod {
  ... on ACHPaymentMethod {
    accountNumberMask
    firstName
    lastName
    routingNumber
    address {
      ...Address
    }
  }
  ... on CardPaymentMethod {
    cardBrand
    cardType
    cardNumberMask
    expirationMonth
    expirationYear
    firstName
    lastName
    address {
      ...Address
    }
  }
}
    ${AddressFragmentDoc}`;
export const SavedPaymentMethodFragmentDoc = gql`
    fragment SavedPaymentMethod on SavedPaymentMethod {
  _id
  isActive
  isExpired
  paymentMethod {
    ...PaymentMethodFragment
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;
export const CustomerWithPaymentFragmentDoc = gql`
    fragment CustomerWithPayment on Customer {
  _id
  email
  firstName
  lastName
  phoneNumber
  profileImageAsset {
    location
    _id
  }
  savedPaymentMethods(businessCode: $businessCode, isActive: true) {
    ...SavedPaymentMethod
  }
  address {
    city
    country
    postalCode
    state
    street1
    street2
  }
  loyaltyLevel(businessCode: $businessCode) {
    _id
    content(language: $language) {
      icon {
        alt
        filename
      }
      name
    }
    repeatPromoCode
    repeatDiscount {
      value {
        currencyCode
        formatted
        value
      }
    }
    returnWindowDiscount {
      value {
        currencyCode
        formatted
        value
      }
    }
  }
}
    ${SavedPaymentMethodFragmentDoc}`;
export const BookingDepartureRoomFragmentDoc = gql`
    fragment BookingDepartureRoom on DepartureRoom {
  _id
  lineItemCode
  content(language: $language) {
    name
  }
}
    `;
export const MeBookingDepartureFragmentDoc = gql`
    fragment MeBookingDeparture on Departure {
  _id
  departureDate
  endDate
  endGatewayCode
  rooms {
    ...BookingDepartureRoom
  }
  activeExtension {
    _id
    rooms {
      ...BookingDepartureRoom
    }
    status
    excursions {
      _id
      lineItemCode
      content(language: $language) {
        name
      }
    }
  }
  activeExtensionContent(language: $language) {
    id
    tourCode
    name
  }
  excursions {
    _id
    lineItemCode
    content(language: $language) {
      name
    }
  }
  flightsRelease {
    releaseDate
  }
  hotelsRelease {
    releaseDate
  }
  price {
    value {
      currencyCode
      formatted
      value
    }
  }
  priceYear {
    year
  }
  departureDate
  startGatewayCode
  tourCode
  tourContent(language: $language) {
    id
    name
    cardImage {
      alt
      filename
    }
    postBookingFaq {
      items {
        answer
        question
      }
    }
  }
  tour {
    _id
    nbTourDays
    activityLevelContent(language: $language) {
      ...ActivityLevelContent
    }
    classLevel
  }
  finalInstallmentDeadline
  status
}
    ${BookingDepartureRoomFragmentDoc}
${ActivityLevelContentFragmentDoc}`;
export const BookingCustomerFragmentDoc = gql`
    fragment BookingCustomer on Customer {
  _id
  email
  firstName
  lastName
}
    `;
export const TsaInfoFragmentFragmentDoc = gql`
    fragment TsaInfoFragment on TSAInformation {
  _id
  confirmationDate
  countryOfIssue
  dateOfBirth
  expirationDate
  firstName
  gender
  issueDate
  lastName
  maskedIdentityDocumentNumber
  middleName
  suffix
  type
}
    `;
export const EmergencyContactFragmentDoc = gql`
    fragment EmergencyContact on EmergencyContact {
  _id
  confirmationDate
  email
  firstName
  lastName
  phone
  relationship
}
    `;
export const NoteFragmentDoc = gql`
    fragment Note on TravelerNote {
  acknowledged
  text
}
    `;
export const MeBookingTripFragmentDoc = gql`
    fragment MeBookingTrip on BookingTrip {
  _id
  customer {
    ...BookingCustomer
  }
  customerType
  checklistItems {
    description
    dueDate
    id
    checklistItemTemplateId
    importanceLevel
    internalName
    isChecked
    status
    title
  }
  currencyCode
  timingStatus
  tsaInformation {
    hasCompletedPassportInformation
    hasConfirmedTsaIdentifiers
    ...TsaInfoFragment
  }
  tsaIdentifiersSelfServiceDeadline
  emergencyContacts {
    ...EmergencyContact
  }
  emergencyContactChecklistItem {
    dueDate
    isCompleted
    status
  }
  emergencyContactsSelfServiceDeadline
  endDate
  passportInformationChecklistItem {
    dueDate
    isCompleted
    status
  }
  passportInformationSelfServiceDeadline
  termsSignatureChecklistItem {
    dueDate
    isCompleted
    status
  }
  tsaIdentifiersChecklistItem {
    dueDate
    isCompleted
    status
  }
  healthNotesChecklistItem {
    dueDate
    isCompleted
    status
  }
  healthNotesSelfServiceDeadline
  hasSignedTerms
  termsAcceptedAt
  signedTerms {
    _id
  }
  isPrimary
  tourLineItem {
    ...BasicLineItem
  }
  openExcursionLineItems {
    ...BasicLineItem
  }
  openRoomLineItem {
    ...BasicLineItem
  }
  openExtensionLineItem {
    departureDate
    endDate
    ...BasicLineItem
  }
  openExtensionRoomLineItem {
    ...BasicLineItem
  }
  openFeeLineItems {
    ...BasicLineItem
  }
  openPrivateGroupLineItem {
    ...BasicLineItem
  }
  openAdjustmentLineItems {
    ...BasicLineItem
  }
  openDepartingFlightLineItem {
    ...BasicLineItem
    departureGateway {
      internalCityName
      cityCode
    }
  }
  openReturningFlightLineItem {
    ...BasicLineItem
    departureGateway {
      internalCityName
      cityCode
    }
  }
  openPromoLineItems {
    ...BasicLineItem
    promoCode
  }
  openInsuranceLineItem {
    ...BasicLineItem
  }
  openInsuranceAddonLineItems {
    ...BasicLineItem
  }
  travelerNotes {
    _id
    dietaryNotes {
      ...Note
    }
    medicalNotes {
      ...Note
    }
    mobilityNotes {
      ...Note
    }
  }
  grandTotal {
    ...MoneyFragment
  }
}
    ${BookingCustomerFragmentDoc}
${TsaInfoFragmentFragmentDoc}
${EmergencyContactFragmentDoc}
${BasicLineItemFragmentDoc}
${NoteFragmentDoc}
${MoneyFragmentFragmentDoc}`;
export const PaymentScheduleFragmentDoc = gql`
    fragment PaymentSchedule on PaymentSchedule {
  ... on PaymentSchedule {
    _id
    frequency
    startDate
    status
    installments {
      _id
      amount {
        ...MoneyFragment
      }
      scheduledDate
    }
    unprocessedInstallments {
      _id
      amount {
        ...MoneyFragment
      }
      scheduledDate
    }
  }
}
    ${MoneyFragmentFragmentDoc}`;
export const GcDepartureFragmentDoc = gql`
    fragment GCDeparture on GCDeparture {
  _id
  nbTravelersWithExtension
  nbTravelersConfirmed
  nbTravelersCancelled
  departure {
    nbSpotsLeft
  }
  micrositeContent(language: $language) {
    title
  }
}
    `;
export const MeBookingFragmentDoc = gql`
    fragment MeBooking on Booking {
  _id
  currencyCode
  trips {
    _id
    ... on BookingTrip {
      ...MeBookingTrip
    }
  }
  transactions {
    ... on DebitPaymentTransaction {
      paymentScheduleId
    }
    ... on CreditPaymentTransaction {
      reasonCode
    }
    _id
    transactionDate
    amount {
      ...MoneyFragment
    }
    paymentMethod {
      ...PaymentMethodFragment
    }
    displayStatus
  }
  activePaymentSchedule {
    ...PaymentSchedule
  }
  gcDeparture {
    ...GCDeparture
  }
  paymentOptions {
    ... on BookingAutopayPaymentOption {
      allowedPaymentMethods
      earliestPaymentScheduleStartDate
      latestPaymentScheduleStartDate
      type
    }
    ... on BookingManualPaymentOption {
      allowedPaymentMethods
      type
    }
  }
  balance {
    ...MoneyFragment
  }
  amountPaid {
    ...MoneyFragment
  }
  grandTotal {
    ...MoneyFragment
  }
  minimumAmountDue {
    ...MoneyFragment
  }
  isEnrolledInAutopay
  finalPaymentDate
  latestFinalPaymentDate
}
    ${MeBookingTripFragmentDoc}
${MoneyFragmentFragmentDoc}
${PaymentMethodFragmentFragmentDoc}
${PaymentScheduleFragmentDoc}
${GcDepartureFragmentDoc}`;
export const BookingSummaryInsurancePlanOfferFragmentDoc = gql`
    fragment BookingSummaryInsurancePlanOffer on InsurancePlanOffer {
  insurancePlan {
    lineItemCode
  }
  price {
    currencyCode
    value
    formatted
  }
  addons {
    insurancePlanAddon {
      lineItemCode
      insurancePlanAddonCode
    }
    price {
      currencyCode
      value
      formatted
    }
  }
  content(language: $language) {
    addons {
      addonCode
      name
    }
    id
    name
  }
}
    `;
export const MeBookingTripWithBookingFragmentDoc = gql`
    fragment MeBookingTripWithBooking on BookingTrip {
  _id
  customer {
    _id
    firstName
  }
  timingStatus
  customerType
  status
  hasSignedTerms
  departure {
    ...MeBookingDeparture
  }
  booking {
    ...MeBooking
  }
  insurancePlanOffers {
    ...BookingSummaryInsurancePlanOffer
  }
  status
  review {
    _id
  }
  canBeReviewed
}
    ${MeBookingDepartureFragmentDoc}
${MeBookingFragmentDoc}
${BookingSummaryInsurancePlanOfferFragmentDoc}`;
export const MyAccountBasicDepartureFragmentDoc = gql`
    fragment MyAccountBasicDeparture on Departure {
  _id
  departureDate
  endDate
  dpd
  activeExtension {
    _id
    excursions {
      _id
      lineItemCode
    }
  }
  activeExtensionContent(language: $language) {
    id
    tourCode
    name
  }
  tourCode
  tourContent(language: $language) {
    id
    name
    cardImage {
      alt
      filename
    }
  }
  timingStatus
  status
}
    `;
export const MyAccountTripWithChecklistFragmentDoc = gql`
    fragment MyAccountTripWithChecklist on BookingTrip {
  _id
  customer {
    ...BookingCustomer
  }
  isPrimary
  customerType
  checklistItems {
    description
    dueDate
    id
    checklistItemTemplateId
    importanceLevel
    internalName
    isChecked
    status
    title
  }
  emergencyContactChecklistItem {
    dueDate
    isCompleted
    status
  }
  passportInformationChecklistItem {
    dueDate
    isCompleted
    status
  }
  termsSignatureChecklistItem {
    dueDate
    isCompleted
    status
  }
  tsaIdentifiersChecklistItem {
    dueDate
    isCompleted
    status
  }
  healthNotesChecklistItem {
    dueDate
    isCompleted
    status
  }
}
    ${BookingCustomerFragmentDoc}`;
export const MyAccountBasicBookingFragmentDoc = gql`
    fragment MyAccountBasicBooking on Booking {
  _id
  currencyCode
  gcDeparture {
    _id
    micrositeContent(language: $language) {
      title
    }
  }
  trips {
    _id
    ... on BookingTrip {
      ...MyAccountTripWithChecklist
    }
  }
}
    ${MyAccountTripWithChecklistFragmentDoc}`;
export const TripFlightSegmentFragmentDoc = gql`
    fragment TripFlightSegment on TripFlightSegment {
  airlineLocator
  arrivesAtLocalTime
  arrivalGateway {
    code
    internalCityName
    stateCode
  }
  departsAtLocalTime
  departureGateway {
    code
    internalCityName
    stateCode
  }
  carrier {
    _id
    code
    iataCode
    icaoCode
    name
    phoneNumber
    shortName
    websiteUrl
  }
  flightNumber
  pnrLocator
  pnrSegmentNumber
  operatedByCarrier {
    _id
    code
    name
    shortName
  }
  ticketNumber
  type
}
    `;
export const MyAccountBasicMyTripFragmentDoc = gql`
    fragment MyAccountBasicMyTrip on BookingTrip {
  _id
  customer {
    _id
  }
  timingStatus
  customerType
  status
  hasSignedTerms
  canBeReviewed
  openExtensionLineItem {
    ...BasicLineItem
  }
  dateBooked
  departureDate
  endDate
  departure {
    ...MyAccountBasicDeparture
  }
  booking {
    ...MyAccountBasicBooking
  }
  status
  review {
    _id
  }
  evaluationRelease {
    isReleased
    releaseDate
  }
  evaluation {
    _id
    hasBeenStarted
    submissionDate
    finalizationDate
    deadlineDate
    availabilityDate
  }
  openDepartingFlightLineItem {
    ...FlightPackageLineItem
  }
  openReturningFlightLineItem {
    ...FlightPackageLineItem
  }
  isLandOnly
  flights {
    hasFullItinerary
    isFullyTicketed
    departingFlights {
      ...TripFlightSegment
    }
    returningFlights {
      ...TripFlightSegment
    }
  }
  isPrimary
}
    ${BasicLineItemFragmentDoc}
${MyAccountBasicDepartureFragmentDoc}
${MyAccountBasicBookingFragmentDoc}
${FlightPackageLineItemFragmentDoc}
${TripFlightSegmentFragmentDoc}`;
export const SavedQuoteFragmentDoc = gql`
    fragment SavedQuote on Quote {
  _id
  businessCode
  customer {
    _id
  }
  grandTotal {
    value
    currencyCode
    formatted
  }
  gcDepartureId
  isSaved
  expirationDate
  isExpired
  stage
  departure {
    _id
    tourCode
    tourContent(language: $language) {
      id
      name
      cardImage {
        id
        filename
        alt
      }
    }
    tour {
      _id
      classLevelContent(language: $language) {
        name
        icon {
          filename
          alt
        }
      }
    }
  }
  trips {
    _id
    isPrimary
    hasExtension
    departureDate
    endDate
    tripCustomer {
      ... on TripExistingCustomer {
        customerId
      }
    }
  }
}
    `;
export const CanceledGroupMemberDetailsFragmentDoc = gql`
    fragment CanceledGroupMemberDetails on BookingTrip {
  _id
  customer {
    _id
    lastName
    firstName
    phoneNumber
    email
    address {
      street1
      street2
      city
      state
      postalCode
      country
    }
  }
  dateBooked
  cancellationMeta {
    cancellationDate
  }
}
    `;
export const ConfirmedRequestedGroupMemberTripsFragmentDoc = gql`
    fragment ConfirmedRequestedGroupMemberTrips on BookingTrip {
  _id
  status
  isPrimary
  dateBooked
  customer {
    _id
    lastName
    firstName
    address {
      street1
      street2
      city
      state
      country
      postalCode
    }
    email
    phoneNumber
  }
  openExtensionRoomLineItem {
    lineItemCode
  }
  openRoomLineItem {
    lineItemCode
  }
  booking {
    _id
    finalPaymentDate
    latestFinalPaymentDate
    balance {
      formatted
    }
    isEnrolledInAutopay
  }
  lineItems {
    _id
    lineItemCode
    status
    type
  }
  isLandOnly
  hasInsurance
  openDepartingFlightLineItem {
    _id
    departureGatewayCode
    departureDate
    departureGateway {
      _id
      stateCode
      internalCityName
    }
  }
  openReturningFlightLineItem {
    _id
    departureDate
  }
  openInsuranceLineItem {
    _id
    isPurchased
    lineItemCode
  }
  openInsuranceAddonLineItems {
    isPurchased
    type
    lineItemCode
    _id
  }
  insurancePlanOffers {
    insurancePlan {
      lineItemCode
      type
      _id
    }
    addons {
      insurancePlanAddon {
        lineItemCode
        insurancePlanAddonCode
        type
        _id
      }
    }
    content(language: $language) {
      id
      name
      addons {
        addonCode
        description
        name
      }
    }
  }
  roommates {
    _id
    lastName
    firstName
  }
  extensionRoommates {
    _id
    lastName
    firstName
  }
  hasSignedTerms
  hasTsaInformation
  healthNotesChecklistItem {
    dueDate
    isCompleted
    status
  }
  emergencyContactChecklistItem {
    dueDate
    isCompleted
    status
  }
  tsaIdentifiersChecklistItem {
    dueDate
    isCompleted
    status
  }
  passportInformationChecklistItem {
    dueDate
    isCompleted
    status
  }
  openExtensionLineItem {
    _id
    isPurchased
    status
  }
  openExcursionLineItems {
    _id
    status
    isPurchased
    lineItemCode
  }
  passportInformationChecklistItem {
    dueDate
    isCompleted
    status
  }
}
    `;
export const GroupMemberProspectDetailsFragmentDoc = gql`
    fragment GroupMemberProspectDetails on GCDepartureProspect {
  _id
  firstName
  lastName
  email
  phoneNumber
  createdAt
  levelOfInterest
  address {
    street1
    street2
    city
    state
    postalCode
    country
  }
}
    `;
export const GroupDepartureExtensionExcursionFragmentDoc = gql`
    fragment GroupDepartureExtensionExcursion on DepartureExcursion {
  _id
  lineItemCode
  content(language: $language) {
    id
    name
  }
}
    `;
export const GroupMembersDepartureFragmentDoc = gql`
    fragment GroupMembersDeparture on Departure {
  _id
  departureDate
  excursions {
    ...GroupDepartureExtensionExcursion
  }
  activeExtension {
    _id
    excursions {
      ...GroupDepartureExtensionExcursion
    }
    rooms {
      _id
      lineItemCode
      bed {
        code
        name
      }
    }
  }
  nbSpotsLeft
  flightsRelease {
    releaseDate
    isReleased
  }
  rooms {
    _id
    lineItemCode
    bed {
      code
      name
    }
  }
}
    ${GroupDepartureExtensionExcursionFragmentDoc}`;
export const TravelerDetailBookingTripTermsSignatureFragmentDoc = gql`
    fragment TravelerDetailBookingTripTermsSignature on TermsSignature {
  termId
  signingCustomer {
    _id
    firstName
    lastName
  }
}
    `;
export const TravelerDetailBookingTripFragmentDoc = gql`
    fragment TravelerDetailBookingTrip on BookingTrip {
  _id
  currencyCode
  endDate
  tsaInformation {
    hasCompletedPassportInformation
    hasConfirmedTsaIdentifiers
    ...TsaInfoFragment
  }
  hasSignedTerms
  termsAcceptedAt
  isPrimary
  signedTerms {
    _id
  }
  termsSignature {
    ...TravelerDetailBookingTripTermsSignature
  }
  customer {
    _id
    firstName
    lastName
  }
  customerType
  currencyCode
  termsSignatureChecklistItem {
    dueDate
    isCompleted
    status
  }
  tsaIdentifiersChecklistItem {
    dueDate
    isCompleted
    status
  }
  tsaIdentifiersSelfServiceDeadline
  passportInformationChecklistItem {
    dueDate
    isCompleted
    status
  }
  passportInformationSelfServiceDeadline
  emergencyContactChecklistItem {
    dueDate
    isCompleted
    status
  }
  emergencyContactsSelfServiceDeadline
  healthNotesChecklistItem {
    dueDate
    isCompleted
    status
  }
  healthNotesSelfServiceDeadline
  emergencyContacts {
    ...EmergencyContact
  }
  travelerNotes {
    _id
    dietaryNotes {
      ...Note
    }
    medicalNotes {
      ...Note
    }
    mobilityNotes {
      ...Note
    }
  }
}
    ${TsaInfoFragmentFragmentDoc}
${TravelerDetailBookingTripTermsSignatureFragmentDoc}
${EmergencyContactFragmentDoc}
${NoteFragmentDoc}`;
export const TravelerDetailBookingTripWithDepartureIdFragmentDoc = gql`
    fragment TravelerDetailBookingTripWithDepartureId on BookingTrip {
  ...TravelerDetailBookingTrip
  departure {
    _id
  }
}
    ${TravelerDetailBookingTripFragmentDoc}`;
export const TravelerDetailDepartureFragmentDoc = gql`
    fragment TravelerDetailDeparture on Departure {
  _id
  departureDate
  tour {
    _id
    activityLevelContent(language: $language) {
      ...ActivityLevelContent
    }
    content(language: $language) {
      id
      name
    }
  }
}
    ${ActivityLevelContentFragmentDoc}`;
export const TravelerDetailBookingTripWithDepartureFragmentDoc = gql`
    fragment TravelerDetailBookingTripWithDeparture on BookingTrip {
  ...TravelerDetailBookingTrip
  departure {
    ...TravelerDetailDeparture
  }
  booking {
    gcDeparture {
      _id
    }
  }
}
    ${TravelerDetailBookingTripFragmentDoc}
${TravelerDetailDepartureFragmentDoc}`;
export const ExtendedStayFragmentDoc = gql`
    fragment ExtendedStay on ExtendedStayLineItem {
  _id
  lineItemCode
  departureDate
  endDate
  bedCode
  cityGateway {
    _id
    internalCityLongName
  }
}
    `;
export const HotelDepartureRoomFragmentDoc = gql`
    fragment HotelDepartureRoom on DepartureRoom {
  _id
  lineItemCode
  content(language: $language) {
    name
    description
  }
  bed {
    capacity
  }
}
    `;
export const HotelFragmentDoc = gql`
    fragment Hotel on TripHotel {
  endDate
  name
  phoneNumber
  startDate
  type
  website
  address {
    city
    country
    postalCode
    state
    street1
    street2
  }
}
    `;
export const CustomizationExcursionFragmentDoc = gql`
    fragment CustomizationExcursion on DepartureExcursion {
  status
  _id
  content(language: $language) {
    name
    id
    description
    departureInfo
    duration
    image {
      alt
      filename
      focus
    }
  }
  price {
    value {
      currencyCode
      value
    }
  }
  tourExcursion {
    isPrebook
  }
  autoApproveDeadline
  isPurchasable
  lineItemCode
}
    `;
export const CustomizationActiveExtensionFragmentDoc = gql`
    fragment CustomizationActiveExtension on DepartureExtension {
  _id
  lineItemCode
  price {
    value {
      value
      currencyCode
    }
  }
  excursions {
    ...CustomizationExcursion
  }
}
    ${CustomizationExcursionFragmentDoc}`;
export const CustomizationExtensionContentFragmentDoc = gql`
    fragment CustomizationExtensionContent on TourExtensionContent {
  description
  image {
    alt
    filename
  }
  isHidden
  name
  nbNights
}
    `;
export const CustomizationTripFragmentDoc = gql`
    fragment CustomizationTrip on BookingTrip {
  _id
  lineItems {
    _id
    lineItemCode
    type
    status
    isOpen
    cancellationMeta {
      cancellationReason
    }
  }
  customer {
    _id
    firstName
    lastName
  }
  openExtensionLineItem {
    _id
    lineItemCode
    isQuoted
    status
    price {
      currencyCode
      formatted
      value
    }
  }
}
    `;
export const DraftBookingCustomizationsTourExcursionLineItemFragmentDoc = gql`
    fragment DraftBookingCustomizationsTourExcursionLineItem on TourExcursionLineItem {
  _id
  lineItemCode
  isQuoted
  status
  price {
    currencyCode
    formatted
    value
  }
  cancellationMeta {
    cancellationReason
  }
}
    `;
export const DraftBookingCustomizationsTripFragmentDoc = gql`
    fragment DraftBookingCustomizationsTrip on BookingTrip {
  _id
  openExcursionLineItems {
    ...DraftBookingCustomizationsTourExcursionLineItem
  }
  customer {
    _id
    firstName
    lastName
  }
  openLineItems {
    _id
    lineItemCode
    isQuoted
    status
    price {
      currencyCode
      formatted
      value
    }
  }
  isPrimary
}
    ${DraftBookingCustomizationsTourExcursionLineItemFragmentDoc}`;
export const DraftBookingCustomizationsOrderFragmentDoc = gql`
    fragment DraftBookingCustomizationsOrder on Booking {
  _id
  trips {
    ...DraftBookingCustomizationsTrip
  }
  minimumAmountDue {
    currencyCode
    formatted
    value
  }
  paymentOptions {
    ... on BookingManualPaymentOption {
      allowedPaymentMethods
      type
    }
  }
  isEnrolledInAutopay
  paymentSchedules {
    _id
    unprocessedInstallments {
      _id
      amount {
        currencyCode
        formatted
        value
      }
    }
    status
  }
  currencyCode
  balance {
    currencyCode
    formatted
    value
  }
}
    ${DraftBookingCustomizationsTripFragmentDoc}`;
export const ItineraryDepartureExcursionFragmentDoc = gql`
    fragment ItineraryDepartureExcursion on DepartureExcursion {
  _id
  autoApproveDeadline
  content(language: $language) {
    departureInfo
    description
    duration
    id
    name
    shortDescription
    image {
      filename
      alt
      focus
    }
  }
  price {
    value {
      currencyCode
      formatted
      value
    }
  }
  isPurchasable
  tourExcursion {
    isPrebook
  }
}
    `;
export const ItineraryTourDayContentFragmentDoc = gql`
    fragment ItineraryTourDayContent on TourDayContent {
  description
  excursionIds
  freeTimeSuggestions
  highlights
  meals
  name
  physicalActivity
  day
  isRange
  dayRangeLength
}
    `;
export const ItineraryTourItineraryItemContentFragmentDoc = gql`
    fragment ItineraryTourItineraryItemContent on TourItineraryItemContent {
  days {
    ...ItineraryTourDayContent
  }
  nbNights
  title
}
    ${ItineraryTourDayContentFragmentDoc}`;
export const ItineraryTourItineraryElementUnionFragmentDoc = gql`
    fragment ItineraryTourItineraryElementUnion on TourItineraryElementUnion {
  ...ItineraryTourDayContent
  ...ItineraryTourItineraryItemContent
}
    ${ItineraryTourDayContentFragmentDoc}
${ItineraryTourItineraryItemContentFragmentDoc}`;
export const ItineraryDepartureExtensionFragmentDoc = gql`
    fragment ItineraryDepartureExtension on DepartureExtension {
  _id
  excursions {
    ...ItineraryDepartureExcursion
  }
  lineItemCode
  tourExtensionContent(language: $language) {
    id
    isPreExtension
    itineraryItems {
      ...ItineraryTourItineraryElementUnion
    }
    nbDaysOverlap
    tourCode
  }
}
    ${ItineraryDepartureExcursionFragmentDoc}
${ItineraryTourItineraryElementUnionFragmentDoc}`;
export const ItineraryTourContentFragmentDoc = gql`
    fragment ItineraryTourContent on TourContent {
  id
  itineraryItems {
    ...ItineraryTourItineraryElementUnion
  }
  mapImage {
    alt
    filename
    focus
    name
  }
  priceYear
  tourCode
}
    ${ItineraryTourItineraryElementUnionFragmentDoc}`;
export const EvaluationFreeTextQuestionFragmentDoc = gql`
    fragment EvaluationFreeTextQuestion on EvaluationFreeTextQuestion {
  _id
  answer {
    ... on EvaluationFreeTextAnswer {
      additionalComments
      nullableValue: value
    }
  }
  canonicalId
  hasBeenAnswered
  isRequired
  meta {
    componentEndDate
    componentStartTime
    placementType
  }
  text
}
    `;
export const EvaluationMultipleChoiceQuestionFragmentDoc = gql`
    fragment EvaluationMultipleChoiceQuestion on EvaluationMultipleChoiceQuestion {
  _id
  answer {
    additionalComments
    choiceId
    value
  }
  canonicalId
  choices {
    _id
    label
    value
  }
  hasBeenAnswered
  isRequired
  meta {
    componentEndDate
    componentStartTime
    placementType
  }
  text
}
    `;
export const EvaluationMatrixQuestionFragmentDoc = gql`
    fragment EvaluationMatrixQuestion on EvaluationMatrixQuestion {
  _id
  canonicalId
  choices {
    _id
    label
    value
  }
  hasBeenAnswered
  isRequired
  meta {
    componentEndDate
    componentStartTime
    placementType
  }
  rows {
    _id
    answer {
      additionalComments
      choiceId
      value
    }
    text
  }
  text
}
    `;
export const CustomerEvalFragmentDoc = gql`
    fragment CustomerEval on CustomerEvaluation {
  _id
  deadlineDate
  submissionDate
  availabilityDate
  finalizationDate
  hasBeenStarted
  hasAnsweredQuestions
  questions {
    _id
    __typename
    ... on EvaluationFreeTextQuestion {
      ...EvaluationFreeTextQuestion
    }
    ... on EvaluationMultipleChoiceQuestion {
      ...EvaluationMultipleChoiceQuestion
    }
    ... on EvaluationMatrixQuestion {
      ...EvaluationMatrixQuestion
    }
  }
}
    ${EvaluationFreeTextQuestionFragmentDoc}
${EvaluationMultipleChoiceQuestionFragmentDoc}
${EvaluationMatrixQuestionFragmentDoc}`;
export const TourReviewFragmentDoc = gql`
    fragment TourReview on Review {
  _id
  customerId
  detail {
    _id
    author
    body
    response {
      author
      body
    }
    status
    title
  }
  images {
    _id
    asset {
      _id
      filename
      location
      key
    }
  }
  nbPastTrips
  isFeatured
  isEditable
  rating
  travelDate
  tourCode
  createdAt
}
    `;
export const TravelProtectionDraftOrderBookingFragmentDoc = gql`
    fragment TravelProtectionDraftOrderBooking on Booking {
  _id
  currencyCode
  balance {
    value
  }
  minimumAmountDue {
    value
  }
  paymentOptions {
    ... on BookingManualPaymentOption {
      allowedPaymentMethods
      type
    }
  }
  isEnrolledInAutopay
  paymentSchedules {
    _id
    unprocessedInstallments {
      _id
      amount {
        value
      }
    }
    frequency
    status
  }
}
    `;
export const DraftBookingFragmentFragmentDoc = gql`
    fragment DraftBookingFragment on DraftOrder {
  _id
  order {
    ... on Booking {
      balance {
        value
      }
    }
  }
}
    `;
export const InsurancePlanContentAddonFragmentDoc = gql`
    fragment InsurancePlanContentAddon on InsurancePlanContentAddon {
  addonCode
  description
  name
  benefits {
    name
    description
    limitMessage
  }
}
    `;
export const InsurancePlanOfferFragmentDoc = gql`
    fragment InsurancePlanOffer on InsurancePlanOffer {
  insurancePlan {
    _id
    lineItemCode
    planCode
    purchasableAfterDays
    purchasableWithinDays
  }
  price {
    currencyCode
    value
    formatted
  }
  addons {
    insurancePlanAddon {
      _id
      lineItemCode
      insurancePlanAddonCode
      includedWithinDays
      preventPurchaseAfterDays
    }
    price {
      currencyCode
      value
      formatted
    }
  }
  content(language: $language) {
    addons {
      ...InsurancePlanContentAddon
    }
    benefits {
      description
      limitMessage
      name
    }
    description
    id
    name
    includedAddonsTitle
    includedAddonsSubtitle
    includedAddonsDescription
    underwriterDescription
    planCode
    planSummaryDocument {
      filename
    }
    planSummaryLink {
      url
      linkType
      cachedUrl
    }
  }
}
    ${InsurancePlanContentAddonFragmentDoc}`;
export const QuoteTripFragmentDoc = gql`
    fragment QuoteTrip on QuoteTrip {
  ...Trip
  tripCustomer {
    ... on TripNewCustomer {
      firstName
      lastName
      email
      phone
    }
    ... on TripExistingCustomer {
      customerId
    }
  }
  insurancePlanOffers {
    ...InsurancePlanOffer
  }
  extensionOffer {
    discountAmount {
      value
    }
    extension {
      lineItemCode
    }
    salePrice {
      value
    }
    appliedToTrip
  }
  excursionOffers {
    discountAmount {
      value
      currencyCode
    }
    salePrice {
      value
      currencyCode
    }
    excursion {
      _id
      lineItemCode
      price {
        value {
          value
          currencyCode
        }
      }
    }
  }
}
    ${TripFragmentDoc}
${InsurancePlanOfferFragmentDoc}`;
export const AutopayCheckoutOptionFragmentDoc = gql`
    fragment AutopayCheckoutOption on QuoteAutopayCheckoutOption {
  type
  amount {
    value
  }
  earliestPaymentScheduleStartDate
  latestPaymentScheduleStartDate
  allowedPaymentMethods
}
    `;
export const CheckoutQuoteFragmentDoc = gql`
    fragment CheckoutQuote on Quote {
  rebookedFromOrderId
  rebookedFromOrder {
    _id
    ... on Booking {
      transferableAmounts {
        totalTransferable {
          value
        }
      }
    }
  }
  checkoutOptions {
    ... on QuoteAutopayCheckoutOption {
      ...AutopayCheckoutOption
    }
    ... on QuoteManualCheckoutOption {
      type
      amount {
        value
      }
      allowedPaymentMethods
      commonFees {
        applyTo
        fee {
          price {
            value
          }
        }
      }
    }
  }
}
    ${AutopayCheckoutOptionFragmentDoc}`;
export const DraftQuoteFragmentFragmentDoc = gql`
    fragment DraftQuoteFragment on DraftOrder {
  _id
  order {
    _id
    ... on Quote {
      _id
      averageTotalPerTrip {
        value
        currencyCode
        formatted
      }
      finalPaymentDate
      departureId
      departure {
        _id
        tourCode
      }
      currencyCode
      grandTotal {
        value
        currencyCode
        formatted
      }
      totalDiscount {
        formatted
        currencyCode
        value
      }
      balance {
        value
        currencyCode
        formatted
      }
      customer {
        ...Customer
      }
      trips {
        ...QuoteTrip
      }
      gcDeparture {
        micrositeContent(language: $language) {
          title
          fullSlug
        }
        lineItemRules {
          level
          lineItemCode
          lineItemType
        }
      }
      isExpired
      isSaved
      expirationDate
      createdAt
      ...CheckoutQuote
    }
  }
}
    ${CustomerFragmentDoc}
${QuoteTripFragmentDoc}
${CheckoutQuoteFragmentDoc}`;
export const GatewayFragmentDoc = gql`
    fragment Gateway on Gateway {
  code
  stateCode
  internalCityName
}
    `;
export const FlightPriceFragmentDoc = gql`
    fragment FlightPrice on DepartureFlightPackagePrice {
  lineItemCode
  isCustomGateway
  prices {
    currencyCode
    value
  }
  homeGateway {
    ...Gateway
  }
}
    ${GatewayFragmentDoc}`;
export const QuoteTripDepartingFlightOffersFragmentFragmentDoc = gql`
    fragment QuoteTripDepartingFlightOffersFragment on FlightOffer {
  salePrice {
    value
  }
  discountAmount {
    value
  }
  flight {
    _id
    lineItemCode
    departureGateway {
      ...Gateway
    }
    isLandOnly
  }
}
    ${GatewayFragmentDoc}`;
export const QuoteTripReturningFlightOffersFragmentFragmentDoc = gql`
    fragment QuoteTripReturningFlightOffersFragment on FlightOffer {
  salePrice {
    value
  }
  discountAmount {
    value
  }
  flight {
    _id
    lineItemCode
    arrivalGateway {
      ...Gateway
    }
    isLandOnly
  }
}
    ${GatewayFragmentDoc}`;
export const QuoteTripFlightOffersFragmentFragmentDoc = gql`
    fragment QuoteTripFlightOffersFragment on QuoteTrip {
  _id
  isPrimary
  lineItems {
    ...BasicLineItem
    status
    ... on FlightPackageLineItem {
      ...FlightPackageLineItem
    }
    ... on TourExcursionLineItem {
      ...TourExcursionLineItemFragment
    }
    ... on PromoLineItem {
      lineItemCode
      promoCode
      targetType
      campaignCode
    }
  }
  openDepartingFlightLineItem {
    _id
    departureGatewayCode
    isLandOnly
  }
  openReturningFlightLineItem {
    _id
    arrivalGatewayCode
    isLandOnly
  }
  departingFlightOffers {
    ...QuoteTripDepartingFlightOffersFragment
  }
  returningFlightOffers {
    ...QuoteTripReturningFlightOffersFragment
  }
}
    ${BasicLineItemFragmentDoc}
${FlightPackageLineItemFragmentDoc}
${TourExcursionLineItemFragmentFragmentDoc}
${QuoteTripDepartingFlightOffersFragmentFragmentDoc}
${QuoteTripReturningFlightOffersFragmentFragmentDoc}`;
export const TermFragmentDoc = gql`
    fragment Term on Term {
  _id
  content
  certificationText
  termType
}
    `;
export const MobileAppCustomerDocument = gql`
    query MobileAppCustomer {
  me {
    _id
    ... on Customer {
      savedPaymentMethods {
        _id
        isActive
        isExpired
        paymentMethod {
          ...PaymentMethodFragment
        }
      }
    }
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;

/**
 * __useMobileAppCustomerQuery__
 *
 * To run a query within a React component, call `useMobileAppCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMobileAppCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMobileAppCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMobileAppCustomerQuery(baseOptions?: Apollo.QueryHookOptions<MobileAppCustomerQuery, MobileAppCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MobileAppCustomerQuery, MobileAppCustomerQueryVariables>(MobileAppCustomerDocument, options);
      }
export function useMobileAppCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MobileAppCustomerQuery, MobileAppCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MobileAppCustomerQuery, MobileAppCustomerQueryVariables>(MobileAppCustomerDocument, options);
        }
export function useMobileAppCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MobileAppCustomerQuery, MobileAppCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MobileAppCustomerQuery, MobileAppCustomerQueryVariables>(MobileAppCustomerDocument, options);
        }
export type MobileAppCustomerQueryHookResult = ReturnType<typeof useMobileAppCustomerQuery>;
export type MobileAppCustomerLazyQueryHookResult = ReturnType<typeof useMobileAppCustomerLazyQuery>;
export type MobileAppCustomerSuspenseQueryHookResult = ReturnType<typeof useMobileAppCustomerSuspenseQuery>;
export type MobileAppCustomerQueryResult = Apollo.QueryResult<MobileAppCustomerQuery, MobileAppCustomerQueryVariables>;
export const BookingDocument = gql`
    query Booking($id: ObjectId!, $language: String!) {
  booking(_id: $id) {
    ...BookingFragment
  }
}
    ${BookingFragmentFragmentDoc}`;

/**
 * __useBookingQuery__
 *
 * To run a query within a React component, call `useBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useBookingQuery(baseOptions: Apollo.QueryHookOptions<BookingQuery, BookingQueryVariables> & ({ variables: BookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
      }
export function useBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export function useBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export type BookingQueryHookResult = ReturnType<typeof useBookingQuery>;
export type BookingLazyQueryHookResult = ReturnType<typeof useBookingLazyQuery>;
export type BookingSuspenseQueryHookResult = ReturnType<typeof useBookingSuspenseQuery>;
export type BookingQueryResult = Apollo.QueryResult<BookingQuery, BookingQueryVariables>;
export const CheckoutDepartureDocument = gql`
    query CheckoutDeparture($departureId: ObjectId!, $language: String!) {
  departure(_id: $departureId) {
    ...CheckoutDeparture
  }
}
    ${CheckoutDepartureFragmentDoc}`;

/**
 * __useCheckoutDepartureQuery__
 *
 * To run a query within a React component, call `useCheckoutDepartureQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutDepartureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutDepartureQuery({
 *   variables: {
 *      departureId: // value for 'departureId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCheckoutDepartureQuery(baseOptions: Apollo.QueryHookOptions<CheckoutDepartureQuery, CheckoutDepartureQueryVariables> & ({ variables: CheckoutDepartureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutDepartureQuery, CheckoutDepartureQueryVariables>(CheckoutDepartureDocument, options);
      }
export function useCheckoutDepartureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutDepartureQuery, CheckoutDepartureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutDepartureQuery, CheckoutDepartureQueryVariables>(CheckoutDepartureDocument, options);
        }
export function useCheckoutDepartureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutDepartureQuery, CheckoutDepartureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutDepartureQuery, CheckoutDepartureQueryVariables>(CheckoutDepartureDocument, options);
        }
export type CheckoutDepartureQueryHookResult = ReturnType<typeof useCheckoutDepartureQuery>;
export type CheckoutDepartureLazyQueryHookResult = ReturnType<typeof useCheckoutDepartureLazyQuery>;
export type CheckoutDepartureSuspenseQueryHookResult = ReturnType<typeof useCheckoutDepartureSuspenseQuery>;
export type CheckoutDepartureQueryResult = Apollo.QueryResult<CheckoutDepartureQuery, CheckoutDepartureQueryVariables>;
export const DraftQuoteDocument = gql`
    query DraftQuote($id: ObjectId!, $language: String!) {
  draftOrder(_id: $id) {
    ...DraftQuoteFragment
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;

/**
 * __useDraftQuoteQuery__
 *
 * To run a query within a React component, call `useDraftQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useDraftQuoteQuery(baseOptions: Apollo.QueryHookOptions<DraftQuoteQuery, DraftQuoteQueryVariables> & ({ variables: DraftQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftQuoteQuery, DraftQuoteQueryVariables>(DraftQuoteDocument, options);
      }
export function useDraftQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftQuoteQuery, DraftQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftQuoteQuery, DraftQuoteQueryVariables>(DraftQuoteDocument, options);
        }
export function useDraftQuoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftQuoteQuery, DraftQuoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DraftQuoteQuery, DraftQuoteQueryVariables>(DraftQuoteDocument, options);
        }
export type DraftQuoteQueryHookResult = ReturnType<typeof useDraftQuoteQuery>;
export type DraftQuoteLazyQueryHookResult = ReturnType<typeof useDraftQuoteLazyQuery>;
export type DraftQuoteSuspenseQueryHookResult = ReturnType<typeof useDraftQuoteSuspenseQuery>;
export type DraftQuoteQueryResult = Apollo.QueryResult<DraftQuoteQuery, DraftQuoteQueryVariables>;
export const GuardBookingDocument = gql`
    query GuardBooking($id: ObjectId!) {
  booking(_id: $id) {
    _id
  }
}
    `;

/**
 * __useGuardBookingQuery__
 *
 * To run a query within a React component, call `useGuardBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardBookingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGuardBookingQuery(baseOptions: Apollo.QueryHookOptions<GuardBookingQuery, GuardBookingQueryVariables> & ({ variables: GuardBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuardBookingQuery, GuardBookingQueryVariables>(GuardBookingDocument, options);
      }
export function useGuardBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuardBookingQuery, GuardBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuardBookingQuery, GuardBookingQueryVariables>(GuardBookingDocument, options);
        }
export function useGuardBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GuardBookingQuery, GuardBookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GuardBookingQuery, GuardBookingQueryVariables>(GuardBookingDocument, options);
        }
export type GuardBookingQueryHookResult = ReturnType<typeof useGuardBookingQuery>;
export type GuardBookingLazyQueryHookResult = ReturnType<typeof useGuardBookingLazyQuery>;
export type GuardBookingSuspenseQueryHookResult = ReturnType<typeof useGuardBookingSuspenseQuery>;
export type GuardBookingQueryResult = Apollo.QueryResult<GuardBookingQuery, GuardBookingQueryVariables>;
export const SetDraftQuoteCustomerDocument = gql`
    mutation SetDraftQuoteCustomer($id: ObjectId!, $tripId: ObjectId!, $existingCustomerInput: TripExistingCustomerInput, $newCustomerInput: TripNewCustomerInput, $language: String!) {
  setDraftQuoteCustomer(
    _id: $id
    tripId: $tripId
    existingCustomerInput: $existingCustomerInput
    newCustomerInput: $newCustomerInput
  ) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type SetDraftQuoteCustomerMutationFn = Apollo.MutationFunction<SetDraftQuoteCustomerMutation, SetDraftQuoteCustomerMutationVariables>;

/**
 * __useSetDraftQuoteCustomerMutation__
 *
 * To run a mutation, you first call `useSetDraftQuoteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDraftQuoteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDraftQuoteCustomerMutation, { data, loading, error }] = useSetDraftQuoteCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripId: // value for 'tripId'
 *      existingCustomerInput: // value for 'existingCustomerInput'
 *      newCustomerInput: // value for 'newCustomerInput'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSetDraftQuoteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<SetDraftQuoteCustomerMutation, SetDraftQuoteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDraftQuoteCustomerMutation, SetDraftQuoteCustomerMutationVariables>(SetDraftQuoteCustomerDocument, options);
      }
export type SetDraftQuoteCustomerMutationHookResult = ReturnType<typeof useSetDraftQuoteCustomerMutation>;
export type SetDraftQuoteCustomerMutationResult = Apollo.MutationResult<SetDraftQuoteCustomerMutation>;
export type SetDraftQuoteCustomerMutationOptions = Apollo.BaseMutationOptions<SetDraftQuoteCustomerMutation, SetDraftQuoteCustomerMutationVariables>;
export const UpdateDraftQuoteSavedDocument = gql`
    mutation UpdateDraftQuoteSaved($id: ObjectId!, $input: UpdateDraftQuoteSavedInput!) {
  updateDraftQuoteSaved(_id: $id, input: $input) {
    ... on DraftOrder {
      _id
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    `;
export type UpdateDraftQuoteSavedMutationFn = Apollo.MutationFunction<UpdateDraftQuoteSavedMutation, UpdateDraftQuoteSavedMutationVariables>;

/**
 * __useUpdateDraftQuoteSavedMutation__
 *
 * To run a mutation, you first call `useUpdateDraftQuoteSavedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftQuoteSavedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftQuoteSavedMutation, { data, loading, error }] = useUpdateDraftQuoteSavedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDraftQuoteSavedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftQuoteSavedMutation, UpdateDraftQuoteSavedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftQuoteSavedMutation, UpdateDraftQuoteSavedMutationVariables>(UpdateDraftQuoteSavedDocument, options);
      }
export type UpdateDraftQuoteSavedMutationHookResult = ReturnType<typeof useUpdateDraftQuoteSavedMutation>;
export type UpdateDraftQuoteSavedMutationResult = Apollo.MutationResult<UpdateDraftQuoteSavedMutation>;
export type UpdateDraftQuoteSavedMutationOptions = Apollo.BaseMutationOptions<UpdateDraftQuoteSavedMutation, UpdateDraftQuoteSavedMutationVariables>;
export const AddDraftOrderPromoDocument = gql`
    mutation AddDraftOrderPromo($id: ObjectId!, $promoCode: String!, $tripIds: [ObjectId!], $language: String!) {
  addDraftOrderPromo(_id: $id, promoCode: $promoCode, tripIds: $tripIds) {
    __typename
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type AddDraftOrderPromoMutationFn = Apollo.MutationFunction<AddDraftOrderPromoMutation, AddDraftOrderPromoMutationVariables>;

/**
 * __useAddDraftOrderPromoMutation__
 *
 * To run a mutation, you first call `useAddDraftOrderPromoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDraftOrderPromoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDraftOrderPromoMutation, { data, loading, error }] = useAddDraftOrderPromoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      promoCode: // value for 'promoCode'
 *      tripIds: // value for 'tripIds'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAddDraftOrderPromoMutation(baseOptions?: Apollo.MutationHookOptions<AddDraftOrderPromoMutation, AddDraftOrderPromoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDraftOrderPromoMutation, AddDraftOrderPromoMutationVariables>(AddDraftOrderPromoDocument, options);
      }
export type AddDraftOrderPromoMutationHookResult = ReturnType<typeof useAddDraftOrderPromoMutation>;
export type AddDraftOrderPromoMutationResult = Apollo.MutationResult<AddDraftOrderPromoMutation>;
export type AddDraftOrderPromoMutationOptions = Apollo.BaseMutationOptions<AddDraftOrderPromoMutation, AddDraftOrderPromoMutationVariables>;
export const RemoveDraftOrderPromoDocument = gql`
    mutation RemoveDraftOrderPromo($id: ObjectId!, $lineItemCode: LineItemCode!, $tripIds: [ObjectId!], $language: String!) {
  removeDraftOrderPromo(_id: $id, lineItemCode: $lineItemCode, tripIds: $tripIds) {
    __typename
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type RemoveDraftOrderPromoMutationFn = Apollo.MutationFunction<RemoveDraftOrderPromoMutation, RemoveDraftOrderPromoMutationVariables>;

/**
 * __useRemoveDraftOrderPromoMutation__
 *
 * To run a mutation, you first call `useRemoveDraftOrderPromoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftOrderPromoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftOrderPromoMutation, { data, loading, error }] = useRemoveDraftOrderPromoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lineItemCode: // value for 'lineItemCode'
 *      tripIds: // value for 'tripIds'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useRemoveDraftOrderPromoMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDraftOrderPromoMutation, RemoveDraftOrderPromoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDraftOrderPromoMutation, RemoveDraftOrderPromoMutationVariables>(RemoveDraftOrderPromoDocument, options);
      }
export type RemoveDraftOrderPromoMutationHookResult = ReturnType<typeof useRemoveDraftOrderPromoMutation>;
export type RemoveDraftOrderPromoMutationResult = Apollo.MutationResult<RemoveDraftOrderPromoMutation>;
export type RemoveDraftOrderPromoMutationOptions = Apollo.BaseMutationOptions<RemoveDraftOrderPromoMutation, RemoveDraftOrderPromoMutationVariables>;
export const UpdateDraftOrderRequestedRoommatesDocument = gql`
    mutation UpdateDraftOrderRequestedRoommates($id: ObjectId!, $requestedRoommates: [String!]!, $tripId: ObjectId!) {
  updateDraftOrderRequestedRoommates(
    _id: $id
    requestedRoommates: $requestedRoommates
    tripId: $tripId
  ) {
    ... on DraftOrder {
      _id
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    `;
export type UpdateDraftOrderRequestedRoommatesMutationFn = Apollo.MutationFunction<UpdateDraftOrderRequestedRoommatesMutation, UpdateDraftOrderRequestedRoommatesMutationVariables>;

/**
 * __useUpdateDraftOrderRequestedRoommatesMutation__
 *
 * To run a mutation, you first call `useUpdateDraftOrderRequestedRoommatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftOrderRequestedRoommatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftOrderRequestedRoommatesMutation, { data, loading, error }] = useUpdateDraftOrderRequestedRoommatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requestedRoommates: // value for 'requestedRoommates'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useUpdateDraftOrderRequestedRoommatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftOrderRequestedRoommatesMutation, UpdateDraftOrderRequestedRoommatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftOrderRequestedRoommatesMutation, UpdateDraftOrderRequestedRoommatesMutationVariables>(UpdateDraftOrderRequestedRoommatesDocument, options);
      }
export type UpdateDraftOrderRequestedRoommatesMutationHookResult = ReturnType<typeof useUpdateDraftOrderRequestedRoommatesMutation>;
export type UpdateDraftOrderRequestedRoommatesMutationResult = Apollo.MutationResult<UpdateDraftOrderRequestedRoommatesMutation>;
export type UpdateDraftOrderRequestedRoommatesMutationOptions = Apollo.BaseMutationOptions<UpdateDraftOrderRequestedRoommatesMutation, UpdateDraftOrderRequestedRoommatesMutationVariables>;
export const AddDraftOrderInsuranceAddonDocument = gql`
    mutation AddDraftOrderInsuranceAddon($id: ObjectId!, $inputs: [AddDraftOrderInsuranceAddonInput!]!, $language: String!) {
  addDraftOrderInsuranceAddon(_id: $id, inputs: $inputs) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type AddDraftOrderInsuranceAddonMutationFn = Apollo.MutationFunction<AddDraftOrderInsuranceAddonMutation, AddDraftOrderInsuranceAddonMutationVariables>;

/**
 * __useAddDraftOrderInsuranceAddonMutation__
 *
 * To run a mutation, you first call `useAddDraftOrderInsuranceAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDraftOrderInsuranceAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDraftOrderInsuranceAddonMutation, { data, loading, error }] = useAddDraftOrderInsuranceAddonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inputs: // value for 'inputs'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAddDraftOrderInsuranceAddonMutation(baseOptions?: Apollo.MutationHookOptions<AddDraftOrderInsuranceAddonMutation, AddDraftOrderInsuranceAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDraftOrderInsuranceAddonMutation, AddDraftOrderInsuranceAddonMutationVariables>(AddDraftOrderInsuranceAddonDocument, options);
      }
export type AddDraftOrderInsuranceAddonMutationHookResult = ReturnType<typeof useAddDraftOrderInsuranceAddonMutation>;
export type AddDraftOrderInsuranceAddonMutationResult = Apollo.MutationResult<AddDraftOrderInsuranceAddonMutation>;
export type AddDraftOrderInsuranceAddonMutationOptions = Apollo.BaseMutationOptions<AddDraftOrderInsuranceAddonMutation, AddDraftOrderInsuranceAddonMutationVariables>;
export const RemoveDraftOrderInsuranceDocument = gql`
    mutation RemoveDraftOrderInsurance($id: ObjectId!, $tripIds: [ObjectId!], $language: String!) {
  removeDraftOrderInsurance(_id: $id, tripIds: $tripIds) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type RemoveDraftOrderInsuranceMutationFn = Apollo.MutationFunction<RemoveDraftOrderInsuranceMutation, RemoveDraftOrderInsuranceMutationVariables>;

/**
 * __useRemoveDraftOrderInsuranceMutation__
 *
 * To run a mutation, you first call `useRemoveDraftOrderInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftOrderInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftOrderInsuranceMutation, { data, loading, error }] = useRemoveDraftOrderInsuranceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripIds: // value for 'tripIds'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useRemoveDraftOrderInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDraftOrderInsuranceMutation, RemoveDraftOrderInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDraftOrderInsuranceMutation, RemoveDraftOrderInsuranceMutationVariables>(RemoveDraftOrderInsuranceDocument, options);
      }
export type RemoveDraftOrderInsuranceMutationHookResult = ReturnType<typeof useRemoveDraftOrderInsuranceMutation>;
export type RemoveDraftOrderInsuranceMutationResult = Apollo.MutationResult<RemoveDraftOrderInsuranceMutation>;
export type RemoveDraftOrderInsuranceMutationOptions = Apollo.BaseMutationOptions<RemoveDraftOrderInsuranceMutation, RemoveDraftOrderInsuranceMutationVariables>;
export const RemoveDraftOrderInsuranceAddonDocument = gql`
    mutation RemoveDraftOrderInsuranceAddon($id: ObjectId!, $tripIds: [ObjectId!], $lineItemCode: LineItemCode!, $language: String!) {
  removeDraftOrderInsuranceAddon(
    _id: $id
    tripIds: $tripIds
    lineItemCode: $lineItemCode
  ) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type RemoveDraftOrderInsuranceAddonMutationFn = Apollo.MutationFunction<RemoveDraftOrderInsuranceAddonMutation, RemoveDraftOrderInsuranceAddonMutationVariables>;

/**
 * __useRemoveDraftOrderInsuranceAddonMutation__
 *
 * To run a mutation, you first call `useRemoveDraftOrderInsuranceAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftOrderInsuranceAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftOrderInsuranceAddonMutation, { data, loading, error }] = useRemoveDraftOrderInsuranceAddonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripIds: // value for 'tripIds'
 *      lineItemCode: // value for 'lineItemCode'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useRemoveDraftOrderInsuranceAddonMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDraftOrderInsuranceAddonMutation, RemoveDraftOrderInsuranceAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDraftOrderInsuranceAddonMutation, RemoveDraftOrderInsuranceAddonMutationVariables>(RemoveDraftOrderInsuranceAddonDocument, options);
      }
export type RemoveDraftOrderInsuranceAddonMutationHookResult = ReturnType<typeof useRemoveDraftOrderInsuranceAddonMutation>;
export type RemoveDraftOrderInsuranceAddonMutationResult = Apollo.MutationResult<RemoveDraftOrderInsuranceAddonMutation>;
export type RemoveDraftOrderInsuranceAddonMutationOptions = Apollo.BaseMutationOptions<RemoveDraftOrderInsuranceAddonMutation, RemoveDraftOrderInsuranceAddonMutationVariables>;
export const UpdateDraftOrderInsuranceDocument = gql`
    mutation UpdateDraftOrderInsurance($id: ObjectId!, $tripIds: [ObjectId!], $addOnLineItemCodes: [LineItemCode!], $lineItemCode: LineItemCode!, $language: String!) {
  updateDraftOrderInsurance(
    _id: $id
    tripIds: $tripIds
    addOnLineItemCodes: $addOnLineItemCodes
    lineItemCode: $lineItemCode
  ) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type UpdateDraftOrderInsuranceMutationFn = Apollo.MutationFunction<UpdateDraftOrderInsuranceMutation, UpdateDraftOrderInsuranceMutationVariables>;

/**
 * __useUpdateDraftOrderInsuranceMutation__
 *
 * To run a mutation, you first call `useUpdateDraftOrderInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftOrderInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftOrderInsuranceMutation, { data, loading, error }] = useUpdateDraftOrderInsuranceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripIds: // value for 'tripIds'
 *      addOnLineItemCodes: // value for 'addOnLineItemCodes'
 *      lineItemCode: // value for 'lineItemCode'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateDraftOrderInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftOrderInsuranceMutation, UpdateDraftOrderInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftOrderInsuranceMutation, UpdateDraftOrderInsuranceMutationVariables>(UpdateDraftOrderInsuranceDocument, options);
      }
export type UpdateDraftOrderInsuranceMutationHookResult = ReturnType<typeof useUpdateDraftOrderInsuranceMutation>;
export type UpdateDraftOrderInsuranceMutationResult = Apollo.MutationResult<UpdateDraftOrderInsuranceMutation>;
export type UpdateDraftOrderInsuranceMutationOptions = Apollo.BaseMutationOptions<UpdateDraftOrderInsuranceMutation, UpdateDraftOrderInsuranceMutationVariables>;
export const AddDraftOrderExcursionDocument = gql`
    mutation AddDraftOrderExcursion($id: ObjectId!, $inputs: [AddDraftOrderExcursionInput!]!, $language: String!) {
  addDraftOrderExcursions(_id: $id, inputs: $inputs) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type AddDraftOrderExcursionMutationFn = Apollo.MutationFunction<AddDraftOrderExcursionMutation, AddDraftOrderExcursionMutationVariables>;

/**
 * __useAddDraftOrderExcursionMutation__
 *
 * To run a mutation, you first call `useAddDraftOrderExcursionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDraftOrderExcursionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDraftOrderExcursionMutation, { data, loading, error }] = useAddDraftOrderExcursionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inputs: // value for 'inputs'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAddDraftOrderExcursionMutation(baseOptions?: Apollo.MutationHookOptions<AddDraftOrderExcursionMutation, AddDraftOrderExcursionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDraftOrderExcursionMutation, AddDraftOrderExcursionMutationVariables>(AddDraftOrderExcursionDocument, options);
      }
export type AddDraftOrderExcursionMutationHookResult = ReturnType<typeof useAddDraftOrderExcursionMutation>;
export type AddDraftOrderExcursionMutationResult = Apollo.MutationResult<AddDraftOrderExcursionMutation>;
export type AddDraftOrderExcursionMutationOptions = Apollo.BaseMutationOptions<AddDraftOrderExcursionMutation, AddDraftOrderExcursionMutationVariables>;
export const AddDraftOrderExcursionsDocument = gql`
    mutation AddDraftOrderExcursions($id: ObjectId!, $inputs: [AddDraftOrderExcursionInput!]!, $language: String!) {
  addDraftOrderExcursions(_id: $id, inputs: $inputs) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type AddDraftOrderExcursionsMutationFn = Apollo.MutationFunction<AddDraftOrderExcursionsMutation, AddDraftOrderExcursionsMutationVariables>;

/**
 * __useAddDraftOrderExcursionsMutation__
 *
 * To run a mutation, you first call `useAddDraftOrderExcursionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDraftOrderExcursionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDraftOrderExcursionsMutation, { data, loading, error }] = useAddDraftOrderExcursionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inputs: // value for 'inputs'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAddDraftOrderExcursionsMutation(baseOptions?: Apollo.MutationHookOptions<AddDraftOrderExcursionsMutation, AddDraftOrderExcursionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDraftOrderExcursionsMutation, AddDraftOrderExcursionsMutationVariables>(AddDraftOrderExcursionsDocument, options);
      }
export type AddDraftOrderExcursionsMutationHookResult = ReturnType<typeof useAddDraftOrderExcursionsMutation>;
export type AddDraftOrderExcursionsMutationResult = Apollo.MutationResult<AddDraftOrderExcursionsMutation>;
export type AddDraftOrderExcursionsMutationOptions = Apollo.BaseMutationOptions<AddDraftOrderExcursionsMutation, AddDraftOrderExcursionsMutationVariables>;
export const RemoveDraftOrderExcursionDocument = gql`
    mutation RemoveDraftOrderExcursion($id: ObjectId!, $lineItemCode: LineItemCode!, $tripIds: [ObjectId!], $language: String!) {
  removeDraftOrderExcursion(
    _id: $id
    lineItemCode: $lineItemCode
    tripIds: $tripIds
  ) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type RemoveDraftOrderExcursionMutationFn = Apollo.MutationFunction<RemoveDraftOrderExcursionMutation, RemoveDraftOrderExcursionMutationVariables>;

/**
 * __useRemoveDraftOrderExcursionMutation__
 *
 * To run a mutation, you first call `useRemoveDraftOrderExcursionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftOrderExcursionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftOrderExcursionMutation, { data, loading, error }] = useRemoveDraftOrderExcursionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lineItemCode: // value for 'lineItemCode'
 *      tripIds: // value for 'tripIds'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useRemoveDraftOrderExcursionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDraftOrderExcursionMutation, RemoveDraftOrderExcursionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDraftOrderExcursionMutation, RemoveDraftOrderExcursionMutationVariables>(RemoveDraftOrderExcursionDocument, options);
      }
export type RemoveDraftOrderExcursionMutationHookResult = ReturnType<typeof useRemoveDraftOrderExcursionMutation>;
export type RemoveDraftOrderExcursionMutationResult = Apollo.MutationResult<RemoveDraftOrderExcursionMutation>;
export type RemoveDraftOrderExcursionMutationOptions = Apollo.BaseMutationOptions<RemoveDraftOrderExcursionMutation, RemoveDraftOrderExcursionMutationVariables>;
export const RemoveDraftOrderExcursionsDocument = gql`
    mutation RemoveDraftOrderExcursions($id: ObjectId!, $tourTypes: [ExcursionTourType!]!, $tripIds: [ObjectId!], $language: String!) {
  removeDraftOrderExcursions(_id: $id, tourTypes: $tourTypes, tripIds: $tripIds) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type RemoveDraftOrderExcursionsMutationFn = Apollo.MutationFunction<RemoveDraftOrderExcursionsMutation, RemoveDraftOrderExcursionsMutationVariables>;

/**
 * __useRemoveDraftOrderExcursionsMutation__
 *
 * To run a mutation, you first call `useRemoveDraftOrderExcursionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftOrderExcursionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftOrderExcursionsMutation, { data, loading, error }] = useRemoveDraftOrderExcursionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tourTypes: // value for 'tourTypes'
 *      tripIds: // value for 'tripIds'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useRemoveDraftOrderExcursionsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDraftOrderExcursionsMutation, RemoveDraftOrderExcursionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDraftOrderExcursionsMutation, RemoveDraftOrderExcursionsMutationVariables>(RemoveDraftOrderExcursionsDocument, options);
      }
export type RemoveDraftOrderExcursionsMutationHookResult = ReturnType<typeof useRemoveDraftOrderExcursionsMutation>;
export type RemoveDraftOrderExcursionsMutationResult = Apollo.MutationResult<RemoveDraftOrderExcursionsMutation>;
export type RemoveDraftOrderExcursionsMutationOptions = Apollo.BaseMutationOptions<RemoveDraftOrderExcursionsMutation, RemoveDraftOrderExcursionsMutationVariables>;
export const UpdateDraftOrderFlightPackagesDocument = gql`
    mutation UpdateDraftOrderFlightPackages($id: ObjectId!, $inputs: [UpdateDraftOrderFlightPackageInput!]!, $language: String!) {
  updateDraftOrderFlightPackages(_id: $id, inputs: $inputs) {
    __typename
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type UpdateDraftOrderFlightPackagesMutationFn = Apollo.MutationFunction<UpdateDraftOrderFlightPackagesMutation, UpdateDraftOrderFlightPackagesMutationVariables>;

/**
 * __useUpdateDraftOrderFlightPackagesMutation__
 *
 * To run a mutation, you first call `useUpdateDraftOrderFlightPackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftOrderFlightPackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftOrderFlightPackagesMutation, { data, loading, error }] = useUpdateDraftOrderFlightPackagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inputs: // value for 'inputs'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateDraftOrderFlightPackagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftOrderFlightPackagesMutation, UpdateDraftOrderFlightPackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftOrderFlightPackagesMutation, UpdateDraftOrderFlightPackagesMutationVariables>(UpdateDraftOrderFlightPackagesDocument, options);
      }
export type UpdateDraftOrderFlightPackagesMutationHookResult = ReturnType<typeof useUpdateDraftOrderFlightPackagesMutation>;
export type UpdateDraftOrderFlightPackagesMutationResult = Apollo.MutationResult<UpdateDraftOrderFlightPackagesMutation>;
export type UpdateDraftOrderFlightPackagesMutationOptions = Apollo.BaseMutationOptions<UpdateDraftOrderFlightPackagesMutation, UpdateDraftOrderFlightPackagesMutationVariables>;
export const UpdateDraftOrderExtensionRoomsDocument = gql`
    mutation UpdateDraftOrderExtensionRooms($id: ObjectId!, $inputs: [UpdateDraftOrderRoomInput!]!, $language: String!) {
  updateDraftOrderExtensionRooms(_id: $id, inputs: $inputs) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type UpdateDraftOrderExtensionRoomsMutationFn = Apollo.MutationFunction<UpdateDraftOrderExtensionRoomsMutation, UpdateDraftOrderExtensionRoomsMutationVariables>;

/**
 * __useUpdateDraftOrderExtensionRoomsMutation__
 *
 * To run a mutation, you first call `useUpdateDraftOrderExtensionRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftOrderExtensionRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftOrderExtensionRoomsMutation, { data, loading, error }] = useUpdateDraftOrderExtensionRoomsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inputs: // value for 'inputs'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateDraftOrderExtensionRoomsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftOrderExtensionRoomsMutation, UpdateDraftOrderExtensionRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftOrderExtensionRoomsMutation, UpdateDraftOrderExtensionRoomsMutationVariables>(UpdateDraftOrderExtensionRoomsDocument, options);
      }
export type UpdateDraftOrderExtensionRoomsMutationHookResult = ReturnType<typeof useUpdateDraftOrderExtensionRoomsMutation>;
export type UpdateDraftOrderExtensionRoomsMutationResult = Apollo.MutationResult<UpdateDraftOrderExtensionRoomsMutation>;
export type UpdateDraftOrderExtensionRoomsMutationOptions = Apollo.BaseMutationOptions<UpdateDraftOrderExtensionRoomsMutation, UpdateDraftOrderExtensionRoomsMutationVariables>;
export const UpdateDraftOrderRoomsDocument = gql`
    mutation UpdateDraftOrderRooms($id: ObjectId!, $inputs: [UpdateDraftOrderRoomInput!]!, $language: String!) {
  updateDraftOrderRooms(_id: $id, inputs: $inputs) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type UpdateDraftOrderRoomsMutationFn = Apollo.MutationFunction<UpdateDraftOrderRoomsMutation, UpdateDraftOrderRoomsMutationVariables>;

/**
 * __useUpdateDraftOrderRoomsMutation__
 *
 * To run a mutation, you first call `useUpdateDraftOrderRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftOrderRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftOrderRoomsMutation, { data, loading, error }] = useUpdateDraftOrderRoomsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inputs: // value for 'inputs'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateDraftOrderRoomsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftOrderRoomsMutation, UpdateDraftOrderRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftOrderRoomsMutation, UpdateDraftOrderRoomsMutationVariables>(UpdateDraftOrderRoomsDocument, options);
      }
export type UpdateDraftOrderRoomsMutationHookResult = ReturnType<typeof useUpdateDraftOrderRoomsMutation>;
export type UpdateDraftOrderRoomsMutationResult = Apollo.MutationResult<UpdateDraftOrderRoomsMutation>;
export type UpdateDraftOrderRoomsMutationOptions = Apollo.BaseMutationOptions<UpdateDraftOrderRoomsMutation, UpdateDraftOrderRoomsMutationVariables>;
export const AddDraftOrderExtensionDocument = gql`
    mutation AddDraftOrderExtension($id: ObjectId!, $tripIds: [ObjectId!], $lineItemCode: LineItemCode!, $language: String!) {
  addDraftOrderExtension(_id: $id, tripIds: $tripIds, lineItemCode: $lineItemCode) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type AddDraftOrderExtensionMutationFn = Apollo.MutationFunction<AddDraftOrderExtensionMutation, AddDraftOrderExtensionMutationVariables>;

/**
 * __useAddDraftOrderExtensionMutation__
 *
 * To run a mutation, you first call `useAddDraftOrderExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDraftOrderExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDraftOrderExtensionMutation, { data, loading, error }] = useAddDraftOrderExtensionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripIds: // value for 'tripIds'
 *      lineItemCode: // value for 'lineItemCode'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAddDraftOrderExtensionMutation(baseOptions?: Apollo.MutationHookOptions<AddDraftOrderExtensionMutation, AddDraftOrderExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDraftOrderExtensionMutation, AddDraftOrderExtensionMutationVariables>(AddDraftOrderExtensionDocument, options);
      }
export type AddDraftOrderExtensionMutationHookResult = ReturnType<typeof useAddDraftOrderExtensionMutation>;
export type AddDraftOrderExtensionMutationResult = Apollo.MutationResult<AddDraftOrderExtensionMutation>;
export type AddDraftOrderExtensionMutationOptions = Apollo.BaseMutationOptions<AddDraftOrderExtensionMutation, AddDraftOrderExtensionMutationVariables>;
export const RemoveDraftOrderExtensionDocument = gql`
    mutation RemoveDraftOrderExtension($id: ObjectId!, $tripIds: [ObjectId!], $language: String!) {
  removeDraftOrderExtension(_id: $id, tripIds: $tripIds) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type RemoveDraftOrderExtensionMutationFn = Apollo.MutationFunction<RemoveDraftOrderExtensionMutation, RemoveDraftOrderExtensionMutationVariables>;

/**
 * __useRemoveDraftOrderExtensionMutation__
 *
 * To run a mutation, you first call `useRemoveDraftOrderExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftOrderExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftOrderExtensionMutation, { data, loading, error }] = useRemoveDraftOrderExtensionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripIds: // value for 'tripIds'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useRemoveDraftOrderExtensionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDraftOrderExtensionMutation, RemoveDraftOrderExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDraftOrderExtensionMutation, RemoveDraftOrderExtensionMutationVariables>(RemoveDraftOrderExtensionDocument, options);
      }
export type RemoveDraftOrderExtensionMutationHookResult = ReturnType<typeof useRemoveDraftOrderExtensionMutation>;
export type RemoveDraftOrderExtensionMutationResult = Apollo.MutationResult<RemoveDraftOrderExtensionMutation>;
export type RemoveDraftOrderExtensionMutationOptions = Apollo.BaseMutationOptions<RemoveDraftOrderExtensionMutation, RemoveDraftOrderExtensionMutationVariables>;
export const AcceptTripTermsAtCheckoutDocument = gql`
    mutation AcceptTripTermsAtCheckout($bookingId: ObjectId!, $termId: ObjectId!, $tripId: ObjectId!) {
  acceptTripTerms(bookingId: $bookingId, termId: $termId, tripId: $tripId) {
    ... on Booking {
      _id
    }
    ... on ValidationError {
      message
    }
  }
}
    `;
export type AcceptTripTermsAtCheckoutMutationFn = Apollo.MutationFunction<AcceptTripTermsAtCheckoutMutation, AcceptTripTermsAtCheckoutMutationVariables>;

/**
 * __useAcceptTripTermsAtCheckoutMutation__
 *
 * To run a mutation, you first call `useAcceptTripTermsAtCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTripTermsAtCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTripTermsAtCheckoutMutation, { data, loading, error }] = useAcceptTripTermsAtCheckoutMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      termId: // value for 'termId'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useAcceptTripTermsAtCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTripTermsAtCheckoutMutation, AcceptTripTermsAtCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTripTermsAtCheckoutMutation, AcceptTripTermsAtCheckoutMutationVariables>(AcceptTripTermsAtCheckoutDocument, options);
      }
export type AcceptTripTermsAtCheckoutMutationHookResult = ReturnType<typeof useAcceptTripTermsAtCheckoutMutation>;
export type AcceptTripTermsAtCheckoutMutationResult = Apollo.MutationResult<AcceptTripTermsAtCheckoutMutation>;
export type AcceptTripTermsAtCheckoutMutationOptions = Apollo.BaseMutationOptions<AcceptTripTermsAtCheckoutMutation, AcceptTripTermsAtCheckoutMutationVariables>;
export const PayAndBookDocument = gql`
    mutation PayAndBook($input: PayAndBookInput!, $quoteId: ObjectId!, $language: String!) {
  payAndBook(input: $input, quoteId: $quoteId) {
    ... on Booking {
      ...BookingFragment
    }
    ... on DomainError {
      message
    }
    ... on ValidationError {
      message
    }
  }
}
    ${BookingFragmentFragmentDoc}`;
export type PayAndBookMutationFn = Apollo.MutationFunction<PayAndBookMutation, PayAndBookMutationVariables>;

/**
 * __usePayAndBookMutation__
 *
 * To run a mutation, you first call `usePayAndBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayAndBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payAndBookMutation, { data, loading, error }] = usePayAndBookMutation({
 *   variables: {
 *      input: // value for 'input'
 *      quoteId: // value for 'quoteId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePayAndBookMutation(baseOptions?: Apollo.MutationHookOptions<PayAndBookMutation, PayAndBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayAndBookMutation, PayAndBookMutationVariables>(PayAndBookDocument, options);
      }
export type PayAndBookMutationHookResult = ReturnType<typeof usePayAndBookMutation>;
export type PayAndBookMutationResult = Apollo.MutationResult<PayAndBookMutation>;
export type PayAndBookMutationOptions = Apollo.BaseMutationOptions<PayAndBookMutation, PayAndBookMutationVariables>;
export const PublishDraftQuoteDocument = gql`
    mutation PublishDraftQuote($id: ObjectId!) {
  publishDraftQuote(_id: $id) {
    ... on Quote {
      _id
      balance {
        value
      }
      ...CheckoutQuote
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${CheckoutQuoteFragmentDoc}`;
export type PublishDraftQuoteMutationFn = Apollo.MutationFunction<PublishDraftQuoteMutation, PublishDraftQuoteMutationVariables>;

/**
 * __usePublishDraftQuoteMutation__
 *
 * To run a mutation, you first call `usePublishDraftQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDraftQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDraftQuoteMutation, { data, loading, error }] = usePublishDraftQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishDraftQuoteMutation(baseOptions?: Apollo.MutationHookOptions<PublishDraftQuoteMutation, PublishDraftQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishDraftQuoteMutation, PublishDraftQuoteMutationVariables>(PublishDraftQuoteDocument, options);
      }
export type PublishDraftQuoteMutationHookResult = ReturnType<typeof usePublishDraftQuoteMutation>;
export type PublishDraftQuoteMutationResult = Apollo.MutationResult<PublishDraftQuoteMutation>;
export type PublishDraftQuoteMutationOptions = Apollo.BaseMutationOptions<PublishDraftQuoteMutation, PublishDraftQuoteMutationVariables>;
export const SetDraftQuoteTravelerWithAddressDocument = gql`
    mutation setDraftQuoteTravelerWithAddress($id: ObjectId!, $tripId: ObjectId!, $tsaInformation: TsaInformationInput!, $address: AddressInput!, $language: String!) {
  updateDraftOrderTsaInformation(
    _id: $id
    tsaInformation: $tsaInformation
    tripId: $tripId
  ) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
  updateDraftOrderAddress(_id: $id, tripId: $tripId, address: $address) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type SetDraftQuoteTravelerWithAddressMutationFn = Apollo.MutationFunction<SetDraftQuoteTravelerWithAddressMutation, SetDraftQuoteTravelerWithAddressMutationVariables>;

/**
 * __useSetDraftQuoteTravelerWithAddressMutation__
 *
 * To run a mutation, you first call `useSetDraftQuoteTravelerWithAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDraftQuoteTravelerWithAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDraftQuoteTravelerWithAddressMutation, { data, loading, error }] = useSetDraftQuoteTravelerWithAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripId: // value for 'tripId'
 *      tsaInformation: // value for 'tsaInformation'
 *      address: // value for 'address'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSetDraftQuoteTravelerWithAddressMutation(baseOptions?: Apollo.MutationHookOptions<SetDraftQuoteTravelerWithAddressMutation, SetDraftQuoteTravelerWithAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDraftQuoteTravelerWithAddressMutation, SetDraftQuoteTravelerWithAddressMutationVariables>(SetDraftQuoteTravelerWithAddressDocument, options);
      }
export type SetDraftQuoteTravelerWithAddressMutationHookResult = ReturnType<typeof useSetDraftQuoteTravelerWithAddressMutation>;
export type SetDraftQuoteTravelerWithAddressMutationResult = Apollo.MutationResult<SetDraftQuoteTravelerWithAddressMutation>;
export type SetDraftQuoteTravelerWithAddressMutationOptions = Apollo.BaseMutationOptions<SetDraftQuoteTravelerWithAddressMutation, SetDraftQuoteTravelerWithAddressMutationVariables>;
export const CheckoutUpdateDraftOrderTsaInformationDocument = gql`
    mutation checkoutUpdateDraftOrderTsaInformation($id: ObjectId!, $tripId: ObjectId!, $tsaInformation: TsaInformationInput!, $language: String!) {
  updateDraftOrderTsaInformation(
    _id: $id
    tsaInformation: $tsaInformation
    tripId: $tripId
  ) {
    ... on DraftOrder {
      ...DraftQuoteFragment
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    ${DraftQuoteFragmentFragmentDoc}`;
export type CheckoutUpdateDraftOrderTsaInformationMutationFn = Apollo.MutationFunction<CheckoutUpdateDraftOrderTsaInformationMutation, CheckoutUpdateDraftOrderTsaInformationMutationVariables>;

/**
 * __useCheckoutUpdateDraftOrderTsaInformationMutation__
 *
 * To run a mutation, you first call `useCheckoutUpdateDraftOrderTsaInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutUpdateDraftOrderTsaInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutUpdateDraftOrderTsaInformationMutation, { data, loading, error }] = useCheckoutUpdateDraftOrderTsaInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripId: // value for 'tripId'
 *      tsaInformation: // value for 'tsaInformation'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCheckoutUpdateDraftOrderTsaInformationMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutUpdateDraftOrderTsaInformationMutation, CheckoutUpdateDraftOrderTsaInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutUpdateDraftOrderTsaInformationMutation, CheckoutUpdateDraftOrderTsaInformationMutationVariables>(CheckoutUpdateDraftOrderTsaInformationDocument, options);
      }
export type CheckoutUpdateDraftOrderTsaInformationMutationHookResult = ReturnType<typeof useCheckoutUpdateDraftOrderTsaInformationMutation>;
export type CheckoutUpdateDraftOrderTsaInformationMutationResult = Apollo.MutationResult<CheckoutUpdateDraftOrderTsaInformationMutation>;
export type CheckoutUpdateDraftOrderTsaInformationMutationOptions = Apollo.BaseMutationOptions<CheckoutUpdateDraftOrderTsaInformationMutation, CheckoutUpdateDraftOrderTsaInformationMutationVariables>;
export const UpdatePrimaryTripCustomerPhoneNumberDocument = gql`
    mutation UpdatePrimaryTripCustomerPhoneNumber($customerId: ObjectId!, $input: UpdateCustomerPhoneNumberInput!) {
  updateCustomerPhoneNumber(customerId: $customerId, input: $input) {
    ... on Customer {
      ...Customer
    }
  }
}
    ${CustomerFragmentDoc}`;
export type UpdatePrimaryTripCustomerPhoneNumberMutationFn = Apollo.MutationFunction<UpdatePrimaryTripCustomerPhoneNumberMutation, UpdatePrimaryTripCustomerPhoneNumberMutationVariables>;

/**
 * __useUpdatePrimaryTripCustomerPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdatePrimaryTripCustomerPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrimaryTripCustomerPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrimaryTripCustomerPhoneNumberMutation, { data, loading, error }] = useUpdatePrimaryTripCustomerPhoneNumberMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrimaryTripCustomerPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrimaryTripCustomerPhoneNumberMutation, UpdatePrimaryTripCustomerPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrimaryTripCustomerPhoneNumberMutation, UpdatePrimaryTripCustomerPhoneNumberMutationVariables>(UpdatePrimaryTripCustomerPhoneNumberDocument, options);
      }
export type UpdatePrimaryTripCustomerPhoneNumberMutationHookResult = ReturnType<typeof useUpdatePrimaryTripCustomerPhoneNumberMutation>;
export type UpdatePrimaryTripCustomerPhoneNumberMutationResult = Apollo.MutationResult<UpdatePrimaryTripCustomerPhoneNumberMutation>;
export type UpdatePrimaryTripCustomerPhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdatePrimaryTripCustomerPhoneNumberMutation, UpdatePrimaryTripCustomerPhoneNumberMutationVariables>;
export const RebookingDocument = gql`
    query Rebooking($id: ObjectId!, $language: String!) {
  booking(_id: $id) {
    _id
    customer {
      _id
    }
    departure {
      _id
      tourContent(language: $language) {
        name
      }
      activeExtensionContent(language: $language) {
        name
      }
    }
    stage
    trips {
      _id
      status
      isPrimary
      isRebooked
      hasExtension
      departureDate
      endDate
    }
  }
}
    `;

/**
 * __useRebookingQuery__
 *
 * To run a query within a React component, call `useRebookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRebookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRebookingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useRebookingQuery(baseOptions: Apollo.QueryHookOptions<RebookingQuery, RebookingQueryVariables> & ({ variables: RebookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RebookingQuery, RebookingQueryVariables>(RebookingDocument, options);
      }
export function useRebookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RebookingQuery, RebookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RebookingQuery, RebookingQueryVariables>(RebookingDocument, options);
        }
export function useRebookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RebookingQuery, RebookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RebookingQuery, RebookingQueryVariables>(RebookingDocument, options);
        }
export type RebookingQueryHookResult = ReturnType<typeof useRebookingQuery>;
export type RebookingLazyQueryHookResult = ReturnType<typeof useRebookingLazyQuery>;
export type RebookingSuspenseQueryHookResult = ReturnType<typeof useRebookingSuspenseQuery>;
export type RebookingQueryResult = Apollo.QueryResult<RebookingQuery, RebookingQueryVariables>;
export const EntryRequirementsToursDocument = gql`
    query EntryRequirementsTours($filter: FilterTourInput, $language: String!, $pagination: PaginateInput) {
  tours(filter: $filter, pagination: $pagination) {
    results {
      _id
      overnightCountries {
        _id
        alpha3Code
      }
      content(language: $language) {
        id
        name
      }
      extensions {
        _id
        overnightCountries {
          _id
          alpha3Code
        }
        content(language: $language) {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useEntryRequirementsToursQuery__
 *
 * To run a query within a React component, call `useEntryRequirementsToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntryRequirementsToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntryRequirementsToursQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      language: // value for 'language'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useEntryRequirementsToursQuery(baseOptions: Apollo.QueryHookOptions<EntryRequirementsToursQuery, EntryRequirementsToursQueryVariables> & ({ variables: EntryRequirementsToursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntryRequirementsToursQuery, EntryRequirementsToursQueryVariables>(EntryRequirementsToursDocument, options);
      }
export function useEntryRequirementsToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntryRequirementsToursQuery, EntryRequirementsToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntryRequirementsToursQuery, EntryRequirementsToursQueryVariables>(EntryRequirementsToursDocument, options);
        }
export function useEntryRequirementsToursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntryRequirementsToursQuery, EntryRequirementsToursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntryRequirementsToursQuery, EntryRequirementsToursQueryVariables>(EntryRequirementsToursDocument, options);
        }
export type EntryRequirementsToursQueryHookResult = ReturnType<typeof useEntryRequirementsToursQuery>;
export type EntryRequirementsToursLazyQueryHookResult = ReturnType<typeof useEntryRequirementsToursLazyQuery>;
export type EntryRequirementsToursSuspenseQueryHookResult = ReturnType<typeof useEntryRequirementsToursSuspenseQuery>;
export type EntryRequirementsToursQueryResult = Apollo.QueryResult<EntryRequirementsToursQuery, EntryRequirementsToursQueryVariables>;
export const AcceptGcDepartureTermsDocument = gql`
    mutation AcceptGCDepartureTerms($id: ObjectId!, $termId: ObjectId!, $language: String!) {
  acceptGCDepartureTerms(_id: $id, termId: $termId) {
    ...GCDeparture
  }
}
    ${GcDepartureFragmentDoc}`;
export type AcceptGcDepartureTermsMutationFn = Apollo.MutationFunction<AcceptGcDepartureTermsMutation, AcceptGcDepartureTermsMutationVariables>;

/**
 * __useAcceptGcDepartureTermsMutation__
 *
 * To run a mutation, you first call `useAcceptGcDepartureTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptGcDepartureTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptGcDepartureTermsMutation, { data, loading, error }] = useAcceptGcDepartureTermsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      termId: // value for 'termId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAcceptGcDepartureTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptGcDepartureTermsMutation, AcceptGcDepartureTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptGcDepartureTermsMutation, AcceptGcDepartureTermsMutationVariables>(AcceptGcDepartureTermsDocument, options);
      }
export type AcceptGcDepartureTermsMutationHookResult = ReturnType<typeof useAcceptGcDepartureTermsMutation>;
export type AcceptGcDepartureTermsMutationResult = Apollo.MutationResult<AcceptGcDepartureTermsMutation>;
export type AcceptGcDepartureTermsMutationOptions = Apollo.BaseMutationOptions<AcceptGcDepartureTermsMutation, AcceptGcDepartureTermsMutationVariables>;
export const AcceptTripTermsDocument = gql`
    mutation AcceptTripTerms($bookingId: ObjectId!, $tripId: ObjectId!, $termId: ObjectId!) {
  acceptTripTerms(bookingId: $bookingId, tripId: $tripId, termId: $termId) {
    ... on Booking {
      _id
      trips {
        _id
        hasSignedTerms
        termsSignatureChecklistItem {
          dueDate
          isCompleted
          status
        }
        termsAcceptedAt
        signedTerms {
          _id
        }
      }
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
  }
}
    `;
export type AcceptTripTermsMutationFn = Apollo.MutationFunction<AcceptTripTermsMutation, AcceptTripTermsMutationVariables>;

/**
 * __useAcceptTripTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTripTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTripTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTripTermsMutation, { data, loading, error }] = useAcceptTripTermsMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      tripId: // value for 'tripId'
 *      termId: // value for 'termId'
 *   },
 * });
 */
export function useAcceptTripTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTripTermsMutation, AcceptTripTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTripTermsMutation, AcceptTripTermsMutationVariables>(AcceptTripTermsDocument, options);
      }
export type AcceptTripTermsMutationHookResult = ReturnType<typeof useAcceptTripTermsMutation>;
export type AcceptTripTermsMutationResult = Apollo.MutationResult<AcceptTripTermsMutation>;
export type AcceptTripTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTripTermsMutation, AcceptTripTermsMutationVariables>;
export const AddDraftBookingPaymentScheduleDocument = gql`
    mutation AddDraftBookingPaymentSchedule($id: ObjectId!, $paymentSchedule: PaymentScheduleInput!) {
  addDraftBookingPaymentSchedule(_id: $id, paymentSchedule: $paymentSchedule) {
    ... on DraftOrder {
      _id
    }
  }
}
    `;
export type AddDraftBookingPaymentScheduleMutationFn = Apollo.MutationFunction<AddDraftBookingPaymentScheduleMutation, AddDraftBookingPaymentScheduleMutationVariables>;

/**
 * __useAddDraftBookingPaymentScheduleMutation__
 *
 * To run a mutation, you first call `useAddDraftBookingPaymentScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDraftBookingPaymentScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDraftBookingPaymentScheduleMutation, { data, loading, error }] = useAddDraftBookingPaymentScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentSchedule: // value for 'paymentSchedule'
 *   },
 * });
 */
export function useAddDraftBookingPaymentScheduleMutation(baseOptions?: Apollo.MutationHookOptions<AddDraftBookingPaymentScheduleMutation, AddDraftBookingPaymentScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDraftBookingPaymentScheduleMutation, AddDraftBookingPaymentScheduleMutationVariables>(AddDraftBookingPaymentScheduleDocument, options);
      }
export type AddDraftBookingPaymentScheduleMutationHookResult = ReturnType<typeof useAddDraftBookingPaymentScheduleMutation>;
export type AddDraftBookingPaymentScheduleMutationResult = Apollo.MutationResult<AddDraftBookingPaymentScheduleMutation>;
export type AddDraftBookingPaymentScheduleMutationOptions = Apollo.BaseMutationOptions<AddDraftBookingPaymentScheduleMutation, AddDraftBookingPaymentScheduleMutationVariables>;
export const CancelPaymentScheduleDocument = gql`
    mutation CancelPaymentSchedule($id: ObjectId!) {
  cancelDraftBookingPaymentSchedule(_id: $id) {
    ... on DraftOrder {
      _id
    }
  }
}
    `;
export type CancelPaymentScheduleMutationFn = Apollo.MutationFunction<CancelPaymentScheduleMutation, CancelPaymentScheduleMutationVariables>;

/**
 * __useCancelPaymentScheduleMutation__
 *
 * To run a mutation, you first call `useCancelPaymentScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentScheduleMutation, { data, loading, error }] = useCancelPaymentScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPaymentScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CancelPaymentScheduleMutation, CancelPaymentScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPaymentScheduleMutation, CancelPaymentScheduleMutationVariables>(CancelPaymentScheduleDocument, options);
      }
export type CancelPaymentScheduleMutationHookResult = ReturnType<typeof useCancelPaymentScheduleMutation>;
export type CancelPaymentScheduleMutationResult = Apollo.MutationResult<CancelPaymentScheduleMutation>;
export type CancelPaymentScheduleMutationOptions = Apollo.BaseMutationOptions<CancelPaymentScheduleMutation, CancelPaymentScheduleMutationVariables>;
export const FeePriceDocument = gql`
    query FeePrice($departureId: ObjectId!, $currencyCode: CurrencyCode!, $departureDate: Date!, $feeTypeCode: FeeTypeCode!) {
  departure(_id: $departureId) {
    _id
    tour {
      _id
      feePrice(
        currencyCode: $currencyCode
        departureDate: $departureDate
        typeCode: $feeTypeCode
      ) {
        currencyCode
        value
        formatted
      }
    }
  }
}
    `;

/**
 * __useFeePriceQuery__
 *
 * To run a query within a React component, call `useFeePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeePriceQuery({
 *   variables: {
 *      departureId: // value for 'departureId'
 *      currencyCode: // value for 'currencyCode'
 *      departureDate: // value for 'departureDate'
 *      feeTypeCode: // value for 'feeTypeCode'
 *   },
 * });
 */
export function useFeePriceQuery(baseOptions: Apollo.QueryHookOptions<FeePriceQuery, FeePriceQueryVariables> & ({ variables: FeePriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeePriceQuery, FeePriceQueryVariables>(FeePriceDocument, options);
      }
export function useFeePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeePriceQuery, FeePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeePriceQuery, FeePriceQueryVariables>(FeePriceDocument, options);
        }
export function useFeePriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeePriceQuery, FeePriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeePriceQuery, FeePriceQueryVariables>(FeePriceDocument, options);
        }
export type FeePriceQueryHookResult = ReturnType<typeof useFeePriceQuery>;
export type FeePriceLazyQueryHookResult = ReturnType<typeof useFeePriceLazyQuery>;
export type FeePriceSuspenseQueryHookResult = ReturnType<typeof useFeePriceSuspenseQuery>;
export type FeePriceQueryResult = Apollo.QueryResult<FeePriceQuery, FeePriceQueryVariables>;
export const LightMeDocument = gql`
    query LightMe($businessCode: BusinessCode!, $language: String!) {
  me {
    _id
    ... on Customer {
      ...BasicCustomer
      hasGCDepartures(businessCode: $businessCode)
      confirmedTrips(businessCode: $businessCode) {
        _id
        ... on BookingTrip {
          ...MyAccountBasicMyTrip
        }
      }
      waitlistedTrips(businessCode: $businessCode) {
        _id
        ... on BookingTrip {
          ...MyAccountBasicMyTrip
        }
      }
      requestedTrips(businessCode: $businessCode) {
        _id
        ... on BookingTrip {
          ...MyAccountBasicMyTrip
        }
      }
      pendingRebookingTrips(businessCode: $businessCode) {
        _id
        ... on BookingTrip {
          ...MyAccountBasicMyTrip
        }
      }
    }
  }
}
    ${BasicCustomerFragmentDoc}
${MyAccountBasicMyTripFragmentDoc}`;

/**
 * __useLightMeQuery__
 *
 * To run a query within a React component, call `useLightMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLightMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLightMeQuery({
 *   variables: {
 *      businessCode: // value for 'businessCode'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useLightMeQuery(baseOptions: Apollo.QueryHookOptions<LightMeQuery, LightMeQueryVariables> & ({ variables: LightMeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LightMeQuery, LightMeQueryVariables>(LightMeDocument, options);
      }
export function useLightMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LightMeQuery, LightMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LightMeQuery, LightMeQueryVariables>(LightMeDocument, options);
        }
export function useLightMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LightMeQuery, LightMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LightMeQuery, LightMeQueryVariables>(LightMeDocument, options);
        }
export type LightMeQueryHookResult = ReturnType<typeof useLightMeQuery>;
export type LightMeLazyQueryHookResult = ReturnType<typeof useLightMeLazyQuery>;
export type LightMeSuspenseQueryHookResult = ReturnType<typeof useLightMeSuspenseQuery>;
export type LightMeQueryResult = Apollo.QueryResult<LightMeQuery, LightMeQueryVariables>;
export const MakeAPaymentDocument = gql`
    mutation MakeAPayment($bookingId: ObjectId!, $payments: [PaymentInput!]!, $language: String!) {
  makeAPayment(bookingId: $bookingId, payments: $payments) {
    ...MeBooking
  }
}
    ${MeBookingFragmentDoc}`;
export type MakeAPaymentMutationFn = Apollo.MutationFunction<MakeAPaymentMutation, MakeAPaymentMutationVariables>;

/**
 * __useMakeAPaymentMutation__
 *
 * To run a mutation, you first call `useMakeAPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeAPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeAPaymentMutation, { data, loading, error }] = useMakeAPaymentMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      payments: // value for 'payments'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMakeAPaymentMutation(baseOptions?: Apollo.MutationHookOptions<MakeAPaymentMutation, MakeAPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeAPaymentMutation, MakeAPaymentMutationVariables>(MakeAPaymentDocument, options);
      }
export type MakeAPaymentMutationHookResult = ReturnType<typeof useMakeAPaymentMutation>;
export type MakeAPaymentMutationResult = Apollo.MutationResult<MakeAPaymentMutation>;
export type MakeAPaymentMutationOptions = Apollo.BaseMutationOptions<MakeAPaymentMutation, MakeAPaymentMutationVariables>;
export const MeBookingTripDocument = gql`
    query MeBookingTrip($tripId: ObjectId!) {
  bookingTrip(_id: $tripId) {
    ... on BookingTrip {
      ...MeBookingTrip
    }
  }
}
    ${MeBookingTripFragmentDoc}`;

/**
 * __useMeBookingTripQuery__
 *
 * To run a query within a React component, call `useMeBookingTripQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeBookingTripQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeBookingTripQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useMeBookingTripQuery(baseOptions: Apollo.QueryHookOptions<MeBookingTripQuery, MeBookingTripQueryVariables> & ({ variables: MeBookingTripQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeBookingTripQuery, MeBookingTripQueryVariables>(MeBookingTripDocument, options);
      }
export function useMeBookingTripLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeBookingTripQuery, MeBookingTripQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeBookingTripQuery, MeBookingTripQueryVariables>(MeBookingTripDocument, options);
        }
export function useMeBookingTripSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeBookingTripQuery, MeBookingTripQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeBookingTripQuery, MeBookingTripQueryVariables>(MeBookingTripDocument, options);
        }
export type MeBookingTripQueryHookResult = ReturnType<typeof useMeBookingTripQuery>;
export type MeBookingTripLazyQueryHookResult = ReturnType<typeof useMeBookingTripLazyQuery>;
export type MeBookingTripSuspenseQueryHookResult = ReturnType<typeof useMeBookingTripSuspenseQuery>;
export type MeBookingTripQueryResult = Apollo.QueryResult<MeBookingTripQuery, MeBookingTripQueryVariables>;
export const MeBookingTripWithBookingDocument = gql`
    query MeBookingTripWithBooking($id: ObjectId!, $language: String!) {
  bookingTrip(_id: $id) {
    ...MeBookingTripWithBooking
  }
}
    ${MeBookingTripWithBookingFragmentDoc}`;

/**
 * __useMeBookingTripWithBookingQuery__
 *
 * To run a query within a React component, call `useMeBookingTripWithBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeBookingTripWithBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeBookingTripWithBookingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMeBookingTripWithBookingQuery(baseOptions: Apollo.QueryHookOptions<MeBookingTripWithBookingQuery, MeBookingTripWithBookingQueryVariables> & ({ variables: MeBookingTripWithBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeBookingTripWithBookingQuery, MeBookingTripWithBookingQueryVariables>(MeBookingTripWithBookingDocument, options);
      }
export function useMeBookingTripWithBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeBookingTripWithBookingQuery, MeBookingTripWithBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeBookingTripWithBookingQuery, MeBookingTripWithBookingQueryVariables>(MeBookingTripWithBookingDocument, options);
        }
export function useMeBookingTripWithBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeBookingTripWithBookingQuery, MeBookingTripWithBookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeBookingTripWithBookingQuery, MeBookingTripWithBookingQueryVariables>(MeBookingTripWithBookingDocument, options);
        }
export type MeBookingTripWithBookingQueryHookResult = ReturnType<typeof useMeBookingTripWithBookingQuery>;
export type MeBookingTripWithBookingLazyQueryHookResult = ReturnType<typeof useMeBookingTripWithBookingLazyQuery>;
export type MeBookingTripWithBookingSuspenseQueryHookResult = ReturnType<typeof useMeBookingTripWithBookingSuspenseQuery>;
export type MeBookingTripWithBookingQueryResult = Apollo.QueryResult<MeBookingTripWithBookingQuery, MeBookingTripWithBookingQueryVariables>;
export const MeBookingTripWithDepartureDocument = gql`
    query MeBookingTripWithDeparture($tripId: ObjectId!, $language: String!) {
  bookingTrip(_id: $tripId) {
    ... on BookingTrip {
      ...MeBookingTrip
      departure {
        ...MeBookingDeparture
      }
    }
  }
}
    ${MeBookingTripFragmentDoc}
${MeBookingDepartureFragmentDoc}`;

/**
 * __useMeBookingTripWithDepartureQuery__
 *
 * To run a query within a React component, call `useMeBookingTripWithDepartureQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeBookingTripWithDepartureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeBookingTripWithDepartureQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMeBookingTripWithDepartureQuery(baseOptions: Apollo.QueryHookOptions<MeBookingTripWithDepartureQuery, MeBookingTripWithDepartureQueryVariables> & ({ variables: MeBookingTripWithDepartureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeBookingTripWithDepartureQuery, MeBookingTripWithDepartureQueryVariables>(MeBookingTripWithDepartureDocument, options);
      }
export function useMeBookingTripWithDepartureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeBookingTripWithDepartureQuery, MeBookingTripWithDepartureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeBookingTripWithDepartureQuery, MeBookingTripWithDepartureQueryVariables>(MeBookingTripWithDepartureDocument, options);
        }
export function useMeBookingTripWithDepartureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeBookingTripWithDepartureQuery, MeBookingTripWithDepartureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeBookingTripWithDepartureQuery, MeBookingTripWithDepartureQueryVariables>(MeBookingTripWithDepartureDocument, options);
        }
export type MeBookingTripWithDepartureQueryHookResult = ReturnType<typeof useMeBookingTripWithDepartureQuery>;
export type MeBookingTripWithDepartureLazyQueryHookResult = ReturnType<typeof useMeBookingTripWithDepartureLazyQuery>;
export type MeBookingTripWithDepartureSuspenseQueryHookResult = ReturnType<typeof useMeBookingTripWithDepartureSuspenseQuery>;
export type MeBookingTripWithDepartureQueryResult = Apollo.QueryResult<MeBookingTripWithDepartureQuery, MeBookingTripWithDepartureQueryVariables>;
export const MyGcDeparturesDocument = gql`
    query MyGcDepartures($language: String!, $filter: FilterGCDepartureInput) {
  gcDepartures(filter: $filter) {
    results {
      _id
      isNonBookedGroupCoordinator
      departure {
        ...MyAccountBasicDeparture
      }
      micrositeContent(language: $language) {
        title
      }
    }
  }
}
    ${MyAccountBasicDepartureFragmentDoc}`;

/**
 * __useMyGcDeparturesQuery__
 *
 * To run a query within a React component, call `useMyGcDeparturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGcDeparturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGcDeparturesQuery({
 *   variables: {
 *      language: // value for 'language'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyGcDeparturesQuery(baseOptions: Apollo.QueryHookOptions<MyGcDeparturesQuery, MyGcDeparturesQueryVariables> & ({ variables: MyGcDeparturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGcDeparturesQuery, MyGcDeparturesQueryVariables>(MyGcDeparturesDocument, options);
      }
export function useMyGcDeparturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGcDeparturesQuery, MyGcDeparturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGcDeparturesQuery, MyGcDeparturesQueryVariables>(MyGcDeparturesDocument, options);
        }
export function useMyGcDeparturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGcDeparturesQuery, MyGcDeparturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGcDeparturesQuery, MyGcDeparturesQueryVariables>(MyGcDeparturesDocument, options);
        }
export type MyGcDeparturesQueryHookResult = ReturnType<typeof useMyGcDeparturesQuery>;
export type MyGcDeparturesLazyQueryHookResult = ReturnType<typeof useMyGcDeparturesLazyQuery>;
export type MyGcDeparturesSuspenseQueryHookResult = ReturnType<typeof useMyGcDeparturesSuspenseQuery>;
export type MyGcDeparturesQueryResult = Apollo.QueryResult<MyGcDeparturesQuery, MyGcDeparturesQueryVariables>;
export const MyGlobalRewardsSummaryDocument = gql`
    query MyGlobalRewardsSummary {
  myGlobalRewardsSummary {
    id
    membershipLevelId
    pointsActive
    pointsPending
  }
}
    `;

/**
 * __useMyGlobalRewardsSummaryQuery__
 *
 * To run a query within a React component, call `useMyGlobalRewardsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGlobalRewardsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGlobalRewardsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGlobalRewardsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<MyGlobalRewardsSummaryQuery, MyGlobalRewardsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGlobalRewardsSummaryQuery, MyGlobalRewardsSummaryQueryVariables>(MyGlobalRewardsSummaryDocument, options);
      }
export function useMyGlobalRewardsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGlobalRewardsSummaryQuery, MyGlobalRewardsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGlobalRewardsSummaryQuery, MyGlobalRewardsSummaryQueryVariables>(MyGlobalRewardsSummaryDocument, options);
        }
export function useMyGlobalRewardsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGlobalRewardsSummaryQuery, MyGlobalRewardsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGlobalRewardsSummaryQuery, MyGlobalRewardsSummaryQueryVariables>(MyGlobalRewardsSummaryDocument, options);
        }
export type MyGlobalRewardsSummaryQueryHookResult = ReturnType<typeof useMyGlobalRewardsSummaryQuery>;
export type MyGlobalRewardsSummaryLazyQueryHookResult = ReturnType<typeof useMyGlobalRewardsSummaryLazyQuery>;
export type MyGlobalRewardsSummarySuspenseQueryHookResult = ReturnType<typeof useMyGlobalRewardsSummarySuspenseQuery>;
export type MyGlobalRewardsSummaryQueryResult = Apollo.QueryResult<MyGlobalRewardsSummaryQuery, MyGlobalRewardsSummaryQueryVariables>;
export const OldTripsDocument = gql`
    query OldTrips($businessCode: BusinessCode!) {
  me {
    _id
    ... on Customer {
      confirmedOldTrips(businessCode: $businessCode) {
        ...BasicOldTrip
      }
    }
  }
}
    ${BasicOldTripFragmentDoc}`;

/**
 * __useOldTripsQuery__
 *
 * To run a query within a React component, call `useOldTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldTripsQuery({
 *   variables: {
 *      businessCode: // value for 'businessCode'
 *   },
 * });
 */
export function useOldTripsQuery(baseOptions: Apollo.QueryHookOptions<OldTripsQuery, OldTripsQueryVariables> & ({ variables: OldTripsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldTripsQuery, OldTripsQueryVariables>(OldTripsDocument, options);
      }
export function useOldTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OldTripsQuery, OldTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldTripsQuery, OldTripsQueryVariables>(OldTripsDocument, options);
        }
export function useOldTripsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OldTripsQuery, OldTripsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OldTripsQuery, OldTripsQueryVariables>(OldTripsDocument, options);
        }
export type OldTripsQueryHookResult = ReturnType<typeof useOldTripsQuery>;
export type OldTripsLazyQueryHookResult = ReturnType<typeof useOldTripsLazyQuery>;
export type OldTripsSuspenseQueryHookResult = ReturnType<typeof useOldTripsSuspenseQuery>;
export type OldTripsQueryResult = Apollo.QueryResult<OldTripsQuery, OldTripsQueryVariables>;
export const PaymentAndAddressDocument = gql`
    query PaymentAndAddress($businessCode: BusinessCode!) {
  me {
    _id
    ... on Customer {
      savedPaymentMethods(businessCode: $businessCode, isActive: true) {
        ...SavedPaymentMethod
      }
      address {
        city
        country
        postalCode
        state
        street1
        street2
      }
    }
  }
}
    ${SavedPaymentMethodFragmentDoc}`;

/**
 * __usePaymentAndAddressQuery__
 *
 * To run a query within a React component, call `usePaymentAndAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentAndAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentAndAddressQuery({
 *   variables: {
 *      businessCode: // value for 'businessCode'
 *   },
 * });
 */
export function usePaymentAndAddressQuery(baseOptions: Apollo.QueryHookOptions<PaymentAndAddressQuery, PaymentAndAddressQueryVariables> & ({ variables: PaymentAndAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentAndAddressQuery, PaymentAndAddressQueryVariables>(PaymentAndAddressDocument, options);
      }
export function usePaymentAndAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentAndAddressQuery, PaymentAndAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentAndAddressQuery, PaymentAndAddressQueryVariables>(PaymentAndAddressDocument, options);
        }
export function usePaymentAndAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentAndAddressQuery, PaymentAndAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentAndAddressQuery, PaymentAndAddressQueryVariables>(PaymentAndAddressDocument, options);
        }
export type PaymentAndAddressQueryHookResult = ReturnType<typeof usePaymentAndAddressQuery>;
export type PaymentAndAddressLazyQueryHookResult = ReturnType<typeof usePaymentAndAddressLazyQuery>;
export type PaymentAndAddressSuspenseQueryHookResult = ReturnType<typeof usePaymentAndAddressSuspenseQuery>;
export type PaymentAndAddressQueryResult = Apollo.QueryResult<PaymentAndAddressQuery, PaymentAndAddressQueryVariables>;
export const SavedQuoteDetailsDocument = gql`
    query SavedQuoteDetails($id: ObjectId!, $language: String!) {
  quote(_id: $id) {
    ...SavedQuote
  }
}
    ${SavedQuoteFragmentDoc}`;

/**
 * __useSavedQuoteDetailsQuery__
 *
 * To run a query within a React component, call `useSavedQuoteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedQuoteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedQuoteDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSavedQuoteDetailsQuery(baseOptions: Apollo.QueryHookOptions<SavedQuoteDetailsQuery, SavedQuoteDetailsQueryVariables> & ({ variables: SavedQuoteDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedQuoteDetailsQuery, SavedQuoteDetailsQueryVariables>(SavedQuoteDetailsDocument, options);
      }
export function useSavedQuoteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedQuoteDetailsQuery, SavedQuoteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedQuoteDetailsQuery, SavedQuoteDetailsQueryVariables>(SavedQuoteDetailsDocument, options);
        }
export function useSavedQuoteDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedQuoteDetailsQuery, SavedQuoteDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedQuoteDetailsQuery, SavedQuoteDetailsQueryVariables>(SavedQuoteDetailsDocument, options);
        }
export type SavedQuoteDetailsQueryHookResult = ReturnType<typeof useSavedQuoteDetailsQuery>;
export type SavedQuoteDetailsLazyQueryHookResult = ReturnType<typeof useSavedQuoteDetailsLazyQuery>;
export type SavedQuoteDetailsSuspenseQueryHookResult = ReturnType<typeof useSavedQuoteDetailsSuspenseQuery>;
export type SavedQuoteDetailsQueryResult = Apollo.QueryResult<SavedQuoteDetailsQuery, SavedQuoteDetailsQueryVariables>;
export const SavedQuotesDocument = gql`
    query SavedQuotes($filter: FilterQuoteInput, $pagination: PaginateInput, $sort: SortQuoteInput, $language: String!) {
  quotes(filter: $filter, pagination: $pagination, sort: $sort) {
    hasNext
    hasPrevious
    next
    previous
    results {
      ...SavedQuote
    }
  }
}
    ${SavedQuoteFragmentDoc}`;

/**
 * __useSavedQuotesQuery__
 *
 * To run a query within a React component, call `useSavedQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedQuotesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSavedQuotesQuery(baseOptions: Apollo.QueryHookOptions<SavedQuotesQuery, SavedQuotesQueryVariables> & ({ variables: SavedQuotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedQuotesQuery, SavedQuotesQueryVariables>(SavedQuotesDocument, options);
      }
export function useSavedQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedQuotesQuery, SavedQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedQuotesQuery, SavedQuotesQueryVariables>(SavedQuotesDocument, options);
        }
export function useSavedQuotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedQuotesQuery, SavedQuotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedQuotesQuery, SavedQuotesQueryVariables>(SavedQuotesDocument, options);
        }
export type SavedQuotesQueryHookResult = ReturnType<typeof useSavedQuotesQuery>;
export type SavedQuotesLazyQueryHookResult = ReturnType<typeof useSavedQuotesLazyQuery>;
export type SavedQuotesSuspenseQueryHookResult = ReturnType<typeof useSavedQuotesSuspenseQuery>;
export type SavedQuotesQueryResult = Apollo.QueryResult<SavedQuotesQuery, SavedQuotesQueryVariables>;
export const TermContentDocument = gql`
    query TermContent($id: ObjectId!) {
  term(_id: $id) {
    content
  }
}
    `;

/**
 * __useTermContentQuery__
 *
 * To run a query within a React component, call `useTermContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTermContentQuery(baseOptions: Apollo.QueryHookOptions<TermContentQuery, TermContentQueryVariables> & ({ variables: TermContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TermContentQuery, TermContentQueryVariables>(TermContentDocument, options);
      }
export function useTermContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TermContentQuery, TermContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TermContentQuery, TermContentQueryVariables>(TermContentDocument, options);
        }
export function useTermContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TermContentQuery, TermContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TermContentQuery, TermContentQueryVariables>(TermContentDocument, options);
        }
export type TermContentQueryHookResult = ReturnType<typeof useTermContentQuery>;
export type TermContentLazyQueryHookResult = ReturnType<typeof useTermContentLazyQuery>;
export type TermContentSuspenseQueryHookResult = ReturnType<typeof useTermContentSuspenseQuery>;
export type TermContentQueryResult = Apollo.QueryResult<TermContentQuery, TermContentQueryVariables>;
export const TooMuchDataMeDocument = gql`
    query TooMuchDataMe($businessCode: BusinessCode!, $language: String!) {
  me {
    _id
    ... on Customer {
      ...CustomerWithPayment
      hasGCDepartures(businessCode: $businessCode)
      confirmedTrips(businessCode: $businessCode) {
        _id
        ... on BookingTrip {
          ...MeBookingTripWithBooking
        }
      }
      waitlistedTrips(businessCode: $businessCode) {
        _id
        ... on BookingTrip {
          ...MeBookingTripWithBooking
        }
      }
      requestedTrips(businessCode: $businessCode) {
        _id
        ... on BookingTrip {
          ...MeBookingTripWithBooking
        }
      }
      pendingRebookingTrips(businessCode: $businessCode) {
        _id
        ... on BookingTrip {
          ...MeBookingTripWithBooking
        }
      }
    }
  }
}
    ${CustomerWithPaymentFragmentDoc}
${MeBookingTripWithBookingFragmentDoc}`;

/**
 * __useTooMuchDataMeQuery__
 *
 * To run a query within a React component, call `useTooMuchDataMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTooMuchDataMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTooMuchDataMeQuery({
 *   variables: {
 *      businessCode: // value for 'businessCode'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTooMuchDataMeQuery(baseOptions: Apollo.QueryHookOptions<TooMuchDataMeQuery, TooMuchDataMeQueryVariables> & ({ variables: TooMuchDataMeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TooMuchDataMeQuery, TooMuchDataMeQueryVariables>(TooMuchDataMeDocument, options);
      }
export function useTooMuchDataMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TooMuchDataMeQuery, TooMuchDataMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TooMuchDataMeQuery, TooMuchDataMeQueryVariables>(TooMuchDataMeDocument, options);
        }
export function useTooMuchDataMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TooMuchDataMeQuery, TooMuchDataMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TooMuchDataMeQuery, TooMuchDataMeQueryVariables>(TooMuchDataMeDocument, options);
        }
export type TooMuchDataMeQueryHookResult = ReturnType<typeof useTooMuchDataMeQuery>;
export type TooMuchDataMeLazyQueryHookResult = ReturnType<typeof useTooMuchDataMeLazyQuery>;
export type TooMuchDataMeSuspenseQueryHookResult = ReturnType<typeof useTooMuchDataMeSuspenseQuery>;
export type TooMuchDataMeQueryResult = Apollo.QueryResult<TooMuchDataMeQuery, TooMuchDataMeQueryVariables>;
export const UpdateDraftBookingPaymentScheduleDocument = gql`
    mutation UpdateDraftBookingPaymentSchedule($id: ObjectId!, $frequency: PaymentScheduleFrequency!, $startDate: Date!) {
  updateDraftBookingPaymentSchedule(
    _id: $id
    frequency: $frequency
    startDate: $startDate
  ) {
    ... on DraftOrder {
      order {
        _id
      }
    }
  }
}
    `;
export type UpdateDraftBookingPaymentScheduleMutationFn = Apollo.MutationFunction<UpdateDraftBookingPaymentScheduleMutation, UpdateDraftBookingPaymentScheduleMutationVariables>;

/**
 * __useUpdateDraftBookingPaymentScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateDraftBookingPaymentScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftBookingPaymentScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftBookingPaymentScheduleMutation, { data, loading, error }] = useUpdateDraftBookingPaymentScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      frequency: // value for 'frequency'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useUpdateDraftBookingPaymentScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftBookingPaymentScheduleMutation, UpdateDraftBookingPaymentScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftBookingPaymentScheduleMutation, UpdateDraftBookingPaymentScheduleMutationVariables>(UpdateDraftBookingPaymentScheduleDocument, options);
      }
export type UpdateDraftBookingPaymentScheduleMutationHookResult = ReturnType<typeof useUpdateDraftBookingPaymentScheduleMutation>;
export type UpdateDraftBookingPaymentScheduleMutationResult = Apollo.MutationResult<UpdateDraftBookingPaymentScheduleMutation>;
export type UpdateDraftBookingPaymentScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateDraftBookingPaymentScheduleMutation, UpdateDraftBookingPaymentScheduleMutationVariables>;
export const UpdateDraftBookingPaymentSchedulePaymentMethodDocument = gql`
    mutation UpdateDraftBookingPaymentSchedulePaymentMethod($id: ObjectId!, $paymentSchedulePaymentMethod: PaymentSchedulePaymentMethodInput!) {
  updateDraftBookingPaymentSchedulePaymentMethod(
    _id: $id
    paymentSchedulePaymentMethod: $paymentSchedulePaymentMethod
  ) {
    ... on DraftOrder {
      order {
        _id
      }
    }
  }
}
    `;
export type UpdateDraftBookingPaymentSchedulePaymentMethodMutationFn = Apollo.MutationFunction<UpdateDraftBookingPaymentSchedulePaymentMethodMutation, UpdateDraftBookingPaymentSchedulePaymentMethodMutationVariables>;

/**
 * __useUpdateDraftBookingPaymentSchedulePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateDraftBookingPaymentSchedulePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftBookingPaymentSchedulePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftBookingPaymentSchedulePaymentMethodMutation, { data, loading, error }] = useUpdateDraftBookingPaymentSchedulePaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentSchedulePaymentMethod: // value for 'paymentSchedulePaymentMethod'
 *   },
 * });
 */
export function useUpdateDraftBookingPaymentSchedulePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftBookingPaymentSchedulePaymentMethodMutation, UpdateDraftBookingPaymentSchedulePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftBookingPaymentSchedulePaymentMethodMutation, UpdateDraftBookingPaymentSchedulePaymentMethodMutationVariables>(UpdateDraftBookingPaymentSchedulePaymentMethodDocument, options);
      }
export type UpdateDraftBookingPaymentSchedulePaymentMethodMutationHookResult = ReturnType<typeof useUpdateDraftBookingPaymentSchedulePaymentMethodMutation>;
export type UpdateDraftBookingPaymentSchedulePaymentMethodMutationResult = Apollo.MutationResult<UpdateDraftBookingPaymentSchedulePaymentMethodMutation>;
export type UpdateDraftBookingPaymentSchedulePaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdateDraftBookingPaymentSchedulePaymentMethodMutation, UpdateDraftBookingPaymentSchedulePaymentMethodMutationVariables>;
export const UpdateDraftOrderEmergencyContactsDocument = gql`
    mutation UpdateDraftOrderEmergencyContacts($id: ObjectId!, $emergencyContacts: [EmergencyContactInput!]!, $tripId: ObjectId!) {
  updateDraftOrderEmergencyContacts(
    _id: $id
    emergencyContacts: $emergencyContacts
    tripId: $tripId
  ) {
    ... on DraftOrder {
      _id
    }
  }
}
    `;
export type UpdateDraftOrderEmergencyContactsMutationFn = Apollo.MutationFunction<UpdateDraftOrderEmergencyContactsMutation, UpdateDraftOrderEmergencyContactsMutationVariables>;

/**
 * __useUpdateDraftOrderEmergencyContactsMutation__
 *
 * To run a mutation, you first call `useUpdateDraftOrderEmergencyContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftOrderEmergencyContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftOrderEmergencyContactsMutation, { data, loading, error }] = useUpdateDraftOrderEmergencyContactsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emergencyContacts: // value for 'emergencyContacts'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useUpdateDraftOrderEmergencyContactsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftOrderEmergencyContactsMutation, UpdateDraftOrderEmergencyContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftOrderEmergencyContactsMutation, UpdateDraftOrderEmergencyContactsMutationVariables>(UpdateDraftOrderEmergencyContactsDocument, options);
      }
export type UpdateDraftOrderEmergencyContactsMutationHookResult = ReturnType<typeof useUpdateDraftOrderEmergencyContactsMutation>;
export type UpdateDraftOrderEmergencyContactsMutationResult = Apollo.MutationResult<UpdateDraftOrderEmergencyContactsMutation>;
export type UpdateDraftOrderEmergencyContactsMutationOptions = Apollo.BaseMutationOptions<UpdateDraftOrderEmergencyContactsMutation, UpdateDraftOrderEmergencyContactsMutationVariables>;
export const UpdateDraftOrderTravelerNotesDocument = gql`
    mutation UpdateDraftOrderTravelerNotes($id: ObjectId!, $tripId: ObjectId!, $input: TravelerNotesInput!) {
  updateDraftOrderTravelerNotes(_id: $id, tripId: $tripId, input: $input) {
    ... on DraftOrder {
      _id
      order {
        trips {
          travelerNotes {
            _id
          }
        }
      }
    }
  }
}
    `;
export type UpdateDraftOrderTravelerNotesMutationFn = Apollo.MutationFunction<UpdateDraftOrderTravelerNotesMutation, UpdateDraftOrderTravelerNotesMutationVariables>;

/**
 * __useUpdateDraftOrderTravelerNotesMutation__
 *
 * To run a mutation, you first call `useUpdateDraftOrderTravelerNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftOrderTravelerNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftOrderTravelerNotesMutation, { data, loading, error }] = useUpdateDraftOrderTravelerNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripId: // value for 'tripId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDraftOrderTravelerNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftOrderTravelerNotesMutation, UpdateDraftOrderTravelerNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftOrderTravelerNotesMutation, UpdateDraftOrderTravelerNotesMutationVariables>(UpdateDraftOrderTravelerNotesDocument, options);
      }
export type UpdateDraftOrderTravelerNotesMutationHookResult = ReturnType<typeof useUpdateDraftOrderTravelerNotesMutation>;
export type UpdateDraftOrderTravelerNotesMutationResult = Apollo.MutationResult<UpdateDraftOrderTravelerNotesMutation>;
export type UpdateDraftOrderTravelerNotesMutationOptions = Apollo.BaseMutationOptions<UpdateDraftOrderTravelerNotesMutation, UpdateDraftOrderTravelerNotesMutationVariables>;
export const UpdateDraftOrderTsaInformationDocument = gql`
    mutation UpdateDraftOrderTsaInformation($id: ObjectId!, $tripId: ObjectId!, $tsaInformation: TsaInformationInput!) {
  updateDraftOrderTsaInformation(
    _id: $id
    tripId: $tripId
    tsaInformation: $tsaInformation
  ) {
    ... on DraftOrder {
      _id
    }
  }
}
    `;
export type UpdateDraftOrderTsaInformationMutationFn = Apollo.MutationFunction<UpdateDraftOrderTsaInformationMutation, UpdateDraftOrderTsaInformationMutationVariables>;

/**
 * __useUpdateDraftOrderTsaInformationMutation__
 *
 * To run a mutation, you first call `useUpdateDraftOrderTsaInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftOrderTsaInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftOrderTsaInformationMutation, { data, loading, error }] = useUpdateDraftOrderTsaInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tripId: // value for 'tripId'
 *      tsaInformation: // value for 'tsaInformation'
 *   },
 * });
 */
export function useUpdateDraftOrderTsaInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftOrderTsaInformationMutation, UpdateDraftOrderTsaInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftOrderTsaInformationMutation, UpdateDraftOrderTsaInformationMutationVariables>(UpdateDraftOrderTsaInformationDocument, options);
      }
export type UpdateDraftOrderTsaInformationMutationHookResult = ReturnType<typeof useUpdateDraftOrderTsaInformationMutation>;
export type UpdateDraftOrderTsaInformationMutationResult = Apollo.MutationResult<UpdateDraftOrderTsaInformationMutation>;
export type UpdateDraftOrderTsaInformationMutationOptions = Apollo.BaseMutationOptions<UpdateDraftOrderTsaInformationMutation, UpdateDraftOrderTsaInformationMutationVariables>;
export const UpdateQuoteSavedDocument = gql`
    mutation UpdateQuoteSaved($id: ObjectId!, $input: UpdateQuoteSavedInput!) {
  updateQuoteSaved(_id: $id, input: $input) {
    ... on Quote {
      _id
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    `;
export type UpdateQuoteSavedMutationFn = Apollo.MutationFunction<UpdateQuoteSavedMutation, UpdateQuoteSavedMutationVariables>;

/**
 * __useUpdateQuoteSavedMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteSavedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteSavedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteSavedMutation, { data, loading, error }] = useUpdateQuoteSavedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteSavedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteSavedMutation, UpdateQuoteSavedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteSavedMutation, UpdateQuoteSavedMutationVariables>(UpdateQuoteSavedDocument, options);
      }
export type UpdateQuoteSavedMutationHookResult = ReturnType<typeof useUpdateQuoteSavedMutation>;
export type UpdateQuoteSavedMutationResult = Apollo.MutationResult<UpdateQuoteSavedMutation>;
export type UpdateQuoteSavedMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteSavedMutation, UpdateQuoteSavedMutationVariables>;
export const BookedGroupMembersTripsDocument = gql`
    query BookedGroupMembersTrips($gcDepartureId: ObjectId!, $language: String!) {
  gcDeparture(_id: $gcDepartureId) {
    _id
    departure {
      ...GroupMembersDeparture
    }
    flightsReleasedDate
    confirmedTrips {
      _id
      ...ConfirmedRequestedGroupMemberTrips
    }
    requestedTrips {
      _id
      ...ConfirmedRequestedGroupMemberTrips
    }
    cancelledTrips {
      _id
      ...CanceledGroupMemberDetails
    }
    groupCoordinatorCustomerId
    nbTravelersConfirmed
    nbTravelersCancelled
    nbTravelersWithExtension
    nbTravelersWithInsurance
  }
}
    ${GroupMembersDepartureFragmentDoc}
${ConfirmedRequestedGroupMemberTripsFragmentDoc}
${CanceledGroupMemberDetailsFragmentDoc}`;

/**
 * __useBookedGroupMembersTripsQuery__
 *
 * To run a query within a React component, call `useBookedGroupMembersTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookedGroupMembersTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookedGroupMembersTripsQuery({
 *   variables: {
 *      gcDepartureId: // value for 'gcDepartureId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useBookedGroupMembersTripsQuery(baseOptions: Apollo.QueryHookOptions<BookedGroupMembersTripsQuery, BookedGroupMembersTripsQueryVariables> & ({ variables: BookedGroupMembersTripsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookedGroupMembersTripsQuery, BookedGroupMembersTripsQueryVariables>(BookedGroupMembersTripsDocument, options);
      }
export function useBookedGroupMembersTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookedGroupMembersTripsQuery, BookedGroupMembersTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookedGroupMembersTripsQuery, BookedGroupMembersTripsQueryVariables>(BookedGroupMembersTripsDocument, options);
        }
export function useBookedGroupMembersTripsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookedGroupMembersTripsQuery, BookedGroupMembersTripsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookedGroupMembersTripsQuery, BookedGroupMembersTripsQueryVariables>(BookedGroupMembersTripsDocument, options);
        }
export type BookedGroupMembersTripsQueryHookResult = ReturnType<typeof useBookedGroupMembersTripsQuery>;
export type BookedGroupMembersTripsLazyQueryHookResult = ReturnType<typeof useBookedGroupMembersTripsLazyQuery>;
export type BookedGroupMembersTripsSuspenseQueryHookResult = ReturnType<typeof useBookedGroupMembersTripsSuspenseQuery>;
export type BookedGroupMembersTripsQueryResult = Apollo.QueryResult<BookedGroupMembersTripsQuery, BookedGroupMembersTripsQueryVariables>;
export const BulkCreateGroupMembersProspectsDocument = gql`
    mutation BulkCreateGroupMembersProspects($groupCoordinatorCustomerId: ObjectId!, $input: [BulkCreateGCDepartureProspectsInput!]!) {
  bulkCreateGCDepartureProspects(
    groupCoordinatorCustomerId: $groupCoordinatorCustomerId
    input: $input
  ) {
    ... on BulkCreateGCDepartureProspectsSuccess {
      data {
        _id
      }
    }
  }
}
    `;
export type BulkCreateGroupMembersProspectsMutationFn = Apollo.MutationFunction<BulkCreateGroupMembersProspectsMutation, BulkCreateGroupMembersProspectsMutationVariables>;

/**
 * __useBulkCreateGroupMembersProspectsMutation__
 *
 * To run a mutation, you first call `useBulkCreateGroupMembersProspectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateGroupMembersProspectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateGroupMembersProspectsMutation, { data, loading, error }] = useBulkCreateGroupMembersProspectsMutation({
 *   variables: {
 *      groupCoordinatorCustomerId: // value for 'groupCoordinatorCustomerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateGroupMembersProspectsMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateGroupMembersProspectsMutation, BulkCreateGroupMembersProspectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateGroupMembersProspectsMutation, BulkCreateGroupMembersProspectsMutationVariables>(BulkCreateGroupMembersProspectsDocument, options);
      }
export type BulkCreateGroupMembersProspectsMutationHookResult = ReturnType<typeof useBulkCreateGroupMembersProspectsMutation>;
export type BulkCreateGroupMembersProspectsMutationResult = Apollo.MutationResult<BulkCreateGroupMembersProspectsMutation>;
export type BulkCreateGroupMembersProspectsMutationOptions = Apollo.BaseMutationOptions<BulkCreateGroupMembersProspectsMutation, BulkCreateGroupMembersProspectsMutationVariables>;
export const GroupMembersProspectsDocument = gql`
    query GroupMembersProspects($gcDepartureId: ObjectId!) {
  gcDepartureProspects(filter: {gcDepartureId: $gcDepartureId}) {
    results {
      _id
      ...GroupMemberProspectDetails
    }
  }
}
    ${GroupMemberProspectDetailsFragmentDoc}`;

/**
 * __useGroupMembersProspectsQuery__
 *
 * To run a query within a React component, call `useGroupMembersProspectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMembersProspectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMembersProspectsQuery({
 *   variables: {
 *      gcDepartureId: // value for 'gcDepartureId'
 *   },
 * });
 */
export function useGroupMembersProspectsQuery(baseOptions: Apollo.QueryHookOptions<GroupMembersProspectsQuery, GroupMembersProspectsQueryVariables> & ({ variables: GroupMembersProspectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupMembersProspectsQuery, GroupMembersProspectsQueryVariables>(GroupMembersProspectsDocument, options);
      }
export function useGroupMembersProspectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupMembersProspectsQuery, GroupMembersProspectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupMembersProspectsQuery, GroupMembersProspectsQueryVariables>(GroupMembersProspectsDocument, options);
        }
export function useGroupMembersProspectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupMembersProspectsQuery, GroupMembersProspectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupMembersProspectsQuery, GroupMembersProspectsQueryVariables>(GroupMembersProspectsDocument, options);
        }
export type GroupMembersProspectsQueryHookResult = ReturnType<typeof useGroupMembersProspectsQuery>;
export type GroupMembersProspectsLazyQueryHookResult = ReturnType<typeof useGroupMembersProspectsLazyQuery>;
export type GroupMembersProspectsSuspenseQueryHookResult = ReturnType<typeof useGroupMembersProspectsSuspenseQuery>;
export type GroupMembersProspectsQueryResult = Apollo.QueryResult<GroupMembersProspectsQuery, GroupMembersProspectsQueryVariables>;
export const TravelerDetailBookingDocument = gql`
    query TravelerDetailBooking($bookingId: ObjectId!) {
  booking(_id: $bookingId) {
    _id
    trips {
      _id
      ... on BookingTrip {
        ...TravelerDetailBookingTripWithDepartureId
      }
    }
  }
}
    ${TravelerDetailBookingTripWithDepartureIdFragmentDoc}`;

/**
 * __useTravelerDetailBookingQuery__
 *
 * To run a query within a React component, call `useTravelerDetailBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelerDetailBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelerDetailBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useTravelerDetailBookingQuery(baseOptions: Apollo.QueryHookOptions<TravelerDetailBookingQuery, TravelerDetailBookingQueryVariables> & ({ variables: TravelerDetailBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelerDetailBookingQuery, TravelerDetailBookingQueryVariables>(TravelerDetailBookingDocument, options);
      }
export function useTravelerDetailBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelerDetailBookingQuery, TravelerDetailBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelerDetailBookingQuery, TravelerDetailBookingQueryVariables>(TravelerDetailBookingDocument, options);
        }
export function useTravelerDetailBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TravelerDetailBookingQuery, TravelerDetailBookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TravelerDetailBookingQuery, TravelerDetailBookingQueryVariables>(TravelerDetailBookingDocument, options);
        }
export type TravelerDetailBookingQueryHookResult = ReturnType<typeof useTravelerDetailBookingQuery>;
export type TravelerDetailBookingLazyQueryHookResult = ReturnType<typeof useTravelerDetailBookingLazyQuery>;
export type TravelerDetailBookingSuspenseQueryHookResult = ReturnType<typeof useTravelerDetailBookingSuspenseQuery>;
export type TravelerDetailBookingQueryResult = Apollo.QueryResult<TravelerDetailBookingQuery, TravelerDetailBookingQueryVariables>;
export const TravelerDetailBookingTripWithDepartureDocument = gql`
    query TravelerDetailBookingTripWithDeparture($tripId: ObjectId!, $language: String!) {
  bookingTrip(_id: $tripId) {
    _id
    ... on BookingTrip {
      ...TravelerDetailBookingTripWithDeparture
    }
  }
}
    ${TravelerDetailBookingTripWithDepartureFragmentDoc}`;

/**
 * __useTravelerDetailBookingTripWithDepartureQuery__
 *
 * To run a query within a React component, call `useTravelerDetailBookingTripWithDepartureQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelerDetailBookingTripWithDepartureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelerDetailBookingTripWithDepartureQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTravelerDetailBookingTripWithDepartureQuery(baseOptions: Apollo.QueryHookOptions<TravelerDetailBookingTripWithDepartureQuery, TravelerDetailBookingTripWithDepartureQueryVariables> & ({ variables: TravelerDetailBookingTripWithDepartureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelerDetailBookingTripWithDepartureQuery, TravelerDetailBookingTripWithDepartureQueryVariables>(TravelerDetailBookingTripWithDepartureDocument, options);
      }
export function useTravelerDetailBookingTripWithDepartureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelerDetailBookingTripWithDepartureQuery, TravelerDetailBookingTripWithDepartureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelerDetailBookingTripWithDepartureQuery, TravelerDetailBookingTripWithDepartureQueryVariables>(TravelerDetailBookingTripWithDepartureDocument, options);
        }
export function useTravelerDetailBookingTripWithDepartureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TravelerDetailBookingTripWithDepartureQuery, TravelerDetailBookingTripWithDepartureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TravelerDetailBookingTripWithDepartureQuery, TravelerDetailBookingTripWithDepartureQueryVariables>(TravelerDetailBookingTripWithDepartureDocument, options);
        }
export type TravelerDetailBookingTripWithDepartureQueryHookResult = ReturnType<typeof useTravelerDetailBookingTripWithDepartureQuery>;
export type TravelerDetailBookingTripWithDepartureLazyQueryHookResult = ReturnType<typeof useTravelerDetailBookingTripWithDepartureLazyQuery>;
export type TravelerDetailBookingTripWithDepartureSuspenseQueryHookResult = ReturnType<typeof useTravelerDetailBookingTripWithDepartureSuspenseQuery>;
export type TravelerDetailBookingTripWithDepartureQueryResult = Apollo.QueryResult<TravelerDetailBookingTripWithDepartureQuery, TravelerDetailBookingTripWithDepartureQueryVariables>;
export const TravelerDetailDepartureDocument = gql`
    query TravelerDetailDeparture($departureId: ObjectId!, $language: String!) {
  departure(_id: $departureId) {
    _id
    ...TravelerDetailDeparture
  }
}
    ${TravelerDetailDepartureFragmentDoc}`;

/**
 * __useTravelerDetailDepartureQuery__
 *
 * To run a query within a React component, call `useTravelerDetailDepartureQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelerDetailDepartureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelerDetailDepartureQuery({
 *   variables: {
 *      departureId: // value for 'departureId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTravelerDetailDepartureQuery(baseOptions: Apollo.QueryHookOptions<TravelerDetailDepartureQuery, TravelerDetailDepartureQueryVariables> & ({ variables: TravelerDetailDepartureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelerDetailDepartureQuery, TravelerDetailDepartureQueryVariables>(TravelerDetailDepartureDocument, options);
      }
export function useTravelerDetailDepartureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelerDetailDepartureQuery, TravelerDetailDepartureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelerDetailDepartureQuery, TravelerDetailDepartureQueryVariables>(TravelerDetailDepartureDocument, options);
        }
export function useTravelerDetailDepartureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TravelerDetailDepartureQuery, TravelerDetailDepartureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TravelerDetailDepartureQuery, TravelerDetailDepartureQueryVariables>(TravelerDetailDepartureDocument, options);
        }
export type TravelerDetailDepartureQueryHookResult = ReturnType<typeof useTravelerDetailDepartureQuery>;
export type TravelerDetailDepartureLazyQueryHookResult = ReturnType<typeof useTravelerDetailDepartureLazyQuery>;
export type TravelerDetailDepartureSuspenseQueryHookResult = ReturnType<typeof useTravelerDetailDepartureSuspenseQuery>;
export type TravelerDetailDepartureQueryResult = Apollo.QueryResult<TravelerDetailDepartureQuery, TravelerDetailDepartureQueryVariables>;
export const BookingTripHotelsDocument = gql`
    query BookingTripHotels($id: ObjectId!, $language: String!) {
  bookingTrip(_id: $id) {
    _id
    openRoomLineItem {
      _id
      lineItemCode
    }
    hotels {
      ...Hotel
    }
    tsaInformation {
      _id
      firstName
      lastName
      middleName
    }
    openPreStayLineItem {
      ...ExtendedStay
    }
    openPostStayLineItem {
      ...ExtendedStay
    }
    departure {
      _id
      hotelsRelease {
        isReleased
        releaseDate
      }
      rooms {
        ...HotelDepartureRoom
      }
      hotelsRequestDeadlineDate
    }
  }
}
    ${HotelFragmentDoc}
${ExtendedStayFragmentDoc}
${HotelDepartureRoomFragmentDoc}`;

/**
 * __useBookingTripHotelsQuery__
 *
 * To run a query within a React component, call `useBookingTripHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingTripHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingTripHotelsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useBookingTripHotelsQuery(baseOptions: Apollo.QueryHookOptions<BookingTripHotelsQuery, BookingTripHotelsQueryVariables> & ({ variables: BookingTripHotelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingTripHotelsQuery, BookingTripHotelsQueryVariables>(BookingTripHotelsDocument, options);
      }
export function useBookingTripHotelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingTripHotelsQuery, BookingTripHotelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingTripHotelsQuery, BookingTripHotelsQueryVariables>(BookingTripHotelsDocument, options);
        }
export function useBookingTripHotelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingTripHotelsQuery, BookingTripHotelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingTripHotelsQuery, BookingTripHotelsQueryVariables>(BookingTripHotelsDocument, options);
        }
export type BookingTripHotelsQueryHookResult = ReturnType<typeof useBookingTripHotelsQuery>;
export type BookingTripHotelsLazyQueryHookResult = ReturnType<typeof useBookingTripHotelsLazyQuery>;
export type BookingTripHotelsSuspenseQueryHookResult = ReturnType<typeof useBookingTripHotelsSuspenseQuery>;
export type BookingTripHotelsQueryResult = Apollo.QueryResult<BookingTripHotelsQuery, BookingTripHotelsQueryVariables>;
export const BookingTripRequestedRoommatesDocument = gql`
    query BookingTripRequestedRoommates($tripId: ObjectId!) {
  bookingTrip(_id: $tripId) {
    _id
    requestedRoommates
  }
}
    `;

/**
 * __useBookingTripRequestedRoommatesQuery__
 *
 * To run a query within a React component, call `useBookingTripRequestedRoommatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingTripRequestedRoommatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingTripRequestedRoommatesQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useBookingTripRequestedRoommatesQuery(baseOptions: Apollo.QueryHookOptions<BookingTripRequestedRoommatesQuery, BookingTripRequestedRoommatesQueryVariables> & ({ variables: BookingTripRequestedRoommatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingTripRequestedRoommatesQuery, BookingTripRequestedRoommatesQueryVariables>(BookingTripRequestedRoommatesDocument, options);
      }
export function useBookingTripRequestedRoommatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingTripRequestedRoommatesQuery, BookingTripRequestedRoommatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingTripRequestedRoommatesQuery, BookingTripRequestedRoommatesQueryVariables>(BookingTripRequestedRoommatesDocument, options);
        }
export function useBookingTripRequestedRoommatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingTripRequestedRoommatesQuery, BookingTripRequestedRoommatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingTripRequestedRoommatesQuery, BookingTripRequestedRoommatesQueryVariables>(BookingTripRequestedRoommatesDocument, options);
        }
export type BookingTripRequestedRoommatesQueryHookResult = ReturnType<typeof useBookingTripRequestedRoommatesQuery>;
export type BookingTripRequestedRoommatesLazyQueryHookResult = ReturnType<typeof useBookingTripRequestedRoommatesLazyQuery>;
export type BookingTripRequestedRoommatesSuspenseQueryHookResult = ReturnType<typeof useBookingTripRequestedRoommatesSuspenseQuery>;
export type BookingTripRequestedRoommatesQueryResult = Apollo.QueryResult<BookingTripRequestedRoommatesQuery, BookingTripRequestedRoommatesQueryVariables>;
export const RequestRoommatesDocument = gql`
    mutation RequestRoommates($id: ObjectId!, $requestedRoommates: [String!]!, $tripId: ObjectId!) {
  updateDraftOrderRequestedRoommates(
    _id: $id
    requestedRoommates: $requestedRoommates
    tripId: $tripId
  ) {
    ... on DraftOrder {
      _id
      order {
        _id
        trips {
          requestedRoommates
        }
      }
    }
  }
}
    `;
export type RequestRoommatesMutationFn = Apollo.MutationFunction<RequestRoommatesMutation, RequestRoommatesMutationVariables>;

/**
 * __useRequestRoommatesMutation__
 *
 * To run a mutation, you first call `useRequestRoommatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestRoommatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestRoommatesMutation, { data, loading, error }] = useRequestRoommatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requestedRoommates: // value for 'requestedRoommates'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useRequestRoommatesMutation(baseOptions?: Apollo.MutationHookOptions<RequestRoommatesMutation, RequestRoommatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestRoommatesMutation, RequestRoommatesMutationVariables>(RequestRoommatesDocument, options);
      }
export type RequestRoommatesMutationHookResult = ReturnType<typeof useRequestRoommatesMutation>;
export type RequestRoommatesMutationResult = Apollo.MutationResult<RequestRoommatesMutation>;
export type RequestRoommatesMutationOptions = Apollo.BaseMutationOptions<RequestRoommatesMutation, RequestRoommatesMutationVariables>;
export const CheckTripChecklistItemDocument = gql`
    mutation CheckTripChecklistItem($checklistItemTemplateId: ObjectId!, $tripId: ObjectId!) {
  checkTripChecklistItem(
    checklistItemTemplateId: $checklistItemTemplateId
    tripId: $tripId
  ) {
    ... on TripChecklistItemState {
      _id
      isChecked
    }
  }
}
    `;
export type CheckTripChecklistItemMutationFn = Apollo.MutationFunction<CheckTripChecklistItemMutation, CheckTripChecklistItemMutationVariables>;

/**
 * __useCheckTripChecklistItemMutation__
 *
 * To run a mutation, you first call `useCheckTripChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckTripChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkTripChecklistItemMutation, { data, loading, error }] = useCheckTripChecklistItemMutation({
 *   variables: {
 *      checklistItemTemplateId: // value for 'checklistItemTemplateId'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useCheckTripChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<CheckTripChecklistItemMutation, CheckTripChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckTripChecklistItemMutation, CheckTripChecklistItemMutationVariables>(CheckTripChecklistItemDocument, options);
      }
export type CheckTripChecklistItemMutationHookResult = ReturnType<typeof useCheckTripChecklistItemMutation>;
export type CheckTripChecklistItemMutationResult = Apollo.MutationResult<CheckTripChecklistItemMutation>;
export type CheckTripChecklistItemMutationOptions = Apollo.BaseMutationOptions<CheckTripChecklistItemMutation, CheckTripChecklistItemMutationVariables>;
export const UncheckTripChecklistItemDocument = gql`
    mutation UncheckTripChecklistItem($checklistItemTemplateId: ObjectId!, $tripId: ObjectId!) {
  uncheckTripChecklistItem(
    checklistItemTemplateId: $checklistItemTemplateId
    tripId: $tripId
  ) {
    ... on TripChecklistItemState {
      _id
      isChecked
    }
  }
}
    `;
export type UncheckTripChecklistItemMutationFn = Apollo.MutationFunction<UncheckTripChecklistItemMutation, UncheckTripChecklistItemMutationVariables>;

/**
 * __useUncheckTripChecklistItemMutation__
 *
 * To run a mutation, you first call `useUncheckTripChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncheckTripChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncheckTripChecklistItemMutation, { data, loading, error }] = useUncheckTripChecklistItemMutation({
 *   variables: {
 *      checklistItemTemplateId: // value for 'checklistItemTemplateId'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useUncheckTripChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<UncheckTripChecklistItemMutation, UncheckTripChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncheckTripChecklistItemMutation, UncheckTripChecklistItemMutationVariables>(UncheckTripChecklistItemDocument, options);
      }
export type UncheckTripChecklistItemMutationHookResult = ReturnType<typeof useUncheckTripChecklistItemMutation>;
export type UncheckTripChecklistItemMutationResult = Apollo.MutationResult<UncheckTripChecklistItemMutation>;
export type UncheckTripChecklistItemMutationOptions = Apollo.BaseMutationOptions<UncheckTripChecklistItemMutation, UncheckTripChecklistItemMutationVariables>;
export const BookingTripCustomizationsDocument = gql`
    query BookingTripCustomizations($id: ObjectId!, $language: String!) {
  bookingTrip(_id: $id) {
    departure {
      activeExtensionContent(language: $language) {
        ...CustomizationExtensionContent
      }
      activeExtension {
        ...CustomizationActiveExtension
      }
      excursions {
        ...CustomizationExcursion
      }
      timingStatus
      finalPaymentDeadline
    }
    booking {
      trips {
        ...CustomizationTrip
      }
      balance {
        currencyCode
        formatted
        value
      }
    }
  }
}
    ${CustomizationExtensionContentFragmentDoc}
${CustomizationActiveExtensionFragmentDoc}
${CustomizationExcursionFragmentDoc}
${CustomizationTripFragmentDoc}`;

/**
 * __useBookingTripCustomizationsQuery__
 *
 * To run a query within a React component, call `useBookingTripCustomizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingTripCustomizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingTripCustomizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useBookingTripCustomizationsQuery(baseOptions: Apollo.QueryHookOptions<BookingTripCustomizationsQuery, BookingTripCustomizationsQueryVariables> & ({ variables: BookingTripCustomizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingTripCustomizationsQuery, BookingTripCustomizationsQueryVariables>(BookingTripCustomizationsDocument, options);
      }
export function useBookingTripCustomizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingTripCustomizationsQuery, BookingTripCustomizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingTripCustomizationsQuery, BookingTripCustomizationsQueryVariables>(BookingTripCustomizationsDocument, options);
        }
export function useBookingTripCustomizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingTripCustomizationsQuery, BookingTripCustomizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingTripCustomizationsQuery, BookingTripCustomizationsQueryVariables>(BookingTripCustomizationsDocument, options);
        }
export type BookingTripCustomizationsQueryHookResult = ReturnType<typeof useBookingTripCustomizationsQuery>;
export type BookingTripCustomizationsLazyQueryHookResult = ReturnType<typeof useBookingTripCustomizationsLazyQuery>;
export type BookingTripCustomizationsSuspenseQueryHookResult = ReturnType<typeof useBookingTripCustomizationsSuspenseQuery>;
export type BookingTripCustomizationsQueryResult = Apollo.QueryResult<BookingTripCustomizationsQuery, BookingTripCustomizationsQueryVariables>;
export const DraftBookingCustomizationsDocument = gql`
    query DraftBookingCustomizations($id: ObjectId!) {
  draftOrder(_id: $id) {
    _id
    order {
      ...DraftBookingCustomizationsOrder
    }
  }
}
    ${DraftBookingCustomizationsOrderFragmentDoc}`;

/**
 * __useDraftBookingCustomizationsQuery__
 *
 * To run a query within a React component, call `useDraftBookingCustomizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftBookingCustomizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftBookingCustomizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDraftBookingCustomizationsQuery(baseOptions: Apollo.QueryHookOptions<DraftBookingCustomizationsQuery, DraftBookingCustomizationsQueryVariables> & ({ variables: DraftBookingCustomizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftBookingCustomizationsQuery, DraftBookingCustomizationsQueryVariables>(DraftBookingCustomizationsDocument, options);
      }
export function useDraftBookingCustomizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftBookingCustomizationsQuery, DraftBookingCustomizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftBookingCustomizationsQuery, DraftBookingCustomizationsQueryVariables>(DraftBookingCustomizationsDocument, options);
        }
export function useDraftBookingCustomizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftBookingCustomizationsQuery, DraftBookingCustomizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DraftBookingCustomizationsQuery, DraftBookingCustomizationsQueryVariables>(DraftBookingCustomizationsDocument, options);
        }
export type DraftBookingCustomizationsQueryHookResult = ReturnType<typeof useDraftBookingCustomizationsQuery>;
export type DraftBookingCustomizationsLazyQueryHookResult = ReturnType<typeof useDraftBookingCustomizationsLazyQuery>;
export type DraftBookingCustomizationsSuspenseQueryHookResult = ReturnType<typeof useDraftBookingCustomizationsSuspenseQuery>;
export type DraftBookingCustomizationsQueryResult = Apollo.QueryResult<DraftBookingCustomizationsQuery, DraftBookingCustomizationsQueryVariables>;
export const BookingTripFlightsDocument = gql`
    query BookingTripFlights($id: ObjectId!) {
  booking(_id: $id) {
    _id
    departure {
      _id
      flightsRelease {
        isReleased
        releaseDate
        releaseEndDate
      }
      flightsRequestMessagingDeadlineDate
      eTicketsRelease {
        isReleased
      }
    }
    gcDeparture {
      _id
      flightsRelease {
        isReleased
        releaseDate
        releaseEndDate
      }
      eTicketsRelease {
        isReleased
      }
    }
    trips {
      _id
      isLandOnly
      flights {
        hasFullItinerary
        isFullyTicketed
        flightSegments {
          ...TripFlightSegment
        }
      }
      tsaInformation {
        _id
        firstName
        lastName
        middleName
        suffix
      }
    }
  }
}
    ${TripFlightSegmentFragmentDoc}`;

/**
 * __useBookingTripFlightsQuery__
 *
 * To run a query within a React component, call `useBookingTripFlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingTripFlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingTripFlightsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingTripFlightsQuery(baseOptions: Apollo.QueryHookOptions<BookingTripFlightsQuery, BookingTripFlightsQueryVariables> & ({ variables: BookingTripFlightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingTripFlightsQuery, BookingTripFlightsQueryVariables>(BookingTripFlightsDocument, options);
      }
export function useBookingTripFlightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingTripFlightsQuery, BookingTripFlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingTripFlightsQuery, BookingTripFlightsQueryVariables>(BookingTripFlightsDocument, options);
        }
export function useBookingTripFlightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingTripFlightsQuery, BookingTripFlightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingTripFlightsQuery, BookingTripFlightsQueryVariables>(BookingTripFlightsDocument, options);
        }
export type BookingTripFlightsQueryHookResult = ReturnType<typeof useBookingTripFlightsQuery>;
export type BookingTripFlightsLazyQueryHookResult = ReturnType<typeof useBookingTripFlightsLazyQuery>;
export type BookingTripFlightsSuspenseQueryHookResult = ReturnType<typeof useBookingTripFlightsSuspenseQuery>;
export type BookingTripFlightsQueryResult = Apollo.QueryResult<BookingTripFlightsQuery, BookingTripFlightsQueryVariables>;
export const BookingTripRequestedTravelCompanionsDocument = gql`
    query BookingTripRequestedTravelCompanions($tripId: ObjectId!) {
  bookingTrip(_id: $tripId) {
    requestedTravelCompanions
  }
}
    `;

/**
 * __useBookingTripRequestedTravelCompanionsQuery__
 *
 * To run a query within a React component, call `useBookingTripRequestedTravelCompanionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingTripRequestedTravelCompanionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingTripRequestedTravelCompanionsQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useBookingTripRequestedTravelCompanionsQuery(baseOptions: Apollo.QueryHookOptions<BookingTripRequestedTravelCompanionsQuery, BookingTripRequestedTravelCompanionsQueryVariables> & ({ variables: BookingTripRequestedTravelCompanionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingTripRequestedTravelCompanionsQuery, BookingTripRequestedTravelCompanionsQueryVariables>(BookingTripRequestedTravelCompanionsDocument, options);
      }
export function useBookingTripRequestedTravelCompanionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingTripRequestedTravelCompanionsQuery, BookingTripRequestedTravelCompanionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingTripRequestedTravelCompanionsQuery, BookingTripRequestedTravelCompanionsQueryVariables>(BookingTripRequestedTravelCompanionsDocument, options);
        }
export function useBookingTripRequestedTravelCompanionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingTripRequestedTravelCompanionsQuery, BookingTripRequestedTravelCompanionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingTripRequestedTravelCompanionsQuery, BookingTripRequestedTravelCompanionsQueryVariables>(BookingTripRequestedTravelCompanionsDocument, options);
        }
export type BookingTripRequestedTravelCompanionsQueryHookResult = ReturnType<typeof useBookingTripRequestedTravelCompanionsQuery>;
export type BookingTripRequestedTravelCompanionsLazyQueryHookResult = ReturnType<typeof useBookingTripRequestedTravelCompanionsLazyQuery>;
export type BookingTripRequestedTravelCompanionsSuspenseQueryHookResult = ReturnType<typeof useBookingTripRequestedTravelCompanionsSuspenseQuery>;
export type BookingTripRequestedTravelCompanionsQueryResult = Apollo.QueryResult<BookingTripRequestedTravelCompanionsQuery, BookingTripRequestedTravelCompanionsQueryVariables>;
export const RequestTravelCompanionsDocument = gql`
    mutation RequestTravelCompanions($bookingId: ObjectId!, $requestedTravelCompanions: [String!]!, $tripId: ObjectId!) {
  updateDraftOrderRequestedTravelCompanions(
    _id: $bookingId
    requestedTravelCompanions: $requestedTravelCompanions
    tripId: $tripId
  ) {
    ... on DraftOrder {
      _id
      order {
        _id
        trips {
          _id
          requestedTravelCompanions
        }
      }
    }
  }
}
    `;
export type RequestTravelCompanionsMutationFn = Apollo.MutationFunction<RequestTravelCompanionsMutation, RequestTravelCompanionsMutationVariables>;

/**
 * __useRequestTravelCompanionsMutation__
 *
 * To run a mutation, you first call `useRequestTravelCompanionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTravelCompanionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTravelCompanionsMutation, { data, loading, error }] = useRequestTravelCompanionsMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      requestedTravelCompanions: // value for 'requestedTravelCompanions'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useRequestTravelCompanionsMutation(baseOptions?: Apollo.MutationHookOptions<RequestTravelCompanionsMutation, RequestTravelCompanionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTravelCompanionsMutation, RequestTravelCompanionsMutationVariables>(RequestTravelCompanionsDocument, options);
      }
export type RequestTravelCompanionsMutationHookResult = ReturnType<typeof useRequestTravelCompanionsMutation>;
export type RequestTravelCompanionsMutationResult = Apollo.MutationResult<RequestTravelCompanionsMutation>;
export type RequestTravelCompanionsMutationOptions = Apollo.BaseMutationOptions<RequestTravelCompanionsMutation, RequestTravelCompanionsMutationVariables>;
export const PostBookingFaqDocument = gql`
    query PostBookingFaq($tripId: ObjectId!, $language: String!) {
  bookingTrip(_id: $tripId) {
    _id
    departure {
      tourContent(language: $language) {
        id
        name
        postBookingFaq {
          items {
            answer
            question
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePostBookingFaqQuery__
 *
 * To run a query within a React component, call `usePostBookingFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostBookingFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostBookingFaqQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePostBookingFaqQuery(baseOptions: Apollo.QueryHookOptions<PostBookingFaqQuery, PostBookingFaqQueryVariables> & ({ variables: PostBookingFaqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostBookingFaqQuery, PostBookingFaqQueryVariables>(PostBookingFaqDocument, options);
      }
export function usePostBookingFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostBookingFaqQuery, PostBookingFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostBookingFaqQuery, PostBookingFaqQueryVariables>(PostBookingFaqDocument, options);
        }
export function usePostBookingFaqSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostBookingFaqQuery, PostBookingFaqQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostBookingFaqQuery, PostBookingFaqQueryVariables>(PostBookingFaqDocument, options);
        }
export type PostBookingFaqQueryHookResult = ReturnType<typeof usePostBookingFaqQuery>;
export type PostBookingFaqLazyQueryHookResult = ReturnType<typeof usePostBookingFaqLazyQuery>;
export type PostBookingFaqSuspenseQueryHookResult = ReturnType<typeof usePostBookingFaqSuspenseQuery>;
export type PostBookingFaqQueryResult = Apollo.QueryResult<PostBookingFaqQuery, PostBookingFaqQueryVariables>;
export const MyAccountItineraryDocument = gql`
    query MyAccountItinerary($id: ObjectId!, $language: String!) {
  bookingTrip(_id: $id) {
    _id
    booking {
      _id
      currencyCode
      gcDeparture {
        _id
        micrositeContent(language: $language) {
          fullSlug
        }
      }
    }
    departure {
      _id
      activeExtension {
        ...ItineraryDepartureExtension
      }
      departureDate
      departureDateWithExtension
      excursions {
        ...ItineraryDepartureExcursion
      }
      extensions {
        ...ItineraryDepartureExtension
      }
      tourContent(language: $language) {
        ...ItineraryTourContent
      }
    }
    hasExtension
    openExtensionLineItem {
      _id
      lineItemCode
    }
  }
}
    ${ItineraryDepartureExtensionFragmentDoc}
${ItineraryDepartureExcursionFragmentDoc}
${ItineraryTourContentFragmentDoc}`;

/**
 * __useMyAccountItineraryQuery__
 *
 * To run a query within a React component, call `useMyAccountItineraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountItineraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountItineraryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMyAccountItineraryQuery(baseOptions: Apollo.QueryHookOptions<MyAccountItineraryQuery, MyAccountItineraryQueryVariables> & ({ variables: MyAccountItineraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountItineraryQuery, MyAccountItineraryQueryVariables>(MyAccountItineraryDocument, options);
      }
export function useMyAccountItineraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountItineraryQuery, MyAccountItineraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountItineraryQuery, MyAccountItineraryQueryVariables>(MyAccountItineraryDocument, options);
        }
export function useMyAccountItinerarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAccountItineraryQuery, MyAccountItineraryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAccountItineraryQuery, MyAccountItineraryQueryVariables>(MyAccountItineraryDocument, options);
        }
export type MyAccountItineraryQueryHookResult = ReturnType<typeof useMyAccountItineraryQuery>;
export type MyAccountItineraryLazyQueryHookResult = ReturnType<typeof useMyAccountItineraryLazyQuery>;
export type MyAccountItinerarySuspenseQueryHookResult = ReturnType<typeof useMyAccountItinerarySuspenseQuery>;
export type MyAccountItineraryQueryResult = Apollo.QueryResult<MyAccountItineraryQuery, MyAccountItineraryQueryVariables>;
export const CustomerTourEvalDocument = gql`
    query CustomerTourEval($id: ObjectId!, $tripId: ObjectId!) {
  customerEvaluation(_id: $id) {
    ...CustomerEval
  }
  bookingTrip(_id: $tripId) {
    _id
    endDate
    departureDate
  }
}
    ${CustomerEvalFragmentDoc}`;

/**
 * __useCustomerTourEvalQuery__
 *
 * To run a query within a React component, call `useCustomerTourEvalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerTourEvalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerTourEvalQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useCustomerTourEvalQuery(baseOptions: Apollo.QueryHookOptions<CustomerTourEvalQuery, CustomerTourEvalQueryVariables> & ({ variables: CustomerTourEvalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerTourEvalQuery, CustomerTourEvalQueryVariables>(CustomerTourEvalDocument, options);
      }
export function useCustomerTourEvalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerTourEvalQuery, CustomerTourEvalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerTourEvalQuery, CustomerTourEvalQueryVariables>(CustomerTourEvalDocument, options);
        }
export function useCustomerTourEvalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerTourEvalQuery, CustomerTourEvalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerTourEvalQuery, CustomerTourEvalQueryVariables>(CustomerTourEvalDocument, options);
        }
export type CustomerTourEvalQueryHookResult = ReturnType<typeof useCustomerTourEvalQuery>;
export type CustomerTourEvalLazyQueryHookResult = ReturnType<typeof useCustomerTourEvalLazyQuery>;
export type CustomerTourEvalSuspenseQueryHookResult = ReturnType<typeof useCustomerTourEvalSuspenseQuery>;
export type CustomerTourEvalQueryResult = Apollo.QueryResult<CustomerTourEvalQuery, CustomerTourEvalQueryVariables>;
export const SaveCustomerEvaluationDocument = gql`
    mutation SaveCustomerEvaluation($id: ObjectId!, $freeTextQuestions: [AnswerFreeTextQuestionInput!], $matrixQuestions: [AnswerMatrixQuestionInput!], $multipleChoiceQuestions: [AnswerMultipleChoiceQuestionInput!]) {
  saveEvaluation(
    _id: $id
    freeTextQuestions: $freeTextQuestions
    matrixQuestions: $matrixQuestions
    multipleChoiceQuestions: $multipleChoiceQuestions
  ) {
    ... on SaveEvaluationSuccess {
      data {
        ...CustomerEval
      }
    }
    ... on InvalidEvaluationError {
      message
    }
  }
}
    ${CustomerEvalFragmentDoc}`;
export type SaveCustomerEvaluationMutationFn = Apollo.MutationFunction<SaveCustomerEvaluationMutation, SaveCustomerEvaluationMutationVariables>;

/**
 * __useSaveCustomerEvaluationMutation__
 *
 * To run a mutation, you first call `useSaveCustomerEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomerEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomerEvaluationMutation, { data, loading, error }] = useSaveCustomerEvaluationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      freeTextQuestions: // value for 'freeTextQuestions'
 *      matrixQuestions: // value for 'matrixQuestions'
 *      multipleChoiceQuestions: // value for 'multipleChoiceQuestions'
 *   },
 * });
 */
export function useSaveCustomerEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomerEvaluationMutation, SaveCustomerEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomerEvaluationMutation, SaveCustomerEvaluationMutationVariables>(SaveCustomerEvaluationDocument, options);
      }
export type SaveCustomerEvaluationMutationHookResult = ReturnType<typeof useSaveCustomerEvaluationMutation>;
export type SaveCustomerEvaluationMutationResult = Apollo.MutationResult<SaveCustomerEvaluationMutation>;
export type SaveCustomerEvaluationMutationOptions = Apollo.BaseMutationOptions<SaveCustomerEvaluationMutation, SaveCustomerEvaluationMutationVariables>;
export const SubmitCustomerEvaluationDocument = gql`
    mutation SubmitCustomerEvaluation($id: ObjectId!) {
  submitEvaluation(_id: $id) {
    ... on SubmitEvaluationSuccess {
      data {
        ...CustomerEval
      }
    }
  }
}
    ${CustomerEvalFragmentDoc}`;
export type SubmitCustomerEvaluationMutationFn = Apollo.MutationFunction<SubmitCustomerEvaluationMutation, SubmitCustomerEvaluationMutationVariables>;

/**
 * __useSubmitCustomerEvaluationMutation__
 *
 * To run a mutation, you first call `useSubmitCustomerEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCustomerEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCustomerEvaluationMutation, { data, loading, error }] = useSubmitCustomerEvaluationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitCustomerEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCustomerEvaluationMutation, SubmitCustomerEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCustomerEvaluationMutation, SubmitCustomerEvaluationMutationVariables>(SubmitCustomerEvaluationDocument, options);
      }
export type SubmitCustomerEvaluationMutationHookResult = ReturnType<typeof useSubmitCustomerEvaluationMutation>;
export type SubmitCustomerEvaluationMutationResult = Apollo.MutationResult<SubmitCustomerEvaluationMutation>;
export type SubmitCustomerEvaluationMutationOptions = Apollo.BaseMutationOptions<SubmitCustomerEvaluationMutation, SubmitCustomerEvaluationMutationVariables>;
export const CreateTourReviewDocument = gql`
    mutation CreateTourReview($input: CreateReviewInput!) {
  createReview(input: $input) {
    ...TourReview
  }
}
    ${TourReviewFragmentDoc}`;
export type CreateTourReviewMutationFn = Apollo.MutationFunction<CreateTourReviewMutation, CreateTourReviewMutationVariables>;

/**
 * __useCreateTourReviewMutation__
 *
 * To run a mutation, you first call `useCreateTourReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTourReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTourReviewMutation, { data, loading, error }] = useCreateTourReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTourReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateTourReviewMutation, CreateTourReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTourReviewMutation, CreateTourReviewMutationVariables>(CreateTourReviewDocument, options);
      }
export type CreateTourReviewMutationHookResult = ReturnType<typeof useCreateTourReviewMutation>;
export type CreateTourReviewMutationResult = Apollo.MutationResult<CreateTourReviewMutation>;
export type CreateTourReviewMutationOptions = Apollo.BaseMutationOptions<CreateTourReviewMutation, CreateTourReviewMutationVariables>;
export const UpdateTourReviewDocument = gql`
    mutation UpdateTourReview($id: ObjectId!, $input: UpdateReviewInput!) {
  updateReview(_id: $id, input: $input) {
    ...TourReview
  }
}
    ${TourReviewFragmentDoc}`;
export type UpdateTourReviewMutationFn = Apollo.MutationFunction<UpdateTourReviewMutation, UpdateTourReviewMutationVariables>;

/**
 * __useUpdateTourReviewMutation__
 *
 * To run a mutation, you first call `useUpdateTourReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourReviewMutation, { data, loading, error }] = useUpdateTourReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTourReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTourReviewMutation, UpdateTourReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTourReviewMutation, UpdateTourReviewMutationVariables>(UpdateTourReviewDocument, options);
      }
export type UpdateTourReviewMutationHookResult = ReturnType<typeof useUpdateTourReviewMutation>;
export type UpdateTourReviewMutationResult = Apollo.MutationResult<UpdateTourReviewMutation>;
export type UpdateTourReviewMutationOptions = Apollo.BaseMutationOptions<UpdateTourReviewMutation, UpdateTourReviewMutationVariables>;
export const DeleteReviewImageDocument = gql`
    mutation DeleteReviewImage($reviewId: ObjectId!, $reviewImageIds: [ObjectId!]!) {
  deleteReviewImage(reviewId: $reviewId, reviewImageIds: $reviewImageIds) {
    ...TourReview
  }
}
    ${TourReviewFragmentDoc}`;
export type DeleteReviewImageMutationFn = Apollo.MutationFunction<DeleteReviewImageMutation, DeleteReviewImageMutationVariables>;

/**
 * __useDeleteReviewImageMutation__
 *
 * To run a mutation, you first call `useDeleteReviewImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewImageMutation, { data, loading, error }] = useDeleteReviewImageMutation({
 *   variables: {
 *      reviewId: // value for 'reviewId'
 *      reviewImageIds: // value for 'reviewImageIds'
 *   },
 * });
 */
export function useDeleteReviewImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReviewImageMutation, DeleteReviewImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReviewImageMutation, DeleteReviewImageMutationVariables>(DeleteReviewImageDocument, options);
      }
export type DeleteReviewImageMutationHookResult = ReturnType<typeof useDeleteReviewImageMutation>;
export type DeleteReviewImageMutationResult = Apollo.MutationResult<DeleteReviewImageMutation>;
export type DeleteReviewImageMutationOptions = Apollo.BaseMutationOptions<DeleteReviewImageMutation, DeleteReviewImageMutationVariables>;
export const TourReviewGetReviewDocument = gql`
    query TourReviewGetReview($id: ObjectId!) {
  review(_id: $id) {
    ... on Review {
      ...TourReview
    }
  }
}
    ${TourReviewFragmentDoc}`;

/**
 * __useTourReviewGetReviewQuery__
 *
 * To run a query within a React component, call `useTourReviewGetReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourReviewGetReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourReviewGetReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTourReviewGetReviewQuery(baseOptions: Apollo.QueryHookOptions<TourReviewGetReviewQuery, TourReviewGetReviewQueryVariables> & ({ variables: TourReviewGetReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TourReviewGetReviewQuery, TourReviewGetReviewQueryVariables>(TourReviewGetReviewDocument, options);
      }
export function useTourReviewGetReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TourReviewGetReviewQuery, TourReviewGetReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TourReviewGetReviewQuery, TourReviewGetReviewQueryVariables>(TourReviewGetReviewDocument, options);
        }
export function useTourReviewGetReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TourReviewGetReviewQuery, TourReviewGetReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TourReviewGetReviewQuery, TourReviewGetReviewQueryVariables>(TourReviewGetReviewDocument, options);
        }
export type TourReviewGetReviewQueryHookResult = ReturnType<typeof useTourReviewGetReviewQuery>;
export type TourReviewGetReviewLazyQueryHookResult = ReturnType<typeof useTourReviewGetReviewLazyQuery>;
export type TourReviewGetReviewSuspenseQueryHookResult = ReturnType<typeof useTourReviewGetReviewSuspenseQuery>;
export type TourReviewGetReviewQueryResult = Apollo.QueryResult<TourReviewGetReviewQuery, TourReviewGetReviewQueryVariables>;
export const TravelProtectionAddDraftOrderInsuranceAddonDocument = gql`
    mutation TravelProtectionAddDraftOrderInsuranceAddon($id: ObjectId!, $inputs: [AddDraftOrderInsuranceAddonInput!]!) {
  addDraftOrderInsuranceAddon(_id: $id, inputs: $inputs) {
    ... on DraftOrder {
      _id
    }
  }
}
    `;
export type TravelProtectionAddDraftOrderInsuranceAddonMutationFn = Apollo.MutationFunction<TravelProtectionAddDraftOrderInsuranceAddonMutation, TravelProtectionAddDraftOrderInsuranceAddonMutationVariables>;

/**
 * __useTravelProtectionAddDraftOrderInsuranceAddonMutation__
 *
 * To run a mutation, you first call `useTravelProtectionAddDraftOrderInsuranceAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelProtectionAddDraftOrderInsuranceAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelProtectionAddDraftOrderInsuranceAddonMutation, { data, loading, error }] = useTravelProtectionAddDraftOrderInsuranceAddonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useTravelProtectionAddDraftOrderInsuranceAddonMutation(baseOptions?: Apollo.MutationHookOptions<TravelProtectionAddDraftOrderInsuranceAddonMutation, TravelProtectionAddDraftOrderInsuranceAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelProtectionAddDraftOrderInsuranceAddonMutation, TravelProtectionAddDraftOrderInsuranceAddonMutationVariables>(TravelProtectionAddDraftOrderInsuranceAddonDocument, options);
      }
export type TravelProtectionAddDraftOrderInsuranceAddonMutationHookResult = ReturnType<typeof useTravelProtectionAddDraftOrderInsuranceAddonMutation>;
export type TravelProtectionAddDraftOrderInsuranceAddonMutationResult = Apollo.MutationResult<TravelProtectionAddDraftOrderInsuranceAddonMutation>;
export type TravelProtectionAddDraftOrderInsuranceAddonMutationOptions = Apollo.BaseMutationOptions<TravelProtectionAddDraftOrderInsuranceAddonMutation, TravelProtectionAddDraftOrderInsuranceAddonMutationVariables>;
export const TravelProtectionBookingDocument = gql`
    query TravelProtectionBooking($bookingId: ObjectId!, $language: String!) {
  booking(_id: $bookingId) {
    _id
    dateBooked
    balance {
      value
    }
    currencyCode
    departure {
      _id
      finalPaymentDeadline
      tourCode
    }
    paymentOptions {
      ... on BookingManualPaymentOption {
        allowedPaymentMethods
        type
      }
    }
    trips {
      _id
      hasInsurance
      isPrimary
      currencyCode
      customer {
        _id
        firstName
        lastName
      }
      tsaInformation {
        countryOfIssue
      }
      address {
        country
      }
      openInsuranceLineItem {
        _id
        travelerInsuranceIdCreationDate
        lineItemCode
        price {
          value
        }
      }
      openInsuranceAddonLineItems {
        _id
        lineItemCode
        price {
          value
        }
      }
      insurancePlanOffers {
        ...InsurancePlanOffer
      }
    }
  }
}
    ${InsurancePlanOfferFragmentDoc}`;

/**
 * __useTravelProtectionBookingQuery__
 *
 * To run a query within a React component, call `useTravelProtectionBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelProtectionBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelProtectionBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTravelProtectionBookingQuery(baseOptions: Apollo.QueryHookOptions<TravelProtectionBookingQuery, TravelProtectionBookingQueryVariables> & ({ variables: TravelProtectionBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelProtectionBookingQuery, TravelProtectionBookingQueryVariables>(TravelProtectionBookingDocument, options);
      }
export function useTravelProtectionBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelProtectionBookingQuery, TravelProtectionBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelProtectionBookingQuery, TravelProtectionBookingQueryVariables>(TravelProtectionBookingDocument, options);
        }
export function useTravelProtectionBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TravelProtectionBookingQuery, TravelProtectionBookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TravelProtectionBookingQuery, TravelProtectionBookingQueryVariables>(TravelProtectionBookingDocument, options);
        }
export type TravelProtectionBookingQueryHookResult = ReturnType<typeof useTravelProtectionBookingQuery>;
export type TravelProtectionBookingLazyQueryHookResult = ReturnType<typeof useTravelProtectionBookingLazyQuery>;
export type TravelProtectionBookingSuspenseQueryHookResult = ReturnType<typeof useTravelProtectionBookingSuspenseQuery>;
export type TravelProtectionBookingQueryResult = Apollo.QueryResult<TravelProtectionBookingQuery, TravelProtectionBookingQueryVariables>;
export const TravelProtectionCreateDraftOrderDocument = gql`
    mutation TravelProtectionCreateDraftOrder($orderId: ObjectId!) {
  createDraftOrder(orderId: $orderId) {
    ... on DraftOrder {
      _id
    }
  }
}
    `;
export type TravelProtectionCreateDraftOrderMutationFn = Apollo.MutationFunction<TravelProtectionCreateDraftOrderMutation, TravelProtectionCreateDraftOrderMutationVariables>;

/**
 * __useTravelProtectionCreateDraftOrderMutation__
 *
 * To run a mutation, you first call `useTravelProtectionCreateDraftOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelProtectionCreateDraftOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelProtectionCreateDraftOrderMutation, { data, loading, error }] = useTravelProtectionCreateDraftOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useTravelProtectionCreateDraftOrderMutation(baseOptions?: Apollo.MutationHookOptions<TravelProtectionCreateDraftOrderMutation, TravelProtectionCreateDraftOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelProtectionCreateDraftOrderMutation, TravelProtectionCreateDraftOrderMutationVariables>(TravelProtectionCreateDraftOrderDocument, options);
      }
export type TravelProtectionCreateDraftOrderMutationHookResult = ReturnType<typeof useTravelProtectionCreateDraftOrderMutation>;
export type TravelProtectionCreateDraftOrderMutationResult = Apollo.MutationResult<TravelProtectionCreateDraftOrderMutation>;
export type TravelProtectionCreateDraftOrderMutationOptions = Apollo.BaseMutationOptions<TravelProtectionCreateDraftOrderMutation, TravelProtectionCreateDraftOrderMutationVariables>;
export const TravelProtectionDraftOrderDocument = gql`
    query TravelProtectionDraftOrder($id: ObjectId!) {
  draftOrder(_id: $id) {
    _id
    order {
      ...TravelProtectionDraftOrderBooking
    }
  }
}
    ${TravelProtectionDraftOrderBookingFragmentDoc}`;

/**
 * __useTravelProtectionDraftOrderQuery__
 *
 * To run a query within a React component, call `useTravelProtectionDraftOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelProtectionDraftOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelProtectionDraftOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTravelProtectionDraftOrderQuery(baseOptions: Apollo.QueryHookOptions<TravelProtectionDraftOrderQuery, TravelProtectionDraftOrderQueryVariables> & ({ variables: TravelProtectionDraftOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TravelProtectionDraftOrderQuery, TravelProtectionDraftOrderQueryVariables>(TravelProtectionDraftOrderDocument, options);
      }
export function useTravelProtectionDraftOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TravelProtectionDraftOrderQuery, TravelProtectionDraftOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TravelProtectionDraftOrderQuery, TravelProtectionDraftOrderQueryVariables>(TravelProtectionDraftOrderDocument, options);
        }
export function useTravelProtectionDraftOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TravelProtectionDraftOrderQuery, TravelProtectionDraftOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TravelProtectionDraftOrderQuery, TravelProtectionDraftOrderQueryVariables>(TravelProtectionDraftOrderDocument, options);
        }
export type TravelProtectionDraftOrderQueryHookResult = ReturnType<typeof useTravelProtectionDraftOrderQuery>;
export type TravelProtectionDraftOrderLazyQueryHookResult = ReturnType<typeof useTravelProtectionDraftOrderLazyQuery>;
export type TravelProtectionDraftOrderSuspenseQueryHookResult = ReturnType<typeof useTravelProtectionDraftOrderSuspenseQuery>;
export type TravelProtectionDraftOrderQueryResult = Apollo.QueryResult<TravelProtectionDraftOrderQuery, TravelProtectionDraftOrderQueryVariables>;
export const TravelProtectionUpdateDraftOrderInsuranceDocument = gql`
    mutation TravelProtectionUpdateDraftOrderInsurance($id: ObjectId!, $lineItemCode: LineItemCode!, $tripIds: [ObjectId!], $addOnLineItemCodes: [LineItemCode!]) {
  updateDraftOrderInsurance(
    _id: $id
    lineItemCode: $lineItemCode
    tripIds: $tripIds
    addOnLineItemCodes: $addOnLineItemCodes
  ) {
    ... on DraftOrder {
      _id
    }
  }
}
    `;
export type TravelProtectionUpdateDraftOrderInsuranceMutationFn = Apollo.MutationFunction<TravelProtectionUpdateDraftOrderInsuranceMutation, TravelProtectionUpdateDraftOrderInsuranceMutationVariables>;

/**
 * __useTravelProtectionUpdateDraftOrderInsuranceMutation__
 *
 * To run a mutation, you first call `useTravelProtectionUpdateDraftOrderInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelProtectionUpdateDraftOrderInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelProtectionUpdateDraftOrderInsuranceMutation, { data, loading, error }] = useTravelProtectionUpdateDraftOrderInsuranceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lineItemCode: // value for 'lineItemCode'
 *      tripIds: // value for 'tripIds'
 *      addOnLineItemCodes: // value for 'addOnLineItemCodes'
 *   },
 * });
 */
export function useTravelProtectionUpdateDraftOrderInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<TravelProtectionUpdateDraftOrderInsuranceMutation, TravelProtectionUpdateDraftOrderInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelProtectionUpdateDraftOrderInsuranceMutation, TravelProtectionUpdateDraftOrderInsuranceMutationVariables>(TravelProtectionUpdateDraftOrderInsuranceDocument, options);
      }
export type TravelProtectionUpdateDraftOrderInsuranceMutationHookResult = ReturnType<typeof useTravelProtectionUpdateDraftOrderInsuranceMutation>;
export type TravelProtectionUpdateDraftOrderInsuranceMutationResult = Apollo.MutationResult<TravelProtectionUpdateDraftOrderInsuranceMutation>;
export type TravelProtectionUpdateDraftOrderInsuranceMutationOptions = Apollo.BaseMutationOptions<TravelProtectionUpdateDraftOrderInsuranceMutation, TravelProtectionUpdateDraftOrderInsuranceMutationVariables>;
export const ProfileMeDocument = gql`
    query ProfileMe($businessCode: BusinessCode!, $language: String!) {
  me {
    _id
    ... on Customer {
      ...CustomerWithPayment
      hasGCDepartures(businessCode: $businessCode)
    }
  }
}
    ${CustomerWithPaymentFragmentDoc}`;

/**
 * __useProfileMeQuery__
 *
 * To run a query within a React component, call `useProfileMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileMeQuery({
 *   variables: {
 *      businessCode: // value for 'businessCode'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useProfileMeQuery(baseOptions: Apollo.QueryHookOptions<ProfileMeQuery, ProfileMeQueryVariables> & ({ variables: ProfileMeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileMeQuery, ProfileMeQueryVariables>(ProfileMeDocument, options);
      }
export function useProfileMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileMeQuery, ProfileMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileMeQuery, ProfileMeQueryVariables>(ProfileMeDocument, options);
        }
export function useProfileMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileMeQuery, ProfileMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileMeQuery, ProfileMeQueryVariables>(ProfileMeDocument, options);
        }
export type ProfileMeQueryHookResult = ReturnType<typeof useProfileMeQuery>;
export type ProfileMeLazyQueryHookResult = ReturnType<typeof useProfileMeLazyQuery>;
export type ProfileMeSuspenseQueryHookResult = ReturnType<typeof useProfileMeSuspenseQuery>;
export type ProfileMeQueryResult = Apollo.QueryResult<ProfileMeQuery, ProfileMeQueryVariables>;
export const UpdateCustomerAddressDocument = gql`
    mutation UpdateCustomerAddress($customerId: ObjectId!, $input: UpdateCustomerAddressInput!) {
  updateCustomerAddress(customerId: $customerId, input: $input) {
    ... on Customer {
      _id
    }
  }
}
    `;
export type UpdateCustomerAddressMutationFn = Apollo.MutationFunction<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>;

/**
 * __useUpdateCustomerAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerAddressMutation, { data, loading, error }] = useUpdateCustomerAddressMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>(UpdateCustomerAddressDocument, options);
      }
export type UpdateCustomerAddressMutationHookResult = ReturnType<typeof useUpdateCustomerAddressMutation>;
export type UpdateCustomerAddressMutationResult = Apollo.MutationResult<UpdateCustomerAddressMutation>;
export type UpdateCustomerAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>;
export const UpdateCustomerNameDocument = gql`
    mutation UpdateCustomerName($customerId: ObjectId!, $input: UpdateCustomerNameInput!) {
  updateCustomerName(customerId: $customerId, input: $input) {
    ... on Customer {
      _id
    }
  }
}
    `;
export type UpdateCustomerNameMutationFn = Apollo.MutationFunction<UpdateCustomerNameMutation, UpdateCustomerNameMutationVariables>;

/**
 * __useUpdateCustomerNameMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerNameMutation, { data, loading, error }] = useUpdateCustomerNameMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerNameMutation, UpdateCustomerNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerNameMutation, UpdateCustomerNameMutationVariables>(UpdateCustomerNameDocument, options);
      }
export type UpdateCustomerNameMutationHookResult = ReturnType<typeof useUpdateCustomerNameMutation>;
export type UpdateCustomerNameMutationResult = Apollo.MutationResult<UpdateCustomerNameMutation>;
export type UpdateCustomerNameMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerNameMutation, UpdateCustomerNameMutationVariables>;
export const UpdateCustomerPasswordDocument = gql`
    mutation UpdateCustomerPassword($input: UpdateCustomerPasswordInput!) {
  updateCustomerPassword(input: $input) {
    ... on UpdatePasswordResult {
      success
    }
  }
}
    `;
export type UpdateCustomerPasswordMutationFn = Apollo.MutationFunction<UpdateCustomerPasswordMutation, UpdateCustomerPasswordMutationVariables>;

/**
 * __useUpdateCustomerPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerPasswordMutation, { data, loading, error }] = useUpdateCustomerPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerPasswordMutation, UpdateCustomerPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerPasswordMutation, UpdateCustomerPasswordMutationVariables>(UpdateCustomerPasswordDocument, options);
      }
export type UpdateCustomerPasswordMutationHookResult = ReturnType<typeof useUpdateCustomerPasswordMutation>;
export type UpdateCustomerPasswordMutationResult = Apollo.MutationResult<UpdateCustomerPasswordMutation>;
export type UpdateCustomerPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerPasswordMutation, UpdateCustomerPasswordMutationVariables>;
export const UpdateCustomerPhoneNumberDocument = gql`
    mutation UpdateCustomerPhoneNumber($customerId: ObjectId!, $input: UpdateCustomerPhoneNumberInput!) {
  updateCustomerPhoneNumber(customerId: $customerId, input: $input) {
    ... on Customer {
      _id
    }
  }
}
    `;
export type UpdateCustomerPhoneNumberMutationFn = Apollo.MutationFunction<UpdateCustomerPhoneNumberMutation, UpdateCustomerPhoneNumberMutationVariables>;

/**
 * __useUpdateCustomerPhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerPhoneNumberMutation, { data, loading, error }] = useUpdateCustomerPhoneNumberMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerPhoneNumberMutation, UpdateCustomerPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerPhoneNumberMutation, UpdateCustomerPhoneNumberMutationVariables>(UpdateCustomerPhoneNumberDocument, options);
      }
export type UpdateCustomerPhoneNumberMutationHookResult = ReturnType<typeof useUpdateCustomerPhoneNumberMutation>;
export type UpdateCustomerPhoneNumberMutationResult = Apollo.MutationResult<UpdateCustomerPhoneNumberMutation>;
export type UpdateCustomerPhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerPhoneNumberMutation, UpdateCustomerPhoneNumberMutationVariables>;
export const CreateWishlistItemDocument = gql`
    mutation CreateWishlistItem($input: CreateWishlistItemInput!) {
  createWishlistItem(input: $input) {
    ... on WishlistItem {
      tourCode
    }
  }
}
    `;
export type CreateWishlistItemMutationFn = Apollo.MutationFunction<CreateWishlistItemMutation, CreateWishlistItemMutationVariables>;

/**
 * __useCreateWishlistItemMutation__
 *
 * To run a mutation, you first call `useCreateWishlistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWishlistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWishlistItemMutation, { data, loading, error }] = useCreateWishlistItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWishlistItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateWishlistItemMutation, CreateWishlistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWishlistItemMutation, CreateWishlistItemMutationVariables>(CreateWishlistItemDocument, options);
      }
export type CreateWishlistItemMutationHookResult = ReturnType<typeof useCreateWishlistItemMutation>;
export type CreateWishlistItemMutationResult = Apollo.MutationResult<CreateWishlistItemMutation>;
export type CreateWishlistItemMutationOptions = Apollo.BaseMutationOptions<CreateWishlistItemMutation, CreateWishlistItemMutationVariables>;
export const DeleteWishlistItemDocument = gql`
    mutation DeleteWishlistItem($id: ObjectId!) {
  deleteWishlistItem(_id: $id) {
    ... on WishlistItemRemovedResult {
      removedId
    }
  }
}
    `;
export type DeleteWishlistItemMutationFn = Apollo.MutationFunction<DeleteWishlistItemMutation, DeleteWishlistItemMutationVariables>;

/**
 * __useDeleteWishlistItemMutation__
 *
 * To run a mutation, you first call `useDeleteWishlistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWishlistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWishlistItemMutation, { data, loading, error }] = useDeleteWishlistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWishlistItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWishlistItemMutation, DeleteWishlistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWishlistItemMutation, DeleteWishlistItemMutationVariables>(DeleteWishlistItemDocument, options);
      }
export type DeleteWishlistItemMutationHookResult = ReturnType<typeof useDeleteWishlistItemMutation>;
export type DeleteWishlistItemMutationResult = Apollo.MutationResult<DeleteWishlistItemMutation>;
export type DeleteWishlistItemMutationOptions = Apollo.BaseMutationOptions<DeleteWishlistItemMutation, DeleteWishlistItemMutationVariables>;
export const CreateHelpCenterLoginTokenDocument = gql`
    mutation CreateHelpCenterLoginToken {
  createHelpCenterLoginToken {
    token
  }
}
    `;
export type CreateHelpCenterLoginTokenMutationFn = Apollo.MutationFunction<CreateHelpCenterLoginTokenMutation, CreateHelpCenterLoginTokenMutationVariables>;

/**
 * __useCreateHelpCenterLoginTokenMutation__
 *
 * To run a mutation, you first call `useCreateHelpCenterLoginTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHelpCenterLoginTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHelpCenterLoginTokenMutation, { data, loading, error }] = useCreateHelpCenterLoginTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateHelpCenterLoginTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateHelpCenterLoginTokenMutation, CreateHelpCenterLoginTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHelpCenterLoginTokenMutation, CreateHelpCenterLoginTokenMutationVariables>(CreateHelpCenterLoginTokenDocument, options);
      }
export type CreateHelpCenterLoginTokenMutationHookResult = ReturnType<typeof useCreateHelpCenterLoginTokenMutation>;
export type CreateHelpCenterLoginTokenMutationResult = Apollo.MutationResult<CreateHelpCenterLoginTokenMutation>;
export type CreateHelpCenterLoginTokenMutationOptions = Apollo.BaseMutationOptions<CreateHelpCenterLoginTokenMutation, CreateHelpCenterLoginTokenMutationVariables>;
export const ContentAncestorsDocument = gql`
    query ContentAncestors($businessCode: BusinessCode!, $fullSlug: String!, $language: String!) {
  contentAncestors(
    businessCode: $businessCode
    fullSlug: $fullSlug
    language: $language
  ) {
    fullSlug
    name
  }
}
    `;

/**
 * __useContentAncestorsQuery__
 *
 * To run a query within a React component, call `useContentAncestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentAncestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentAncestorsQuery({
 *   variables: {
 *      businessCode: // value for 'businessCode'
 *      fullSlug: // value for 'fullSlug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useContentAncestorsQuery(baseOptions: Apollo.QueryHookOptions<ContentAncestorsQuery, ContentAncestorsQueryVariables> & ({ variables: ContentAncestorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentAncestorsQuery, ContentAncestorsQueryVariables>(ContentAncestorsDocument, options);
      }
export function useContentAncestorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentAncestorsQuery, ContentAncestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentAncestorsQuery, ContentAncestorsQueryVariables>(ContentAncestorsDocument, options);
        }
export function useContentAncestorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentAncestorsQuery, ContentAncestorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentAncestorsQuery, ContentAncestorsQueryVariables>(ContentAncestorsDocument, options);
        }
export type ContentAncestorsQueryHookResult = ReturnType<typeof useContentAncestorsQuery>;
export type ContentAncestorsLazyQueryHookResult = ReturnType<typeof useContentAncestorsLazyQuery>;
export type ContentAncestorsSuspenseQueryHookResult = ReturnType<typeof useContentAncestorsSuspenseQuery>;
export type ContentAncestorsQueryResult = Apollo.QueryResult<ContentAncestorsQuery, ContentAncestorsQueryVariables>;
export const ContactInfoContentDocument = gql`
    query ContactInfoContent($businessCode: BusinessCode!, $language: String!) {
  contactInfoContent(businessCode: $businessCode, language: $language) {
    address {
      addressName
      city
      state
      street
      zip
    }
    groupSales {
      phoneNumber
      phoneNumberFormatted
    }
    indiesSales {
      phoneNumber
      phoneNumberFormatted
    }
  }
}
    `;

/**
 * __useContactInfoContentQuery__
 *
 * To run a query within a React component, call `useContactInfoContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactInfoContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactInfoContentQuery({
 *   variables: {
 *      businessCode: // value for 'businessCode'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useContactInfoContentQuery(baseOptions: Apollo.QueryHookOptions<ContactInfoContentQuery, ContactInfoContentQueryVariables> & ({ variables: ContactInfoContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactInfoContentQuery, ContactInfoContentQueryVariables>(ContactInfoContentDocument, options);
      }
export function useContactInfoContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactInfoContentQuery, ContactInfoContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactInfoContentQuery, ContactInfoContentQueryVariables>(ContactInfoContentDocument, options);
        }
export function useContactInfoContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactInfoContentQuery, ContactInfoContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactInfoContentQuery, ContactInfoContentQueryVariables>(ContactInfoContentDocument, options);
        }
export type ContactInfoContentQueryHookResult = ReturnType<typeof useContactInfoContentQuery>;
export type ContactInfoContentLazyQueryHookResult = ReturnType<typeof useContactInfoContentLazyQuery>;
export type ContactInfoContentSuspenseQueryHookResult = ReturnType<typeof useContactInfoContentSuspenseQuery>;
export type ContactInfoContentQueryResult = Apollo.QueryResult<ContactInfoContentQuery, ContactInfoContentQueryVariables>;
export const CreateDraftOrderDocument = gql`
    mutation CreateDraftOrder($orderId: ObjectId!) {
  createDraftOrder(orderId: $orderId) {
    ... on DraftOrder {
      _id
      order {
        trips {
          _id
        }
      }
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    `;
export type CreateDraftOrderMutationFn = Apollo.MutationFunction<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>;

/**
 * __useCreateDraftOrderMutation__
 *
 * To run a mutation, you first call `useCreateDraftOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftOrderMutation, { data, loading, error }] = useCreateDraftOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCreateDraftOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>(CreateDraftOrderDocument, options);
      }
export type CreateDraftOrderMutationHookResult = ReturnType<typeof useCreateDraftOrderMutation>;
export type CreateDraftOrderMutationResult = Apollo.MutationResult<CreateDraftOrderMutation>;
export type CreateDraftOrderMutationOptions = Apollo.BaseMutationOptions<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>;
export const LatestGeneralTermsDocument = gql`
    query LatestGeneralTerms($businessCode: BusinessCode!, $market: TermMarket!) {
  latestTerm(businessCode: $businessCode, market: $market, termType: GENERAL) {
    _id
    content
    certificationText
  }
}
    `;

/**
 * __useLatestGeneralTermsQuery__
 *
 * To run a query within a React component, call `useLatestGeneralTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestGeneralTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestGeneralTermsQuery({
 *   variables: {
 *      businessCode: // value for 'businessCode'
 *      market: // value for 'market'
 *   },
 * });
 */
export function useLatestGeneralTermsQuery(baseOptions: Apollo.QueryHookOptions<LatestGeneralTermsQuery, LatestGeneralTermsQueryVariables> & ({ variables: LatestGeneralTermsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestGeneralTermsQuery, LatestGeneralTermsQueryVariables>(LatestGeneralTermsDocument, options);
      }
export function useLatestGeneralTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestGeneralTermsQuery, LatestGeneralTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestGeneralTermsQuery, LatestGeneralTermsQueryVariables>(LatestGeneralTermsDocument, options);
        }
export function useLatestGeneralTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestGeneralTermsQuery, LatestGeneralTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestGeneralTermsQuery, LatestGeneralTermsQueryVariables>(LatestGeneralTermsDocument, options);
        }
export type LatestGeneralTermsQueryHookResult = ReturnType<typeof useLatestGeneralTermsQuery>;
export type LatestGeneralTermsLazyQueryHookResult = ReturnType<typeof useLatestGeneralTermsLazyQuery>;
export type LatestGeneralTermsSuspenseQueryHookResult = ReturnType<typeof useLatestGeneralTermsSuspenseQuery>;
export type LatestGeneralTermsQueryResult = Apollo.QueryResult<LatestGeneralTermsQuery, LatestGeneralTermsQueryVariables>;
export const LatestTermDocument = gql`
    query LatestTerm($businessCode: BusinessCode!, $market: TermMarket!, $termType: TermType!) {
  latestTerm(businessCode: $businessCode, market: $market, termType: $termType) {
    ...Term
  }
}
    ${TermFragmentDoc}`;

/**
 * __useLatestTermQuery__
 *
 * To run a query within a React component, call `useLatestTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestTermQuery({
 *   variables: {
 *      businessCode: // value for 'businessCode'
 *      market: // value for 'market'
 *      termType: // value for 'termType'
 *   },
 * });
 */
export function useLatestTermQuery(baseOptions: Apollo.QueryHookOptions<LatestTermQuery, LatestTermQueryVariables> & ({ variables: LatestTermQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestTermQuery, LatestTermQueryVariables>(LatestTermDocument, options);
      }
export function useLatestTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestTermQuery, LatestTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestTermQuery, LatestTermQueryVariables>(LatestTermDocument, options);
        }
export function useLatestTermSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestTermQuery, LatestTermQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestTermQuery, LatestTermQueryVariables>(LatestTermDocument, options);
        }
export type LatestTermQueryHookResult = ReturnType<typeof useLatestTermQuery>;
export type LatestTermLazyQueryHookResult = ReturnType<typeof useLatestTermLazyQuery>;
export type LatestTermSuspenseQueryHookResult = ReturnType<typeof useLatestTermSuspenseQuery>;
export type LatestTermQueryResult = Apollo.QueryResult<LatestTermQuery, LatestTermQueryVariables>;
export const PaymentScheduleDocument = gql`
    mutation PaymentSchedule($draftOrderId: ObjectId!, $input: CalculatePaymentScheduleInput!) {
  calculatePaymentSchedule(draftOrderId: $draftOrderId, input: $input) {
    ...PaymentSchedule
    ... on DomainError {
      message
    }
    ... on InvalidPaymentScheduleError {
      message
    }
  }
}
    ${PaymentScheduleFragmentDoc}`;
export type PaymentScheduleMutationFn = Apollo.MutationFunction<PaymentScheduleMutation, PaymentScheduleMutationVariables>;

/**
 * __usePaymentScheduleMutation__
 *
 * To run a mutation, you first call `usePaymentScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentScheduleMutation, { data, loading, error }] = usePaymentScheduleMutation({
 *   variables: {
 *      draftOrderId: // value for 'draftOrderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentScheduleMutation(baseOptions?: Apollo.MutationHookOptions<PaymentScheduleMutation, PaymentScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentScheduleMutation, PaymentScheduleMutationVariables>(PaymentScheduleDocument, options);
      }
export type PaymentScheduleMutationHookResult = ReturnType<typeof usePaymentScheduleMutation>;
export type PaymentScheduleMutationResult = Apollo.MutationResult<PaymentScheduleMutation>;
export type PaymentScheduleMutationOptions = Apollo.BaseMutationOptions<PaymentScheduleMutation, PaymentScheduleMutationVariables>;
export const PublishDraftBookingDocument = gql`
    mutation PublishDraftBooking($publishDraftBookingId: ObjectId!, $input: PublishDraftBookingInput) {
  publishDraftBooking(_id: $publishDraftBookingId, input: $input) {
    ... on Booking {
      _id
    }
    ... on ValidationError {
      allErrors
      code
      message
    }
    ... on DomainError {
      code
      message
    }
  }
}
    `;
export type PublishDraftBookingMutationFn = Apollo.MutationFunction<PublishDraftBookingMutation, PublishDraftBookingMutationVariables>;

/**
 * __usePublishDraftBookingMutation__
 *
 * To run a mutation, you first call `usePublishDraftBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDraftBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDraftBookingMutation, { data, loading, error }] = usePublishDraftBookingMutation({
 *   variables: {
 *      publishDraftBookingId: // value for 'publishDraftBookingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishDraftBookingMutation(baseOptions?: Apollo.MutationHookOptions<PublishDraftBookingMutation, PublishDraftBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishDraftBookingMutation, PublishDraftBookingMutationVariables>(PublishDraftBookingDocument, options);
      }
export type PublishDraftBookingMutationHookResult = ReturnType<typeof usePublishDraftBookingMutation>;
export type PublishDraftBookingMutationResult = Apollo.MutationResult<PublishDraftBookingMutation>;
export type PublishDraftBookingMutationOptions = Apollo.BaseMutationOptions<PublishDraftBookingMutation, PublishDraftBookingMutationVariables>;
export const QuoteTripFlightOffersDocument = gql`
    query QuoteTripFlightOffers($id: ObjectId!) {
  draftOrder(_id: $id) {
    _id
    order {
      _id
      ... on Quote {
        _id
        trips {
          ...QuoteTripFlightOffersFragment
        }
      }
    }
  }
}
    ${QuoteTripFlightOffersFragmentFragmentDoc}`;

/**
 * __useQuoteTripFlightOffersQuery__
 *
 * To run a query within a React component, call `useQuoteTripFlightOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteTripFlightOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteTripFlightOffersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteTripFlightOffersQuery(baseOptions: Apollo.QueryHookOptions<QuoteTripFlightOffersQuery, QuoteTripFlightOffersQueryVariables> & ({ variables: QuoteTripFlightOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteTripFlightOffersQuery, QuoteTripFlightOffersQueryVariables>(QuoteTripFlightOffersDocument, options);
      }
export function useQuoteTripFlightOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteTripFlightOffersQuery, QuoteTripFlightOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteTripFlightOffersQuery, QuoteTripFlightOffersQueryVariables>(QuoteTripFlightOffersDocument, options);
        }
export function useQuoteTripFlightOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuoteTripFlightOffersQuery, QuoteTripFlightOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuoteTripFlightOffersQuery, QuoteTripFlightOffersQueryVariables>(QuoteTripFlightOffersDocument, options);
        }
export type QuoteTripFlightOffersQueryHookResult = ReturnType<typeof useQuoteTripFlightOffersQuery>;
export type QuoteTripFlightOffersLazyQueryHookResult = ReturnType<typeof useQuoteTripFlightOffersLazyQuery>;
export type QuoteTripFlightOffersSuspenseQueryHookResult = ReturnType<typeof useQuoteTripFlightOffersSuspenseQuery>;
export type QuoteTripFlightOffersQueryResult = Apollo.QueryResult<QuoteTripFlightOffersQuery, QuoteTripFlightOffersQueryVariables>;
export const ReviewAggregateDocument = gql`
    query ReviewAggregate($tourCodes: [String!]!, $businessCode: BusinessCode!) {
  reviewAggregate(tourCodes: $tourCodes, businessCode: $businessCode) {
    avgRating
  }
}
    `;

/**
 * __useReviewAggregateQuery__
 *
 * To run a query within a React component, call `useReviewAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewAggregateQuery({
 *   variables: {
 *      tourCodes: // value for 'tourCodes'
 *      businessCode: // value for 'businessCode'
 *   },
 * });
 */
export function useReviewAggregateQuery(baseOptions: Apollo.QueryHookOptions<ReviewAggregateQuery, ReviewAggregateQueryVariables> & ({ variables: ReviewAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewAggregateQuery, ReviewAggregateQueryVariables>(ReviewAggregateDocument, options);
      }
export function useReviewAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewAggregateQuery, ReviewAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewAggregateQuery, ReviewAggregateQueryVariables>(ReviewAggregateDocument, options);
        }
export function useReviewAggregateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewAggregateQuery, ReviewAggregateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewAggregateQuery, ReviewAggregateQueryVariables>(ReviewAggregateDocument, options);
        }
export type ReviewAggregateQueryHookResult = ReturnType<typeof useReviewAggregateQuery>;
export type ReviewAggregateLazyQueryHookResult = ReturnType<typeof useReviewAggregateLazyQuery>;
export type ReviewAggregateSuspenseQueryHookResult = ReturnType<typeof useReviewAggregateSuspenseQuery>;
export type ReviewAggregateQueryResult = Apollo.QueryResult<ReviewAggregateQuery, ReviewAggregateQueryVariables>;